(function () {
  function E(a, b) {
    return a.push.apply(a, b), a;
  }
  function F(a, b, c, d) {
    for (var e = a.length, f = c + (d ? 1 : -1); d ? f-- : ++f < e; )
      if (b(a[f], f, a)) return f;
    return -1;
  }
  function G(b) {
    return function (c) {
      return null == c ? a : c[b];
    };
  }
  function H(b) {
    return function (c) {
      return null == b ? a : b[c];
    };
  }
  function I(a, b, c, d, e) {
    return (
      e(a, function (a, e, f) {
        c = d ? ((d = !1), a) : b(c, a, e, f);
      }),
      c
    );
  }
  function J(a, b) {
    return sb(b, function (b) {
      return a[b];
    });
  }
  function L(a, b) {
    return function (c) {
      return a(b(c));
    };
  }
  function X(a) {
    return a instanceof Z ? a : new Z(a);
  }
  function Z(a, b) {
    (this.__wrapped__ = a), (this.__actions__ = []), (this.__chain__ = !!b);
  }
  function $(b, c, d) {
    var e = b[c];
    (O.call(b, c) && uc(e, d) && (d !== a || c in b)) || _(b, c, d);
  }
  function _(a, b, c) {
    a[b] = c;
  }
  function ab(b, d, e) {
    if ("function" != typeof b) throw new TypeError(c);
    return setTimeout(function () {
      b.apply(a, e);
    }, d);
  }
  function cb(a, b) {
    var c = !0;
    return (
      bb(a, function (a, d, e) {
        return (c = !!b(a, d, e));
      }),
      c
    );
  }
  function db(b, c, d) {
    for (var e = -1, f = b.length; ++e < f; ) {
      var g = b[e],
        h = c(g);
      if (null != h && (i === a ? h === h && !0 : d(h, i)))
        var i = h,
          j = g;
    }
    return j;
  }
  function eb(a, b) {
    var c = [];
    return (
      bb(a, function (a, d, e) {
        b(a, d, e) && c.push(a);
      }),
      c
    );
  }
  function fb(a, b, c, d, e) {
    var f = -1,
      g = a.length;
    for (c || (c = Nb), e || (e = []); ++f < g; ) {
      var h = a[f];
      b > 0 && c(h)
        ? b > 1
          ? fb(h, b - 1, c, d, e)
          : E(e, h)
        : d || (e[e.length] = h);
    }
    return e;
  }
  function hb(a, b) {
    return a && gb(a, b, Xc);
  }
  function ib(a, b) {
    return eb(b, function (b) {
      return Dc(a[b]);
    });
  }
  function jb(a) {
    return Pb(a);
  }
  function kb(a, b) {
    return a > b;
  }
  function mb(a) {
    return Gc(a) && jb(a) == n;
  }
  function nb(a, b, c, d, e) {
    return a === b
      ? !0
      : null == a || null == b || (!Gc(a) && !Gc(b))
      ? a !== a && b !== b
      : ob(a, b, c, d, nb, e);
  }
  function ob(a, b, c, e, f, g) {
    var h = wc(a),
      i = wc(b),
      l = h ? k : jb(a),
      m = i ? k : jb(b);
    (l = l == j ? s : l), (m = m == j ? s : m);
    var n = l == s,
      o = m == s,
      p = l == m;
    g || (g = []);
    var q = gc(g, function (b) {
        return b[0] == a;
      }),
      r = gc(g, function (a) {
        return a[0] == b;
      });
    if (q && r) return q[1] == b;
    if ((g.push([a, b]), g.push([b, a]), p && !n)) {
      var t = h ? Jb(a, b, c, e, f, g) : Kb(a, b, l, c, e, f, g);
      return g.pop(), t;
    }
    if (!(c & d)) {
      var u = n && O.call(a, "__wrapped__"),
        v = o && O.call(b, "__wrapped__");
      if (u || v) {
        var w = u ? a.value() : a,
          x = v ? b.value() : b,
          t = f(w, x, c, e, g);
        return g.pop(), t;
      }
    }
    if (!p) return !1;
    var t = Lb(a, b, c, e, f, g);
    return g.pop(), t;
  }
  function pb(a) {
    return Gc(a) && jb(a) == u;
  }
  function qb(a) {
    return "function" == typeof a
      ? a
      : null == a
      ? bd
      : ("object" == typeof a ? tb : G)(a);
  }
  function rb(a, b) {
    return a < b;
  }
  function sb(a, b) {
    var c = -1,
      d = xc(a) ? Array(a.length) : [];
    return (
      bb(a, function (a, e, f) {
        d[++c] = b(a, e, f);
      }),
      d
    );
  }
  function tb(a) {
    var b = V(a);
    return function (c) {
      var f = b.length;
      if (null == c) return !f;
      for (c = Object(c); f--; ) {
        var g = b[f];
        if (!(g in c && nb(a[g], c[g], d | e))) return !1;
      }
      return !0;
    };
  }
  function ub(a, b) {
    return (
      (a = Object(a)),
      jc(
        b,
        function (b, c) {
          return c in a && (b[c] = a[c]), b;
        },
        {}
      )
    );
  }
  function vb(a, b) {
    return Rb(Qb(a, b, bd), a + "");
  }
  function wb(a, b, c) {
    var d = -1,
      e = a.length;
    b < 0 && (b = -b > e ? 0 : e + b),
      (c = c > e ? e : c),
      c < 0 && (c += e),
      (e = b > c ? 0 : (c - b) >>> 0),
      (b >>>= 0);
    for (var f = Array(e); ++d < e; ) f[d] = a[d + b];
    return f;
  }
  function xb(a) {
    return wb(a, 0, a.length);
  }
  function yb(a, b) {
    var c;
    return (
      bb(a, function (a, d, e) {
        return (c = b(a, d, e)), !c;
      }),
      !!c
    );
  }
  function zb(a, b) {
    var c = a;
    return jc(
      b,
      function (a, b) {
        return b.func.apply(b.thisArg, E([a], b.args));
      },
      c
    );
  }
  function Ab(b, c) {
    if (b !== c) {
      var d = b !== a,
        e = null === b,
        f = b === b,
        g = !1,
        h = c !== a,
        i = null === c,
        j = c === c,
        k = !1;
      if (
        (!i && !k && !g && b > c) ||
        (g && h && j && !i && !k) ||
        (e && h && j) ||
        (!d && j) ||
        !f
      )
        return 1;
      if (
        (!e && !g && !k && b < c) ||
        (k && d && f && !e && !g) ||
        (i && d && f) ||
        (!h && f) ||
        !j
      )
        return -1;
    }
    return 0;
  }
  function Bb(b, c, d, e) {
    var f = !d;
    d || (d = {});
    for (var g = -1, h = c.length; ++g < h; ) {
      var i = c[g],
        j = e ? e(d[i], b[i], i, d, b) : a;
      j === a && (j = b[i]), f ? _(d, i, j) : $(d, i, j);
    }
    return d;
  }
  function Cb(b) {
    return vb(function (c, d) {
      var e = -1,
        f = d.length,
        g = f > 1 ? d[f - 1] : a;
      for (
        g = b.length > 3 && "function" == typeof g ? (f--, g) : a,
          c = Object(c);
        ++e < f;

      ) {
        var h = d[e];
        h && b(c, h, e, g);
      }
      return c;
    });
  }
  function Db(a, b) {
    return function (c, d) {
      if (null == c) return c;
      if (!xc(c)) return a(c, d);
      for (
        var e = c.length, f = b ? e : -1, g = Object(c);
        (b ? f-- : ++f < e) && d(g[f], f, g) !== !1;

      );
      return c;
    };
  }
  function Eb(a) {
    return function (b, c, d) {
      for (var e = -1, f = Object(b), g = d(b), h = g.length; h--; ) {
        var i = g[a ? h : ++e];
        if (c(f[i], i, f) === !1) break;
      }
      return b;
    };
  }
  function Fb(a) {
    return function () {
      var b = arguments,
        c = Y(a.prototype),
        d = a.apply(c, b);
      return Fc(d) ? d : c;
    };
  }
  function Gb(b) {
    return function (c, d, e) {
      var f = Object(c);
      if (!xc(c)) {
        var g = qb(d, 3);
        (c = Xc(c)),
          (d = function (a) {
            return g(f[a], a, f);
          });
      }
      var h = b(c, d, e);
      return h > -1 ? f[g ? c[h] : h] : a;
    };
  }
  function Hb(a, b, d, e) {
    function i() {
      for (
        var b = -1,
          c = arguments.length,
          f = -1,
          j = e.length,
          k = Array(j + c),
          l = this && this !== B && this instanceof i ? h : a;
        ++f < j;

      )
        k[f] = e[f];
      for (; c--; ) k[f++] = arguments[++b];
      return l.apply(g ? d : this, k);
    }
    if ("function" != typeof a) throw new TypeError(c);
    var g = b & f,
      h = Fb(a);
    return i;
  }
  function Ib(b, c, d, e) {
    return b === a || (uc(b, N[d]) && !O.call(e, d)) ? c : b;
  }
  function Jb(b, c, f, g, h, i) {
    var j = f & d,
      k = b.length,
      l = c.length;
    if (k != l && !(j && l > k)) return !1;
    for (var m = -1, n = !0, o = f & e ? [] : a; ++m < k; ) {
      var r,
        p = b[m],
        q = c[m];
      if (r !== a) {
        if (r) continue;
        n = !1;
        break;
      }
      if (o) {
        if (
          !yb(c, function (a, b) {
            return Yb(o, b) || (p !== a && !h(p, a, f, g, i))
              ? void 0
              : o.push(b);
          })
        ) {
          n = !1;
          break;
        }
      } else if (p !== q && !h(p, q, f, g, i)) {
        n = !1;
        break;
      }
    }
    return n;
  }
  function Kb(a, b, c) {
    switch (c) {
      case m:
      case n:
      case r:
        return uc(+a, +b);
      case o:
        return a.name == b.name && a.message == b.message;
      case u:
      case v:
        return a == b + "";
    }
    return !1;
  }
  function Lb(b, c, e, f, g, h) {
    var i = e & d,
      j = Xc(b),
      k = j.length,
      l = Xc(c),
      m = l.length;
    if (k != m && !i) return !1;
    for (var n = k; n--; ) {
      var o = j[n];
      if (!(i ? o in c : O.call(c, o))) return !1;
    }
    for (var p = !0, q = i; ++n < k; ) {
      o = j[n];
      var t,
        r = b[o],
        s = c[o];
      if (!(t === a ? r === s || g(r, s, e, f, h) : t)) {
        p = !1;
        break;
      }
      q || (q = "constructor" == o);
    }
    if (p && !q) {
      var u = b.constructor,
        v = c.constructor;
      u != v &&
        "constructor" in b &&
        "constructor" in c &&
        !(
          "function" == typeof u &&
          u instanceof u &&
          "function" == typeof v &&
          v instanceof v
        ) &&
        (p = !1);
    }
    return p;
  }
  function Mb(b) {
    return Rb(Qb(b, a, Vb), b + "");
  }
  function Nb(a) {
    return wc(a) || vc(a);
  }
  function Ob(a) {
    var b = [];
    if (null != a) for (var c in Object(a)) b.push(c);
    return b;
  }
  function Pb(a) {
    return Q.call(a);
  }
  function Qb(b, c, d) {
    return (
      (c = W(c === a ? b.length - 1 : c, 0)),
      function () {
        for (
          var a = arguments, e = -1, f = W(a.length - c, 0), g = Array(f);
          ++e < f;

        )
          g[e] = a[c + e];
        e = -1;
        for (var h = Array(c + 1); ++e < c; ) h[e] = a[e];
        return (h[c] = d(g)), b.apply(this, h);
      }
    );
  }
  function Sb(a) {
    return eb(a, Boolean);
  }
  function Tb() {
    var a = arguments.length;
    if (!a) return [];
    for (var b = Array(a - 1), c = arguments[0], d = a; d--; )
      b[d - 1] = arguments[d];
    return E(wc(c) ? xb(c) : [c], fb(b, 1));
  }
  function Ub(a, b, c) {
    var d = null == a ? 0 : a.length;
    if (!d) return -1;
    var e = null == c ? 0 : Oc(c);
    return e < 0 && (e = W(d + e, 0)), F(a, qb(b, 3), e);
  }
  function Vb(a) {
    var b = null == a ? 0 : a.length;
    return b ? fb(a, 1) : [];
  }
  function Wb(a) {
    var b = null == a ? 0 : a.length;
    return b ? fb(a, h) : [];
  }
  function Xb(b) {
    return b && b.length ? b[0] : a;
  }
  function Yb(a, b, c) {
    var d = null == a ? 0 : a.length;
    c = "number" == typeof c ? (c < 0 ? W(d + c, 0) : c) : 0;
    for (var e = (c || 0) - 1, f = b === b; ++e < d; ) {
      var g = a[e];
      if (f ? g === b : g !== g) return e;
    }
    return -1;
  }
  function Zb(b) {
    var c = null == b ? 0 : b.length;
    return c ? b[c - 1] : a;
  }
  function $b(b, c, d) {
    var e = null == b ? 0 : b.length;
    return (
      (c = null == c ? 0 : +c), (d = d === a ? e : +d), e ? wb(b, c, d) : []
    );
  }
  function _b(a) {
    var b = X(a);
    return (b.__chain__ = !0), b;
  }
  function ac(a, b) {
    return b(a), a;
  }
  function bc(a, b) {
    return b(a);
  }
  function dc() {
    return zb(this.__wrapped__, this.__actions__);
  }
  function ec(b, c, d) {
    return (c = d ? a : c), cb(b, qb(c));
  }
  function fc(a, b) {
    return eb(a, qb(b));
  }
  function hc(a, b) {
    return bb(a, qb(b));
  }
  function ic(a, b) {
    return sb(a, qb(b));
  }
  function jc(a, b, c) {
    return I(a, qb(b), c, arguments.length < 3, bb);
  }
  function kc(a) {
    return null == a ? 0 : ((a = xc(a) ? a : V(a)), a.length);
  }
  function lc(b, c, d) {
    return (c = d ? a : c), yb(b, qb(c));
  }
  function mc(a, b) {
    var c = 0;
    return (
      (b = qb(b)),
      sb(
        sb(a, function (a, d, e) {
          return { value: a, index: c++, criteria: b(a, d, e) };
        }).sort(function (a, b) {
          return Ab(a.criteria, b.criteria) || a.index - b.index;
        }),
        G("value")
      )
    );
  }
  function nc(b, d) {
    var e;
    if ("function" != typeof d) throw new TypeError(c);
    return (
      (b = Oc(b)),
      function () {
        return --b > 0 && (e = d.apply(this, arguments)), b <= 1 && (d = a), e;
      }
    );
  }
  function rc(a) {
    if ("function" != typeof a) throw new TypeError(c);
    return function () {
      var b = arguments;
      return !a.apply(this, b);
    };
  }
  function sc(a) {
    return nc(2, a);
  }
  function tc(a) {
    return Fc(a) ? (wc(a) ? xb(a) : Bb(a, V(a))) : a;
  }
  function uc(a, b) {
    return a === b || (a !== a && b !== b);
  }
  function xc(a) {
    return null != a && Ec(a.length) && !Dc(a);
  }
  function yc(a) {
    return a === !0 || a === !1 || (Gc(a) && jb(a) == m);
  }
  function Ac(a) {
    return xc(a) && (wc(a) || Lc(a) || Dc(a.splice) || vc(a))
      ? !a.length
      : !V(a).length;
  }
  function Bc(a, b) {
    return nb(a, b);
  }
  function Cc(a) {
    return "number" == typeof a && U(a);
  }
  function Dc(a) {
    if (!Fc(a)) return !1;
    var b = jb(a);
    return b == p || b == q || b == l || b == t;
  }
  function Ec(a) {
    return "number" == typeof a && a > -1 && a % 1 == 0 && a <= i;
  }
  function Fc(a) {
    var b = typeof a;
    return null != a && ("object" == b || "function" == b);
  }
  function Gc(a) {
    return null != a && "object" == typeof a;
  }
  function Hc(a) {
    return Jc(a) && a != +a;
  }
  function Ic(a) {
    return null === a;
  }
  function Jc(a) {
    return "number" == typeof a || (Gc(a) && jb(a) == r);
  }
  function Lc(a) {
    return "string" == typeof a || (!wc(a) && Gc(a) && jb(a) == v);
  }
  function Mc(b) {
    return b === a;
  }
  function Nc(a) {
    return xc(a) ? (a.length ? xb(a) : []) : _c(a);
  }
  function Qc(a) {
    return "string" == typeof a ? a : null == a ? "" : a + "";
  }
  function Uc(a, b) {
    var c = Y(a);
    return null == b ? c : Rc(c, b);
  }
  function Wc(a, b) {
    return null != a && O.call(a, b);
  }
  function $c(b, c, d) {
    var e = null == b ? a : b[c];
    return e === a && (e = d), Dc(e) ? e.call(b) : e;
  }
  function _c(a) {
    return null == a ? [] : J(a, Xc(a));
  }
  function ad(a) {
    return (a = Qc(a)), a && x.test(a) ? a.replace(w, K) : a;
  }
  function bd(a) {
    return a;
  }
  function dd(a) {
    return tb(Rc({}, a));
  }
  function ed(a, b, c) {
    var d = Xc(b),
      e = ib(b, d);
    null != c ||
      (Fc(b) && (e.length || !d.length)) ||
      ((c = b), (b = a), (a = this), (e = ib(b, Xc(b))));
    var f = !(Fc(c) && "chain" in c) || !!c.chain,
      g = Dc(a);
    return (
      bb(e, function (c) {
        var d = b[c];
        (a[c] = d),
          g &&
            (a.prototype[c] = function () {
              var b = this.__chain__;
              if (f || b) {
                var c = a(this.__wrapped__),
                  e = (c.__actions__ = xb(this.__actions__));
                return (
                  e.push({ func: d, args: arguments, thisArg: a }),
                  (c.__chain__ = b),
                  c
                );
              }
              return d.apply(a, E([this.value()], arguments));
            });
      }),
      a
    );
  }
  function fd() {
    return B._ === this && (B._ = R), this;
  }
  function gd() {}
  function hd(a) {
    var b = ++P;
    return Qc(a) + b;
  }
  function id(b) {
    return b && b.length ? db(b, bd, kb) : a;
  }
  function jd(b) {
    return b && b.length ? db(b, bd, rb) : a;
  }
  var a,
    b = "4.17.4",
    c = "Expected a function",
    d = 1,
    e = 2,
    f = 1,
    g = 32,
    h = 1 / 0,
    i = 9007199254740991,
    j = "[object Arguments]",
    k = "[object Array]",
    l = "[object AsyncFunction]",
    m = "[object Boolean]",
    n = "[object Date]",
    o = "[object Error]",
    p = "[object Function]",
    q = "[object GeneratorFunction]",
    r = "[object Number]",
    s = "[object Object]",
    t = "[object Proxy]",
    u = "[object RegExp]",
    v = "[object String]",
    w = /[&<>"']/g,
    x = RegExp(w.source),
    y = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" },
    z =
      "object" == typeof global && global && global.Object === Object && global,
    A = "object" == typeof self && self && self.Object === Object && self,
    B = z || A || Function("return this")(),
    C = "object" == typeof exports && exports && !exports.nodeType && exports,
    D = C && "object" == typeof module && module && !module.nodeType && module,
    K = H(y),
    M = Array.prototype,
    N = Object.prototype,
    O = N.hasOwnProperty,
    P = 0,
    Q = N.toString,
    R = B._,
    S = Object.create,
    T = N.propertyIsEnumerable,
    U = B.isFinite,
    V = L(Object.keys, Object),
    W = Math.max,
    Y = (function () {
      function b() {}
      return function (c) {
        if (!Fc(c)) return {};
        if (S) return S(c);
        b.prototype = c;
        var d = new b();
        return (b.prototype = a), d;
      };
    })();
  (Z.prototype = Y(X.prototype)), (Z.prototype.constructor = Z);
  var bb = Db(hb),
    gb = Eb(),
    lb = gd,
    Rb = bd,
    gc = Gb(Ub),
    oc = vb(function (a, b, c) {
      return Hb(a, f | g, b, c);
    }),
    pc = vb(function (a, b) {
      return ab(a, 1, b);
    }),
    qc = vb(function (a, b, c) {
      return ab(a, Pc(b) || 0, c);
    }),
    vc = lb(
      (function () {
        return arguments;
      })()
    )
      ? lb
      : function (a) {
          return Gc(a) && O.call(a, "callee") && !T.call(a, "callee");
        },
    wc = Array.isArray,
    zc = mb,
    Kc = pb,
    Oc = Number,
    Pc = Number,
    Rc = Cb(function (a, b) {
      Bb(b, V(b), a);
    }),
    Sc = Cb(function (a, b) {
      Bb(b, Ob(b), a);
    }),
    Tc = Cb(function (a, b, c, d) {
      Bb(b, Yc(b), a, d);
    }),
    Vc = vb(function (b) {
      return b.push(a, Ib), Tc.apply(a, b);
    }),
    Xc = V,
    Yc = Ob,
    Zc = Mb(function (a, b) {
      return null == a ? {} : ub(a, b);
    }),
    cd = qb;
  (X.assignIn = Sc),
    (X.before = nc),
    (X.bind = oc),
    (X.chain = _b),
    (X.compact = Sb),
    (X.concat = Tb),
    (X.create = Uc),
    (X.defaults = Vc),
    (X.defer = pc),
    (X.delay = qc),
    (X.filter = fc),
    (X.flatten = Vb),
    (X.flattenDeep = Wb),
    (X.iteratee = cd),
    (X.keys = Xc),
    (X.map = ic),
    (X.matches = dd),
    (X.mixin = ed),
    (X.negate = rc),
    (X.once = sc),
    (X.pick = Zc),
    (X.slice = $b),
    (X.sortBy = mc),
    (X.tap = ac),
    (X.thru = bc),
    (X.toArray = Nc),
    (X.values = _c),
    (X.extend = Sc),
    ed(X, X),
    (X.clone = tc),
    (X.escape = ad),
    (X.every = ec),
    (X.find = gc),
    (X.forEach = hc),
    (X.has = Wc),
    (X.head = Xb),
    (X.identity = bd),
    (X.indexOf = Yb),
    (X.isArguments = vc),
    (X.isArray = wc),
    (X.isBoolean = yc),
    (X.isDate = zc),
    (X.isEmpty = Ac),
    (X.isEqual = Bc),
    (X.isFinite = Cc),
    (X.isFunction = Dc),
    (X.isNaN = Hc),
    (X.isNull = Ic),
    (X.isNumber = Jc),
    (X.isObject = Fc),
    (X.isRegExp = Kc),
    (X.isString = Lc),
    (X.isUndefined = Mc),
    (X.last = Zb),
    (X.max = id),
    (X.min = jd),
    (X.noConflict = fd),
    (X.noop = gd),
    (X.reduce = jc),
    (X.result = $c),
    (X.size = kc),
    (X.some = lc),
    (X.uniqueId = hd),
    (X.each = hc),
    (X.first = Xb),
    ed(
      X,
      (function () {
        var a = {};
        return (
          hb(X, function (b, c) {
            O.call(X.prototype, c) || (a[c] = b);
          }),
          a
        );
      })(),
      { chain: !1 }
    ),
    (X.VERSION = b),
    bb(
      [
        "pop",
        "join",
        "replace",
        "reverse",
        "split",
        "push",
        "shift",
        "sort",
        "splice",
        "unshift",
      ],
      function (a) {
        var b = (/^(?:replace|split)$/.test(a) ? String.prototype : M)[a],
          c = /^(?:push|sort|unshift)$/.test(a) ? "tap" : "thru",
          d = /^(?:pop|join|replace|shift)$/.test(a);
        X.prototype[a] = function () {
          var a = arguments;
          if (d && !this.__chain__) {
            var e = this.value();
            return b.apply(wc(e) ? e : [], a);
          }
          return this[c](function (c) {
            return b.apply(wc(c) ? c : [], a);
          });
        };
      }
    ),
    (X.prototype.toJSON = X.prototype.valueOf = X.prototype.value = dc),
    "function" == typeof define && "object" == typeof define.amd && define.amd
      ? ((B._ = X),
        define(function () {
          return X;
        }))
      : D
      ? (((D.exports = X)._ = X), (C._ = X))
      : (B._ = X);
}.call(this));
!(function (n) {
  n.fn.prepareTransition = function () {
    return this.each(function () {
      var i = n(this);
      i.one(
        "TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",
        function () {
          i.removeClass("is-transitioning");
        }
      );
      var t = [
          "transition-duration",
          "-moz-transition-duration",
          "-webkit-transition-duration",
          "-o-transition-duration",
        ],
        o = 0;
      n.each(t, function (n, t) {
        o || (o = parseFloat(i.css(t)));
      }),
        0 != o && (i.addClass("is-transitioning"), i[0].offsetWidth);
    });
  };
})(jQuery);
(function (b, c) {
  var $ = b.jQuery || b.Cowboy || (b.Cowboy = {}),
    a;
  $.throttle = a = function (e, f, j, i) {
    var h,
      d = 0;
    if (typeof f !== "boolean") {
      i = j;
      j = f;
      f = c;
    }
    function g() {
      var o = this,
        m = +new Date() - d,
        n = arguments;
      function l() {
        d = +new Date();
        j.apply(o, n);
      }
      function k() {
        h = c;
      }
      if (i && !h) {
        l();
      }
      h && clearTimeout(h);
      if (i === c && m > e) {
        l();
      } else {
        if (f !== true) {
          h = setTimeout(i ? k : l, i === c ? e - m : e);
        }
      }
    }
    if ($.guid) {
      g.guid = j.guid = j.guid || $.guid++;
    }
    return g;
  };
  $.debounce = function (d, e, f) {
    return f === c ? a(d, e, false) : a(d, f, e !== false);
  };
})(this);
if ("undefined" == typeof jQuery)
  throw new Error("Bootstrap's JavaScript requires jQuery");
+(function (a) {
  "use strict";
  var b = a.fn.jquery.split(" ")[0].split(".");
  if (
    (b[0] < 2 && b[1] < 9) ||
    (1 == b[0] && 9 == b[1] && b[2] < 1) ||
    b[0] > 3
  )
    throw new Error(
      "Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 3"
    );
})(jQuery),
  +(function (a) {
    "use strict";
    function b() {
      var a = document.createElement("bootstrap"),
        b = {
          WebkitTransition: "webkitTransitionEnd",
          MozTransition: "transitionend",
          OTransition: "oTransitionEnd otransitionend",
          transition: "transitionend",
        };
      for (var c in b) if (void 0 !== a.style[c]) return { end: b[c] };
      return !1;
    }
    (a.fn.emulateTransitionEnd = function (b) {
      var c = !1,
        d = this;
      a(this).one("bsTransitionEnd", function () {
        c = !0;
      });
      var e = function () {
        c || a(d).trigger(a.support.transition.end);
      };
      return setTimeout(e, b), this;
    }),
      a(function () {
        (a.support.transition = b()),
          a.support.transition &&
            (a.event.special.bsTransitionEnd = {
              bindType: a.support.transition.end,
              delegateType: a.support.transition.end,
              handle: function (b) {
                return a(b.target).is(this)
                  ? b.handleObj.handler.apply(this, arguments)
                  : void 0;
              },
            });
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var c = a(this),
          e = c.data("bs.alert");
        e || c.data("bs.alert", (e = new d(this))),
          "string" == typeof b && e[b].call(c);
      });
    }
    var c = '[data-dismiss="alert"]',
      d = function (b) {
        a(b).on("click", c, this.close);
      };
    (d.VERSION = "3.3.6"),
      (d.TRANSITION_DURATION = 150),
      (d.prototype.close = function (b) {
        function c() {
          g.detach().trigger("closed.bs.alert").remove();
        }
        var e = a(this),
          f = e.attr("data-target");
        f || ((f = e.attr("href")), (f = f && f.replace(/.*(?=#[^\s]*$)/, "")));
        var g = a(f);
        b && b.preventDefault(),
          g.length || (g = e.closest(".alert")),
          g.trigger((b = a.Event("close.bs.alert"))),
          b.isDefaultPrevented() ||
            (g.removeClass("in"),
            a.support.transition && g.hasClass("fade")
              ? g
                  .one("bsTransitionEnd", c)
                  .emulateTransitionEnd(d.TRANSITION_DURATION)
              : c());
      });
    var e = a.fn.alert;
    (a.fn.alert = b),
      (a.fn.alert.Constructor = d),
      (a.fn.alert.noConflict = function () {
        return (a.fn.alert = e), this;
      }),
      a(document).on("click.bs.alert.data-api", c, d.prototype.close);
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.button"),
          f = "object" == typeof b && b;
        e || d.data("bs.button", (e = new c(this, f))),
          "toggle" == b ? e.toggle() : b && e.setState(b);
      });
    }
    var c = function (b, d) {
      (this.$element = a(b)),
        (this.options = a.extend({}, c.DEFAULTS, d)),
        (this.isLoading = !1);
    };
    (c.VERSION = "3.3.6"),
      (c.DEFAULTS = { loadingText: "loading..." }),
      (c.prototype.setState = function (b) {
        var c = "disabled",
          d = this.$element,
          e = d.is("input") ? "val" : "html",
          f = d.data();
        (b += "Text"),
          null == f.resetText && d.data("resetText", d[e]()),
          setTimeout(
            a.proxy(function () {
              d[e](null == f[b] ? this.options[b] : f[b]),
                "loadingText" == b
                  ? ((this.isLoading = !0), d.addClass(c).attr(c, c))
                  : this.isLoading &&
                    ((this.isLoading = !1), d.removeClass(c).removeAttr(c));
            }, this),
            0
          );
      }),
      (c.prototype.toggle = function () {
        var a = !0,
          b = this.$element.closest('[data-toggle="buttons"]');
        if (b.length) {
          var c = this.$element.find("input");
          "radio" == c.prop("type")
            ? (c.prop("checked") && (a = !1),
              b.find(".active").removeClass("active"),
              this.$element.addClass("active"))
            : "checkbox" == c.prop("type") &&
              (c.prop("checked") !== this.$element.hasClass("active") &&
                (a = !1),
              this.$element.toggleClass("active")),
            c.prop("checked", this.$element.hasClass("active")),
            a && c.trigger("change");
        } else
          this.$element.attr("aria-pressed", !this.$element.hasClass("active")),
            this.$element.toggleClass("active");
      });
    var d = a.fn.button;
    (a.fn.button = b),
      (a.fn.button.Constructor = c),
      (a.fn.button.noConflict = function () {
        return (a.fn.button = d), this;
      }),
      a(document)
        .on(
          "click.bs.button.data-api",
          '[data-toggle^="button"]',
          function (c) {
            var d = a(c.target);
            d.hasClass("btn") || (d = d.closest(".btn")),
              b.call(d, "toggle"),
              a(c.target).is('input[type="radio"]') ||
                a(c.target).is('input[type="checkbox"]') ||
                c.preventDefault();
          }
        )
        .on(
          "focus.bs.button.data-api blur.bs.button.data-api",
          '[data-toggle^="button"]',
          function (b) {
            a(b.target)
              .closest(".btn")
              .toggleClass("focus", /^focus(in)?$/.test(b.type));
          }
        );
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.carousel"),
          f = a.extend({}, c.DEFAULTS, d.data(), "object" == typeof b && b),
          g = "string" == typeof b ? b : f.slide;
        e || d.data("bs.carousel", (e = new c(this, f))),
          "number" == typeof b
            ? e.to(b)
            : g
            ? e[g]()
            : f.interval && e.pause().cycle();
      });
    }
    var c = function (b, c) {
      (this.$element = a(b)),
        (this.$indicators = this.$element.find(".carousel-indicators")),
        (this.options = c),
        (this.paused = null),
        (this.sliding = null),
        (this.interval = null),
        (this.$active = null),
        (this.$items = null),
        this.options.keyboard &&
          this.$element.on("keydown.bs.carousel", a.proxy(this.keydown, this)),
        "hover" == this.options.pause &&
          !("ontouchstart" in document.documentElement) &&
          this.$element
            .on("mouseenter.bs.carousel", a.proxy(this.pause, this))
            .on("mouseleave.bs.carousel", a.proxy(this.cycle, this));
    };
    (c.VERSION = "3.3.6"),
      (c.TRANSITION_DURATION = 600),
      (c.DEFAULTS = { interval: 5e3, pause: "hover", wrap: !0, keyboard: !0 }),
      (c.prototype.keydown = function (a) {
        if (!/input|textarea/i.test(a.target.tagName)) {
          switch (a.which) {
            case 37:
              this.prev();
              break;
            case 39:
              this.next();
              break;
            default:
              return;
          }
          a.preventDefault();
        }
      }),
      (c.prototype.cycle = function (b) {
        return (
          b || (this.paused = !1),
          this.interval && clearInterval(this.interval),
          this.options.interval &&
            !this.paused &&
            (this.interval = setInterval(
              a.proxy(this.next, this),
              this.options.interval
            )),
          this
        );
      }),
      (c.prototype.getItemIndex = function (a) {
        return (
          (this.$items = a.parent().children(".item")),
          this.$items.index(a || this.$active)
        );
      }),
      (c.prototype.getItemForDirection = function (a, b) {
        var c = this.getItemIndex(b),
          d =
            ("prev" == a && 0 === c) ||
            ("next" == a && c == this.$items.length - 1);
        if (d && !this.options.wrap) return b;
        var e = "prev" == a ? -1 : 1,
          f = (c + e) % this.$items.length;
        return this.$items.eq(f);
      }),
      (c.prototype.to = function (a) {
        var b = this,
          c = this.getItemIndex(
            (this.$active = this.$element.find(".item.active"))
          );
        return a > this.$items.length - 1 || 0 > a
          ? void 0
          : this.sliding
          ? this.$element.one("slid.bs.carousel", function () {
              b.to(a);
            })
          : c == a
          ? this.pause().cycle()
          : this.slide(a > c ? "next" : "prev", this.$items.eq(a));
      }),
      (c.prototype.pause = function (b) {
        return (
          b || (this.paused = !0),
          this.$element.find(".next, .prev").length &&
            a.support.transition &&
            (this.$element.trigger(a.support.transition.end), this.cycle(!0)),
          (this.interval = clearInterval(this.interval)),
          this
        );
      }),
      (c.prototype.next = function () {
        return this.sliding ? void 0 : this.slide("next");
      }),
      (c.prototype.prev = function () {
        return this.sliding ? void 0 : this.slide("prev");
      }),
      (c.prototype.slide = function (b, d) {
        var e = this.$element.find(".item.active"),
          f = d || this.getItemForDirection(b, e),
          g = this.interval,
          h = "next" == b ? "left" : "right",
          i = this;
        if (f.hasClass("active")) return (this.sliding = !1);
        var j = f[0],
          k = a.Event("slide.bs.carousel", { relatedTarget: j, direction: h });
        if ((this.$element.trigger(k), !k.isDefaultPrevented())) {
          if (
            ((this.sliding = !0), g && this.pause(), this.$indicators.length)
          ) {
            this.$indicators.find(".active").removeClass("active");
            var l = a(this.$indicators.children()[this.getItemIndex(f)]);
            l && l.addClass("active");
          }
          var m = a.Event("slid.bs.carousel", {
            relatedTarget: j,
            direction: h,
          });
          return (
            a.support.transition && this.$element.hasClass("slide")
              ? (f.addClass(b),
                f[0].offsetWidth,
                e.addClass(h),
                f.addClass(h),
                e
                  .one("bsTransitionEnd", function () {
                    f.removeClass([b, h].join(" ")).addClass("active"),
                      e.removeClass(["active", h].join(" ")),
                      (i.sliding = !1),
                      setTimeout(function () {
                        i.$element.trigger(m);
                      }, 0);
                  })
                  .emulateTransitionEnd(c.TRANSITION_DURATION))
              : (e.removeClass("active"),
                f.addClass("active"),
                (this.sliding = !1),
                this.$element.trigger(m)),
            g && this.cycle(),
            this
          );
        }
      });
    var d = a.fn.carousel;
    (a.fn.carousel = b),
      (a.fn.carousel.Constructor = c),
      (a.fn.carousel.noConflict = function () {
        return (a.fn.carousel = d), this;
      });
    var e = function (c) {
      var d,
        e = a(this),
        f = a(
          e.attr("data-target") ||
            ((d = e.attr("href")) && d.replace(/.*(?=#[^\s]+$)/, ""))
        );
      if (f.hasClass("carousel")) {
        var g = a.extend({}, f.data(), e.data()),
          h = e.attr("data-slide-to");
        h && (g.interval = !1),
          b.call(f, g),
          h && f.data("bs.carousel").to(h),
          c.preventDefault();
      }
    };
    a(document)
      .on("click.bs.carousel.data-api", "[data-slide]", e)
      .on("click.bs.carousel.data-api", "[data-slide-to]", e),
      a(window).on("load", function () {
        a('[data-ride="carousel"]').each(function () {
          var c = a(this);
          b.call(c, c.data());
        });
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      var c,
        d =
          b.attr("data-target") ||
          ((c = b.attr("href")) && c.replace(/.*(?=#[^\s]+$)/, ""));
      return a(d);
    }
    function c(b) {
      return this.each(function () {
        var c = a(this),
          e = c.data("bs.collapse"),
          f = a.extend({}, d.DEFAULTS, c.data(), "object" == typeof b && b);
        !e && f.toggle && /show|hide/.test(b) && (f.toggle = !1),
          e || c.data("bs.collapse", (e = new d(this, f))),
          "string" == typeof b && e[b]();
      });
    }
    var d = function (b, c) {
      (this.$element = a(b)),
        (this.options = a.extend({}, d.DEFAULTS, c)),
        (this.$trigger = a(
          '[data-toggle="collapse"][href="#' +
            b.id +
            '"],[data-toggle="collapse"][data-target="#' +
            b.id +
            '"]'
        )),
        (this.transitioning = null),
        this.options.parent
          ? (this.$parent = this.getParent())
          : this.addAriaAndCollapsedClass(this.$element, this.$trigger),
        this.options.toggle && this.toggle();
    };
    (d.VERSION = "3.3.6"),
      (d.TRANSITION_DURATION = 350),
      (d.DEFAULTS = { toggle: !0 }),
      (d.prototype.dimension = function () {
        var a = this.$element.hasClass("width");
        return a ? "width" : "height";
      }),
      (d.prototype.show = function () {
        if (!this.transitioning && !this.$element.hasClass("in")) {
          var b,
            e =
              this.$parent &&
              this.$parent.children(".panel").children(".in, .collapsing");
          if (
            !(
              e &&
              e.length &&
              ((b = e.data("bs.collapse")), b && b.transitioning)
            )
          ) {
            var f = a.Event("show.bs.collapse");
            if ((this.$element.trigger(f), !f.isDefaultPrevented())) {
              e &&
                e.length &&
                (c.call(e, "hide"), b || e.data("bs.collapse", null));
              var g = this.dimension();
              this.$element
                .removeClass("collapse")
                .addClass("collapsing")
                [g](0)
                .attr("aria-expanded", !0),
                this.$trigger
                  .removeClass("collapsed")
                  .attr("aria-expanded", !0),
                (this.transitioning = 1);
              var h = function () {
                this.$element
                  .removeClass("collapsing")
                  .addClass("collapse in")
                  [g](""),
                  (this.transitioning = 0),
                  this.$element.trigger("shown.bs.collapse");
              };
              if (!a.support.transition) return h.call(this);
              var i = a.camelCase(["scroll", g].join("-"));
              this.$element
                .one("bsTransitionEnd", a.proxy(h, this))
                .emulateTransitionEnd(d.TRANSITION_DURATION)
                [g](this.$element[0][i]);
            }
          }
        }
      }),
      (d.prototype.hide = function () {
        if (!this.transitioning && this.$element.hasClass("in")) {
          var b = a.Event("hide.bs.collapse");
          if ((this.$element.trigger(b), !b.isDefaultPrevented())) {
            var c = this.dimension();
            this.$element[c](this.$element[c]())[0].offsetHeight,
              this.$element
                .addClass("collapsing")
                .removeClass("collapse in")
                .attr("aria-expanded", !1),
              this.$trigger.addClass("collapsed").attr("aria-expanded", !1),
              (this.transitioning = 1);
            var e = function () {
              (this.transitioning = 0),
                this.$element
                  .removeClass("collapsing")
                  .addClass("collapse")
                  .trigger("hidden.bs.collapse");
            };
            return a.support.transition
              ? void this.$element[c](0)
                  .one("bsTransitionEnd", a.proxy(e, this))
                  .emulateTransitionEnd(d.TRANSITION_DURATION)
              : e.call(this);
          }
        }
      }),
      (d.prototype.toggle = function () {
        this[this.$element.hasClass("in") ? "hide" : "show"]();
      }),
      (d.prototype.getParent = function () {
        return a(this.options.parent)
          .find(
            '[data-toggle="collapse"][data-parent="' +
              this.options.parent +
              '"]'
          )
          .each(
            a.proxy(function (c, d) {
              var e = a(d);
              this.addAriaAndCollapsedClass(b(e), e);
            }, this)
          )
          .end();
      }),
      (d.prototype.addAriaAndCollapsedClass = function (a, b) {
        var c = a.hasClass("in");
        a.attr("aria-expanded", c),
          b.toggleClass("collapsed", !c).attr("aria-expanded", c);
      });
    var e = a.fn.collapse;
    (a.fn.collapse = c),
      (a.fn.collapse.Constructor = d),
      (a.fn.collapse.noConflict = function () {
        return (a.fn.collapse = e), this;
      }),
      a(document).on(
        "click.bs.collapse.data-api",
        '[data-toggle="collapse"]',
        function (d) {
          var e = a(this);
          e.attr("data-target") || d.preventDefault();
          var f = b(e),
            g = f.data("bs.collapse"),
            h = g ? "toggle" : e.data();
          c.call(f, h);
        }
      );
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      var c = b.attr("data-target");
      c ||
        ((c = b.attr("href")),
        (c = c && /#[A-Za-z]/.test(c) && c.replace(/.*(?=#[^\s]*$)/, "")));
      var d = c && a(c);
      return d && d.length ? d : b.parent();
    }
    function c(c) {
      (c && 3 === c.which) ||
        (a(e).remove(),
        a(f).each(function () {
          var d = a(this),
            e = b(d),
            f = { relatedTarget: this };
          e.hasClass("open") &&
            ((c &&
              "click" == c.type &&
              /input|textarea/i.test(c.target.tagName) &&
              a.contains(e[0], c.target)) ||
              (e.trigger((c = a.Event("hide.bs.dropdown", f))),
              c.isDefaultPrevented() ||
                (d.attr("aria-expanded", "false"),
                e
                  .removeClass("open")
                  .trigger(a.Event("hidden.bs.dropdown", f)))));
        }));
    }
    function d(b) {
      return this.each(function () {
        var c = a(this),
          d = c.data("bs.dropdown");
        d || c.data("bs.dropdown", (d = new g(this))),
          "string" == typeof b && d[b].call(c);
      });
    }
    var e = ".dropdown-backdrop",
      f = '[data-toggle="dropdown"]',
      g = function (b) {
        a(b).on("click.bs.dropdown", this.toggle);
      };
    (g.VERSION = "3.3.6"),
      (g.prototype.toggle = function (d) {
        var e = a(this);
        if (!e.is(".disabled, :disabled")) {
          var f = b(e),
            g = f.hasClass("open");
          if ((c(), !g)) {
            "ontouchstart" in document.documentElement &&
              !f.closest(".navbar-nav").length &&
              a(document.createElement("div"))
                .addClass("dropdown-backdrop")
                .insertAfter(a(this))
                .on("click", c);
            var h = { relatedTarget: this };
            if (
              (f.trigger((d = a.Event("show.bs.dropdown", h))),
              d.isDefaultPrevented())
            )
              return;
            e.trigger("focus").attr("aria-expanded", "true"),
              f.toggleClass("open").trigger(a.Event("shown.bs.dropdown", h));
          }
          return !1;
        }
      }),
      (g.prototype.keydown = function (c) {
        if (
          /(38|40|27|32)/.test(c.which) &&
          !/input|textarea/i.test(c.target.tagName)
        ) {
          var d = a(this);
          if (
            (c.preventDefault(),
            c.stopPropagation(),
            !d.is(".disabled, :disabled"))
          ) {
            var e = b(d),
              g = e.hasClass("open");
            if ((!g && 27 != c.which) || (g && 27 == c.which))
              return (
                27 == c.which && e.find(f).trigger("focus"), d.trigger("click")
              );
            var h = " li:not(.disabled):visible a",
              i = e.find(".dropdown-menu" + h);
            if (i.length) {
              var j = i.index(c.target);
              38 == c.which && j > 0 && j--,
                40 == c.which && j < i.length - 1 && j++,
                ~j || (j = 0),
                i.eq(j).trigger("focus");
            }
          }
        }
      });
    var h = a.fn.dropdown;
    (a.fn.dropdown = d),
      (a.fn.dropdown.Constructor = g),
      (a.fn.dropdown.noConflict = function () {
        return (a.fn.dropdown = h), this;
      }),
      a(document)
        .on("click.bs.dropdown.data-api", c)
        .on("click.bs.dropdown.data-api", ".dropdown form", function (a) {
          a.stopPropagation();
        })
        .on("click.bs.dropdown.data-api", f, g.prototype.toggle)
        .on("keydown.bs.dropdown.data-api", f, g.prototype.keydown)
        .on(
          "keydown.bs.dropdown.data-api",
          ".dropdown-menu",
          g.prototype.keydown
        );
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b, d) {
      return this.each(function () {
        var e = a(this),
          f = e.data("bs.modal"),
          g = a.extend({}, c.DEFAULTS, e.data(), "object" == typeof b && b);
        f || e.data("bs.modal", (f = new c(this, g))),
          "string" == typeof b ? f[b](d) : g.show && f.show(d);
      });
    }
    var c = function (b, c) {
      (this.options = c),
        (this.$body = a(document.body)),
        (this.$element = a(b)),
        (this.$dialog = this.$element.find(".modal-dialog")),
        (this.$backdrop = null),
        (this.isShown = null),
        (this.originalBodyPad = null),
        (this.scrollbarWidth = 0),
        (this.ignoreBackdropClick = !1),
        this.options.remote &&
          this.$element.find(".modal-content").load(
            this.options.remote,
            a.proxy(function () {
              this.$element.trigger("loaded.bs.modal");
            }, this)
          );
    };
    (c.VERSION = "3.3.6"),
      (c.TRANSITION_DURATION = 300),
      (c.BACKDROP_TRANSITION_DURATION = 150),
      (c.DEFAULTS = { backdrop: !0, keyboard: !0, show: !0 }),
      (c.prototype.toggle = function (a) {
        return this.isShown ? this.hide() : this.show(a);
      }),
      (c.prototype.show = function (b) {
        var d = this,
          e = a.Event("show.bs.modal", { relatedTarget: b });
        this.$element.trigger(e),
          this.isShown ||
            e.isDefaultPrevented() ||
            ((this.isShown = !0),
            this.checkScrollbar(),
            this.setScrollbar(),
            this.$body.addClass("modal-open"),
            this.escape(),
            this.resize(),
            this.$element.on(
              "click.dismiss.bs.modal",
              '[data-dismiss="modal"]',
              a.proxy(this.hide, this)
            ),
            this.$dialog.on("mousedown.dismiss.bs.modal", function () {
              d.$element.one("mouseup.dismiss.bs.modal", function (b) {
                a(b.target).is(d.$element) && (d.ignoreBackdropClick = !0);
              });
            }),
            this.backdrop(function () {
              var e = a.support.transition && d.$element.hasClass("fade");
              d.$element.parent().length || d.$element.appendTo(d.$body),
                d.$element.show().scrollTop(0),
                d.adjustDialog(),
                e && d.$element[0].offsetWidth,
                d.$element.addClass("in"),
                d.enforceFocus();
              var f = a.Event("shown.bs.modal", { relatedTarget: b });
              e
                ? d.$dialog
                    .one("bsTransitionEnd", function () {
                      d.$element.trigger("focus").trigger(f);
                    })
                    .emulateTransitionEnd(c.TRANSITION_DURATION)
                : d.$element.trigger("focus").trigger(f);
            }));
      }),
      (c.prototype.hide = function (b) {
        b && b.preventDefault(),
          (b = a.Event("hide.bs.modal")),
          this.$element.trigger(b),
          this.isShown &&
            !b.isDefaultPrevented() &&
            ((this.isShown = !1),
            this.escape(),
            this.resize(),
            a(document).off("focusin.bs.modal"),
            this.$element
              .removeClass("in")
              .off("click.dismiss.bs.modal")
              .off("mouseup.dismiss.bs.modal"),
            this.$dialog.off("mousedown.dismiss.bs.modal"),
            a.support.transition && this.$element.hasClass("fade")
              ? this.$element
                  .one("bsTransitionEnd", a.proxy(this.hideModal, this))
                  .emulateTransitionEnd(c.TRANSITION_DURATION)
              : this.hideModal());
      }),
      (c.prototype.enforceFocus = function () {
        a(document)
          .off("focusin.bs.modal")
          .on(
            "focusin.bs.modal",
            a.proxy(function (a) {
              this.$element[0] === a.target ||
                this.$element.has(a.target).length ||
                this.$element.trigger("focus");
            }, this)
          );
      }),
      (c.prototype.escape = function () {
        this.isShown && this.options.keyboard
          ? this.$element.on(
              "keydown.dismiss.bs.modal",
              a.proxy(function (a) {
                27 == a.which && this.hide();
              }, this)
            )
          : this.isShown || this.$element.off("keydown.dismiss.bs.modal");
      }),
      (c.prototype.resize = function () {
        this.isShown
          ? a(window).on("resize.bs.modal", a.proxy(this.handleUpdate, this))
          : a(window).off("resize.bs.modal");
      }),
      (c.prototype.hideModal = function () {
        var a = this;
        this.$element.hide(),
          this.backdrop(function () {
            a.$body.removeClass("modal-open"),
              a.resetAdjustments(),
              a.resetScrollbar(),
              a.$element.trigger("hidden.bs.modal");
          });
      }),
      (c.prototype.removeBackdrop = function () {
        this.$backdrop && this.$backdrop.remove(), (this.$backdrop = null);
      }),
      (c.prototype.backdrop = function (b) {
        var d = this,
          e = this.$element.hasClass("fade") ? "fade" : "";
        if (this.isShown && this.options.backdrop) {
          var f = a.support.transition && e;
          if (
            ((this.$backdrop = a(document.createElement("div"))
              .addClass("modal-backdrop " + e)
              .appendTo(this.$body)),
            this.$element.on(
              "click.dismiss.bs.modal",
              a.proxy(function (a) {
                return this.ignoreBackdropClick
                  ? void (this.ignoreBackdropClick = !1)
                  : void (
                      a.target === a.currentTarget &&
                      ("static" == this.options.backdrop
                        ? this.$element[0].focus()
                        : this.hide())
                    );
              }, this)
            ),
            f && this.$backdrop[0].offsetWidth,
            this.$backdrop.addClass("in"),
            !b)
          )
            return;
          f
            ? this.$backdrop
                .one("bsTransitionEnd", b)
                .emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION)
            : b();
        } else if (!this.isShown && this.$backdrop) {
          this.$backdrop.removeClass("in");
          var g = function () {
            d.removeBackdrop(), b && b();
          };
          a.support.transition && this.$element.hasClass("fade")
            ? this.$backdrop
                .one("bsTransitionEnd", g)
                .emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION)
            : g();
        } else b && b();
      }),
      (c.prototype.handleUpdate = function () {
        this.adjustDialog();
      }),
      (c.prototype.adjustDialog = function () {
        var a =
          this.$element[0].scrollHeight > document.documentElement.clientHeight;
        this.$element.css({
          paddingLeft: !this.bodyIsOverflowing && a ? this.scrollbarWidth : "",
          paddingRight: this.bodyIsOverflowing && !a ? this.scrollbarWidth : "",
        });
      }),
      (c.prototype.resetAdjustments = function () {
        this.$element.css({ paddingLeft: "", paddingRight: "" });
      }),
      (c.prototype.checkScrollbar = function () {
        var a = window.innerWidth;
        if (!a) {
          var b = document.documentElement.getBoundingClientRect();
          a = b.right - Math.abs(b.left);
        }
        (this.bodyIsOverflowing = document.body.clientWidth < a),
          (this.scrollbarWidth = this.measureScrollbar());
      }),
      (c.prototype.setScrollbar = function () {
        var a = parseInt(this.$body.css("padding-right") || 0, 10);
        (this.originalBodyPad = document.body.style.paddingRight || ""),
          this.bodyIsOverflowing &&
            this.$body.css("padding-right", a + this.scrollbarWidth);
      }),
      (c.prototype.resetScrollbar = function () {
        this.$body.css("padding-right", this.originalBodyPad);
      }),
      (c.prototype.measureScrollbar = function () {
        var a = document.createElement("div");
        (a.className = "modal-scrollbar-measure"), this.$body.append(a);
        var b = a.offsetWidth - a.clientWidth;
        return this.$body[0].removeChild(a), b;
      });
    var d = a.fn.modal;
    (a.fn.modal = b),
      (a.fn.modal.Constructor = c),
      (a.fn.modal.noConflict = function () {
        return (a.fn.modal = d), this;
      }),
      a(document).on(
        "click.bs.modal.data-api",
        '[data-toggle="modal"]',
        function (c) {
          var d = a(this),
            e = d.attr("href"),
            f = a(
              d.attr("data-target") || (e && e.replace(/.*(?=#[^\s]+$)/, ""))
            ),
            g = f.data("bs.modal")
              ? "toggle"
              : a.extend({ remote: !/#/.test(e) && e }, f.data(), d.data());
          d.is("a") && c.preventDefault(),
            f.one("show.bs.modal", function (a) {
              a.isDefaultPrevented() ||
                f.one("hidden.bs.modal", function () {
                  d.is(":visible") && d.trigger("focus");
                });
            }),
            b.call(f, g, this);
        }
      );
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.tooltip"),
          f = "object" == typeof b && b;
        (e || !/destroy|hide/.test(b)) &&
          (e || d.data("bs.tooltip", (e = new c(this, f))),
          "string" == typeof b && e[b]());
      });
    }
    var c = function (a, b) {
      (this.type = null),
        (this.options = null),
        (this.enabled = null),
        (this.timeout = null),
        (this.hoverState = null),
        (this.$element = null),
        (this.inState = null),
        this.init("tooltip", a, b);
    };
    (c.VERSION = "3.3.6"),
      (c.TRANSITION_DURATION = 150),
      (c.DEFAULTS = {
        animation: !0,
        placement: "top",
        selector: !1,
        template:
          '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: !1,
        container: !1,
        viewport: { selector: "body", padding: 0 },
      }),
      (c.prototype.init = function (b, c, d) {
        if (
          ((this.enabled = !0),
          (this.type = b),
          (this.$element = a(c)),
          (this.options = this.getOptions(d)),
          (this.$viewport =
            this.options.viewport &&
            a(
              a.isFunction(this.options.viewport)
                ? this.options.viewport.call(this, this.$element)
                : this.options.viewport.selector || this.options.viewport
            )),
          (this.inState = { click: !1, hover: !1, focus: !1 }),
          this.$element[0] instanceof document.constructor &&
            !this.options.selector)
        )
          throw new Error(
            "`selector` option must be specified when initializing " +
              this.type +
              " on the window.document object!"
          );
        for (var e = this.options.trigger.split(" "), f = e.length; f--; ) {
          var g = e[f];
          if ("click" == g)
            this.$element.on(
              "click." + this.type,
              this.options.selector,
              a.proxy(this.toggle, this)
            );
          else if ("manual" != g) {
            var h = "hover" == g ? "mouseenter" : "focusin",
              i = "hover" == g ? "mouseleave" : "focusout";
            this.$element.on(
              h + "." + this.type,
              this.options.selector,
              a.proxy(this.enter, this)
            ),
              this.$element.on(
                i + "." + this.type,
                this.options.selector,
                a.proxy(this.leave, this)
              );
          }
        }
        this.options.selector
          ? (this._options = a.extend({}, this.options, {
              trigger: "manual",
              selector: "",
            }))
          : this.fixTitle();
      }),
      (c.prototype.getDefaults = function () {
        return c.DEFAULTS;
      }),
      (c.prototype.getOptions = function (b) {
        return (
          (b = a.extend({}, this.getDefaults(), this.$element.data(), b)),
          b.delay &&
            "number" == typeof b.delay &&
            (b.delay = { show: b.delay, hide: b.delay }),
          b
        );
      }),
      (c.prototype.getDelegateOptions = function () {
        var b = {},
          c = this.getDefaults();
        return (
          this._options &&
            a.each(this._options, function (a, d) {
              c[a] != d && (b[a] = d);
            }),
          b
        );
      }),
      (c.prototype.enter = function (b) {
        var c =
          b instanceof this.constructor
            ? b
            : a(b.currentTarget).data("bs." + this.type);
        return (
          c ||
            ((c = new this.constructor(
              b.currentTarget,
              this.getDelegateOptions()
            )),
            a(b.currentTarget).data("bs." + this.type, c)),
          b instanceof a.Event &&
            (c.inState["focusin" == b.type ? "focus" : "hover"] = !0),
          c.tip().hasClass("in") || "in" == c.hoverState
            ? void (c.hoverState = "in")
            : (clearTimeout(c.timeout),
              (c.hoverState = "in"),
              c.options.delay && c.options.delay.show
                ? void (c.timeout = setTimeout(function () {
                    "in" == c.hoverState && c.show();
                  }, c.options.delay.show))
                : c.show())
        );
      }),
      (c.prototype.isInStateTrue = function () {
        for (var a in this.inState) if (this.inState[a]) return !0;
        return !1;
      }),
      (c.prototype.leave = function (b) {
        var c =
          b instanceof this.constructor
            ? b
            : a(b.currentTarget).data("bs." + this.type);
        return (
          c ||
            ((c = new this.constructor(
              b.currentTarget,
              this.getDelegateOptions()
            )),
            a(b.currentTarget).data("bs." + this.type, c)),
          b instanceof a.Event &&
            (c.inState["focusout" == b.type ? "focus" : "hover"] = !1),
          c.isInStateTrue()
            ? void 0
            : (clearTimeout(c.timeout),
              (c.hoverState = "out"),
              c.options.delay && c.options.delay.hide
                ? void (c.timeout = setTimeout(function () {
                    "out" == c.hoverState && c.hide();
                  }, c.options.delay.hide))
                : c.hide())
        );
      }),
      (c.prototype.show = function () {
        var b = a.Event("show.bs." + this.type);
        if (this.hasContent() && this.enabled) {
          this.$element.trigger(b);
          var d = a.contains(
            this.$element[0].ownerDocument.documentElement,
            this.$element[0]
          );
          if (b.isDefaultPrevented() || !d) return;
          var e = this,
            f = this.tip(),
            g = this.getUID(this.type);
          this.setContent(),
            f.attr("id", g),
            this.$element.attr("aria-describedby", g),
            this.options.animation && f.addClass("fade");
          var h =
              "function" == typeof this.options.placement
                ? this.options.placement.call(this, f[0], this.$element[0])
                : this.options.placement,
            i = /\s?auto?\s?/i,
            j = i.test(h);
          j && (h = h.replace(i, "") || "top"),
            f
              .detach()
              .css({ top: 0, left: 0, display: "block" })
              .addClass(h)
              .data("bs." + this.type, this),
            this.options.container
              ? f.appendTo(this.options.container)
              : f.insertAfter(this.$element),
            this.$element.trigger("inserted.bs." + this.type);
          var k = this.getPosition(),
            l = f[0].offsetWidth,
            m = f[0].offsetHeight;
          if (j) {
            var n = h,
              o = this.getPosition(this.$viewport);
            (h =
              "bottom" == h && k.bottom + m > o.bottom
                ? "top"
                : "top" == h && k.top - m < o.top
                ? "bottom"
                : "right" == h && k.right + l > o.width
                ? "left"
                : "left" == h && k.left - l < o.left
                ? "right"
                : h),
              f.removeClass(n).addClass(h);
          }
          var p = this.getCalculatedOffset(h, k, l, m);
          this.applyPlacement(p, h);
          var q = function () {
            var a = e.hoverState;
            e.$element.trigger("shown.bs." + e.type),
              (e.hoverState = null),
              "out" == a && e.leave(e);
          };
          a.support.transition && this.$tip.hasClass("fade")
            ? f
                .one("bsTransitionEnd", q)
                .emulateTransitionEnd(c.TRANSITION_DURATION)
            : q();
        }
      }),
      (c.prototype.applyPlacement = function (b, c) {
        var d = this.tip(),
          e = d[0].offsetWidth,
          f = d[0].offsetHeight,
          g = parseInt(d.css("margin-top"), 10),
          h = parseInt(d.css("margin-left"), 10);
        isNaN(g) && (g = 0),
          isNaN(h) && (h = 0),
          (b.top += g),
          (b.left += h),
          a.offset.setOffset(
            d[0],
            a.extend(
              {
                using: function (a) {
                  d.css({ top: Math.round(a.top), left: Math.round(a.left) });
                },
              },
              b
            ),
            0
          ),
          d.addClass("in");
        var i = d[0].offsetWidth,
          j = d[0].offsetHeight;
        "top" == c && j != f && (b.top = b.top + f - j);
        var k = this.getViewportAdjustedDelta(c, b, i, j);
        k.left ? (b.left += k.left) : (b.top += k.top);
        var l = /top|bottom/.test(c),
          m = l ? 2 * k.left - e + i : 2 * k.top - f + j,
          n = l ? "offsetWidth" : "offsetHeight";
        d.offset(b), this.replaceArrow(m, d[0][n], l);
      }),
      (c.prototype.replaceArrow = function (a, b, c) {
        this.arrow()
          .css(c ? "left" : "top", 50 * (1 - a / b) + "%")
          .css(c ? "top" : "left", "");
      }),
      (c.prototype.setContent = function () {
        var a = this.tip(),
          b = this.getTitle();
        a.find(".tooltip-inner")[this.options.html ? "html" : "text"](b),
          a.removeClass("fade in top bottom left right");
      }),
      (c.prototype.hide = function (b) {
        function d() {
          "in" != e.hoverState && f.detach(),
            e.$element
              .removeAttr("aria-describedby")
              .trigger("hidden.bs." + e.type),
            b && b();
        }
        var e = this,
          f = a(this.$tip),
          g = a.Event("hide.bs." + this.type);
        return (
          this.$element.trigger(g),
          g.isDefaultPrevented()
            ? void 0
            : (f.removeClass("in"),
              a.support.transition && f.hasClass("fade")
                ? f
                    .one("bsTransitionEnd", d)
                    .emulateTransitionEnd(c.TRANSITION_DURATION)
                : d(),
              (this.hoverState = null),
              this)
        );
      }),
      (c.prototype.fixTitle = function () {
        var a = this.$element;
        (a.attr("title") || "string" != typeof a.attr("data-original-title")) &&
          a
            .attr("data-original-title", a.attr("title") || "")
            .attr("title", "");
      }),
      (c.prototype.hasContent = function () {
        return this.getTitle();
      }),
      (c.prototype.getPosition = function (b) {
        b = b || this.$element;
        var c = b[0],
          d = "BODY" == c.tagName,
          e = c.getBoundingClientRect();
        null == e.width &&
          (e = a.extend({}, e, {
            width: e.right - e.left,
            height: e.bottom - e.top,
          }));
        var f = d ? { top: 0, left: 0 } : b.offset(),
          g = {
            scroll: d
              ? document.documentElement.scrollTop || document.body.scrollTop
              : b.scrollTop(),
          },
          h = d
            ? { width: a(window).width(), height: a(window).height() }
            : null;
        return a.extend({}, e, g, h, f);
      }),
      (c.prototype.getCalculatedOffset = function (a, b, c, d) {
        return "bottom" == a
          ? { top: b.top + b.height, left: b.left + b.width / 2 - c / 2 }
          : "top" == a
          ? { top: b.top - d, left: b.left + b.width / 2 - c / 2 }
          : "left" == a
          ? { top: b.top + b.height / 2 - d / 2, left: b.left - c }
          : { top: b.top + b.height / 2 - d / 2, left: b.left + b.width };
      }),
      (c.prototype.getViewportAdjustedDelta = function (a, b, c, d) {
        var e = { top: 0, left: 0 };
        if (!this.$viewport) return e;
        var f = (this.options.viewport && this.options.viewport.padding) || 0,
          g = this.getPosition(this.$viewport);
        if (/right|left/.test(a)) {
          var h = b.top - f - g.scroll,
            i = b.top + f - g.scroll + d;
          h < g.top
            ? (e.top = g.top - h)
            : i > g.top + g.height && (e.top = g.top + g.height - i);
        } else {
          var j = b.left - f,
            k = b.left + f + c;
          j < g.left
            ? (e.left = g.left - j)
            : k > g.right && (e.left = g.left + g.width - k);
        }
        return e;
      }),
      (c.prototype.getTitle = function () {
        var a,
          b = this.$element,
          c = this.options;
        return (a =
          b.attr("data-original-title") ||
          ("function" == typeof c.title ? c.title.call(b[0]) : c.title));
      }),
      (c.prototype.getUID = function (a) {
        do a += ~~(1e6 * Math.random());
        while (document.getElementById(a));
        return a;
      }),
      (c.prototype.tip = function () {
        if (
          !this.$tip &&
          ((this.$tip = a(this.options.template)), 1 != this.$tip.length)
        )
          throw new Error(
            this.type +
              " `template` option must consist of exactly 1 top-level element!"
          );
        return this.$tip;
      }),
      (c.prototype.arrow = function () {
        return (this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow"));
      }),
      (c.prototype.enable = function () {
        this.enabled = !0;
      }),
      (c.prototype.disable = function () {
        this.enabled = !1;
      }),
      (c.prototype.toggleEnabled = function () {
        this.enabled = !this.enabled;
      }),
      (c.prototype.toggle = function (b) {
        var c = this;
        b &&
          ((c = a(b.currentTarget).data("bs." + this.type)),
          c ||
            ((c = new this.constructor(
              b.currentTarget,
              this.getDelegateOptions()
            )),
            a(b.currentTarget).data("bs." + this.type, c))),
          b
            ? ((c.inState.click = !c.inState.click),
              c.isInStateTrue() ? c.enter(c) : c.leave(c))
            : c.tip().hasClass("in")
            ? c.leave(c)
            : c.enter(c);
      }),
      (c.prototype.destroy = function () {
        var a = this;
        clearTimeout(this.timeout),
          this.hide(function () {
            a.$element.off("." + a.type).removeData("bs." + a.type),
              a.$tip && a.$tip.detach(),
              (a.$tip = null),
              (a.$arrow = null),
              (a.$viewport = null);
          });
      });
    var d = a.fn.tooltip;
    (a.fn.tooltip = b),
      (a.fn.tooltip.Constructor = c),
      (a.fn.tooltip.noConflict = function () {
        return (a.fn.tooltip = d), this;
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.popover"),
          f = "object" == typeof b && b;
        (e || !/destroy|hide/.test(b)) &&
          (e || d.data("bs.popover", (e = new c(this, f))),
          "string" == typeof b && e[b]());
      });
    }
    var c = function (a, b) {
      this.init("popover", a, b);
    };
    if (!a.fn.tooltip) throw new Error("Popover requires tooltip.js");
    (c.VERSION = "3.3.6"),
      (c.DEFAULTS = a.extend({}, a.fn.tooltip.Constructor.DEFAULTS, {
        placement: "right",
        trigger: "click",
        content: "",
        template:
          '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
      })),
      (c.prototype = a.extend({}, a.fn.tooltip.Constructor.prototype)),
      (c.prototype.constructor = c),
      (c.prototype.getDefaults = function () {
        return c.DEFAULTS;
      }),
      (c.prototype.setContent = function () {
        var a = this.tip(),
          b = this.getTitle(),
          c = this.getContent();
        a.find(".popover-title")[this.options.html ? "html" : "text"](b),
          a
            .find(".popover-content")
            .children()
            .detach()
            .end()
            [
              this.options.html
                ? "string" == typeof c
                  ? "html"
                  : "append"
                : "text"
            ](c),
          a.removeClass("fade top bottom left right in"),
          a.find(".popover-title").html() || a.find(".popover-title").hide();
      }),
      (c.prototype.hasContent = function () {
        return this.getTitle() || this.getContent();
      }),
      (c.prototype.getContent = function () {
        var a = this.$element,
          b = this.options;
        return (
          a.attr("data-content") ||
          ("function" == typeof b.content ? b.content.call(a[0]) : b.content)
        );
      }),
      (c.prototype.arrow = function () {
        return (this.$arrow = this.$arrow || this.tip().find(".arrow"));
      });
    var d = a.fn.popover;
    (a.fn.popover = b),
      (a.fn.popover.Constructor = c),
      (a.fn.popover.noConflict = function () {
        return (a.fn.popover = d), this;
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(c, d) {
      (this.$body = a(document.body)),
        (this.$scrollElement = a(a(c).is(document.body) ? window : c)),
        (this.options = a.extend({}, b.DEFAULTS, d)),
        (this.selector = (this.options.target || "") + " .nav li > a"),
        (this.offsets = []),
        (this.targets = []),
        (this.activeTarget = null),
        (this.scrollHeight = 0),
        this.$scrollElement.on(
          "scroll.bs.scrollspy",
          a.proxy(this.process, this)
        ),
        this.refresh(),
        this.process();
    }
    function c(c) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.scrollspy"),
          f = "object" == typeof c && c;
        e || d.data("bs.scrollspy", (e = new b(this, f))),
          "string" == typeof c && e[c]();
      });
    }
    (b.VERSION = "3.3.6"),
      (b.DEFAULTS = { offset: 10 }),
      (b.prototype.getScrollHeight = function () {
        return (
          this.$scrollElement[0].scrollHeight ||
          Math.max(
            this.$body[0].scrollHeight,
            document.documentElement.scrollHeight
          )
        );
      }),
      (b.prototype.refresh = function () {
        var b = this,
          c = "offset",
          d = 0;
        (this.offsets = []),
          (this.targets = []),
          (this.scrollHeight = this.getScrollHeight()),
          a.isWindow(this.$scrollElement[0]) ||
            ((c = "position"), (d = this.$scrollElement.scrollTop())),
          this.$body
            .find(this.selector)
            .map(function () {
              var b = a(this),
                e = b.data("target") || b.attr("href"),
                f = /^#./.test(e) && a(e);
              return (
                (f && f.length && f.is(":visible") && [[f[c]().top + d, e]]) ||
                null
              );
            })
            .sort(function (a, b) {
              return a[0] - b[0];
            })
            .each(function () {
              b.offsets.push(this[0]), b.targets.push(this[1]);
            });
      }),
      (b.prototype.process = function () {
        var a,
          b = this.$scrollElement.scrollTop() + this.options.offset,
          c = this.getScrollHeight(),
          d = this.options.offset + c - this.$scrollElement.height(),
          e = this.offsets,
          f = this.targets,
          g = this.activeTarget;
        if ((this.scrollHeight != c && this.refresh(), b >= d))
          return g != (a = f[f.length - 1]) && this.activate(a);
        if (g && b < e[0]) return (this.activeTarget = null), this.clear();
        for (a = e.length; a--; )
          g != f[a] &&
            b >= e[a] &&
            (void 0 === e[a + 1] || b < e[a + 1]) &&
            this.activate(f[a]);
      }),
      (b.prototype.activate = function (b) {
        (this.activeTarget = b), this.clear();
        var c =
            this.selector +
            '[data-target="' +
            b +
            '"],' +
            this.selector +
            '[href="' +
            b +
            '"]',
          d = a(c).parents("li").addClass("active");
        d.parent(".dropdown-menu").length &&
          (d = d.closest("li.dropdown").addClass("active")),
          d.trigger("activate.bs.scrollspy");
      }),
      (b.prototype.clear = function () {
        a(this.selector)
          .parentsUntil(this.options.target, ".active")
          .removeClass("active");
      });
    var d = a.fn.scrollspy;
    (a.fn.scrollspy = c),
      (a.fn.scrollspy.Constructor = b),
      (a.fn.scrollspy.noConflict = function () {
        return (a.fn.scrollspy = d), this;
      }),
      a(window).on("load.bs.scrollspy.data-api", function () {
        a('[data-spy="scroll"]').each(function () {
          var b = a(this);
          c.call(b, b.data());
        });
      });
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.tab");
        e || d.data("bs.tab", (e = new c(this))),
          "string" == typeof b && e[b]();
      });
    }
    var c = function (b) {
      this.element = a(b);
    };
    (c.VERSION = "3.3.6"),
      (c.TRANSITION_DURATION = 150),
      (c.prototype.show = function () {
        var b = this.element,
          c = b.closest("ul:not(.dropdown-menu)"),
          d = b.data("target");
        if (
          (d ||
            ((d = b.attr("href")), (d = d && d.replace(/.*(?=#[^\s]*$)/, ""))),
          !b.parent("li").hasClass("active"))
        ) {
          var e = c.find(".active:last a"),
            f = a.Event("hide.bs.tab", { relatedTarget: b[0] }),
            g = a.Event("show.bs.tab", { relatedTarget: e[0] });
          if (
            (e.trigger(f),
            b.trigger(g),
            !g.isDefaultPrevented() && !f.isDefaultPrevented())
          ) {
            var h = a(d);
            this.activate(b.closest("li"), c),
              this.activate(h, h.parent(), function () {
                e.trigger({ type: "hidden.bs.tab", relatedTarget: b[0] }),
                  b.trigger({ type: "shown.bs.tab", relatedTarget: e[0] });
              });
          }
        }
      }),
      (c.prototype.activate = function (b, d, e) {
        function f() {
          g
            .removeClass("active")
            .find("> .dropdown-menu > .active")
            .removeClass("active")
            .end()
            .find('[data-toggle="tab"]')
            .attr("aria-expanded", !1),
            b
              .addClass("active")
              .find('[data-toggle="tab"]')
              .attr("aria-expanded", !0),
            h ? (b[0].offsetWidth, b.addClass("in")) : b.removeClass("fade"),
            b.parent(".dropdown-menu").length &&
              b
                .closest("li.dropdown")
                .addClass("active")
                .end()
                .find('[data-toggle="tab"]')
                .attr("aria-expanded", !0),
            e && e();
        }
        var g = d.find("> .active"),
          h =
            e &&
            a.support.transition &&
            ((g.length && g.hasClass("fade")) || !!d.find("> .fade").length);
        g.length && h
          ? g
              .one("bsTransitionEnd", f)
              .emulateTransitionEnd(c.TRANSITION_DURATION)
          : f(),
          g.removeClass("in");
      });
    var d = a.fn.tab;
    (a.fn.tab = b),
      (a.fn.tab.Constructor = c),
      (a.fn.tab.noConflict = function () {
        return (a.fn.tab = d), this;
      });
    var e = function (c) {
      c.preventDefault(), b.call(a(this), "show");
    };
    a(document)
      .on("click.bs.tab.data-api", '[data-toggle="tab"]', e)
      .on("click.bs.tab.data-api", '[data-toggle="pill"]', e);
  })(jQuery),
  +(function (a) {
    "use strict";
    function b(b) {
      return this.each(function () {
        var d = a(this),
          e = d.data("bs.affix"),
          f = "object" == typeof b && b;
        e || d.data("bs.affix", (e = new c(this, f))),
          "string" == typeof b && e[b]();
      });
    }
    var c = function (b, d) {
      (this.options = a.extend({}, c.DEFAULTS, d)),
        (this.$target = a(this.options.target)
          .on("scroll.bs.affix.data-api", a.proxy(this.checkPosition, this))
          .on(
            "click.bs.affix.data-api",
            a.proxy(this.checkPositionWithEventLoop, this)
          )),
        (this.$element = a(b)),
        (this.affixed = null),
        (this.unpin = null),
        (this.pinnedOffset = null),
        this.checkPosition();
    };
    (c.VERSION = "3.3.6"),
      (c.RESET = "affix affix-top affix-bottom"),
      (c.DEFAULTS = { offset: 0, target: window }),
      (c.prototype.getState = function (a, b, c, d) {
        var e = this.$target.scrollTop(),
          f = this.$element.offset(),
          g = this.$target.height();
        if (null != c && "top" == this.affixed) return c > e ? "top" : !1;
        if ("bottom" == this.affixed)
          return null != c
            ? e + this.unpin <= f.top
              ? !1
              : "bottom"
            : a - d >= e + g
            ? !1
            : "bottom";
        var h = null == this.affixed,
          i = h ? e : f.top,
          j = h ? g : b;
        return null != c && c >= e
          ? "top"
          : null != d && i + j >= a - d
          ? "bottom"
          : !1;
      }),
      (c.prototype.getPinnedOffset = function () {
        if (this.pinnedOffset) return this.pinnedOffset;
        this.$element.removeClass(c.RESET).addClass("affix");
        var a = this.$target.scrollTop(),
          b = this.$element.offset();
        return (this.pinnedOffset = b.top - a);
      }),
      (c.prototype.checkPositionWithEventLoop = function () {
        setTimeout(a.proxy(this.checkPosition, this), 1);
      }),
      (c.prototype.checkPosition = function () {
        if (this.$element.is(":visible")) {
          var b = this.$element.height(),
            d = this.options.offset,
            e = d.top,
            f = d.bottom,
            g = Math.max(a(document).height(), a(document.body).height());
          "object" != typeof d && (f = e = d),
            "function" == typeof e && (e = d.top(this.$element)),
            "function" == typeof f && (f = d.bottom(this.$element));
          var h = this.getState(g, b, e, f);
          if (this.affixed != h) {
            null != this.unpin && this.$element.css("top", "");
            var i = "affix" + (h ? "-" + h : ""),
              j = a.Event(i + ".bs.affix");
            if ((this.$element.trigger(j), j.isDefaultPrevented())) return;
            (this.affixed = h),
              (this.unpin = "bottom" == h ? this.getPinnedOffset() : null),
              this.$element
                .removeClass(c.RESET)
                .addClass(i)
                .trigger(i.replace("affix", "affixed") + ".bs.affix");
          }
          "bottom" == h && this.$element.offset({ top: g - b - f });
        }
      });
    var d = a.fn.affix;
    (a.fn.affix = b),
      (a.fn.affix.Constructor = c),
      (a.fn.affix.noConflict = function () {
        return (a.fn.affix = d), this;
      }),
      a(window).on("load", function () {
        a('[data-spy="affix"]').each(function () {
          var c = a(this),
            d = c.data();
          (d.offset = d.offset || {}),
            null != d.offsetBottom && (d.offset.bottom = d.offsetBottom),
            null != d.offsetTop && (d.offset.top = d.offsetTop),
            b.call(c, d);
        });
      });
  })(jQuery);
!(function (a, b) {
  "object" == typeof exports && "object" == typeof module
    ? (module.exports = b())
    : "function" == typeof define && define.amd
    ? define([], b)
    : "object" == typeof exports
    ? (exports.Handlebars = b())
    : (a.Handlebars = b());
})(this, function () {
  return (function (a) {
    function b(d) {
      if (c[d]) return c[d].exports;
      var e = (c[d] = { exports: {}, id: d, loaded: !1 });
      return a[d].call(e.exports, e, e.exports, b), (e.loaded = !0), e.exports;
    }
    var c = {};
    return (b.m = a), (b.c = c), (b.p = ""), b(0);
  })([
    function (a, b, c) {
      "use strict";
      function d() {
        var a = r();
        return (
          (a.compile = function (b, c) {
            return k.compile(b, c, a);
          }),
          (a.precompile = function (b, c) {
            return k.precompile(b, c, a);
          }),
          (a.AST = i["default"]),
          (a.Compiler = k.Compiler),
          (a.JavaScriptCompiler = m["default"]),
          (a.Parser = j.parser),
          (a.parse = j.parse),
          a
        );
      }
      var e = c(1)["default"];
      b.__esModule = !0;
      var f = c(2),
        g = e(f),
        h = c(35),
        i = e(h),
        j = c(36),
        k = c(41),
        l = c(42),
        m = e(l),
        n = c(39),
        o = e(n),
        p = c(34),
        q = e(p),
        r = g["default"].create,
        s = d();
      (s.create = d),
        q["default"](s),
        (s.Visitor = o["default"]),
        (s["default"] = s),
        (b["default"] = s),
        (a.exports = b["default"]);
    },
    function (a, b) {
      "use strict";
      (b["default"] = function (a) {
        return a && a.__esModule ? a : { default: a };
      }),
        (b.__esModule = !0);
    },
    function (a, b, c) {
      "use strict";
      function d() {
        var a = new h.HandlebarsEnvironment();
        return (
          n.extend(a, h),
          (a.SafeString = j["default"]),
          (a.Exception = l["default"]),
          (a.Utils = n),
          (a.escapeExpression = n.escapeExpression),
          (a.VM = p),
          (a.template = function (b) {
            return p.template(b, a);
          }),
          a
        );
      }
      var e = c(3)["default"],
        f = c(1)["default"];
      b.__esModule = !0;
      var g = c(4),
        h = e(g),
        i = c(21),
        j = f(i),
        k = c(6),
        l = f(k),
        m = c(5),
        n = e(m),
        o = c(22),
        p = e(o),
        q = c(34),
        r = f(q),
        s = d();
      (s.create = d),
        r["default"](s),
        (s["default"] = s),
        (b["default"] = s),
        (a.exports = b["default"]);
    },
    function (a, b) {
      "use strict";
      (b["default"] = function (a) {
        if (a && a.__esModule) return a;
        var b = {};
        if (null != a)
          for (var c in a)
            Object.prototype.hasOwnProperty.call(a, c) && (b[c] = a[c]);
        return (b["default"] = a), b;
      }),
        (b.__esModule = !0);
    },
    function (a, b, c) {
      "use strict";
      function d(a, b, c) {
        (this.helpers = a || {}),
          (this.partials = b || {}),
          (this.decorators = c || {}),
          i.registerDefaultHelpers(this),
          j.registerDefaultDecorators(this);
      }
      var e = c(1)["default"];
      (b.__esModule = !0), (b.HandlebarsEnvironment = d);
      var f = c(5),
        g = c(6),
        h = e(g),
        i = c(10),
        j = c(18),
        k = c(20),
        l = e(k),
        m = "4.0.11";
      b.VERSION = m;
      var n = 7;
      b.COMPILER_REVISION = n;
      var o = {
        1: "<= 1.0.rc.2",
        2: "== 1.0.0-rc.3",
        3: "== 1.0.0-rc.4",
        4: "== 1.x.x",
        5: "== 2.0.0-alpha.x",
        6: ">= 2.0.0-beta.1",
        7: ">= 4.0.0",
      };
      b.REVISION_CHANGES = o;
      var p = "[object Object]";
      d.prototype = {
        constructor: d,
        logger: l["default"],
        log: l["default"].log,
        registerHelper: function (a, b) {
          if (f.toString.call(a) === p) {
            if (b)
              throw new h["default"]("Arg not supported with multiple helpers");
            f.extend(this.helpers, a);
          } else this.helpers[a] = b;
        },
        unregisterHelper: function (a) {
          delete this.helpers[a];
        },
        registerPartial: function (a, b) {
          if (f.toString.call(a) === p) f.extend(this.partials, a);
          else {
            if ("undefined" == typeof b)
              throw new h["default"](
                'Attempting to register a partial called "' +
                  a +
                  '" as undefined'
              );
            this.partials[a] = b;
          }
        },
        unregisterPartial: function (a) {
          delete this.partials[a];
        },
        registerDecorator: function (a, b) {
          if (f.toString.call(a) === p) {
            if (b)
              throw new h["default"](
                "Arg not supported with multiple decorators"
              );
            f.extend(this.decorators, a);
          } else this.decorators[a] = b;
        },
        unregisterDecorator: function (a) {
          delete this.decorators[a];
        },
      };
      var q = l["default"].log;
      (b.log = q), (b.createFrame = f.createFrame), (b.logger = l["default"]);
    },
    function (a, b) {
      "use strict";
      function c(a) {
        return k[a];
      }
      function d(a) {
        for (var b = 1; b < arguments.length; b++)
          for (var c in arguments[b])
            Object.prototype.hasOwnProperty.call(arguments[b], c) &&
              (a[c] = arguments[b][c]);
        return a;
      }
      function e(a, b) {
        for (var c = 0, d = a.length; c < d; c++) if (a[c] === b) return c;
        return -1;
      }
      function f(a) {
        if ("string" != typeof a) {
          if (a && a.toHTML) return a.toHTML();
          if (null == a) return "";
          if (!a) return a + "";
          a = "" + a;
        }
        return m.test(a) ? a.replace(l, c) : a;
      }
      function g(a) {
        return (!a && 0 !== a) || !(!p(a) || 0 !== a.length);
      }
      function h(a) {
        var b = d({}, a);
        return (b._parent = a), b;
      }
      function i(a, b) {
        return (a.path = b), a;
      }
      function j(a, b) {
        return (a ? a + "." : "") + b;
      }
      (b.__esModule = !0),
        (b.extend = d),
        (b.indexOf = e),
        (b.escapeExpression = f),
        (b.isEmpty = g),
        (b.createFrame = h),
        (b.blockParams = i),
        (b.appendContextPath = j);
      var k = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#x27;",
          "`": "&#x60;",
          "=": "&#x3D;",
        },
        l = /[&<>"'`=]/g,
        m = /[&<>"'`=]/,
        n = Object.prototype.toString;
      b.toString = n;
      var o = function (a) {
        return "function" == typeof a;
      };
      o(/x/) &&
        (b.isFunction = o =
          function (a) {
            return "function" == typeof a && "[object Function]" === n.call(a);
          }),
        (b.isFunction = o);
      var p =
        Array.isArray ||
        function (a) {
          return (
            !(!a || "object" != typeof a) && "[object Array]" === n.call(a)
          );
        };
      b.isArray = p;
    },
    function (a, b, c) {
      "use strict";
      function d(a, b) {
        var c = b && b.loc,
          g = void 0,
          h = void 0;
        c &&
          ((g = c.start.line),
          (h = c.start.column),
          (a += " - " + g + ":" + h));
        for (
          var i = Error.prototype.constructor.call(this, a), j = 0;
          j < f.length;
          j++
        )
          this[f[j]] = i[f[j]];
        Error.captureStackTrace && Error.captureStackTrace(this, d);
        try {
          c &&
            ((this.lineNumber = g),
            e
              ? Object.defineProperty(this, "column", {
                  value: h,
                  enumerable: !0,
                })
              : (this.column = h));
        } catch (k) {}
      }
      var e = c(7)["default"];
      b.__esModule = !0;
      var f = [
        "description",
        "fileName",
        "lineNumber",
        "message",
        "name",
        "number",
        "stack",
      ];
      (d.prototype = new Error()),
        (b["default"] = d),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      a.exports = { default: c(8), __esModule: !0 };
    },
    function (a, b, c) {
      var d = c(9);
      a.exports = function (a, b, c) {
        return d.setDesc(a, b, c);
      };
    },
    function (a, b) {
      var c = Object;
      a.exports = {
        create: c.create,
        getProto: c.getPrototypeOf,
        isEnum: {}.propertyIsEnumerable,
        getDesc: c.getOwnPropertyDescriptor,
        setDesc: c.defineProperty,
        setDescs: c.defineProperties,
        getKeys: c.keys,
        getNames: c.getOwnPropertyNames,
        getSymbols: c.getOwnPropertySymbols,
        each: [].forEach,
      };
    },
    function (a, b, c) {
      "use strict";
      function d(a) {
        g["default"](a),
          i["default"](a),
          k["default"](a),
          m["default"](a),
          o["default"](a),
          q["default"](a),
          s["default"](a);
      }
      var e = c(1)["default"];
      (b.__esModule = !0), (b.registerDefaultHelpers = d);
      var f = c(11),
        g = e(f),
        h = c(12),
        i = e(h),
        j = c(13),
        k = e(j),
        l = c(14),
        m = e(l),
        n = c(15),
        o = e(n),
        p = c(16),
        q = e(p),
        r = c(17),
        s = e(r);
    },
    function (a, b, c) {
      "use strict";
      b.__esModule = !0;
      var d = c(5);
      (b["default"] = function (a) {
        a.registerHelper("blockHelperMissing", function (b, c) {
          var e = c.inverse,
            f = c.fn;
          if (b === !0) return f(this);
          if (b === !1 || null == b) return e(this);
          if (d.isArray(b))
            return b.length > 0
              ? (c.ids && (c.ids = [c.name]), a.helpers.each(b, c))
              : e(this);
          if (c.data && c.ids) {
            var g = d.createFrame(c.data);
            (g.contextPath = d.appendContextPath(c.data.contextPath, c.name)),
              (c = { data: g });
          }
          return f(b, c);
        });
      }),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      var d = c(1)["default"];
      b.__esModule = !0;
      var e = c(5),
        f = c(6),
        g = d(f);
      (b["default"] = function (a) {
        a.registerHelper("each", function (a, b) {
          function c(b, c, f) {
            j &&
              ((j.key = b),
              (j.index = c),
              (j.first = 0 === c),
              (j.last = !!f),
              k && (j.contextPath = k + b)),
              (i += d(a[b], {
                data: j,
                blockParams: e.blockParams([a[b], b], [k + b, null]),
              }));
          }
          if (!b) throw new g["default"]("Must pass iterator to #each");
          var d = b.fn,
            f = b.inverse,
            h = 0,
            i = "",
            j = void 0,
            k = void 0;
          if (
            (b.data &&
              b.ids &&
              (k = e.appendContextPath(b.data.contextPath, b.ids[0]) + "."),
            e.isFunction(a) && (a = a.call(this)),
            b.data && (j = e.createFrame(b.data)),
            a && "object" == typeof a)
          )
            if (e.isArray(a))
              for (var l = a.length; h < l; h++)
                h in a && c(h, h, h === a.length - 1);
            else {
              var m = void 0;
              for (var n in a)
                a.hasOwnProperty(n) &&
                  (void 0 !== m && c(m, h - 1), (m = n), h++);
              void 0 !== m && c(m, h - 1, !0);
            }
          return 0 === h && (i = f(this)), i;
        });
      }),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      var d = c(1)["default"];
      b.__esModule = !0;
      var e = c(6),
        f = d(e);
      (b["default"] = function (a) {
        a.registerHelper("helperMissing", function () {
          if (1 !== arguments.length)
            throw new f["default"](
              'Missing helper: "' + arguments[arguments.length - 1].name + '"'
            );
        });
      }),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      b.__esModule = !0;
      var d = c(5);
      (b["default"] = function (a) {
        a.registerHelper("if", function (a, b) {
          return (
            d.isFunction(a) && (a = a.call(this)),
            (!b.hash.includeZero && !a) || d.isEmpty(a)
              ? b.inverse(this)
              : b.fn(this)
          );
        }),
        a.registerHelper('ifEqualsChained', function() {
          var options = arguments[arguments.length-1];
          // Assuming that all wanted operator are '||'
          var valueToTest=arguments[0];
          for (var i = 1; i < (arguments.length - 1); i++) {
            if (valueToTest === arguments[i]) {
              return options.fn(this);
            }
          }
          return options.inverse(this);
        }),
          a.registerHelper("unless", function (b, c) {
            return a.helpers["if"].call(this, b, {
              fn: c.inverse,
              inverse: c.fn,
              hash: c.hash,
            });
          });
      }),
        (a.exports = b["default"]);
    },
    function (a, b) {
      "use strict";
      (b.__esModule = !0),
        (b["default"] = function (a) {
          a.registerHelper("log", function () {
            for (
              var b = [void 0], c = arguments[arguments.length - 1], d = 0;
              d < arguments.length - 1;
              d++
            )
              b.push(arguments[d]);
            var e = 1;
            null != c.hash.level
              ? (e = c.hash.level)
              : c.data && null != c.data.level && (e = c.data.level),
              (b[0] = e),
              a.log.apply(a, b);
          });
        }),
        (a.exports = b["default"]);
    },
    function (a, b) {
      "use strict";
      (b.__esModule = !0),
        (b["default"] = function (a) {
          a.registerHelper("lookup", function (a, b) {
            return a && a[b];
          });
        }),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      b.__esModule = !0;
      var d = c(5);
      (b["default"] = function (a) {
        a.registerHelper("with", function (a, b) {
          d.isFunction(a) && (a = a.call(this));
          var c = b.fn;
          if (d.isEmpty(a)) return b.inverse(this);
          var e = b.data;
          return (
            b.data &&
              b.ids &&
              ((e = d.createFrame(b.data)),
              (e.contextPath = d.appendContextPath(
                b.data.contextPath,
                b.ids[0]
              ))),
            c(a, {
              data: e,
              blockParams: d.blockParams([a], [e && e.contextPath]),
            })
          );
        });
      }),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      function d(a) {
        g["default"](a);
      }
      var e = c(1)["default"];
      (b.__esModule = !0), (b.registerDefaultDecorators = d);
      var f = c(19),
        g = e(f);
    },
    function (a, b, c) {
      "use strict";
      b.__esModule = !0;
      var d = c(5);
      (b["default"] = function (a) {
        a.registerDecorator("inline", function (a, b, c, e) {
          var f = a;
          return (
            b.partials ||
              ((b.partials = {}),
              (f = function (e, f) {
                var g = c.partials;
                c.partials = d.extend({}, g, b.partials);
                var h = a(e, f);
                return (c.partials = g), h;
              })),
            (b.partials[e.args[0]] = e.fn),
            f
          );
        });
      }),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      b.__esModule = !0;
      var d = c(5),
        e = {
          methodMap: ["debug", "info", "warn", "error"],
          level: "info",
          lookupLevel: function (a) {
            if ("string" == typeof a) {
              var b = d.indexOf(e.methodMap, a.toLowerCase());
              a = b >= 0 ? b : parseInt(a, 10);
            }
            return a;
          },
          log: function (a) {
            if (
              ((a = e.lookupLevel(a)),
              "undefined" != typeof console && e.lookupLevel(e.level) <= a)
            ) {
              var b = e.methodMap[a];
              console[b] || (b = "log");
              for (
                var c = arguments.length, d = Array(c > 1 ? c - 1 : 0), f = 1;
                f < c;
                f++
              )
                d[f - 1] = arguments[f];
              console[b].apply(console, d);
            }
          },
        };
      (b["default"] = e), (a.exports = b["default"]);
    },
    function (a, b) {
      "use strict";
      function c(a) {
        this.string = a;
      }
      (b.__esModule = !0),
        (c.prototype.toString = c.prototype.toHTML =
          function () {
            return "" + this.string;
          }),
        (b["default"] = c),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      function d(a) {
        var b = (a && a[0]) || 1,
          c = s.COMPILER_REVISION;
        if (b !== c) {
          if (b < c) {
            var d = s.REVISION_CHANGES[c],
              e = s.REVISION_CHANGES[b];
            throw new r["default"](
              "Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" +
                d +
                ") or downgrade your runtime to an older version (" +
                e +
                ")."
            );
          }
          throw new r["default"](
            "Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" +
              a[1] +
              ")."
          );
        }
      }
      function e(a, b) {
        function c(c, d, e) {
          e.hash && ((d = p.extend({}, d, e.hash)), e.ids && (e.ids[0] = !0)),
            (c = b.VM.resolvePartial.call(this, c, d, e));
          var f = b.VM.invokePartial.call(this, c, d, e);
          if (
            (null == f &&
              b.compile &&
              ((e.partials[e.name] = b.compile(c, a.compilerOptions, b)),
              (f = e.partials[e.name](d, e))),
            null != f)
          ) {
            if (e.indent) {
              for (
                var g = f.split("\n"), h = 0, i = g.length;
                h < i && (g[h] || h + 1 !== i);
                h++
              )
                g[h] = e.indent + g[h];
              f = g.join("\n");
            }
            return f;
          }
          throw new r["default"](
            "The partial " +
              e.name +
              " could not be compiled when running in runtime-only mode"
          );
        }
        function d(b) {
          function c(b) {
            return "" + a.main(e, b, e.helpers, e.partials, g, i, h);
          }
          var f =
              arguments.length <= 1 || void 0 === arguments[1]
                ? {}
                : arguments[1],
            g = f.data;
          d._setup(f), !f.partial && a.useData && (g = j(b, g));
          var h = void 0,
            i = a.useBlockParams ? [] : void 0;
          return (
            a.useDepths &&
              (h = f.depths
                ? b != f.depths[0]
                  ? [b].concat(f.depths)
                  : f.depths
                : [b]),
            (c = k(a.main, c, e, f.depths || [], g, i))(b, f)
          );
        }
        if (!b) throw new r["default"]("No environment passed to template");
        if (!a || !a.main)
          throw new r["default"]("Unknown template object: " + typeof a);
        (a.main.decorator = a.main_d), b.VM.checkRevision(a.compiler);
        var e = {
          strict: function (a, b) {
            if (!(b in a))
              throw new r["default"]('"' + b + '" not defined in ' + a);
            return a[b];
          },
          lookup: function (a, b) {
            for (var c = a.length, d = 0; d < c; d++)
              if (a[d] && null != a[d][b]) return a[d][b];
          },
          lambda: function (a, b) {
            return "function" == typeof a ? a.call(b) : a;
          },
          escapeExpression: p.escapeExpression,
          invokePartial: c,
          fn: function (b) {
            var c = a[b];
            return (c.decorator = a[b + "_d"]), c;
          },
          programs: [],
          program: function (a, b, c, d, e) {
            var g = this.programs[a],
              h = this.fn(a);
            return (
              b || e || d || c
                ? (g = f(this, a, h, b, c, d, e))
                : g || (g = this.programs[a] = f(this, a, h)),
              g
            );
          },
          data: function (a, b) {
            for (; a && b--; ) a = a._parent;
            return a;
          },
          merge: function (a, b) {
            var c = a || b;
            return a && b && a !== b && (c = p.extend({}, b, a)), c;
          },
          nullContext: l({}),
          noop: b.VM.noop,
          compilerInfo: a.compiler,
        };
        return (
          (d.isTop = !0),
          (d._setup = function (c) {
            c.partial
              ? ((e.helpers = c.helpers),
                (e.partials = c.partials),
                (e.decorators = c.decorators))
              : ((e.helpers = e.merge(c.helpers, b.helpers)),
                a.usePartial && (e.partials = e.merge(c.partials, b.partials)),
                (a.usePartial || a.useDecorators) &&
                  (e.decorators = e.merge(c.decorators, b.decorators)));
          }),
          (d._child = function (b, c, d, g) {
            if (a.useBlockParams && !d)
              throw new r["default"]("must pass block params");
            if (a.useDepths && !g)
              throw new r["default"]("must pass parent depths");
            return f(e, b, a[b], c, 0, d, g);
          }),
          d
        );
      }
      function f(a, b, c, d, e, f, g) {
        function h(b) {
          var e =
              arguments.length <= 1 || void 0 === arguments[1]
                ? {}
                : arguments[1],
            h = g;
          return (
            !g ||
              b == g[0] ||
              (b === a.nullContext && null === g[0]) ||
              (h = [b].concat(g)),
            c(
              a,
              b,
              a.helpers,
              a.partials,
              e.data || d,
              f && [e.blockParams].concat(f),
              h
            )
          );
        }
        return (
          (h = k(c, h, a, g, d, f)),
          (h.program = b),
          (h.depth = g ? g.length : 0),
          (h.blockParams = e || 0),
          h
        );
      }
      function g(a, b, c) {
        return (
          a
            ? a.call || c.name || ((c.name = a), (a = c.partials[a]))
            : (a =
                "@partial-block" === c.name
                  ? c.data["partial-block"]
                  : c.partials[c.name]),
          a
        );
      }
      function h(a, b, c) {
        var d = c.data && c.data["partial-block"];
        (c.partial = !0),
          c.ids && (c.data.contextPath = c.ids[0] || c.data.contextPath);
        var e = void 0;
        if (
          (c.fn &&
            c.fn !== i &&
            !(function () {
              c.data = s.createFrame(c.data);
              var a = c.fn;
              (e = c.data["partial-block"] =
                function (b) {
                  var c =
                    arguments.length <= 1 || void 0 === arguments[1]
                      ? {}
                      : arguments[1];
                  return (
                    (c.data = s.createFrame(c.data)),
                    (c.data["partial-block"] = d),
                    a(b, c)
                  );
                }),
                a.partials &&
                  (c.partials = p.extend({}, c.partials, a.partials));
            })(),
          void 0 === a && e && (a = e),
          void 0 === a)
        )
          throw new r["default"](
            "The partial " + c.name + " could not be found"
          );
        if (a instanceof Function) return a(b, c);
      }
      function i() {
        return "";
      }
      function j(a, b) {
        return (
          (b && "root" in b) || ((b = b ? s.createFrame(b) : {}), (b.root = a)),
          b
        );
      }
      function k(a, b, c, d, e, f) {
        if (a.decorator) {
          var g = {};
          (b = a.decorator(b, g, c, d && d[0], e, f, d)), p.extend(b, g);
        }
        return b;
      }
      var l = c(23)["default"],
        m = c(3)["default"],
        n = c(1)["default"];
      (b.__esModule = !0),
        (b.checkRevision = d),
        (b.template = e),
        (b.wrapProgram = f),
        (b.resolvePartial = g),
        (b.invokePartial = h),
        (b.noop = i);
      var o = c(5),
        p = m(o),
        q = c(6),
        r = n(q),
        s = c(4);
    },
    function (a, b, c) {
      a.exports = { default: c(24), __esModule: !0 };
    },
    function (a, b, c) {
      c(25), (a.exports = c(30).Object.seal);
    },
    function (a, b, c) {
      var d = c(26);
      c(27)("seal", function (a) {
        return function (b) {
          return a && d(b) ? a(b) : b;
        };
      });
    },
    function (a, b) {
      a.exports = function (a) {
        return "object" == typeof a ? null !== a : "function" == typeof a;
      };
    },
    function (a, b, c) {
      var d = c(28),
        e = c(30),
        f = c(33);
      a.exports = function (a, b) {
        var c = (e.Object || {})[a] || Object[a],
          g = {};
        (g[a] = b(c)),
          d(
            d.S +
              d.F *
                f(function () {
                  c(1);
                }),
            "Object",
            g
          );
      };
    },
    function (a, b, c) {
      var d = c(29),
        e = c(30),
        f = c(31),
        g = "prototype",
        h = function (a, b, c) {
          var i,
            j,
            k,
            l = a & h.F,
            m = a & h.G,
            n = a & h.S,
            o = a & h.P,
            p = a & h.B,
            q = a & h.W,
            r = m ? e : e[b] || (e[b] = {}),
            s = m ? d : n ? d[b] : (d[b] || {})[g];
          m && (c = b);
          for (i in c)
            (j = !l && s && i in s),
              (j && i in r) ||
                ((k = j ? s[i] : c[i]),
                (r[i] =
                  m && "function" != typeof s[i]
                    ? c[i]
                    : p && j
                    ? f(k, d)
                    : q && s[i] == k
                    ? (function (a) {
                        var b = function (b) {
                          return this instanceof a ? new a(b) : a(b);
                        };
                        return (b[g] = a[g]), b;
                      })(k)
                    : o && "function" == typeof k
                    ? f(Function.call, k)
                    : k),
                o && ((r[g] || (r[g] = {}))[i] = k));
        };
      (h.F = 1),
        (h.G = 2),
        (h.S = 4),
        (h.P = 8),
        (h.B = 16),
        (h.W = 32),
        (a.exports = h);
    },
    function (a, b) {
      var c = (a.exports =
        "undefined" != typeof window && window.Math == Math
          ? window
          : "undefined" != typeof self && self.Math == Math
          ? self
          : Function("return this")());
      "number" == typeof __g && (__g = c);
    },
    function (a, b) {
      var c = (a.exports = { version: "1.2.6" });
      "number" == typeof __e && (__e = c);
    },
    function (a, b, c) {
      var d = c(32);
      a.exports = function (a, b, c) {
        if ((d(a), void 0 === b)) return a;
        switch (c) {
          case 1:
            return function (c) {
              return a.call(b, c);
            };
          case 2:
            return function (c, d) {
              return a.call(b, c, d);
            };
          case 3:
            return function (c, d, e) {
              return a.call(b, c, d, e);
            };
        }
        return function () {
          return a.apply(b, arguments);
        };
      };
    },
    function (a, b) {
      a.exports = function (a) {
        if ("function" != typeof a) throw TypeError(a + " is not a function!");
        return a;
      };
    },
    function (a, b) {
      a.exports = function (a) {
        try {
          return !!a();
        } catch (b) {
          return !0;
        }
      };
    },
    function (a, b) {
      (function (c) {
        "use strict";
        (b.__esModule = !0),
          (b["default"] = function (a) {
            var b = "undefined" != typeof c ? c : window,
              d = b.Handlebars;
            a.noConflict = function () {
              return b.Handlebars === a && (b.Handlebars = d), a;
            };
          }),
          (a.exports = b["default"]);
      }.call(
        b,
        (function () {
          return this;
        })()
      ));
    },
    function (a, b) {
      "use strict";
      b.__esModule = !0;
      var c = {
        helpers: {
          helperExpression: function (a) {
            return (
              "SubExpression" === a.type ||
              (("MustacheStatement" === a.type ||
                "BlockStatement" === a.type) &&
                !!((a.params && a.params.length) || a.hash))
            );
          },
          scopedId: function (a) {
            return /^\.|this\b/.test(a.original);
          },
          simpleId: function (a) {
            return 1 === a.parts.length && !c.helpers.scopedId(a) && !a.depth;
          },
        },
      };
      (b["default"] = c), (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      function d(a, b) {
        if ("Program" === a.type) return a;
        (h["default"].yy = n),
          (n.locInfo = function (a) {
            return new n.SourceLocation(b && b.srcName, a);
          });
        var c = new j["default"](b);
        return c.accept(h["default"].parse(a));
      }
      var e = c(1)["default"],
        f = c(3)["default"];
      (b.__esModule = !0), (b.parse = d);
      var g = c(37),
        h = e(g),
        i = c(38),
        j = e(i),
        k = c(40),
        l = f(k),
        m = c(5);
      b.parser = h["default"];
      var n = {};
      m.extend(n, l);
    },
    function (a, b) {
      "use strict";
      b.__esModule = !0;
      var c = (function () {
        function a() {
          this.yy = {};
        }
        var b = {
            trace: function () {},
            yy: {},
            symbols_: {
              error: 2,
              root: 3,
              program: 4,
              EOF: 5,
              program_repetition0: 6,
              statement: 7,
              mustache: 8,
              block: 9,
              rawBlock: 10,
              partial: 11,
              partialBlock: 12,
              content: 13,
              COMMENT: 14,
              CONTENT: 15,
              openRawBlock: 16,
              rawBlock_repetition_plus0: 17,
              END_RAW_BLOCK: 18,
              OPEN_RAW_BLOCK: 19,
              helperName: 20,
              openRawBlock_repetition0: 21,
              openRawBlock_option0: 22,
              CLOSE_RAW_BLOCK: 23,
              openBlock: 24,
              block_option0: 25,
              closeBlock: 26,
              openInverse: 27,
              block_option1: 28,
              OPEN_BLOCK: 29,
              openBlock_repetition0: 30,
              openBlock_option0: 31,
              openBlock_option1: 32,
              CLOSE: 33,
              OPEN_INVERSE: 34,
              openInverse_repetition0: 35,
              openInverse_option0: 36,
              openInverse_option1: 37,
              openInverseChain: 38,
              OPEN_INVERSE_CHAIN: 39,
              openInverseChain_repetition0: 40,
              openInverseChain_option0: 41,
              openInverseChain_option1: 42,
              inverseAndProgram: 43,
              INVERSE: 44,
              inverseChain: 45,
              inverseChain_option0: 46,
              OPEN_ENDBLOCK: 47,
              OPEN: 48,
              mustache_repetition0: 49,
              mustache_option0: 50,
              OPEN_UNESCAPED: 51,
              mustache_repetition1: 52,
              mustache_option1: 53,
              CLOSE_UNESCAPED: 54,
              OPEN_PARTIAL: 55,
              partialName: 56,
              partial_repetition0: 57,
              partial_option0: 58,
              openPartialBlock: 59,
              OPEN_PARTIAL_BLOCK: 60,
              openPartialBlock_repetition0: 61,
              openPartialBlock_option0: 62,
              param: 63,
              sexpr: 64,
              OPEN_SEXPR: 65,
              sexpr_repetition0: 66,
              sexpr_option0: 67,
              CLOSE_SEXPR: 68,
              hash: 69,
              hash_repetition_plus0: 70,
              hashSegment: 71,
              ID: 72,
              EQUALS: 73,
              blockParams: 74,
              OPEN_BLOCK_PARAMS: 75,
              blockParams_repetition_plus0: 76,
              CLOSE_BLOCK_PARAMS: 77,
              path: 78,
              dataName: 79,
              STRING: 80,
              NUMBER: 81,
              BOOLEAN: 82,
              UNDEFINED: 83,
              NULL: 84,
              DATA: 85,
              pathSegments: 86,
              SEP: 87,
              $accept: 0,
              $end: 1,
            },
            terminals_: {
              2: "error",
              5: "EOF",
              14: "COMMENT",
              15: "CONTENT",
              18: "END_RAW_BLOCK",
              19: "OPEN_RAW_BLOCK",
              23: "CLOSE_RAW_BLOCK",
              29: "OPEN_BLOCK",
              33: "CLOSE",
              34: "OPEN_INVERSE",
              39: "OPEN_INVERSE_CHAIN",
              44: "INVERSE",
              47: "OPEN_ENDBLOCK",
              48: "OPEN",
              51: "OPEN_UNESCAPED",
              54: "CLOSE_UNESCAPED",
              55: "OPEN_PARTIAL",
              60: "OPEN_PARTIAL_BLOCK",
              65: "OPEN_SEXPR",
              68: "CLOSE_SEXPR",
              72: "ID",
              73: "EQUALS",
              75: "OPEN_BLOCK_PARAMS",
              77: "CLOSE_BLOCK_PARAMS",
              80: "STRING",
              81: "NUMBER",
              82: "BOOLEAN",
              83: "UNDEFINED",
              84: "NULL",
              85: "DATA",
              87: "SEP",
            },
            productions_: [
              0,
              [3, 2],
              [4, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [13, 1],
              [10, 3],
              [16, 5],
              [9, 4],
              [9, 4],
              [24, 6],
              [27, 6],
              [38, 6],
              [43, 2],
              [45, 3],
              [45, 1],
              [26, 3],
              [8, 5],
              [8, 5],
              [11, 5],
              [12, 3],
              [59, 5],
              [63, 1],
              [63, 1],
              [64, 5],
              [69, 1],
              [71, 3],
              [74, 3],
              [20, 1],
              [20, 1],
              [20, 1],
              [20, 1],
              [20, 1],
              [20, 1],
              [20, 1],
              [56, 1],
              [56, 1],
              [79, 2],
              [78, 1],
              [86, 3],
              [86, 1],
              [6, 0],
              [6, 2],
              [17, 1],
              [17, 2],
              [21, 0],
              [21, 2],
              [22, 0],
              [22, 1],
              [25, 0],
              [25, 1],
              [28, 0],
              [28, 1],
              [30, 0],
              [30, 2],
              [31, 0],
              [31, 1],
              [32, 0],
              [32, 1],
              [35, 0],
              [35, 2],
              [36, 0],
              [36, 1],
              [37, 0],
              [37, 1],
              [40, 0],
              [40, 2],
              [41, 0],
              [41, 1],
              [42, 0],
              [42, 1],
              [46, 0],
              [46, 1],
              [49, 0],
              [49, 2],
              [50, 0],
              [50, 1],
              [52, 0],
              [52, 2],
              [53, 0],
              [53, 1],
              [57, 0],
              [57, 2],
              [58, 0],
              [58, 1],
              [61, 0],
              [61, 2],
              [62, 0],
              [62, 1],
              [66, 0],
              [66, 2],
              [67, 0],
              [67, 1],
              [70, 1],
              [70, 2],
              [76, 1],
              [76, 2],
            ],
            performAction: function (a, b, c, d, e, f, g) {
              var h = f.length - 1;
              switch (e) {
                case 1:
                  return f[h - 1];
                case 2:
                  this.$ = d.prepareProgram(f[h]);
                  break;
                case 3:
                  this.$ = f[h];
                  break;
                case 4:
                  this.$ = f[h];
                  break;
                case 5:
                  this.$ = f[h];
                  break;
                case 6:
                  this.$ = f[h];
                  break;
                case 7:
                  this.$ = f[h];
                  break;
                case 8:
                  this.$ = f[h];
                  break;
                case 9:
                  this.$ = {
                    type: "CommentStatement",
                    value: d.stripComment(f[h]),
                    strip: d.stripFlags(f[h], f[h]),
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 10:
                  this.$ = {
                    type: "ContentStatement",
                    original: f[h],
                    value: f[h],
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 11:
                  this.$ = d.prepareRawBlock(f[h - 2], f[h - 1], f[h], this._$);
                  break;
                case 12:
                  this.$ = { path: f[h - 3], params: f[h - 2], hash: f[h - 1] };
                  break;
                case 13:
                  this.$ = d.prepareBlock(
                    f[h - 3],
                    f[h - 2],
                    f[h - 1],
                    f[h],
                    !1,
                    this._$
                  );
                  break;
                case 14:
                  this.$ = d.prepareBlock(
                    f[h - 3],
                    f[h - 2],
                    f[h - 1],
                    f[h],
                    !0,
                    this._$
                  );
                  break;
                case 15:
                  this.$ = {
                    open: f[h - 5],
                    path: f[h - 4],
                    params: f[h - 3],
                    hash: f[h - 2],
                    blockParams: f[h - 1],
                    strip: d.stripFlags(f[h - 5], f[h]),
                  };
                  break;
                case 16:
                  this.$ = {
                    path: f[h - 4],
                    params: f[h - 3],
                    hash: f[h - 2],
                    blockParams: f[h - 1],
                    strip: d.stripFlags(f[h - 5], f[h]),
                  };
                  break;
                case 17:
                  this.$ = {
                    path: f[h - 4],
                    params: f[h - 3],
                    hash: f[h - 2],
                    blockParams: f[h - 1],
                    strip: d.stripFlags(f[h - 5], f[h]),
                  };
                  break;
                case 18:
                  this.$ = {
                    strip: d.stripFlags(f[h - 1], f[h - 1]),
                    program: f[h],
                  };
                  break;
                case 19:
                  var i = d.prepareBlock(
                      f[h - 2],
                      f[h - 1],
                      f[h],
                      f[h],
                      !1,
                      this._$
                    ),
                    j = d.prepareProgram([i], f[h - 1].loc);
                  (j.chained = !0),
                    (this.$ = { strip: f[h - 2].strip, program: j, chain: !0 });
                  break;
                case 20:
                  this.$ = f[h];
                  break;
                case 21:
                  this.$ = {
                    path: f[h - 1],
                    strip: d.stripFlags(f[h - 2], f[h]),
                  };
                  break;
                case 22:
                  this.$ = d.prepareMustache(
                    f[h - 3],
                    f[h - 2],
                    f[h - 1],
                    f[h - 4],
                    d.stripFlags(f[h - 4], f[h]),
                    this._$
                  );
                  break;
                case 23:
                  this.$ = d.prepareMustache(
                    f[h - 3],
                    f[h - 2],
                    f[h - 1],
                    f[h - 4],
                    d.stripFlags(f[h - 4], f[h]),
                    this._$
                  );
                  break;
                case 24:
                  this.$ = {
                    type: "PartialStatement",
                    name: f[h - 3],
                    params: f[h - 2],
                    hash: f[h - 1],
                    indent: "",
                    strip: d.stripFlags(f[h - 4], f[h]),
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 25:
                  this.$ = d.preparePartialBlock(
                    f[h - 2],
                    f[h - 1],
                    f[h],
                    this._$
                  );
                  break;
                case 26:
                  this.$ = {
                    path: f[h - 3],
                    params: f[h - 2],
                    hash: f[h - 1],
                    strip: d.stripFlags(f[h - 4], f[h]),
                  };
                  break;
                case 27:
                  this.$ = f[h];
                  break;
                case 28:
                  this.$ = f[h];
                  break;
                case 29:
                  this.$ = {
                    type: "SubExpression",
                    path: f[h - 3],
                    params: f[h - 2],
                    hash: f[h - 1],
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 30:
                  this.$ = {
                    type: "Hash",
                    pairs: f[h],
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 31:
                  this.$ = {
                    type: "HashPair",
                    key: d.id(f[h - 2]),
                    value: f[h],
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 32:
                  this.$ = d.id(f[h - 1]);
                  break;
                case 33:
                  this.$ = f[h];
                  break;
                case 34:
                  this.$ = f[h];
                  break;
                case 35:
                  this.$ = {
                    type: "StringLiteral",
                    value: f[h],
                    original: f[h],
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 36:
                  this.$ = {
                    type: "NumberLiteral",
                    value: Number(f[h]),
                    original: Number(f[h]),
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 37:
                  this.$ = {
                    type: "BooleanLiteral",
                    value: "true" === f[h],
                    original: "true" === f[h],
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 38:
                  this.$ = {
                    type: "UndefinedLiteral",
                    original: void 0,
                    value: void 0,
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 39:
                  this.$ = {
                    type: "NullLiteral",
                    original: null,
                    value: null,
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 40:
                  this.$ = f[h];
                  break;
                case 41:
                  this.$ = f[h];
                  break;
                case 42:
                  this.$ = d.preparePath(!0, f[h], this._$);
                  break;
                case 43:
                  this.$ = d.preparePath(!1, f[h], this._$);
                  break;
                case 44:
                  f[h - 2].push({
                    part: d.id(f[h]),
                    original: f[h],
                    separator: f[h - 1],
                  }),
                    (this.$ = f[h - 2]);
                  break;
                case 45:
                  this.$ = [{ part: d.id(f[h]), original: f[h] }];
                  break;
                case 46:
                  this.$ = [];
                  break;
                case 47:
                  f[h - 1].push(f[h]);
                  break;
                case 48:
                  this.$ = [f[h]];
                  break;
                case 49:
                  f[h - 1].push(f[h]);
                  break;
                case 50:
                  this.$ = [];
                  break;
                case 51:
                  f[h - 1].push(f[h]);
                  break;
                case 58:
                  this.$ = [];
                  break;
                case 59:
                  f[h - 1].push(f[h]);
                  break;
                case 64:
                  this.$ = [];
                  break;
                case 65:
                  f[h - 1].push(f[h]);
                  break;
                case 70:
                  this.$ = [];
                  break;
                case 71:
                  f[h - 1].push(f[h]);
                  break;
                case 78:
                  this.$ = [];
                  break;
                case 79:
                  f[h - 1].push(f[h]);
                  break;
                case 82:
                  this.$ = [];
                  break;
                case 83:
                  f[h - 1].push(f[h]);
                  break;
                case 86:
                  this.$ = [];
                  break;
                case 87:
                  f[h - 1].push(f[h]);
                  break;
                case 90:
                  this.$ = [];
                  break;
                case 91:
                  f[h - 1].push(f[h]);
                  break;
                case 94:
                  this.$ = [];
                  break;
                case 95:
                  f[h - 1].push(f[h]);
                  break;
                case 98:
                  this.$ = [f[h]];
                  break;
                case 99:
                  f[h - 1].push(f[h]);
                  break;
                case 100:
                  this.$ = [f[h]];
                  break;
                case 101:
                  f[h - 1].push(f[h]);
              }
            },
            table: [
              {
                3: 1,
                4: 2,
                5: [2, 46],
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              { 1: [3] },
              { 5: [1, 4] },
              {
                5: [2, 2],
                7: 5,
                8: 6,
                9: 7,
                10: 8,
                11: 9,
                12: 10,
                13: 11,
                14: [1, 12],
                15: [1, 20],
                16: 17,
                19: [1, 23],
                24: 15,
                27: 16,
                29: [1, 21],
                34: [1, 22],
                39: [2, 2],
                44: [2, 2],
                47: [2, 2],
                48: [1, 13],
                51: [1, 14],
                55: [1, 18],
                59: 19,
                60: [1, 24],
              },
              { 1: [2, 1] },
              {
                5: [2, 47],
                14: [2, 47],
                15: [2, 47],
                19: [2, 47],
                29: [2, 47],
                34: [2, 47],
                39: [2, 47],
                44: [2, 47],
                47: [2, 47],
                48: [2, 47],
                51: [2, 47],
                55: [2, 47],
                60: [2, 47],
              },
              {
                5: [2, 3],
                14: [2, 3],
                15: [2, 3],
                19: [2, 3],
                29: [2, 3],
                34: [2, 3],
                39: [2, 3],
                44: [2, 3],
                47: [2, 3],
                48: [2, 3],
                51: [2, 3],
                55: [2, 3],
                60: [2, 3],
              },
              {
                5: [2, 4],
                14: [2, 4],
                15: [2, 4],
                19: [2, 4],
                29: [2, 4],
                34: [2, 4],
                39: [2, 4],
                44: [2, 4],
                47: [2, 4],
                48: [2, 4],
                51: [2, 4],
                55: [2, 4],
                60: [2, 4],
              },
              {
                5: [2, 5],
                14: [2, 5],
                15: [2, 5],
                19: [2, 5],
                29: [2, 5],
                34: [2, 5],
                39: [2, 5],
                44: [2, 5],
                47: [2, 5],
                48: [2, 5],
                51: [2, 5],
                55: [2, 5],
                60: [2, 5],
              },
              {
                5: [2, 6],
                14: [2, 6],
                15: [2, 6],
                19: [2, 6],
                29: [2, 6],
                34: [2, 6],
                39: [2, 6],
                44: [2, 6],
                47: [2, 6],
                48: [2, 6],
                51: [2, 6],
                55: [2, 6],
                60: [2, 6],
              },
              {
                5: [2, 7],
                14: [2, 7],
                15: [2, 7],
                19: [2, 7],
                29: [2, 7],
                34: [2, 7],
                39: [2, 7],
                44: [2, 7],
                47: [2, 7],
                48: [2, 7],
                51: [2, 7],
                55: [2, 7],
                60: [2, 7],
              },
              {
                5: [2, 8],
                14: [2, 8],
                15: [2, 8],
                19: [2, 8],
                29: [2, 8],
                34: [2, 8],
                39: [2, 8],
                44: [2, 8],
                47: [2, 8],
                48: [2, 8],
                51: [2, 8],
                55: [2, 8],
                60: [2, 8],
              },
              {
                5: [2, 9],
                14: [2, 9],
                15: [2, 9],
                19: [2, 9],
                29: [2, 9],
                34: [2, 9],
                39: [2, 9],
                44: [2, 9],
                47: [2, 9],
                48: [2, 9],
                51: [2, 9],
                55: [2, 9],
                60: [2, 9],
              },
              {
                20: 25,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 36,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                4: 37,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                39: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              {
                4: 38,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              { 13: 40, 15: [1, 20], 17: 39 },
              {
                20: 42,
                56: 41,
                64: 43,
                65: [1, 44],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                4: 45,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              {
                5: [2, 10],
                14: [2, 10],
                15: [2, 10],
                18: [2, 10],
                19: [2, 10],
                29: [2, 10],
                34: [2, 10],
                39: [2, 10],
                44: [2, 10],
                47: [2, 10],
                48: [2, 10],
                51: [2, 10],
                55: [2, 10],
                60: [2, 10],
              },
              {
                20: 46,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 47,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 48,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 42,
                56: 49,
                64: 43,
                65: [1, 44],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                33: [2, 78],
                49: 50,
                65: [2, 78],
                72: [2, 78],
                80: [2, 78],
                81: [2, 78],
                82: [2, 78],
                83: [2, 78],
                84: [2, 78],
                85: [2, 78],
              },
              {
                23: [2, 33],
                33: [2, 33],
                54: [2, 33],
                65: [2, 33],
                68: [2, 33],
                72: [2, 33],
                75: [2, 33],
                80: [2, 33],
                81: [2, 33],
                82: [2, 33],
                83: [2, 33],
                84: [2, 33],
                85: [2, 33],
              },
              {
                23: [2, 34],
                33: [2, 34],
                54: [2, 34],
                65: [2, 34],
                68: [2, 34],
                72: [2, 34],
                75: [2, 34],
                80: [2, 34],
                81: [2, 34],
                82: [2, 34],
                83: [2, 34],
                84: [2, 34],
                85: [2, 34],
              },
              {
                23: [2, 35],
                33: [2, 35],
                54: [2, 35],
                65: [2, 35],
                68: [2, 35],
                72: [2, 35],
                75: [2, 35],
                80: [2, 35],
                81: [2, 35],
                82: [2, 35],
                83: [2, 35],
                84: [2, 35],
                85: [2, 35],
              },
              {
                23: [2, 36],
                33: [2, 36],
                54: [2, 36],
                65: [2, 36],
                68: [2, 36],
                72: [2, 36],
                75: [2, 36],
                80: [2, 36],
                81: [2, 36],
                82: [2, 36],
                83: [2, 36],
                84: [2, 36],
                85: [2, 36],
              },
              {
                23: [2, 37],
                33: [2, 37],
                54: [2, 37],
                65: [2, 37],
                68: [2, 37],
                72: [2, 37],
                75: [2, 37],
                80: [2, 37],
                81: [2, 37],
                82: [2, 37],
                83: [2, 37],
                84: [2, 37],
                85: [2, 37],
              },
              {
                23: [2, 38],
                33: [2, 38],
                54: [2, 38],
                65: [2, 38],
                68: [2, 38],
                72: [2, 38],
                75: [2, 38],
                80: [2, 38],
                81: [2, 38],
                82: [2, 38],
                83: [2, 38],
                84: [2, 38],
                85: [2, 38],
              },
              {
                23: [2, 39],
                33: [2, 39],
                54: [2, 39],
                65: [2, 39],
                68: [2, 39],
                72: [2, 39],
                75: [2, 39],
                80: [2, 39],
                81: [2, 39],
                82: [2, 39],
                83: [2, 39],
                84: [2, 39],
                85: [2, 39],
              },
              {
                23: [2, 43],
                33: [2, 43],
                54: [2, 43],
                65: [2, 43],
                68: [2, 43],
                72: [2, 43],
                75: [2, 43],
                80: [2, 43],
                81: [2, 43],
                82: [2, 43],
                83: [2, 43],
                84: [2, 43],
                85: [2, 43],
                87: [1, 51],
              },
              { 72: [1, 35], 86: 52 },
              {
                23: [2, 45],
                33: [2, 45],
                54: [2, 45],
                65: [2, 45],
                68: [2, 45],
                72: [2, 45],
                75: [2, 45],
                80: [2, 45],
                81: [2, 45],
                82: [2, 45],
                83: [2, 45],
                84: [2, 45],
                85: [2, 45],
                87: [2, 45],
              },
              {
                52: 53,
                54: [2, 82],
                65: [2, 82],
                72: [2, 82],
                80: [2, 82],
                81: [2, 82],
                82: [2, 82],
                83: [2, 82],
                84: [2, 82],
                85: [2, 82],
              },
              {
                25: 54,
                38: 56,
                39: [1, 58],
                43: 57,
                44: [1, 59],
                45: 55,
                47: [2, 54],
              },
              { 28: 60, 43: 61, 44: [1, 59], 47: [2, 56] },
              { 13: 63, 15: [1, 20], 18: [1, 62] },
              { 15: [2, 48], 18: [2, 48] },
              {
                33: [2, 86],
                57: 64,
                65: [2, 86],
                72: [2, 86],
                80: [2, 86],
                81: [2, 86],
                82: [2, 86],
                83: [2, 86],
                84: [2, 86],
                85: [2, 86],
              },
              {
                33: [2, 40],
                65: [2, 40],
                72: [2, 40],
                80: [2, 40],
                81: [2, 40],
                82: [2, 40],
                83: [2, 40],
                84: [2, 40],
                85: [2, 40],
              },
              {
                33: [2, 41],
                65: [2, 41],
                72: [2, 41],
                80: [2, 41],
                81: [2, 41],
                82: [2, 41],
                83: [2, 41],
                84: [2, 41],
                85: [2, 41],
              },
              {
                20: 65,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              { 26: 66, 47: [1, 67] },
              {
                30: 68,
                33: [2, 58],
                65: [2, 58],
                72: [2, 58],
                75: [2, 58],
                80: [2, 58],
                81: [2, 58],
                82: [2, 58],
                83: [2, 58],
                84: [2, 58],
                85: [2, 58],
              },
              {
                33: [2, 64],
                35: 69,
                65: [2, 64],
                72: [2, 64],
                75: [2, 64],
                80: [2, 64],
                81: [2, 64],
                82: [2, 64],
                83: [2, 64],
                84: [2, 64],
                85: [2, 64],
              },
              {
                21: 70,
                23: [2, 50],
                65: [2, 50],
                72: [2, 50],
                80: [2, 50],
                81: [2, 50],
                82: [2, 50],
                83: [2, 50],
                84: [2, 50],
                85: [2, 50],
              },
              {
                33: [2, 90],
                61: 71,
                65: [2, 90],
                72: [2, 90],
                80: [2, 90],
                81: [2, 90],
                82: [2, 90],
                83: [2, 90],
                84: [2, 90],
                85: [2, 90],
              },
              {
                20: 75,
                33: [2, 80],
                50: 72,
                63: 73,
                64: 76,
                65: [1, 44],
                69: 74,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              { 72: [1, 80] },
              {
                23: [2, 42],
                33: [2, 42],
                54: [2, 42],
                65: [2, 42],
                68: [2, 42],
                72: [2, 42],
                75: [2, 42],
                80: [2, 42],
                81: [2, 42],
                82: [2, 42],
                83: [2, 42],
                84: [2, 42],
                85: [2, 42],
                87: [1, 51],
              },
              {
                20: 75,
                53: 81,
                54: [2, 84],
                63: 82,
                64: 76,
                65: [1, 44],
                69: 83,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              { 26: 84, 47: [1, 67] },
              { 47: [2, 55] },
              {
                4: 85,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                39: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              { 47: [2, 20] },
              {
                20: 86,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                4: 87,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              { 26: 88, 47: [1, 67] },
              { 47: [2, 57] },
              {
                5: [2, 11],
                14: [2, 11],
                15: [2, 11],
                19: [2, 11],
                29: [2, 11],
                34: [2, 11],
                39: [2, 11],
                44: [2, 11],
                47: [2, 11],
                48: [2, 11],
                51: [2, 11],
                55: [2, 11],
                60: [2, 11],
              },
              { 15: [2, 49], 18: [2, 49] },
              {
                20: 75,
                33: [2, 88],
                58: 89,
                63: 90,
                64: 76,
                65: [1, 44],
                69: 91,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                65: [2, 94],
                66: 92,
                68: [2, 94],
                72: [2, 94],
                80: [2, 94],
                81: [2, 94],
                82: [2, 94],
                83: [2, 94],
                84: [2, 94],
                85: [2, 94],
              },
              {
                5: [2, 25],
                14: [2, 25],
                15: [2, 25],
                19: [2, 25],
                29: [2, 25],
                34: [2, 25],
                39: [2, 25],
                44: [2, 25],
                47: [2, 25],
                48: [2, 25],
                51: [2, 25],
                55: [2, 25],
                60: [2, 25],
              },
              {
                20: 93,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 75,
                31: 94,
                33: [2, 60],
                63: 95,
                64: 76,
                65: [1, 44],
                69: 96,
                70: 77,
                71: 78,
                72: [1, 79],
                75: [2, 60],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 75,
                33: [2, 66],
                36: 97,
                63: 98,
                64: 76,
                65: [1, 44],
                69: 99,
                70: 77,
                71: 78,
                72: [1, 79],
                75: [2, 66],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 75,
                22: 100,
                23: [2, 52],
                63: 101,
                64: 76,
                65: [1, 44],
                69: 102,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 75,
                33: [2, 92],
                62: 103,
                63: 104,
                64: 76,
                65: [1, 44],
                69: 105,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              { 33: [1, 106] },
              {
                33: [2, 79],
                65: [2, 79],
                72: [2, 79],
                80: [2, 79],
                81: [2, 79],
                82: [2, 79],
                83: [2, 79],
                84: [2, 79],
                85: [2, 79],
              },
              { 33: [2, 81] },
              {
                23: [2, 27],
                33: [2, 27],
                54: [2, 27],
                65: [2, 27],
                68: [2, 27],
                72: [2, 27],
                75: [2, 27],
                80: [2, 27],
                81: [2, 27],
                82: [2, 27],
                83: [2, 27],
                84: [2, 27],
                85: [2, 27],
              },
              {
                23: [2, 28],
                33: [2, 28],
                54: [2, 28],
                65: [2, 28],
                68: [2, 28],
                72: [2, 28],
                75: [2, 28],
                80: [2, 28],
                81: [2, 28],
                82: [2, 28],
                83: [2, 28],
                84: [2, 28],
                85: [2, 28],
              },
              {
                23: [2, 30],
                33: [2, 30],
                54: [2, 30],
                68: [2, 30],
                71: 107,
                72: [1, 108],
                75: [2, 30],
              },
              {
                23: [2, 98],
                33: [2, 98],
                54: [2, 98],
                68: [2, 98],
                72: [2, 98],
                75: [2, 98],
              },
              {
                23: [2, 45],
                33: [2, 45],
                54: [2, 45],
                65: [2, 45],
                68: [2, 45],
                72: [2, 45],
                73: [1, 109],
                75: [2, 45],
                80: [2, 45],
                81: [2, 45],
                82: [2, 45],
                83: [2, 45],
                84: [2, 45],
                85: [2, 45],
                87: [2, 45],
              },
              {
                23: [2, 44],
                33: [2, 44],
                54: [2, 44],
                65: [2, 44],
                68: [2, 44],
                72: [2, 44],
                75: [2, 44],
                80: [2, 44],
                81: [2, 44],
                82: [2, 44],
                83: [2, 44],
                84: [2, 44],
                85: [2, 44],
                87: [2, 44],
              },
              { 54: [1, 110] },
              {
                54: [2, 83],
                65: [2, 83],
                72: [2, 83],
                80: [2, 83],
                81: [2, 83],
                82: [2, 83],
                83: [2, 83],
                84: [2, 83],
                85: [2, 83],
              },
              { 54: [2, 85] },
              {
                5: [2, 13],
                14: [2, 13],
                15: [2, 13],
                19: [2, 13],
                29: [2, 13],
                34: [2, 13],
                39: [2, 13],
                44: [2, 13],
                47: [2, 13],
                48: [2, 13],
                51: [2, 13],
                55: [2, 13],
                60: [2, 13],
              },
              {
                38: 56,
                39: [1, 58],
                43: 57,
                44: [1, 59],
                45: 112,
                46: 111,
                47: [2, 76],
              },
              {
                33: [2, 70],
                40: 113,
                65: [2, 70],
                72: [2, 70],
                75: [2, 70],
                80: [2, 70],
                81: [2, 70],
                82: [2, 70],
                83: [2, 70],
                84: [2, 70],
                85: [2, 70],
              },
              { 47: [2, 18] },
              {
                5: [2, 14],
                14: [2, 14],
                15: [2, 14],
                19: [2, 14],
                29: [2, 14],
                34: [2, 14],
                39: [2, 14],
                44: [2, 14],
                47: [2, 14],
                48: [2, 14],
                51: [2, 14],
                55: [2, 14],
                60: [2, 14],
              },
              { 33: [1, 114] },
              {
                33: [2, 87],
                65: [2, 87],
                72: [2, 87],
                80: [2, 87],
                81: [2, 87],
                82: [2, 87],
                83: [2, 87],
                84: [2, 87],
                85: [2, 87],
              },
              { 33: [2, 89] },
              {
                20: 75,
                63: 116,
                64: 76,
                65: [1, 44],
                67: 115,
                68: [2, 96],
                69: 117,
                70: 77,
                71: 78,
                72: [1, 79],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              { 33: [1, 118] },
              { 32: 119, 33: [2, 62], 74: 120, 75: [1, 121] },
              {
                33: [2, 59],
                65: [2, 59],
                72: [2, 59],
                75: [2, 59],
                80: [2, 59],
                81: [2, 59],
                82: [2, 59],
                83: [2, 59],
                84: [2, 59],
                85: [2, 59],
              },
              { 33: [2, 61], 75: [2, 61] },
              { 33: [2, 68], 37: 122, 74: 123, 75: [1, 121] },
              {
                33: [2, 65],
                65: [2, 65],
                72: [2, 65],
                75: [2, 65],
                80: [2, 65],
                81: [2, 65],
                82: [2, 65],
                83: [2, 65],
                84: [2, 65],
                85: [2, 65],
              },
              { 33: [2, 67], 75: [2, 67] },
              { 23: [1, 124] },
              {
                23: [2, 51],
                65: [2, 51],
                72: [2, 51],
                80: [2, 51],
                81: [2, 51],
                82: [2, 51],
                83: [2, 51],
                84: [2, 51],
                85: [2, 51],
              },
              { 23: [2, 53] },
              { 33: [1, 125] },
              {
                33: [2, 91],
                65: [2, 91],
                72: [2, 91],
                80: [2, 91],
                81: [2, 91],
                82: [2, 91],
                83: [2, 91],
                84: [2, 91],
                85: [2, 91],
              },
              { 33: [2, 93] },
              {
                5: [2, 22],
                14: [2, 22],
                15: [2, 22],
                19: [2, 22],
                29: [2, 22],
                34: [2, 22],
                39: [2, 22],
                44: [2, 22],
                47: [2, 22],
                48: [2, 22],
                51: [2, 22],
                55: [2, 22],
                60: [2, 22],
              },
              {
                23: [2, 99],
                33: [2, 99],
                54: [2, 99],
                68: [2, 99],
                72: [2, 99],
                75: [2, 99],
              },
              { 73: [1, 109] },
              {
                20: 75,
                63: 126,
                64: 76,
                65: [1, 44],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                5: [2, 23],
                14: [2, 23],
                15: [2, 23],
                19: [2, 23],
                29: [2, 23],
                34: [2, 23],
                39: [2, 23],
                44: [2, 23],
                47: [2, 23],
                48: [2, 23],
                51: [2, 23],
                55: [2, 23],
                60: [2, 23],
              },
              { 47: [2, 19] },
              { 47: [2, 77] },
              {
                20: 75,
                33: [2, 72],
                41: 127,
                63: 128,
                64: 76,
                65: [1, 44],
                69: 129,
                70: 77,
                71: 78,
                72: [1, 79],
                75: [2, 72],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                5: [2, 24],
                14: [2, 24],
                15: [2, 24],
                19: [2, 24],
                29: [2, 24],
                34: [2, 24],
                39: [2, 24],
                44: [2, 24],
                47: [2, 24],
                48: [2, 24],
                51: [2, 24],
                55: [2, 24],
                60: [2, 24],
              },
              { 68: [1, 130] },
              {
                65: [2, 95],
                68: [2, 95],
                72: [2, 95],
                80: [2, 95],
                81: [2, 95],
                82: [2, 95],
                83: [2, 95],
                84: [2, 95],
                85: [2, 95],
              },
              { 68: [2, 97] },
              {
                5: [2, 21],
                14: [2, 21],
                15: [2, 21],
                19: [2, 21],
                29: [2, 21],
                34: [2, 21],
                39: [2, 21],
                44: [2, 21],
                47: [2, 21],
                48: [2, 21],
                51: [2, 21],
                55: [2, 21],
                60: [2, 21],
              },
              { 33: [1, 131] },
              { 33: [2, 63] },
              { 72: [1, 133], 76: 132 },
              { 33: [1, 134] },
              { 33: [2, 69] },
              { 15: [2, 12] },
              {
                14: [2, 26],
                15: [2, 26],
                19: [2, 26],
                29: [2, 26],
                34: [2, 26],
                47: [2, 26],
                48: [2, 26],
                51: [2, 26],
                55: [2, 26],
                60: [2, 26],
              },
              {
                23: [2, 31],
                33: [2, 31],
                54: [2, 31],
                68: [2, 31],
                72: [2, 31],
                75: [2, 31],
              },
              { 33: [2, 74], 42: 135, 74: 136, 75: [1, 121] },
              {
                33: [2, 71],
                65: [2, 71],
                72: [2, 71],
                75: [2, 71],
                80: [2, 71],
                81: [2, 71],
                82: [2, 71],
                83: [2, 71],
                84: [2, 71],
                85: [2, 71],
              },
              { 33: [2, 73], 75: [2, 73] },
              {
                23: [2, 29],
                33: [2, 29],
                54: [2, 29],
                65: [2, 29],
                68: [2, 29],
                72: [2, 29],
                75: [2, 29],
                80: [2, 29],
                81: [2, 29],
                82: [2, 29],
                83: [2, 29],
                84: [2, 29],
                85: [2, 29],
              },
              {
                14: [2, 15],
                15: [2, 15],
                19: [2, 15],
                29: [2, 15],
                34: [2, 15],
                39: [2, 15],
                44: [2, 15],
                47: [2, 15],
                48: [2, 15],
                51: [2, 15],
                55: [2, 15],
                60: [2, 15],
              },
              { 72: [1, 138], 77: [1, 137] },
              { 72: [2, 100], 77: [2, 100] },
              {
                14: [2, 16],
                15: [2, 16],
                19: [2, 16],
                29: [2, 16],
                34: [2, 16],
                44: [2, 16],
                47: [2, 16],
                48: [2, 16],
                51: [2, 16],
                55: [2, 16],
                60: [2, 16],
              },
              { 33: [1, 139] },
              { 33: [2, 75] },
              { 33: [2, 32] },
              { 72: [2, 101], 77: [2, 101] },
              {
                14: [2, 17],
                15: [2, 17],
                19: [2, 17],
                29: [2, 17],
                34: [2, 17],
                39: [2, 17],
                44: [2, 17],
                47: [2, 17],
                48: [2, 17],
                51: [2, 17],
                55: [2, 17],
                60: [2, 17],
              },
            ],
            defaultActions: {
              4: [2, 1],
              55: [2, 55],
              57: [2, 20],
              61: [2, 57],
              74: [2, 81],
              83: [2, 85],
              87: [2, 18],
              91: [2, 89],
              102: [2, 53],
              105: [2, 93],
              111: [2, 19],
              112: [2, 77],
              117: [2, 97],
              120: [2, 63],
              123: [2, 69],
              124: [2, 12],
              136: [2, 75],
              137: [2, 32],
            },
            parseError: function (a, b) {
              throw new Error(a);
            },
            parse: function (a) {
              function b() {
                var a;
                return (
                  (a = c.lexer.lex() || 1),
                  "number" != typeof a && (a = c.symbols_[a] || a),
                  a
                );
              }
              var c = this,
                d = [0],
                e = [null],
                f = [],
                g = this.table,
                h = "",
                i = 0,
                j = 0,
                k = 0;
              this.lexer.setInput(a),
                (this.lexer.yy = this.yy),
                (this.yy.lexer = this.lexer),
                (this.yy.parser = this),
                "undefined" == typeof this.lexer.yylloc &&
                  (this.lexer.yylloc = {});
              var l = this.lexer.yylloc;
              f.push(l);
              var m = this.lexer.options && this.lexer.options.ranges;
              "function" == typeof this.yy.parseError &&
                (this.parseError = this.yy.parseError);
              for (var n, o, p, q, r, s, t, u, v, w = {}; ; ) {
                if (
                  ((p = d[d.length - 1]),
                  this.defaultActions[p]
                    ? (q = this.defaultActions[p])
                    : ((null !== n && "undefined" != typeof n) || (n = b()),
                      (q = g[p] && g[p][n])),
                  "undefined" == typeof q || !q.length || !q[0])
                ) {
                  var x = "";
                  if (!k) {
                    v = [];
                    for (s in g[p])
                      this.terminals_[s] &&
                        s > 2 &&
                        v.push("'" + this.terminals_[s] + "'");
                    (x = this.lexer.showPosition
                      ? "Parse error on line " +
                        (i + 1) +
                        ":\n" +
                        this.lexer.showPosition() +
                        "\nExpecting " +
                        v.join(", ") +
                        ", got '" +
                        (this.terminals_[n] || n) +
                        "'"
                      : "Parse error on line " +
                        (i + 1) +
                        ": Unexpected " +
                        (1 == n
                          ? "end of input"
                          : "'" + (this.terminals_[n] || n) + "'")),
                      this.parseError(x, {
                        text: this.lexer.match,
                        token: this.terminals_[n] || n,
                        line: this.lexer.yylineno,
                        loc: l,
                        expected: v,
                      });
                  }
                }
                if (q[0] instanceof Array && q.length > 1)
                  throw new Error(
                    "Parse Error: multiple actions possible at state: " +
                      p +
                      ", token: " +
                      n
                  );
                switch (q[0]) {
                  case 1:
                    d.push(n),
                      e.push(this.lexer.yytext),
                      f.push(this.lexer.yylloc),
                      d.push(q[1]),
                      (n = null),
                      o
                        ? ((n = o), (o = null))
                        : ((j = this.lexer.yyleng),
                          (h = this.lexer.yytext),
                          (i = this.lexer.yylineno),
                          (l = this.lexer.yylloc),
                          k > 0 && k--);
                    break;
                  case 2:
                    if (
                      ((t = this.productions_[q[1]][1]),
                      (w.$ = e[e.length - t]),
                      (w._$ = {
                        first_line: f[f.length - (t || 1)].first_line,
                        last_line: f[f.length - 1].last_line,
                        first_column: f[f.length - (t || 1)].first_column,
                        last_column: f[f.length - 1].last_column,
                      }),
                      m &&
                        (w._$.range = [
                          f[f.length - (t || 1)].range[0],
                          f[f.length - 1].range[1],
                        ]),
                      (r = this.performAction.call(
                        w,
                        h,
                        j,
                        i,
                        this.yy,
                        q[1],
                        e,
                        f
                      )),
                      "undefined" != typeof r)
                    )
                      return r;
                    t &&
                      ((d = d.slice(0, -1 * t * 2)),
                      (e = e.slice(0, -1 * t)),
                      (f = f.slice(0, -1 * t))),
                      d.push(this.productions_[q[1]][0]),
                      e.push(w.$),
                      f.push(w._$),
                      (u = g[d[d.length - 2]][d[d.length - 1]]),
                      d.push(u);
                    break;
                  case 3:
                    return !0;
                }
              }
              return !0;
            },
          },
          c = (function () {
            var a = {
              EOF: 1,
              parseError: function (a, b) {
                if (!this.yy.parser) throw new Error(a);
                this.yy.parser.parseError(a, b);
              },
              setInput: function (a) {
                return (
                  (this._input = a),
                  (this._more = this._less = this.done = !1),
                  (this.yylineno = this.yyleng = 0),
                  (this.yytext = this.matched = this.match = ""),
                  (this.conditionStack = ["INITIAL"]),
                  (this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                  }),
                  this.options.ranges && (this.yylloc.range = [0, 0]),
                  (this.offset = 0),
                  this
                );
              },
              input: function () {
                var a = this._input[0];
                (this.yytext += a),
                  this.yyleng++,
                  this.offset++,
                  (this.match += a),
                  (this.matched += a);
                var b = a.match(/(?:\r\n?|\n).*/g);
                return (
                  b
                    ? (this.yylineno++, this.yylloc.last_line++)
                    : this.yylloc.last_column++,
                  this.options.ranges && this.yylloc.range[1]++,
                  (this._input = this._input.slice(1)),
                  a
                );
              },
              unput: function (a) {
                var b = a.length,
                  c = a.split(/(?:\r\n?|\n)/g);
                (this._input = a + this._input),
                  (this.yytext = this.yytext.substr(
                    0,
                    this.yytext.length - b - 1
                  )),
                  (this.offset -= b);
                var d = this.match.split(/(?:\r\n?|\n)/g);
                (this.match = this.match.substr(0, this.match.length - 1)),
                  (this.matched = this.matched.substr(
                    0,
                    this.matched.length - 1
                  )),
                  c.length - 1 && (this.yylineno -= c.length - 1);
                var e = this.yylloc.range;
                return (
                  (this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: c
                      ? (c.length === d.length ? this.yylloc.first_column : 0) +
                        d[d.length - c.length].length -
                        c[0].length
                      : this.yylloc.first_column - b,
                  }),
                  this.options.ranges &&
                    (this.yylloc.range = [e[0], e[0] + this.yyleng - b]),
                  this
                );
              },
              more: function () {
                return (this._more = !0), this;
              },
              less: function (a) {
                this.unput(this.match.slice(a));
              },
              pastInput: function () {
                var a = this.matched.substr(
                  0,
                  this.matched.length - this.match.length
                );
                return (
                  (a.length > 20 ? "..." : "") +
                  a.substr(-20).replace(/\n/g, "")
                );
              },
              upcomingInput: function () {
                var a = this.match;
                return (
                  a.length < 20 && (a += this._input.substr(0, 20 - a.length)),
                  (a.substr(0, 20) + (a.length > 20 ? "..." : "")).replace(
                    /\n/g,
                    ""
                  )
                );
              },
              showPosition: function () {
                var a = this.pastInput(),
                  b = new Array(a.length + 1).join("-");
                return a + this.upcomingInput() + "\n" + b + "^";
              },
              next: function () {
                if (this.done) return this.EOF;
                this._input || (this.done = !0);
                var a, b, c, d, e;
                this._more || ((this.yytext = ""), (this.match = ""));
                for (
                  var f = this._currentRules(), g = 0;
                  g < f.length &&
                  ((c = this._input.match(this.rules[f[g]])),
                  !c ||
                    (b && !(c[0].length > b[0].length)) ||
                    ((b = c), (d = g), this.options.flex));
                  g++
                );
                return b
                  ? ((e = b[0].match(/(?:\r\n?|\n).*/g)),
                    e && (this.yylineno += e.length),
                    (this.yylloc = {
                      first_line: this.yylloc.last_line,
                      last_line: this.yylineno + 1,
                      first_column: this.yylloc.last_column,
                      last_column: e
                        ? e[e.length - 1].length -
                          e[e.length - 1].match(/\r?\n?/)[0].length
                        : this.yylloc.last_column + b[0].length,
                    }),
                    (this.yytext += b[0]),
                    (this.match += b[0]),
                    (this.matches = b),
                    (this.yyleng = this.yytext.length),
                    this.options.ranges &&
                      (this.yylloc.range = [
                        this.offset,
                        (this.offset += this.yyleng),
                      ]),
                    (this._more = !1),
                    (this._input = this._input.slice(b[0].length)),
                    (this.matched += b[0]),
                    (a = this.performAction.call(
                      this,
                      this.yy,
                      this,
                      f[d],
                      this.conditionStack[this.conditionStack.length - 1]
                    )),
                    this.done && this._input && (this.done = !1),
                    a ? a : void 0)
                  : "" === this._input
                  ? this.EOF
                  : this.parseError(
                      "Lexical error on line " +
                        (this.yylineno + 1) +
                        ". Unrecognized text.\n" +
                        this.showPosition(),
                      { text: "", token: null, line: this.yylineno }
                    );
              },
              lex: function () {
                var a = this.next();
                return "undefined" != typeof a ? a : this.lex();
              },
              begin: function (a) {
                this.conditionStack.push(a);
              },
              popState: function () {
                return this.conditionStack.pop();
              },
              _currentRules: function () {
                return this.conditions[
                  this.conditionStack[this.conditionStack.length - 1]
                ].rules;
              },
              topState: function () {
                return this.conditionStack[this.conditionStack.length - 2];
              },
              pushState: function (a) {
                this.begin(a);
              },
            };
            return (
              (a.options = {}),
              (a.performAction = function (a, b, c, d) {
                function e(a, c) {
                  return (b.yytext = b.yytext.substr(a, b.yyleng - c));
                }
                switch (c) {
                  case 0:
                    if (
                      ("\\\\" === b.yytext.slice(-2)
                        ? (e(0, 1), this.begin("mu"))
                        : "\\" === b.yytext.slice(-1)
                        ? (e(0, 1), this.begin("emu"))
                        : this.begin("mu"),
                      b.yytext)
                    )
                      return 15;
                    break;
                  case 1:
                    return 15;
                  case 2:
                    return this.popState(), 15;
                  case 3:
                    return this.begin("raw"), 15;
                  case 4:
                    return (
                      this.popState(),
                      "raw" ===
                      this.conditionStack[this.conditionStack.length - 1]
                        ? 15
                        : ((b.yytext = b.yytext.substr(5, b.yyleng - 9)),
                          "END_RAW_BLOCK")
                    );
                  case 5:
                    return 15;
                  case 6:
                    return this.popState(), 14;
                  case 7:
                    return 65;
                  case 8:
                    return 68;
                  case 9:
                    return 19;
                  case 10:
                    return this.popState(), this.begin("raw"), 23;
                  case 11:
                    return 55;
                  case 12:
                    return 60;
                  case 13:
                    return 29;
                  case 14:
                    return 47;
                  case 15:
                    return this.popState(), 44;
                  case 16:
                    return this.popState(), 44;
                  case 17:
                    return 34;
                  case 18:
                    return 39;
                  case 19:
                    return 51;
                  case 20:
                    return 48;
                  case 21:
                    this.unput(b.yytext), this.popState(), this.begin("com");
                    break;
                  case 22:
                    return this.popState(), 14;
                  case 23:
                    return 48;
                  case 24:
                    return 73;
                  case 25:
                    return 72;
                  case 26:
                    return 72;
                  case 27:
                    return 87;
                  case 28:
                    break;
                  case 29:
                    return this.popState(), 54;
                  case 30:
                    return this.popState(), 33;
                  case 31:
                    return (b.yytext = e(1, 2).replace(/\\"/g, '"')), 80;
                  case 32:
                    return (b.yytext = e(1, 2).replace(/\\'/g, "'")), 80;
                  case 33:
                    return 85;
                  case 34:
                    return 82;
                  case 35:
                    return 82;
                  case 36:
                    return 83;
                  case 37:
                    return 84;
                  case 38:
                    return 81;
                  case 39:
                    return 75;
                  case 40:
                    return 77;
                  case 41:
                    return 72;
                  case 42:
                    return (
                      (b.yytext = b.yytext.replace(/\\([\\\]])/g, "$1")), 72
                    );
                  case 43:
                    return "INVALID";
                  case 44:
                    return 5;
                }
              }),
              (a.rules = [
                /^(?:[^\x00]*?(?=(\{\{)))/,
                /^(?:[^\x00]+)/,
                /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
                /^(?:\{\{\{\{(?=[^\/]))/,
                /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,
                /^(?:[^\x00]*?(?=(\{\{\{\{)))/,
                /^(?:[\s\S]*?--(~)?\}\})/,
                /^(?:\()/,
                /^(?:\))/,
                /^(?:\{\{\{\{)/,
                /^(?:\}\}\}\})/,
                /^(?:\{\{(~)?>)/,
                /^(?:\{\{(~)?#>)/,
                /^(?:\{\{(~)?#\*?)/,
                /^(?:\{\{(~)?\/)/,
                /^(?:\{\{(~)?\^\s*(~)?\}\})/,
                /^(?:\{\{(~)?\s*else\s*(~)?\}\})/,
                /^(?:\{\{(~)?\^)/,
                /^(?:\{\{(~)?\s*else\b)/,
                /^(?:\{\{(~)?\{)/,
                /^(?:\{\{(~)?&)/,
                /^(?:\{\{(~)?!--)/,
                /^(?:\{\{(~)?![\s\S]*?\}\})/,
                /^(?:\{\{(~)?\*?)/,
                /^(?:=)/,
                /^(?:\.\.)/,
                /^(?:\.(?=([=~}\s\/.)|])))/,
                /^(?:[\/.])/,
                /^(?:\s+)/,
                /^(?:\}(~)?\}\})/,
                /^(?:(~)?\}\})/,
                /^(?:"(\\["]|[^"])*")/,
                /^(?:'(\\[']|[^'])*')/,
                /^(?:@)/,
                /^(?:true(?=([~}\s)])))/,
                /^(?:false(?=([~}\s)])))/,
                /^(?:undefined(?=([~}\s)])))/,
                /^(?:null(?=([~}\s)])))/,
                /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,
                /^(?:as\s+\|)/,
                /^(?:\|)/,
                /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,
                /^(?:\[(\\\]|[^\]])*\])/,
                /^(?:.)/,
                /^(?:$)/,
              ]),
              (a.conditions = {
                mu: {
                  rules: [
                    7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
                    23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
                    38, 39, 40, 41, 42, 43, 44,
                  ],
                  inclusive: !1,
                },
                emu: { rules: [2], inclusive: !1 },
                com: { rules: [6], inclusive: !1 },
                raw: { rules: [3, 4, 5], inclusive: !1 },
                INITIAL: { rules: [0, 1, 44], inclusive: !0 },
              }),
              a
            );
          })();
        return (b.lexer = c), (a.prototype = b), (b.Parser = a), new a();
      })();
      (b["default"] = c), (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      function d() {
        var a =
          arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0];
        this.options = a;
      }
      function e(a, b, c) {
        void 0 === b && (b = a.length);
        var d = a[b - 1],
          e = a[b - 2];
        return d
          ? "ContentStatement" === d.type
            ? (e || !c ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(d.original)
            : void 0
          : c;
      }
      function f(a, b, c) {
        void 0 === b && (b = -1);
        var d = a[b + 1],
          e = a[b + 2];
        return d
          ? "ContentStatement" === d.type
            ? (e || !c ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(d.original)
            : void 0
          : c;
      }
      function g(a, b, c) {
        var d = a[null == b ? 0 : b + 1];
        if (d && "ContentStatement" === d.type && (c || !d.rightStripped)) {
          var e = d.value;
          (d.value = d.value.replace(c ? /^\s+/ : /^[ \t]*\r?\n?/, "")),
            (d.rightStripped = d.value !== e);
        }
      }
      function h(a, b, c) {
        var d = a[null == b ? a.length - 1 : b - 1];
        if (d && "ContentStatement" === d.type && (c || !d.leftStripped)) {
          var e = d.value;
          return (
            (d.value = d.value.replace(c ? /\s+$/ : /[ \t]+$/, "")),
            (d.leftStripped = d.value !== e),
            d.leftStripped
          );
        }
      }
      var i = c(1)["default"];
      b.__esModule = !0;
      var j = c(39),
        k = i(j);
      (d.prototype = new k["default"]()),
        (d.prototype.Program = function (a) {
          var b = !this.options.ignoreStandalone,
            c = !this.isRootSeen;
          this.isRootSeen = !0;
          for (var d = a.body, i = 0, j = d.length; i < j; i++) {
            var k = d[i],
              l = this.accept(k);
            if (l) {
              var m = e(d, i, c),
                n = f(d, i, c),
                o = l.openStandalone && m,
                p = l.closeStandalone && n,
                q = l.inlineStandalone && m && n;
              l.close && g(d, i, !0),
                l.open && h(d, i, !0),
                b &&
                  q &&
                  (g(d, i),
                  h(d, i) &&
                    "PartialStatement" === k.type &&
                    (k.indent = /([ \t]+$)/.exec(d[i - 1].original)[1])),
                b && o && (g((k.program || k.inverse).body), h(d, i)),
                b && p && (g(d, i), h((k.inverse || k.program).body));
            }
          }
          return a;
        }),
        (d.prototype.BlockStatement =
          d.prototype.DecoratorBlock =
          d.prototype.PartialBlockStatement =
            function (a) {
              this.accept(a.program), this.accept(a.inverse);
              var b = a.program || a.inverse,
                c = a.program && a.inverse,
                d = c,
                i = c;
              if (c && c.chained)
                for (d = c.body[0].program; i.chained; )
                  i = i.body[i.body.length - 1].program;
              var j = {
                open: a.openStrip.open,
                close: a.closeStrip.close,
                openStandalone: f(b.body),
                closeStandalone: e((d || b).body),
              };
              if ((a.openStrip.close && g(b.body, null, !0), c)) {
                var k = a.inverseStrip;
                k.open && h(b.body, null, !0),
                  k.close && g(d.body, null, !0),
                  a.closeStrip.open && h(i.body, null, !0),
                  !this.options.ignoreStandalone &&
                    e(b.body) &&
                    f(d.body) &&
                    (h(b.body), g(d.body));
              } else a.closeStrip.open && h(b.body, null, !0);
              return j;
            }),
        (d.prototype.Decorator = d.prototype.MustacheStatement =
          function (a) {
            return a.strip;
          }),
        (d.prototype.PartialStatement = d.prototype.CommentStatement =
          function (a) {
            var b = a.strip || {};
            return { inlineStandalone: !0, open: b.open, close: b.close };
          }),
        (b["default"] = d),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      function d() {
        this.parents = [];
      }
      function e(a) {
        this.acceptRequired(a, "path"),
          this.acceptArray(a.params),
          this.acceptKey(a, "hash");
      }
      function f(a) {
        e.call(this, a),
          this.acceptKey(a, "program"),
          this.acceptKey(a, "inverse");
      }
      function g(a) {
        this.acceptRequired(a, "name"),
          this.acceptArray(a.params),
          this.acceptKey(a, "hash");
      }
      var h = c(1)["default"];
      b.__esModule = !0;
      var i = c(6),
        j = h(i);
      (d.prototype = {
        constructor: d,
        mutating: !1,
        acceptKey: function (a, b) {
          var c = this.accept(a[b]);
          if (this.mutating) {
            if (c && !d.prototype[c.type])
              throw new j["default"](
                'Unexpected node type "' +
                  c.type +
                  '" found when accepting ' +
                  b +
                  " on " +
                  a.type
              );
            a[b] = c;
          }
        },
        acceptRequired: function (a, b) {
          if ((this.acceptKey(a, b), !a[b]))
            throw new j["default"](a.type + " requires " + b);
        },
        acceptArray: function (a) {
          for (var b = 0, c = a.length; b < c; b++)
            this.acceptKey(a, b), a[b] || (a.splice(b, 1), b--, c--);
        },
        accept: function (a) {
          if (a) {
            if (!this[a.type])
              throw new j["default"]("Unknown type: " + a.type, a);
            this.current && this.parents.unshift(this.current),
              (this.current = a);
            var b = this[a.type](a);
            return (
              (this.current = this.parents.shift()),
              !this.mutating || b ? b : b !== !1 ? a : void 0
            );
          }
        },
        Program: function (a) {
          this.acceptArray(a.body);
        },
        MustacheStatement: e,
        Decorator: e,
        BlockStatement: f,
        DecoratorBlock: f,
        PartialStatement: g,
        PartialBlockStatement: function (a) {
          g.call(this, a), this.acceptKey(a, "program");
        },
        ContentStatement: function () {},
        CommentStatement: function () {},
        SubExpression: e,
        PathExpression: function () {},
        StringLiteral: function () {},
        NumberLiteral: function () {},
        BooleanLiteral: function () {},
        UndefinedLiteral: function () {},
        NullLiteral: function () {},
        Hash: function (a) {
          this.acceptArray(a.pairs);
        },
        HashPair: function (a) {
          this.acceptRequired(a, "value");
        },
      }),
        (b["default"] = d),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      function d(a, b) {
        if (((b = b.path ? b.path.original : b), a.path.original !== b)) {
          var c = { loc: a.path.loc };
          throw new q["default"](a.path.original + " doesn't match " + b, c);
        }
      }
      function e(a, b) {
        (this.source = a),
          (this.start = { line: b.first_line, column: b.first_column }),
          (this.end = { line: b.last_line, column: b.last_column });
      }
      function f(a) {
        return /^\[.*\]$/.test(a) ? a.substr(1, a.length - 2) : a;
      }
      function g(a, b) {
        return {
          open: "~" === a.charAt(2),
          close: "~" === b.charAt(b.length - 3),
        };
      }
      function h(a) {
        return a.replace(/^\{\{~?\!-?-?/, "").replace(/-?-?~?\}\}$/, "");
      }
      function i(a, b, c) {
        c = this.locInfo(c);
        for (
          var d = a ? "@" : "", e = [], f = 0, g = "", h = 0, i = b.length;
          h < i;
          h++
        ) {
          var j = b[h].part,
            k = b[h].original !== j;
          if (
            ((d += (b[h].separator || "") + j),
            k || (".." !== j && "." !== j && "this" !== j))
          )
            e.push(j);
          else {
            if (e.length > 0)
              throw new q["default"]("Invalid path: " + d, { loc: c });
            ".." === j && (f++, (g += "../"));
          }
        }
        return {
          type: "PathExpression",
          data: a,
          depth: f,
          parts: e,
          original: d,
          loc: c,
        };
      }
      function j(a, b, c, d, e, f) {
        var g = d.charAt(3) || d.charAt(2),
          h = "{" !== g && "&" !== g,
          i = /\*/.test(d);
        return {
          type: i ? "Decorator" : "MustacheStatement",
          path: a,
          params: b,
          hash: c,
          escaped: h,
          strip: e,
          loc: this.locInfo(f),
        };
      }
      function k(a, b, c, e) {
        d(a, c), (e = this.locInfo(e));
        var f = { type: "Program", body: b, strip: {}, loc: e };
        return {
          type: "BlockStatement",
          path: a.path,
          params: a.params,
          hash: a.hash,
          program: f,
          openStrip: {},
          inverseStrip: {},
          closeStrip: {},
          loc: e,
        };
      }
      function l(a, b, c, e, f, g) {
        e && e.path && d(a, e);
        var h = /\*/.test(a.open);
        b.blockParams = a.blockParams;
        var i = void 0,
          j = void 0;
        if (c) {
          if (h)
            throw new q["default"]("Unexpected inverse block on decorator", c);
          c.chain && (c.program.body[0].closeStrip = e.strip),
            (j = c.strip),
            (i = c.program);
        }
        return (
          f && ((f = i), (i = b), (b = f)),
          {
            type: h ? "DecoratorBlock" : "BlockStatement",
            path: a.path,
            params: a.params,
            hash: a.hash,
            program: b,
            inverse: i,
            openStrip: a.strip,
            inverseStrip: j,
            closeStrip: e && e.strip,
            loc: this.locInfo(g),
          }
        );
      }
      function m(a, b) {
        if (!b && a.length) {
          var c = a[0].loc,
            d = a[a.length - 1].loc;
          c &&
            d &&
            (b = {
              source: c.source,
              start: { line: c.start.line, column: c.start.column },
              end: { line: d.end.line, column: d.end.column },
            });
        }
        return { type: "Program", body: a, strip: {}, loc: b };
      }
      function n(a, b, c, e) {
        return (
          d(a, c),
          {
            type: "PartialBlockStatement",
            name: a.path,
            params: a.params,
            hash: a.hash,
            program: b,
            openStrip: a.strip,
            closeStrip: c && c.strip,
            loc: this.locInfo(e),
          }
        );
      }
      var o = c(1)["default"];
      (b.__esModule = !0),
        (b.SourceLocation = e),
        (b.id = f),
        (b.stripFlags = g),
        (b.stripComment = h),
        (b.preparePath = i),
        (b.prepareMustache = j),
        (b.prepareRawBlock = k),
        (b.prepareBlock = l),
        (b.prepareProgram = m),
        (b.preparePartialBlock = n);
      var p = c(6),
        q = o(p);
    },
    function (a, b, c) {
      "use strict";
      function d() {}
      function e(a, b, c) {
        if (null == a || ("string" != typeof a && "Program" !== a.type))
          throw new k["default"](
            "You must pass a string or Handlebars AST to Handlebars.precompile. You passed " +
              a
          );
        (b = b || {}),
          "data" in b || (b.data = !0),
          b.compat && (b.useDepths = !0);
        var d = c.parse(a, b),
          e = new c.Compiler().compile(d, b);
        return new c.JavaScriptCompiler().compile(e, b);
      }
      function f(a, b, c) {
        function d() {
          var d = c.parse(a, b),
            e = new c.Compiler().compile(d, b),
            f = new c.JavaScriptCompiler().compile(e, b, void 0, !0);
          return c.template(f);
        }
        function e(a, b) {
          return f || (f = d()), f.call(this, a, b);
        }
        if (
          (void 0 === b && (b = {}),
          null == a || ("string" != typeof a && "Program" !== a.type))
        )
          throw new k["default"](
            "You must pass a string or Handlebars AST to Handlebars.compile. You passed " +
              a
          );
        (b = l.extend({}, b)),
          "data" in b || (b.data = !0),
          b.compat && (b.useDepths = !0);
        var f = void 0;
        return (
          (e._setup = function (a) {
            return f || (f = d()), f._setup(a);
          }),
          (e._child = function (a, b, c, e) {
            return f || (f = d()), f._child(a, b, c, e);
          }),
          e
        );
      }
      function g(a, b) {
        if (a === b) return !0;
        if (l.isArray(a) && l.isArray(b) && a.length === b.length) {
          for (var c = 0; c < a.length; c++) if (!g(a[c], b[c])) return !1;
          return !0;
        }
      }
      function h(a) {
        if (!a.path.parts) {
          var b = a.path;
          a.path = {
            type: "PathExpression",
            data: !1,
            depth: 0,
            parts: [b.original + ""],
            original: b.original + "",
            loc: b.loc,
          };
        }
      }
      var i = c(1)["default"];
      (b.__esModule = !0),
        (b.Compiler = d),
        (b.precompile = e),
        (b.compile = f);
      var j = c(6),
        k = i(j),
        l = c(5),
        m = c(35),
        n = i(m),
        o = [].slice;
      d.prototype = {
        compiler: d,
        equals: function (a) {
          var b = this.opcodes.length;
          if (a.opcodes.length !== b) return !1;
          for (var c = 0; c < b; c++) {
            var d = this.opcodes[c],
              e = a.opcodes[c];
            if (d.opcode !== e.opcode || !g(d.args, e.args)) return !1;
          }
          b = this.children.length;
          for (var c = 0; c < b; c++)
            if (!this.children[c].equals(a.children[c])) return !1;
          return !0;
        },
        guid: 0,
        compile: function (a, b) {
          (this.sourceNode = []),
            (this.opcodes = []),
            (this.children = []),
            (this.options = b),
            (this.stringParams = b.stringParams),
            (this.trackIds = b.trackIds),
            (b.blockParams = b.blockParams || []);
          var c = b.knownHelpers;
          if (
            ((b.knownHelpers = {
              helperMissing: !0,
              blockHelperMissing: !0,
              each: !0,
              if: !0,
              unless: !0,
              with: !0,
              log: !0,
              lookup: !0,
            }),
            c)
          )
            for (var d in c) d in c && (this.options.knownHelpers[d] = c[d]);
          return this.accept(a);
        },
        compileProgram: function (a) {
          var b = new this.compiler(),
            c = b.compile(a, this.options),
            d = this.guid++;
          return (
            (this.usePartial = this.usePartial || c.usePartial),
            (this.children[d] = c),
            (this.useDepths = this.useDepths || c.useDepths),
            d
          );
        },
        accept: function (a) {
          if (!this[a.type])
            throw new k["default"]("Unknown type: " + a.type, a);
          this.sourceNode.unshift(a);
          var b = this[a.type](a);
          return this.sourceNode.shift(), b;
        },
        Program: function (a) {
          this.options.blockParams.unshift(a.blockParams);
          for (var b = a.body, c = b.length, d = 0; d < c; d++)
            this.accept(b[d]);
          return (
            this.options.blockParams.shift(),
            (this.isSimple = 1 === c),
            (this.blockParams = a.blockParams ? a.blockParams.length : 0),
            this
          );
        },
        BlockStatement: function (a) {
          h(a);
          var b = a.program,
            c = a.inverse;
          (b = b && this.compileProgram(b)), (c = c && this.compileProgram(c));
          var d = this.classifySexpr(a);
          "helper" === d
            ? this.helperSexpr(a, b, c)
            : "simple" === d
            ? (this.simpleSexpr(a),
              this.opcode("pushProgram", b),
              this.opcode("pushProgram", c),
              this.opcode("emptyHash"),
              this.opcode("blockValue", a.path.original))
            : (this.ambiguousSexpr(a, b, c),
              this.opcode("pushProgram", b),
              this.opcode("pushProgram", c),
              this.opcode("emptyHash"),
              this.opcode("ambiguousBlockValue")),
            this.opcode("append");
        },
        DecoratorBlock: function (a) {
          var b = a.program && this.compileProgram(a.program),
            c = this.setupFullMustacheParams(a, b, void 0),
            d = a.path;
          (this.useDecorators = !0),
            this.opcode("registerDecorator", c.length, d.original);
        },
        PartialStatement: function (a) {
          this.usePartial = !0;
          var b = a.program;
          b && (b = this.compileProgram(a.program));
          var c = a.params;
          if (c.length > 1)
            throw new k["default"](
              "Unsupported number of partial arguments: " + c.length,
              a
            );
          c.length ||
            (this.options.explicitPartialContext
              ? this.opcode("pushLiteral", "undefined")
              : c.push({ type: "PathExpression", parts: [], depth: 0 }));
          var d = a.name.original,
            e = "SubExpression" === a.name.type;
          e && this.accept(a.name),
            this.setupFullMustacheParams(a, b, void 0, !0);
          var f = a.indent || "";
          this.options.preventIndent &&
            f &&
            (this.opcode("appendContent", f), (f = "")),
            this.opcode("invokePartial", e, d, f),
            this.opcode("append");
        },
        PartialBlockStatement: function (a) {
          this.PartialStatement(a);
        },
        MustacheStatement: function (a) {
          this.SubExpression(a),
            a.escaped && !this.options.noEscape
              ? this.opcode("appendEscaped")
              : this.opcode("append");
        },
        Decorator: function (a) {
          this.DecoratorBlock(a);
        },
        ContentStatement: function (a) {
          a.value && this.opcode("appendContent", a.value);
        },
        CommentStatement: function () {},
        SubExpression: function (a) {
          h(a);
          var b = this.classifySexpr(a);
          "simple" === b
            ? this.simpleSexpr(a)
            : "helper" === b
            ? this.helperSexpr(a)
            : this.ambiguousSexpr(a);
        },
        ambiguousSexpr: function (a, b, c) {
          var d = a.path,
            e = d.parts[0],
            f = null != b || null != c;
          this.opcode("getContext", d.depth),
            this.opcode("pushProgram", b),
            this.opcode("pushProgram", c),
            (d.strict = !0),
            this.accept(d),
            this.opcode("invokeAmbiguous", e, f);
        },
        simpleSexpr: function (a) {
          var b = a.path;
          (b.strict = !0), this.accept(b), this.opcode("resolvePossibleLambda");
        },
        helperSexpr: function (a, b, c) {
          var d = this.setupFullMustacheParams(a, b, c),
            e = a.path,
            f = e.parts[0];
          if (this.options.knownHelpers[f])
            this.opcode("invokeKnownHelper", d.length, f);
          else {
            if (this.options.knownHelpersOnly)
              throw new k["default"](
                "You specified knownHelpersOnly, but used the unknown helper " +
                  f,
                a
              );
            (e.strict = !0),
              (e.falsy = !0),
              this.accept(e),
              this.opcode(
                "invokeHelper",
                d.length,
                e.original,
                n["default"].helpers.simpleId(e)
              );
          }
        },
        PathExpression: function (a) {
          this.addDepth(a.depth), this.opcode("getContext", a.depth);
          var b = a.parts[0],
            c = n["default"].helpers.scopedId(a),
            d = !a.depth && !c && this.blockParamIndex(b);
          d
            ? this.opcode("lookupBlockParam", d, a.parts)
            : b
            ? a.data
              ? ((this.options.data = !0),
                this.opcode("lookupData", a.depth, a.parts, a.strict))
              : this.opcode("lookupOnContext", a.parts, a.falsy, a.strict, c)
            : this.opcode("pushContext");
        },
        StringLiteral: function (a) {
          this.opcode("pushString", a.value);
        },
        NumberLiteral: function (a) {
          this.opcode("pushLiteral", a.value);
        },
        BooleanLiteral: function (a) {
          this.opcode("pushLiteral", a.value);
        },
        UndefinedLiteral: function () {
          this.opcode("pushLiteral", "undefined");
        },
        NullLiteral: function () {
          this.opcode("pushLiteral", "null");
        },
        Hash: function (a) {
          var b = a.pairs,
            c = 0,
            d = b.length;
          for (this.opcode("pushHash"); c < d; c++) this.pushParam(b[c].value);
          for (; c--; ) this.opcode("assignToHash", b[c].key);
          this.opcode("popHash");
        },
        opcode: function (a) {
          this.opcodes.push({
            opcode: a,
            args: o.call(arguments, 1),
            loc: this.sourceNode[0].loc,
          });
        },
        addDepth: function (a) {
          a && (this.useDepths = !0);
        },
        classifySexpr: function (a) {
          var b = n["default"].helpers.simpleId(a.path),
            c = b && !!this.blockParamIndex(a.path.parts[0]),
            d = !c && n["default"].helpers.helperExpression(a),
            e = !c && (d || b);
          if (e && !d) {
            var f = a.path.parts[0],
              g = this.options;
            g.knownHelpers[f] ? (d = !0) : g.knownHelpersOnly && (e = !1);
          }
          return d ? "helper" : e ? "ambiguous" : "simple";
        },
        pushParams: function (a) {
          for (var b = 0, c = a.length; b < c; b++) this.pushParam(a[b]);
        },
        pushParam: function (a) {
          var b = null != a.value ? a.value : a.original || "";
          if (this.stringParams)
            b.replace &&
              (b = b.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".")),
              a.depth && this.addDepth(a.depth),
              this.opcode("getContext", a.depth || 0),
              this.opcode("pushStringParam", b, a.type),
              "SubExpression" === a.type && this.accept(a);
          else {
            if (this.trackIds) {
              var c = void 0;
              if (
                (!a.parts ||
                  n["default"].helpers.scopedId(a) ||
                  a.depth ||
                  (c = this.blockParamIndex(a.parts[0])),
                c)
              ) {
                var d = a.parts.slice(1).join(".");
                this.opcode("pushId", "BlockParam", c, d);
              } else
                (b = a.original || b),
                  b.replace &&
                    (b = b
                      .replace(/^this(?:\.|$)/, "")
                      .replace(/^\.\//, "")
                      .replace(/^\.$/, "")),
                  this.opcode("pushId", a.type, b);
            }
            this.accept(a);
          }
        },
        setupFullMustacheParams: function (a, b, c, d) {
          var e = a.params;
          return (
            this.pushParams(e),
            this.opcode("pushProgram", b),
            this.opcode("pushProgram", c),
            a.hash ? this.accept(a.hash) : this.opcode("emptyHash", d),
            e
          );
        },
        blockParamIndex: function (a) {
          for (var b = 0, c = this.options.blockParams.length; b < c; b++) {
            var d = this.options.blockParams[b],
              e = d && l.indexOf(d, a);
            if (d && e >= 0) return [b, e];
          }
        },
      };
    },
    function (a, b, c) {
      "use strict";
      function d(a) {
        this.value = a;
      }
      function e() {}
      function f(a, b, c, d) {
        var e = b.popStack(),
          f = 0,
          g = c.length;
        for (a && g--; f < g; f++) e = b.nameLookup(e, c[f], d);
        return a
          ? [
              b.aliasable("container.strict"),
              "(",
              e,
              ", ",
              b.quotedString(c[f]),
              ")",
            ]
          : e;
      }
      var g = c(1)["default"];
      b.__esModule = !0;
      var h = c(4),
        i = c(6),
        j = g(i),
        k = c(5),
        l = c(43),
        m = g(l);
      (e.prototype = {
        nameLookup: function (a, b) {
          return e.isValidJavaScriptVariableName(b)
            ? [a, ".", b]
            : [a, "[", JSON.stringify(b), "]"];
        },
        depthedLookup: function (a) {
          return [this.aliasable("container.lookup"), '(depths, "', a, '")'];
        },
        compilerInfo: function () {
          var a = h.COMPILER_REVISION,
            b = h.REVISION_CHANGES[a];
          return [a, b];
        },
        appendToBuffer: function (a, b, c) {
          return (
            k.isArray(a) || (a = [a]),
            (a = this.source.wrap(a, b)),
            this.environment.isSimple
              ? ["return ", a, ";"]
              : c
              ? ["buffer += ", a, ";"]
              : ((a.appendToBuffer = !0), a)
          );
        },
        initializeBuffer: function () {
          return this.quotedString("");
        },
        compile: function (a, b, c, d) {
          (this.environment = a),
            (this.options = b),
            (this.stringParams = this.options.stringParams),
            (this.trackIds = this.options.trackIds),
            (this.precompile = !d),
            (this.name = this.environment.name),
            (this.isChild = !!c),
            (this.context = c || {
              decorators: [],
              programs: [],
              environments: [],
            }),
            this.preamble(),
            (this.stackSlot = 0),
            (this.stackVars = []),
            (this.aliases = {}),
            (this.registers = { list: [] }),
            (this.hashes = []),
            (this.compileStack = []),
            (this.inlineStack = []),
            (this.blockParams = []),
            this.compileChildren(a, b),
            (this.useDepths =
              this.useDepths ||
              a.useDepths ||
              a.useDecorators ||
              this.options.compat),
            (this.useBlockParams = this.useBlockParams || a.useBlockParams);
          var e = a.opcodes,
            f = void 0,
            g = void 0,
            h = void 0,
            i = void 0;
          for (h = 0, i = e.length; h < i; h++)
            (f = e[h]),
              (this.source.currentLocation = f.loc),
              (g = g || f.loc),
              this[f.opcode].apply(this, f.args);
          if (
            ((this.source.currentLocation = g),
            this.pushSource(""),
            this.stackSlot ||
              this.inlineStack.length ||
              this.compileStack.length)
          )
            throw new j["default"](
              "Compile completed with content left on stack"
            );
          this.decorators.isEmpty()
            ? (this.decorators = void 0)
            : ((this.useDecorators = !0),
              this.decorators.prepend(
                "var decorators = container.decorators;\n"
              ),
              this.decorators.push("return fn;"),
              d
                ? (this.decorators = Function.apply(this, [
                    "fn",
                    "props",
                    "container",
                    "depth0",
                    "data",
                    "blockParams",
                    "depths",
                    this.decorators.merge(),
                  ]))
                : (this.decorators.prepend(
                    "function(fn, props, container, depth0, data, blockParams, depths) {\n"
                  ),
                  this.decorators.push("}\n"),
                  (this.decorators = this.decorators.merge())));
          var k = this.createFunctionContext(d);
          if (this.isChild) return k;
          var l = { compiler: this.compilerInfo(), main: k };
          this.decorators &&
            ((l.main_d = this.decorators), (l.useDecorators = !0));
          var m = this.context,
            n = m.programs,
            o = m.decorators;
          for (h = 0, i = n.length; h < i; h++)
            n[h] &&
              ((l[h] = n[h]),
              o[h] && ((l[h + "_d"] = o[h]), (l.useDecorators = !0)));
          return (
            this.environment.usePartial && (l.usePartial = !0),
            this.options.data && (l.useData = !0),
            this.useDepths && (l.useDepths = !0),
            this.useBlockParams && (l.useBlockParams = !0),
            this.options.compat && (l.compat = !0),
            d
              ? (l.compilerOptions = this.options)
              : ((l.compiler = JSON.stringify(l.compiler)),
                (this.source.currentLocation = {
                  start: { line: 1, column: 0 },
                }),
                (l = this.objectLiteral(l)),
                b.srcName
                  ? ((l = l.toStringWithSourceMap({ file: b.destName })),
                    (l.map = l.map && l.map.toString()))
                  : (l = l.toString())),
            l
          );
        },
        preamble: function () {
          (this.lastContext = 0),
            (this.source = new m["default"](this.options.srcName)),
            (this.decorators = new m["default"](this.options.srcName));
        },
        createFunctionContext: function (a) {
          var b = "",
            c = this.stackVars.concat(this.registers.list);
          c.length > 0 && (b += ", " + c.join(", "));
          var d = 0;
          for (var e in this.aliases) {
            var f = this.aliases[e];
            this.aliases.hasOwnProperty(e) &&
              f.children &&
              f.referenceCount > 1 &&
              ((b += ", alias" + ++d + "=" + e), (f.children[0] = "alias" + d));
          }
          var g = ["container", "depth0", "helpers", "partials", "data"];
          (this.useBlockParams || this.useDepths) && g.push("blockParams"),
            this.useDepths && g.push("depths");
          var h = this.mergeSource(b);
          return a
            ? (g.push(h), Function.apply(this, g))
            : this.source.wrap(["function(", g.join(","), ") {\n  ", h, "}"]);
        },
        mergeSource: function (a) {
          var b = this.environment.isSimple,
            c = !this.forceBuffer,
            d = void 0,
            e = void 0,
            f = void 0,
            g = void 0;
          return (
            this.source.each(function (a) {
              a.appendToBuffer
                ? (f ? a.prepend("  + ") : (f = a), (g = a))
                : (f &&
                    (e ? f.prepend("buffer += ") : (d = !0),
                    g.add(";"),
                    (f = g = void 0)),
                  (e = !0),
                  b || (c = !1));
            }),
            c
              ? f
                ? (f.prepend("return "), g.add(";"))
                : e || this.source.push('return "";')
              : ((a += ", buffer = " + (d ? "" : this.initializeBuffer())),
                f
                  ? (f.prepend("return buffer + "), g.add(";"))
                  : this.source.push("return buffer;")),
            a &&
              this.source.prepend("var " + a.substring(2) + (d ? "" : ";\n")),
            this.source.merge()
          );
        },
        blockValue: function (a) {
          var b = this.aliasable("helpers.blockHelperMissing"),
            c = [this.contextName(0)];
          this.setupHelperArgs(a, 0, c);
          var d = this.popStack();
          c.splice(1, 0, d), this.push(this.source.functionCall(b, "call", c));
        },
        ambiguousBlockValue: function () {
          var a = this.aliasable("helpers.blockHelperMissing"),
            b = [this.contextName(0)];
          this.setupHelperArgs("", 0, b, !0), this.flushInline();
          var c = this.topStack();
          b.splice(1, 0, c),
            this.pushSource([
              "if (!",
              this.lastHelper,
              ") { ",
              c,
              " = ",
              this.source.functionCall(a, "call", b),
              "}",
            ]);
        },
        appendContent: function (a) {
          this.pendingContent
            ? (a = this.pendingContent + a)
            : (this.pendingLocation = this.source.currentLocation),
            (this.pendingContent = a);
        },
        append: function () {
          if (this.isInline())
            this.replaceStack(function (a) {
              return [" != null ? ", a, ' : ""'];
            }),
              this.pushSource(this.appendToBuffer(this.popStack()));
          else {
            var a = this.popStack();
            this.pushSource([
              "if (",
              a,
              " != null) { ",
              this.appendToBuffer(a, void 0, !0),
              " }",
            ]),
              this.environment.isSimple &&
                this.pushSource([
                  "else { ",
                  this.appendToBuffer("''", void 0, !0),
                  " }",
                ]);
          }
        },
        appendEscaped: function () {
          this.pushSource(
            this.appendToBuffer([
              this.aliasable("container.escapeExpression"),
              "(",
              this.popStack(),
              ")",
            ])
          );
        },
        getContext: function (a) {
          this.lastContext = a;
        },
        pushContext: function () {
          this.pushStackLiteral(this.contextName(this.lastContext));
        },
        lookupOnContext: function (a, b, c, d) {
          var e = 0;
          d || !this.options.compat || this.lastContext
            ? this.pushContext()
            : this.push(this.depthedLookup(a[e++])),
            this.resolvePath("context", a, e, b, c);
        },
        lookupBlockParam: function (a, b) {
          (this.useBlockParams = !0),
            this.push(["blockParams[", a[0], "][", a[1], "]"]),
            this.resolvePath("context", b, 1);
        },
        lookupData: function (a, b, c) {
          a
            ? this.pushStackLiteral("container.data(data, " + a + ")")
            : this.pushStackLiteral("data"),
            this.resolvePath("data", b, 0, !0, c);
        },
        resolvePath: function (a, b, c, d, e) {
          var g = this;
          if (this.options.strict || this.options.assumeObjects)
            return void this.push(f(this.options.strict && e, this, b, a));
          for (var h = b.length; c < h; c++)
            this.replaceStack(function (e) {
              var f = g.nameLookup(e, b[c], a);
              return d ? [" && ", f] : [" != null ? ", f, " : ", e];
            });
        },
        resolvePossibleLambda: function () {
          this.push([
            this.aliasable("container.lambda"),
            "(",
            this.popStack(),
            ", ",
            this.contextName(0),
            ")",
          ]);
        },
        pushStringParam: function (a, b) {
          this.pushContext(),
            this.pushString(b),
            "SubExpression" !== b &&
              ("string" == typeof a
                ? this.pushString(a)
                : this.pushStackLiteral(a));
        },
        emptyHash: function (a) {
          this.trackIds && this.push("{}"),
            this.stringParams && (this.push("{}"), this.push("{}")),
            this.pushStackLiteral(a ? "undefined" : "{}");
        },
        pushHash: function () {
          this.hash && this.hashes.push(this.hash),
            (this.hash = { values: [], types: [], contexts: [], ids: [] });
        },
        popHash: function () {
          var a = this.hash;
          (this.hash = this.hashes.pop()),
            this.trackIds && this.push(this.objectLiteral(a.ids)),
            this.stringParams &&
              (this.push(this.objectLiteral(a.contexts)),
              this.push(this.objectLiteral(a.types))),
            this.push(this.objectLiteral(a.values));
        },
        pushString: function (a) {
          this.pushStackLiteral(this.quotedString(a));
        },
        pushLiteral: function (a) {
          this.pushStackLiteral(a);
        },
        pushProgram: function (a) {
          null != a
            ? this.pushStackLiteral(this.programExpression(a))
            : this.pushStackLiteral(null);
        },
        registerDecorator: function (a, b) {
          var c = this.nameLookup("decorators", b, "decorator"),
            d = this.setupHelperArgs(b, a);
          this.decorators.push([
            "fn = ",
            this.decorators.functionCall(c, "", [
              "fn",
              "props",
              "container",
              d,
            ]),
            " || fn;",
          ]);
        },
        invokeHelper: function (a, b, c) {
          var d = this.popStack(),
            e = this.setupHelper(a, b),
            f = c ? [e.name, " || "] : "",
            g = ["("].concat(f, d);
          this.options.strict ||
            g.push(" || ", this.aliasable("helpers.helperMissing")),
            g.push(")"),
            this.push(this.source.functionCall(g, "call", e.callParams));
        },
        invokeKnownHelper: function (a, b) {
          var c = this.setupHelper(a, b);
          this.push(this.source.functionCall(c.name, "call", c.callParams));
        },
        invokeAmbiguous: function (a, b) {
          this.useRegister("helper");
          var c = this.popStack();
          this.emptyHash();
          var d = this.setupHelper(0, a, b),
            e = (this.lastHelper = this.nameLookup("helpers", a, "helper")),
            f = ["(", "(helper = ", e, " || ", c, ")"];
          this.options.strict ||
            ((f[0] = "(helper = "),
            f.push(
              " != null ? helper : ",
              this.aliasable("helpers.helperMissing")
            )),
            this.push([
              "(",
              f,
              d.paramsInit ? ["),(", d.paramsInit] : [],
              "),",
              "(typeof helper === ",
              this.aliasable('"function"'),
              " ? ",
              this.source.functionCall("helper", "call", d.callParams),
              " : helper))",
            ]);
        },
        invokePartial: function (a, b, c) {
          var d = [],
            e = this.setupParams(b, 1, d);
          a && ((b = this.popStack()), delete e.name),
            c && (e.indent = JSON.stringify(c)),
            (e.helpers = "helpers"),
            (e.partials = "partials"),
            (e.decorators = "container.decorators"),
            a
              ? d.unshift(b)
              : d.unshift(this.nameLookup("partials", b, "partial")),
            this.options.compat && (e.depths = "depths"),
            (e = this.objectLiteral(e)),
            d.push(e),
            this.push(
              this.source.functionCall("container.invokePartial", "", d)
            );
        },
        assignToHash: function (a) {
          var b = this.popStack(),
            c = void 0,
            d = void 0,
            e = void 0;
          this.trackIds && (e = this.popStack()),
            this.stringParams && ((d = this.popStack()), (c = this.popStack()));
          var f = this.hash;
          c && (f.contexts[a] = c),
            d && (f.types[a] = d),
            e && (f.ids[a] = e),
            (f.values[a] = b);
        },
        pushId: function (a, b, c) {
          "BlockParam" === a
            ? this.pushStackLiteral(
                "blockParams[" +
                  b[0] +
                  "].path[" +
                  b[1] +
                  "]" +
                  (c ? " + " + JSON.stringify("." + c) : "")
              )
            : "PathExpression" === a
            ? this.pushString(b)
            : "SubExpression" === a
            ? this.pushStackLiteral("true")
            : this.pushStackLiteral("null");
        },
        compiler: e,
        compileChildren: function (a, b) {
          for (
            var c = a.children, d = void 0, e = void 0, f = 0, g = c.length;
            f < g;
            f++
          ) {
            (d = c[f]), (e = new this.compiler());
            var h = this.matchExistingProgram(d);
            if (null == h) {
              this.context.programs.push("");
              var i = this.context.programs.length;
              (d.index = i),
                (d.name = "program" + i),
                (this.context.programs[i] = e.compile(
                  d,
                  b,
                  this.context,
                  !this.precompile
                )),
                (this.context.decorators[i] = e.decorators),
                (this.context.environments[i] = d),
                (this.useDepths = this.useDepths || e.useDepths),
                (this.useBlockParams = this.useBlockParams || e.useBlockParams),
                (d.useDepths = this.useDepths),
                (d.useBlockParams = this.useBlockParams);
            } else
              (d.index = h.index),
                (d.name = "program" + h.index),
                (this.useDepths = this.useDepths || h.useDepths),
                (this.useBlockParams = this.useBlockParams || h.useBlockParams);
          }
        },
        matchExistingProgram: function (a) {
          for (var b = 0, c = this.context.environments.length; b < c; b++) {
            var d = this.context.environments[b];
            if (d && d.equals(a)) return d;
          }
        },
        programExpression: function (a) {
          var b = this.environment.children[a],
            c = [b.index, "data", b.blockParams];
          return (
            (this.useBlockParams || this.useDepths) && c.push("blockParams"),
            this.useDepths && c.push("depths"),
            "container.program(" + c.join(", ") + ")"
          );
        },
        useRegister: function (a) {
          this.registers[a] ||
            ((this.registers[a] = !0), this.registers.list.push(a));
        },
        push: function (a) {
          return (
            a instanceof d || (a = this.source.wrap(a)),
            this.inlineStack.push(a),
            a
          );
        },
        pushStackLiteral: function (a) {
          this.push(new d(a));
        },
        pushSource: function (a) {
          this.pendingContent &&
            (this.source.push(
              this.appendToBuffer(
                this.source.quotedString(this.pendingContent),
                this.pendingLocation
              )
            ),
            (this.pendingContent = void 0)),
            a && this.source.push(a);
        },
        replaceStack: function (a) {
          var b = ["("],
            c = void 0,
            e = void 0,
            f = void 0;
          if (!this.isInline())
            throw new j["default"]("replaceStack on non-inline");
          var g = this.popStack(!0);
          if (g instanceof d) (c = [g.value]), (b = ["(", c]), (f = !0);
          else {
            e = !0;
            var h = this.incrStack();
            (b = ["((", this.push(h), " = ", g, ")"]), (c = this.topStack());
          }
          var i = a.call(this, c);
          f || this.popStack(),
            e && this.stackSlot--,
            this.push(b.concat(i, ")"));
        },
        incrStack: function () {
          return (
            this.stackSlot++,
            this.stackSlot > this.stackVars.length &&
              this.stackVars.push("stack" + this.stackSlot),
            this.topStackName()
          );
        },
        topStackName: function () {
          return "stack" + this.stackSlot;
        },
        flushInline: function () {
          var a = this.inlineStack;
          this.inlineStack = [];
          for (var b = 0, c = a.length; b < c; b++) {
            var e = a[b];
            if (e instanceof d) this.compileStack.push(e);
            else {
              var f = this.incrStack();
              this.pushSource([f, " = ", e, ";"]), this.compileStack.push(f);
            }
          }
        },
        isInline: function () {
          return this.inlineStack.length;
        },
        popStack: function (a) {
          var b = this.isInline(),
            c = (b ? this.inlineStack : this.compileStack).pop();
          if (!a && c instanceof d) return c.value;
          if (!b) {
            if (!this.stackSlot) throw new j["default"]("Invalid stack pop");
            this.stackSlot--;
          }
          return c;
        },
        topStack: function () {
          var a = this.isInline() ? this.inlineStack : this.compileStack,
            b = a[a.length - 1];
          return b instanceof d ? b.value : b;
        },
        contextName: function (a) {
          return this.useDepths && a ? "depths[" + a + "]" : "depth" + a;
        },
        quotedString: function (a) {
          return this.source.quotedString(a);
        },
        objectLiteral: function (a) {
          return this.source.objectLiteral(a);
        },
        aliasable: function (a) {
          var b = this.aliases[a];
          return b
            ? (b.referenceCount++, b)
            : ((b = this.aliases[a] = this.source.wrap(a)),
              (b.aliasable = !0),
              (b.referenceCount = 1),
              b);
        },
        setupHelper: function (a, b, c) {
          var d = [],
            e = this.setupHelperArgs(b, a, d, c),
            f = this.nameLookup("helpers", b, "helper"),
            g = this.aliasable(
              this.contextName(0) +
                " != null ? " +
                this.contextName(0) +
                " : (container.nullContext || {})"
            );
          return {
            params: d,
            paramsInit: e,
            name: f,
            callParams: [g].concat(d),
          };
        },
        setupParams: function (a, b, c) {
          var d = {},
            e = [],
            f = [],
            g = [],
            h = !c,
            i = void 0;
          h && (c = []),
            (d.name = this.quotedString(a)),
            (d.hash = this.popStack()),
            this.trackIds && (d.hashIds = this.popStack()),
            this.stringParams &&
              ((d.hashTypes = this.popStack()),
              (d.hashContexts = this.popStack()));
          var j = this.popStack(),
            k = this.popStack();
          (k || j) &&
            ((d.fn = k || "container.noop"),
            (d.inverse = j || "container.noop"));
          for (var l = b; l--; )
            (i = this.popStack()),
              (c[l] = i),
              this.trackIds && (g[l] = this.popStack()),
              this.stringParams &&
                ((f[l] = this.popStack()), (e[l] = this.popStack()));
          return (
            h && (d.args = this.source.generateArray(c)),
            this.trackIds && (d.ids = this.source.generateArray(g)),
            this.stringParams &&
              ((d.types = this.source.generateArray(f)),
              (d.contexts = this.source.generateArray(e))),
            this.options.data && (d.data = "data"),
            this.useBlockParams && (d.blockParams = "blockParams"),
            d
          );
        },
        setupHelperArgs: function (a, b, c, d) {
          var e = this.setupParams(a, b, c);
          return (
            (e = this.objectLiteral(e)),
            d
              ? (this.useRegister("options"),
                c.push("options"),
                ["options=", e])
              : c
              ? (c.push(e), "")
              : e
          );
        },
      }),
        (function () {
          for (
            var a =
                "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(
                  " "
                ),
              b = (e.RESERVED_WORDS = {}),
              c = 0,
              d = a.length;
            c < d;
            c++
          )
            b[a[c]] = !0;
        })(),
        (e.isValidJavaScriptVariableName = function (a) {
          return !e.RESERVED_WORDS[a] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(a);
        }),
        (b["default"] = e),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      function d(a, b, c) {
        if (f.isArray(a)) {
          for (var d = [], e = 0, g = a.length; e < g; e++)
            d.push(b.wrap(a[e], c));
          return d;
        }
        return "boolean" == typeof a || "number" == typeof a ? a + "" : a;
      }
      function e(a) {
        (this.srcFile = a), (this.source = []);
      }
      b.__esModule = !0;
      var f = c(5),
        g = void 0;
      try {
      } catch (h) {}
      g ||
        ((g = function (a, b, c, d) {
          (this.src = ""), d && this.add(d);
        }),
        (g.prototype = {
          add: function (a) {
            f.isArray(a) && (a = a.join("")), (this.src += a);
          },
          prepend: function (a) {
            f.isArray(a) && (a = a.join("")), (this.src = a + this.src);
          },
          toStringWithSourceMap: function () {
            return { code: this.toString() };
          },
          toString: function () {
            return this.src;
          },
        })),
        (e.prototype = {
          isEmpty: function () {
            return !this.source.length;
          },
          prepend: function (a, b) {
            this.source.unshift(this.wrap(a, b));
          },
          push: function (a, b) {
            this.source.push(this.wrap(a, b));
          },
          merge: function () {
            var a = this.empty();
            return (
              this.each(function (b) {
                a.add(["  ", b, "\n"]);
              }),
              a
            );
          },
          each: function (a) {
            for (var b = 0, c = this.source.length; b < c; b++)
              a(this.source[b]);
          },
          empty: function () {
            var a = this.currentLocation || { start: {} };
            return new g(a.start.line, a.start.column, this.srcFile);
          },
          wrap: function (a) {
            var b =
              arguments.length <= 1 || void 0 === arguments[1]
                ? this.currentLocation || { start: {} }
                : arguments[1];
            return a instanceof g
              ? a
              : ((a = d(a, this, b)),
                new g(b.start.line, b.start.column, this.srcFile, a));
          },
          functionCall: function (a, b, c) {
            return (
              (c = this.generateList(c)),
              this.wrap([a, b ? "." + b + "(" : "(", c, ")"])
            );
          },
          quotedString: function (a) {
            return (
              '"' +
              (a + "")
                .replace(/\\/g, "\\\\")
                .replace(/"/g, '\\"')
                .replace(/\n/g, "\\n")
                .replace(/\r/g, "\\r")
                .replace(/\u2028/g, "\\u2028")
                .replace(/\u2029/g, "\\u2029") +
              '"'
            );
          },
          objectLiteral: function (a) {
            var b = [];
            for (var c in a)
              if (a.hasOwnProperty(c)) {
                var e = d(a[c], this);
                "undefined" !== e && b.push([this.quotedString(c), ":", e]);
              }
            var f = this.generateList(b);
            return f.prepend("{"), f.add("}"), f;
          },
          generateList: function (a) {
            for (var b = this.empty(), c = 0, e = a.length; c < e; c++)
              c && b.add(","), b.add(d(a[c], this));
            return b;
          },
          generateArray: function (a) {
            var b = this.generateList(a);
            return b.prepend("["), b.add("]"), b;
          },
        }),
        (b["default"] = e),
        (a.exports = b["default"]);
    },
  ]);
});
!(function (a) {
  "use strict";
  "function" == typeof define && define.amd
    ? define(["jquery"], a)
    : "undefined" != typeof exports
    ? (module.exports = a(require("jquery")))
    : a(jQuery);
})(function (a) {
  "use strict";
  var b = window.Slick || {};
  (b = (function () {
    function c(c, d) {
      var f,
        e = this;
      (e.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        appendArrows: a(c),
        appendDots: a(c),
        arrows: !0,
        asNavFor: null,
        prevArrow:
          '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
        nextArrow:
          '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
        autoplay: !1,
        autoplaySpeed: 3e3,
        centerMode: !1,
        centerPadding: "50px",
        cssEase: "ease",
        customPaging: function (a, b) {
          return (
            '<button type="button" data-role="none" role="button" aria-required="false" tabindex="0">' +
            (b + 1) +
            "</button>"
          );
        },
        dots: !1,
        dotsClass: "slick-dots",
        draggable: !0,
        easing: "linear",
        edgeFriction: 0.35,
        fade: !1,
        focusOnSelect: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: "ondemand",
        mobileFirst: !1,
        pauseOnHover: !0,
        pauseOnDotsHover: !1,
        respondTo: "window",
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: "",
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: !0,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !1,
        variableWidth: !1,
        vertical: !1,
        verticalSwiping: !1,
        waitForAnimate: !0,
        zIndex: 1e3,
      }),
        (e.initials = {
          animating: !1,
          dragging: !1,
          autoPlayTimer: null,
          currentDirection: 0,
          currentLeft: null,
          currentSlide: 0,
          direction: 1,
          $dots: null,
          listWidth: null,
          listHeight: null,
          loadIndex: 0,
          $nextArrow: null,
          $prevArrow: null,
          slideCount: null,
          slideWidth: null,
          $slideTrack: null,
          $slides: null,
          sliding: !1,
          slideOffset: 0,
          swipeLeft: null,
          $list: null,
          touchObject: {},
          transformsEnabled: !1,
          unslicked: !1,
        }),
        a.extend(e, e.initials),
        (e.activeBreakpoint = null),
        (e.animType = null),
        (e.animProp = null),
        (e.breakpoints = []),
        (e.breakpointSettings = []),
        (e.cssTransitions = !1),
        (e.hidden = "hidden"),
        (e.paused = !1),
        (e.positionProp = null),
        (e.respondTo = null),
        (e.rowCount = 1),
        (e.shouldClick = !0),
        (e.$slider = a(c)),
        (e.$slidesCache = null),
        (e.transformType = null),
        (e.transitionType = null),
        (e.visibilityChange = "visibilitychange"),
        (e.windowWidth = 0),
        (e.windowTimer = null),
        (f = a(c).data("slick") || {}),
        (e.options = a.extend({}, e.defaults, f, d)),
        (e.currentSlide = e.options.initialSlide),
        (e.originalSettings = e.options),
        "undefined" != typeof document.mozHidden
          ? ((e.hidden = "mozHidden"),
            (e.visibilityChange = "mozvisibilitychange"))
          : "undefined" != typeof document.webkitHidden &&
            ((e.hidden = "webkitHidden"),
            (e.visibilityChange = "webkitvisibilitychange")),
        (e.autoPlay = a.proxy(e.autoPlay, e)),
        (e.autoPlayClear = a.proxy(e.autoPlayClear, e)),
        (e.changeSlide = a.proxy(e.changeSlide, e)),
        (e.clickHandler = a.proxy(e.clickHandler, e)),
        (e.selectHandler = a.proxy(e.selectHandler, e)),
        (e.setPosition = a.proxy(e.setPosition, e)),
        (e.swipeHandler = a.proxy(e.swipeHandler, e)),
        (e.dragHandler = a.proxy(e.dragHandler, e)),
        (e.keyHandler = a.proxy(e.keyHandler, e)),
        (e.autoPlayIterator = a.proxy(e.autoPlayIterator, e)),
        (e.instanceUid = b++),
        (e.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
        e.registerBreakpoints(),
        e.init(!0),
        e.checkResponsive(!0);
    }
    var b = 0;
    return c;
  })()),
    (b.prototype.addSlide = b.prototype.slickAdd =
      function (b, c, d) {
        var e = this;
        if ("boolean" == typeof c) (d = c), (c = null);
        else if (0 > c || c >= e.slideCount) return !1;
        e.unload(),
          "number" == typeof c
            ? 0 === c && 0 === e.$slides.length
              ? a(b).appendTo(e.$slideTrack)
              : d
              ? a(b).insertBefore(e.$slides.eq(c))
              : a(b).insertAfter(e.$slides.eq(c))
            : d === !0
            ? a(b).prependTo(e.$slideTrack)
            : a(b).appendTo(e.$slideTrack),
          (e.$slides = e.$slideTrack.children(this.options.slide)),
          e.$slideTrack.children(this.options.slide).detach(),
          e.$slideTrack.append(e.$slides),
          e.$slides.each(function (b, c) {
            a(c).attr("data-slick-index", b);
          }),
          (e.$slidesCache = e.$slides),
          e.reinit();
      }),
    (b.prototype.animateHeight = function () {
      var a = this;
      if (
        1 === a.options.slidesToShow &&
        a.options.adaptiveHeight === !0 &&
        a.options.vertical === !1
      ) {
        var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
        a.$list.animate({ height: b }, a.options.speed);
      }
    }),
    (b.prototype.animateSlide = function (b, c) {
      var d = {},
        e = this;
      e.animateHeight(),
        e.options.rtl === !0 && e.options.vertical === !1 && (b = -b),
        e.transformsEnabled === !1
          ? e.options.vertical === !1
            ? e.$slideTrack.animate(
                { left: b },
                e.options.speed,
                e.options.easing,
                c
              )
            : e.$slideTrack.animate(
                { top: b },
                e.options.speed,
                e.options.easing,
                c
              )
          : e.cssTransitions === !1
          ? (e.options.rtl === !0 && (e.currentLeft = -e.currentLeft),
            a({ animStart: e.currentLeft }).animate(
              { animStart: b },
              {
                duration: e.options.speed,
                easing: e.options.easing,
                step: function (a) {
                  (a = Math.ceil(a)),
                    e.options.vertical === !1
                      ? ((d[e.animType] = "translate(" + a + "px, 0px)"),
                        e.$slideTrack.css(d))
                      : ((d[e.animType] = "translate(0px," + a + "px)"),
                        e.$slideTrack.css(d));
                },
                complete: function () {
                  c && c.call();
                },
              }
            ))
          : (e.applyTransition(),
            (b = Math.ceil(b)),
            e.options.vertical === !1
              ? (d[e.animType] = "translate3d(" + b + "px, 0px, 0px)")
              : (d[e.animType] = "translate3d(0px," + b + "px, 0px)"),
            e.$slideTrack.css(d),
            c &&
              setTimeout(function () {
                e.disableTransition(), c.call();
              }, e.options.speed));
    }),
    (b.prototype.asNavFor = function (b) {
      var c = this,
        d = c.options.asNavFor;
      d && null !== d && (d = a(d).not(c.$slider)),
        null !== d &&
          "object" == typeof d &&
          d.each(function () {
            var c = a(this).slick("getSlick");
            c.unslicked || c.slideHandler(b, !0);
          });
    }),
    (b.prototype.applyTransition = function (a) {
      var b = this,
        c = {};
      b.options.fade === !1
        ? (c[b.transitionType] =
            b.transformType + " " + b.options.speed + "ms " + b.options.cssEase)
        : (c[b.transitionType] =
            "opacity " + b.options.speed + "ms " + b.options.cssEase),
        b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c);
    }),
    (b.prototype.autoPlay = function () {
      var a = this;
      a.autoPlayTimer && clearInterval(a.autoPlayTimer),
        a.slideCount > a.options.slidesToShow &&
          a.paused !== !0 &&
          (a.autoPlayTimer = setInterval(
            a.autoPlayIterator,
            a.options.autoplaySpeed
          ));
    }),
    (b.prototype.autoPlayClear = function () {
      var a = this;
      a.autoPlayTimer && clearInterval(a.autoPlayTimer);
    }),
    (b.prototype.autoPlayIterator = function () {
      var a = this;
      a.options.infinite === !1
        ? 1 === a.direction
          ? (a.currentSlide + 1 === a.slideCount - 1 && (a.direction = 0),
            a.slideHandler(a.currentSlide + a.options.slidesToScroll))
          : (a.currentSlide - 1 === 0 && (a.direction = 1),
            a.slideHandler(a.currentSlide - a.options.slidesToScroll))
        : a.slideHandler(a.currentSlide + a.options.slidesToScroll);
    }),
    (b.prototype.buildArrows = function () {
      var b = this;
      b.options.arrows === !0 &&
        ((b.$prevArrow = a(b.options.prevArrow).addClass("slick-arrow")),
        (b.$nextArrow = a(b.options.nextArrow).addClass("slick-arrow")),
        b.slideCount > b.options.slidesToShow
          ? (b.$prevArrow
              .removeClass("slick-hidden")
              .removeAttr("aria-hidden tabindex"),
            b.$nextArrow
              .removeClass("slick-hidden")
              .removeAttr("aria-hidden tabindex"),
            b.htmlExpr.test(b.options.prevArrow) &&
              b.$prevArrow.prependTo(b.options.appendArrows),
            b.htmlExpr.test(b.options.nextArrow) &&
              b.$nextArrow.appendTo(b.options.appendArrows),
            b.options.infinite !== !0 &&
              b.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"))
          : b.$prevArrow
              .add(b.$nextArrow)
              .addClass("slick-hidden")
              .attr({ "aria-disabled": "true", tabindex: "-1" }));
    }),
    (b.prototype.buildDots = function () {
      var c,
        d,
        b = this;
      if (b.options.dots === !0 && b.slideCount > b.options.slidesToShow) {
        for (
          d = '<ul class="' + b.options.dotsClass + '">', c = 0;
          c <= b.getDotCount();
          c += 1
        )
          d += "<li>" + b.options.customPaging.call(this, b, c) + "</li>";
        (d += "</ul>"),
          (b.$dots = a(d).appendTo(b.options.appendDots)),
          b.$dots
            .find("li")
            .first()
            .addClass("slick-active")
            .attr("aria-hidden", "false");
      }
    }),
    (b.prototype.buildOut = function () {
      var b = this;
      (b.$slides = b.$slider
        .children(b.options.slide + ":not(.slick-cloned)")
        .addClass("slick-slide")),
        (b.slideCount = b.$slides.length),
        b.$slides.each(function (b, c) {
          a(c)
            .attr("data-slick-index", b)
            .data("originalStyling", a(c).attr("style") || "");
        }),
        b.$slider.addClass("slick-slider"),
        (b.$slideTrack =
          0 === b.slideCount
            ? a('<div class="slick-track"/>').appendTo(b.$slider)
            : b.$slides.wrapAll('<div class="slick-track"/>').parent()),
        (b.$list = b.$slideTrack
          .wrap('<div aria-live="polite" class="slick-list"/>')
          .parent()),
        b.$slideTrack.css("opacity", 0),
        (b.options.centerMode === !0 || b.options.swipeToSlide === !0) &&
          (b.options.slidesToScroll = 1),
        a("img[data-lazy]", b.$slider).not("[src]").addClass("slick-loading"),
        b.setupInfinite(),
        b.buildArrows(),
        b.buildDots(),
        b.updateDots(),
        b.setSlideClasses(
          "number" == typeof b.currentSlide ? b.currentSlide : 0
        ),
        b.options.draggable === !0 && b.$list.addClass("draggable");
    }),
    (b.prototype.buildRows = function () {
      var b,
        c,
        d,
        e,
        f,
        g,
        h,
        a = this;
      if (
        ((e = document.createDocumentFragment()),
        (g = a.$slider.children()),
        a.options.rows > 1)
      ) {
        for (
          h = a.options.slidesPerRow * a.options.rows,
            f = Math.ceil(g.length / h),
            b = 0;
          f > b;
          b++
        ) {
          var i = document.createElement("div");
          for (c = 0; c < a.options.rows; c++) {
            var j = document.createElement("div");
            for (d = 0; d < a.options.slidesPerRow; d++) {
              var k = b * h + (c * a.options.slidesPerRow + d);
              g.get(k) && j.appendChild(g.get(k));
            }
            i.appendChild(j);
          }
          e.appendChild(i);
        }
        a.$slider.html(e),
          a.$slider
            .children()
            .children()
            .children()
            .css({
              width: 100 / a.options.slidesPerRow + "%",
              display: "inline-block",
            });
      }
    }),
    (b.prototype.checkResponsive = function (b, c) {
      var e,
        f,
        g,
        d = this,
        h = !1,
        i = d.$slider.width(),
        j = window.innerWidth || a(window).width();
      if (
        ("window" === d.respondTo
          ? (g = j)
          : "slider" === d.respondTo
          ? (g = i)
          : "min" === d.respondTo && (g = Math.min(j, i)),
        d.options.responsive &&
          d.options.responsive.length &&
          null !== d.options.responsive)
      ) {
        f = null;
        for (e in d.breakpoints)
          d.breakpoints.hasOwnProperty(e) &&
            (d.originalSettings.mobileFirst === !1
              ? g < d.breakpoints[e] && (f = d.breakpoints[e])
              : g > d.breakpoints[e] && (f = d.breakpoints[e]));
        null !== f
          ? null !== d.activeBreakpoint
            ? (f !== d.activeBreakpoint || c) &&
              ((d.activeBreakpoint = f),
              "unslick" === d.breakpointSettings[f]
                ? d.unslick(f)
                : ((d.options = a.extend(
                    {},
                    d.originalSettings,
                    d.breakpointSettings[f]
                  )),
                  b === !0 && (d.currentSlide = d.options.initialSlide),
                  d.refresh(b)),
              (h = f))
            : ((d.activeBreakpoint = f),
              "unslick" === d.breakpointSettings[f]
                ? d.unslick(f)
                : ((d.options = a.extend(
                    {},
                    d.originalSettings,
                    d.breakpointSettings[f]
                  )),
                  b === !0 && (d.currentSlide = d.options.initialSlide),
                  d.refresh(b)),
              (h = f))
          : null !== d.activeBreakpoint &&
            ((d.activeBreakpoint = null),
            (d.options = d.originalSettings),
            b === !0 && (d.currentSlide = d.options.initialSlide),
            d.refresh(b),
            (h = f)),
          b || h === !1 || d.$slider.trigger("breakpoint", [d, h]);
      }
    }),
    (b.prototype.changeSlide = function (b, c) {
      var f,
        g,
        h,
        d = this,
        e = a(b.target);
      switch (
        (e.is("a") && b.preventDefault(),
        e.is("li") || (e = e.closest("li")),
        (h = d.slideCount % d.options.slidesToScroll !== 0),
        (f = h
          ? 0
          : (d.slideCount - d.currentSlide) % d.options.slidesToScroll),
        b.data.message)
      ) {
        case "previous":
          (g = 0 === f ? d.options.slidesToScroll : d.options.slidesToShow - f),
            d.slideCount > d.options.slidesToShow &&
              d.slideHandler(d.currentSlide - g, !1, c);
          break;
        case "next":
          (g = 0 === f ? d.options.slidesToScroll : f),
            d.slideCount > d.options.slidesToShow &&
              d.slideHandler(d.currentSlide + g, !1, c);
          break;
        case "index":
          var i =
            0 === b.data.index
              ? 0
              : b.data.index || e.index() * d.options.slidesToScroll;
          d.slideHandler(d.checkNavigable(i), !1, c),
            e.children().trigger("focus");
          break;
        default:
          return;
      }
    }),
    (b.prototype.checkNavigable = function (a) {
      var c,
        d,
        b = this;
      if (((c = b.getNavigableIndexes()), (d = 0), a > c[c.length - 1]))
        a = c[c.length - 1];
      else
        for (var e in c) {
          if (a < c[e]) {
            a = d;
            break;
          }
          d = c[e];
        }
      return a;
    }),
    (b.prototype.cleanUpEvents = function () {
      var b = this;
      b.options.dots &&
        null !== b.$dots &&
        (a("li", b.$dots).off("click.slick", b.changeSlide),
        b.options.pauseOnDotsHover === !0 &&
          b.options.autoplay === !0 &&
          a("li", b.$dots)
            .off("mouseenter.slick", a.proxy(b.setPaused, b, !0))
            .off("mouseleave.slick", a.proxy(b.setPaused, b, !1))),
        b.options.arrows === !0 &&
          b.slideCount > b.options.slidesToShow &&
          (b.$prevArrow && b.$prevArrow.off("click.slick", b.changeSlide),
          b.$nextArrow && b.$nextArrow.off("click.slick", b.changeSlide)),
        b.$list.off("touchstart.slick mousedown.slick", b.swipeHandler),
        b.$list.off("touchmove.slick mousemove.slick", b.swipeHandler),
        b.$list.off("touchend.slick mouseup.slick", b.swipeHandler),
        b.$list.off("touchcancel.slick mouseleave.slick", b.swipeHandler),
        b.$list.off("click.slick", b.clickHandler),
        a(document).off(b.visibilityChange, b.visibility),
        b.$list.off("mouseenter.slick", a.proxy(b.setPaused, b, !0)),
        b.$list.off("mouseleave.slick", a.proxy(b.setPaused, b, !1)),
        b.options.accessibility === !0 &&
          b.$list.off("keydown.slick", b.keyHandler),
        b.options.focusOnSelect === !0 &&
          a(b.$slideTrack).children().off("click.slick", b.selectHandler),
        a(window).off(
          "orientationchange.slick.slick-" + b.instanceUid,
          b.orientationChange
        ),
        a(window).off("resize.slick.slick-" + b.instanceUid, b.resize),
        a("[draggable!=true]", b.$slideTrack).off(
          "dragstart",
          b.preventDefault
        ),
        a(window).off("load.slick.slick-" + b.instanceUid, b.setPosition),
        a(document).off("ready.slick.slick-" + b.instanceUid, b.setPosition);
    }),
    (b.prototype.cleanUpRows = function () {
      var b,
        a = this;
      a.options.rows > 1 &&
        ((b = a.$slides.children().children()),
        b.removeAttr("style"),
        a.$slider.html(b));
    }),
    (b.prototype.clickHandler = function (a) {
      var b = this;
      b.shouldClick === !1 &&
        (a.stopImmediatePropagation(), a.stopPropagation(), a.preventDefault());
    }),
    (b.prototype.destroy = function (b) {
      var c = this;
      c.autoPlayClear(),
        (c.touchObject = {}),
        c.cleanUpEvents(),
        a(".slick-cloned", c.$slider).detach(),
        c.$dots && c.$dots.remove(),
        c.$prevArrow &&
          c.$prevArrow.length &&
          (c.$prevArrow
            .removeClass("slick-disabled slick-arrow slick-hidden")
            .removeAttr("aria-hidden aria-disabled tabindex")
            .css("display", ""),
          c.htmlExpr.test(c.options.prevArrow) && c.$prevArrow.remove()),
        c.$nextArrow &&
          c.$nextArrow.length &&
          (c.$nextArrow
            .removeClass("slick-disabled slick-arrow slick-hidden")
            .removeAttr("aria-hidden aria-disabled tabindex")
            .css("display", ""),
          c.htmlExpr.test(c.options.nextArrow) && c.$nextArrow.remove()),
        c.$slides &&
          (c.$slides
            .removeClass(
              "slick-slide slick-active slick-center slick-visible slick-current"
            )
            .removeAttr("aria-hidden")
            .removeAttr("data-slick-index")
            .each(function () {
              a(this).attr("style", a(this).data("originalStyling"));
            }),
          c.$slideTrack.children(this.options.slide).detach(),
          c.$slideTrack.detach(),
          c.$list.detach(),
          c.$slider.append(c.$slides)),
        c.cleanUpRows(),
        c.$slider.removeClass("slick-slider"),
        c.$slider.removeClass("slick-initialized"),
        (c.unslicked = !0),
        b || c.$slider.trigger("destroy", [c]);
    }),
    (b.prototype.disableTransition = function (a) {
      var b = this,
        c = {};
      (c[b.transitionType] = ""),
        b.options.fade === !1 ? b.$slideTrack.css(c) : b.$slides.eq(a).css(c);
    }),
    (b.prototype.fadeSlide = function (a, b) {
      var c = this;
      c.cssTransitions === !1
        ? (c.$slides.eq(a).css({ zIndex: c.options.zIndex }),
          c.$slides
            .eq(a)
            .animate({ opacity: 1 }, c.options.speed, c.options.easing, b))
        : (c.applyTransition(a),
          c.$slides.eq(a).css({ opacity: 1, zIndex: c.options.zIndex }),
          b &&
            setTimeout(function () {
              c.disableTransition(a), b.call();
            }, c.options.speed));
    }),
    (b.prototype.fadeSlideOut = function (a) {
      var b = this;
      b.cssTransitions === !1
        ? b.$slides
            .eq(a)
            .animate(
              { opacity: 0, zIndex: b.options.zIndex - 2 },
              b.options.speed,
              b.options.easing
            )
        : (b.applyTransition(a),
          b.$slides.eq(a).css({ opacity: 0, zIndex: b.options.zIndex - 2 }));
    }),
    (b.prototype.filterSlides = b.prototype.slickFilter =
      function (a) {
        var b = this;
        null !== a &&
          ((b.$slidesCache = b.$slides),
          b.unload(),
          b.$slideTrack.children(this.options.slide).detach(),
          b.$slidesCache.filter(a).appendTo(b.$slideTrack),
          b.reinit());
      }),
    (b.prototype.getCurrent = b.prototype.slickCurrentSlide =
      function () {
        var a = this;
        return a.currentSlide;
      }),
    (b.prototype.getDotCount = function () {
      var a = this,
        b = 0,
        c = 0,
        d = 0;
      if (a.options.infinite === !0)
        for (; b < a.slideCount; )
          ++d,
            (b = c + a.options.slidesToScroll),
            (c +=
              a.options.slidesToScroll <= a.options.slidesToShow
                ? a.options.slidesToScroll
                : a.options.slidesToShow);
      else if (a.options.centerMode === !0) d = a.slideCount;
      else
        for (; b < a.slideCount; )
          ++d,
            (b = c + a.options.slidesToScroll),
            (c +=
              a.options.slidesToScroll <= a.options.slidesToShow
                ? a.options.slidesToScroll
                : a.options.slidesToShow);
      return d - 1;
    }),
    (b.prototype.getLeft = function (a) {
      var c,
        d,
        f,
        b = this,
        e = 0;
      return (
        (b.slideOffset = 0),
        (d = b.$slides.first().outerHeight(!0)),
        b.options.infinite === !0
          ? (b.slideCount > b.options.slidesToShow &&
              ((b.slideOffset = b.slideWidth * b.options.slidesToShow * -1),
              (e = d * b.options.slidesToShow * -1)),
            b.slideCount % b.options.slidesToScroll !== 0 &&
              a + b.options.slidesToScroll > b.slideCount &&
              b.slideCount > b.options.slidesToShow &&
              (a > b.slideCount
                ? ((b.slideOffset =
                    (b.options.slidesToShow - (a - b.slideCount)) *
                    b.slideWidth *
                    -1),
                  (e = (b.options.slidesToShow - (a - b.slideCount)) * d * -1))
                : ((b.slideOffset =
                    (b.slideCount % b.options.slidesToScroll) *
                    b.slideWidth *
                    -1),
                  (e = (b.slideCount % b.options.slidesToScroll) * d * -1))))
          : a + b.options.slidesToShow > b.slideCount &&
            ((b.slideOffset =
              (a + b.options.slidesToShow - b.slideCount) * b.slideWidth),
            (e = (a + b.options.slidesToShow - b.slideCount) * d)),
        b.slideCount <= b.options.slidesToShow &&
          ((b.slideOffset = 0), (e = 0)),
        b.options.centerMode === !0 && b.options.infinite === !0
          ? (b.slideOffset +=
              b.slideWidth * Math.floor(b.options.slidesToShow / 2) -
              b.slideWidth)
          : b.options.centerMode === !0 &&
            ((b.slideOffset = 0),
            (b.slideOffset +=
              b.slideWidth * Math.floor(b.options.slidesToShow / 2))),
        (c =
          b.options.vertical === !1
            ? a * b.slideWidth * -1 + b.slideOffset
            : a * d * -1 + e),
        b.options.variableWidth === !0 &&
          ((f =
            b.slideCount <= b.options.slidesToShow || b.options.infinite === !1
              ? b.$slideTrack.children(".slick-slide").eq(a)
              : b.$slideTrack
                  .children(".slick-slide")
                  .eq(a + b.options.slidesToShow)),
          (c =
            b.options.rtl === !0
              ? f[0]
                ? -1 * (b.$slideTrack.width() - f[0].offsetLeft - f.width())
                : 0
              : f[0]
              ? -1 * f[0].offsetLeft
              : 0),
          b.options.centerMode === !0 &&
            ((f =
              b.slideCount <= b.options.slidesToShow ||
              b.options.infinite === !1
                ? b.$slideTrack.children(".slick-slide").eq(a)
                : b.$slideTrack
                    .children(".slick-slide")
                    .eq(a + b.options.slidesToShow + 1)),
            (c =
              b.options.rtl === !0
                ? f[0]
                  ? -1 * (b.$slideTrack.width() - f[0].offsetLeft - f.width())
                  : 0
                : f[0]
                ? -1 * f[0].offsetLeft
                : 0),
            (c += (b.$list.width() - f.outerWidth()) / 2))),
        c
      );
    }),
    (b.prototype.getOption = b.prototype.slickGetOption =
      function (a) {
        var b = this;
        return b.options[a];
      }),
    (b.prototype.getNavigableIndexes = function () {
      var e,
        a = this,
        b = 0,
        c = 0,
        d = [];
      for (
        a.options.infinite === !1
          ? (e = a.slideCount)
          : ((b = -1 * a.options.slidesToScroll),
            (c = -1 * a.options.slidesToScroll),
            (e = 2 * a.slideCount));
        e > b;

      )
        d.push(b),
          (b = c + a.options.slidesToScroll),
          (c +=
            a.options.slidesToScroll <= a.options.slidesToShow
              ? a.options.slidesToScroll
              : a.options.slidesToShow);
      return d;
    }),
    (b.prototype.getSlick = function () {
      return this;
    }),
    (b.prototype.getSlideCount = function () {
      var c,
        d,
        e,
        b = this;
      return (
        (e =
          b.options.centerMode === !0
            ? b.slideWidth * Math.floor(b.options.slidesToShow / 2)
            : 0),
        b.options.swipeToSlide === !0
          ? (b.$slideTrack.find(".slick-slide").each(function (c, f) {
              return f.offsetLeft - e + a(f).outerWidth() / 2 > -1 * b.swipeLeft
                ? ((d = f), !1)
                : void 0;
            }),
            (c = Math.abs(a(d).attr("data-slick-index") - b.currentSlide) || 1))
          : b.options.slidesToScroll
      );
    }),
    (b.prototype.goTo = b.prototype.slickGoTo =
      function (a, b) {
        var c = this;
        c.changeSlide({ data: { message: "index", index: parseInt(a) } }, b);
      }),
    (b.prototype.init = function (b) {
      var c = this;
      a(c.$slider).hasClass("slick-initialized") ||
        (a(c.$slider).addClass("slick-initialized"),
        c.buildRows(),
        c.buildOut(),
        c.setProps(),
        c.startLoad(),
        c.loadSlider(),
        c.initializeEvents(),
        c.updateArrows(),
        c.updateDots()),
        b && c.$slider.trigger("init", [c]),
        c.options.accessibility === !0 && c.initADA();
    }),
    (b.prototype.initArrowEvents = function () {
      var a = this;
      a.options.arrows === !0 &&
        a.slideCount > a.options.slidesToShow &&
        (a.$prevArrow.on("click.slick", { message: "previous" }, a.changeSlide),
        a.$nextArrow.on("click.slick", { message: "next" }, a.changeSlide));
    }),
    (b.prototype.initDotEvents = function () {
      var b = this;
      b.options.dots === !0 &&
        b.slideCount > b.options.slidesToShow &&
        a("li", b.$dots).on("click.slick", { message: "index" }, b.changeSlide),
        b.options.dots === !0 &&
          b.options.pauseOnDotsHover === !0 &&
          b.options.autoplay === !0 &&
          a("li", b.$dots)
            .on("mouseenter.slick", a.proxy(b.setPaused, b, !0))
            .on("mouseleave.slick", a.proxy(b.setPaused, b, !1));
    }),
    (b.prototype.initializeEvents = function () {
      var b = this;
      b.initArrowEvents(),
        b.initDotEvents(),
        b.$list.on(
          "touchstart.slick mousedown.slick",
          { action: "start" },
          b.swipeHandler
        ),
        b.$list.on(
          "touchmove.slick mousemove.slick",
          { action: "move" },
          b.swipeHandler
        ),
        b.$list.on(
          "touchend.slick mouseup.slick",
          { action: "end" },
          b.swipeHandler
        ),
        b.$list.on(
          "touchcancel.slick mouseleave.slick",
          { action: "end" },
          b.swipeHandler
        ),
        b.$list.on("click.slick", b.clickHandler),
        a(document).on(b.visibilityChange, a.proxy(b.visibility, b)),
        b.$list.on("mouseenter.slick", a.proxy(b.setPaused, b, !0)),
        b.$list.on("mouseleave.slick", a.proxy(b.setPaused, b, !1)),
        b.options.accessibility === !0 &&
          b.$list.on("keydown.slick", b.keyHandler),
        b.options.focusOnSelect === !0 &&
          a(b.$slideTrack).children().on("click.slick", b.selectHandler),
        a(window).on(
          "orientationchange.slick.slick-" + b.instanceUid,
          a.proxy(b.orientationChange, b)
        ),
        a(window).on(
          "resize.slick.slick-" + b.instanceUid,
          a.proxy(b.resize, b)
        ),
        a("[draggable!=true]", b.$slideTrack).on("dragstart", b.preventDefault),
        a(window).on("load.slick.slick-" + b.instanceUid, b.setPosition),
        a(document).on("ready.slick.slick-" + b.instanceUid, b.setPosition);
    }),
    (b.prototype.initUI = function () {
      var a = this;
      a.options.arrows === !0 &&
        a.slideCount > a.options.slidesToShow &&
        (a.$prevArrow.show(), a.$nextArrow.show()),
        a.options.dots === !0 &&
          a.slideCount > a.options.slidesToShow &&
          a.$dots.show(),
        a.options.autoplay === !0 && a.autoPlay();
    }),
    (b.prototype.keyHandler = function (a) {
      var b = this;
      a.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
        (37 === a.keyCode && b.options.accessibility === !0
          ? b.changeSlide({ data: { message: "previous" } })
          : 39 === a.keyCode &&
            b.options.accessibility === !0 &&
            b.changeSlide({ data: { message: "next" } }));
    }),
    (b.prototype.lazyLoad = function () {
      function g(b) {
        a("img[data-lazy]", b).each(function () {
          var b = a(this),
            c = a(this).attr("data-lazy"),
            d = document.createElement("img");
          (d.onload = function () {
            b.animate({ opacity: 0 }, 100, function () {
              b.attr("src", c).animate({ opacity: 1 }, 200, function () {
                b.removeAttr("data-lazy").removeClass("slick-loading");
              });
            });
          }),
            (d.src = c);
        });
      }
      var c,
        d,
        e,
        f,
        b = this;
      b.options.centerMode === !0
        ? b.options.infinite === !0
          ? ((e = b.currentSlide + (b.options.slidesToShow / 2 + 1)),
            (f = e + b.options.slidesToShow + 2))
          : ((e = Math.max(
              0,
              b.currentSlide - (b.options.slidesToShow / 2 + 1)
            )),
            (f = 2 + (b.options.slidesToShow / 2 + 1) + b.currentSlide))
        : ((e = b.options.infinite
            ? b.options.slidesToShow + b.currentSlide
            : b.currentSlide),
          (f = e + b.options.slidesToShow),
          b.options.fade === !0 && (e > 0 && e--, f <= b.slideCount && f++)),
        (c = b.$slider.find(".slick-slide").slice(e, f)),
        g(c),
        b.slideCount <= b.options.slidesToShow
          ? ((d = b.$slider.find(".slick-slide")), g(d))
          : b.currentSlide >= b.slideCount - b.options.slidesToShow
          ? ((d = b.$slider
              .find(".slick-cloned")
              .slice(0, b.options.slidesToShow)),
            g(d))
          : 0 === b.currentSlide &&
            ((d = b.$slider
              .find(".slick-cloned")
              .slice(-1 * b.options.slidesToShow)),
            g(d));
    }),
    (b.prototype.loadSlider = function () {
      var a = this;
      a.setPosition(),
        a.$slideTrack.css({ opacity: 1 }),
        a.$slider.removeClass("slick-loading"),
        a.initUI(),
        "progressive" === a.options.lazyLoad && a.progressiveLazyLoad();
    }),
    (b.prototype.next = b.prototype.slickNext =
      function () {
        var a = this;
        a.changeSlide({ data: { message: "next" } });
      }),
    (b.prototype.orientationChange = function () {
      var a = this;
      a.checkResponsive(), a.setPosition();
    }),
    (b.prototype.pause = b.prototype.slickPause =
      function () {
        var a = this;
        a.autoPlayClear(), (a.paused = !0);
      }),
    (b.prototype.play = b.prototype.slickPlay =
      function () {
        var a = this;
        (a.paused = !1), a.autoPlay();
      }),
    (b.prototype.postSlide = function (a) {
      var b = this;
      b.$slider.trigger("afterChange", [b, a]),
        (b.animating = !1),
        b.setPosition(),
        (b.swipeLeft = null),
        b.options.autoplay === !0 && b.paused === !1 && b.autoPlay(),
        b.options.accessibility === !0 && b.initADA();
    }),
    (b.prototype.prev = b.prototype.slickPrev =
      function () {
        var a = this;
        a.changeSlide({ data: { message: "previous" } });
      }),
    (b.prototype.preventDefault = function (a) {
      a.preventDefault();
    }),
    (b.prototype.progressiveLazyLoad = function () {
      var c,
        d,
        b = this;
      (c = a("img[data-lazy]", b.$slider).length),
        c > 0 &&
          ((d = a("img[data-lazy]", b.$slider).first()),
          d.attr("src", null),
          d
            .attr("src", d.attr("data-lazy"))
            .removeClass("slick-loading")
            .load(function () {
              d.removeAttr("data-lazy"),
                b.progressiveLazyLoad(),
                b.options.adaptiveHeight === !0 && b.setPosition();
            })
            .error(function () {
              d.removeAttr("data-lazy"), b.progressiveLazyLoad();
            }));
    }),
    (b.prototype.refresh = function (b) {
      var d,
        e,
        c = this;
      (e = c.slideCount - c.options.slidesToShow),
        c.options.infinite ||
          (c.slideCount <= c.options.slidesToShow
            ? (c.currentSlide = 0)
            : c.currentSlide > e && (c.currentSlide = e)),
        (d = c.currentSlide),
        c.destroy(!0),
        a.extend(c, c.initials, { currentSlide: d }),
        c.init(),
        b || c.changeSlide({ data: { message: "index", index: d } }, !1);
    }),
    (b.prototype.registerBreakpoints = function () {
      var c,
        d,
        e,
        b = this,
        f = b.options.responsive || null;
      if ("array" === a.type(f) && f.length) {
        b.respondTo = b.options.respondTo || "window";
        for (c in f)
          if (
            ((e = b.breakpoints.length - 1),
            (d = f[c].breakpoint),
            f.hasOwnProperty(c))
          ) {
            for (; e >= 0; )
              b.breakpoints[e] &&
                b.breakpoints[e] === d &&
                b.breakpoints.splice(e, 1),
                e--;
            b.breakpoints.push(d), (b.breakpointSettings[d] = f[c].settings);
          }
        b.breakpoints.sort(function (a, c) {
          return b.options.mobileFirst ? a - c : c - a;
        });
      }
    }),
    (b.prototype.reinit = function () {
      var b = this;
      (b.$slides = b.$slideTrack
        .children(b.options.slide)
        .addClass("slick-slide")),
        (b.slideCount = b.$slides.length),
        b.currentSlide >= b.slideCount &&
          0 !== b.currentSlide &&
          (b.currentSlide = b.currentSlide - b.options.slidesToScroll),
        b.slideCount <= b.options.slidesToShow && (b.currentSlide = 0),
        b.registerBreakpoints(),
        b.setProps(),
        b.setupInfinite(),
        b.buildArrows(),
        b.updateArrows(),
        b.initArrowEvents(),
        b.buildDots(),
        b.updateDots(),
        b.initDotEvents(),
        b.checkResponsive(!1, !0),
        b.options.focusOnSelect === !0 &&
          a(b.$slideTrack).children().on("click.slick", b.selectHandler),
        b.setSlideClasses(0),
        b.setPosition(),
        b.$slider.trigger("reInit", [b]),
        b.options.autoplay === !0 && b.focusHandler();
    }),
    (b.prototype.resize = function () {
      var b = this;
      a(window).width() !== b.windowWidth &&
        (clearTimeout(b.windowDelay),
        (b.windowDelay = window.setTimeout(function () {
          (b.windowWidth = a(window).width()),
            b.checkResponsive(),
            b.unslicked || b.setPosition();
        }, 50)));
    }),
    (b.prototype.removeSlide = b.prototype.slickRemove =
      function (a, b, c) {
        var d = this;
        return (
          "boolean" == typeof a
            ? ((b = a), (a = b === !0 ? 0 : d.slideCount - 1))
            : (a = b === !0 ? --a : a),
          d.slideCount < 1 || 0 > a || a > d.slideCount - 1
            ? !1
            : (d.unload(),
              c === !0
                ? d.$slideTrack.children().remove()
                : d.$slideTrack.children(this.options.slide).eq(a).remove(),
              (d.$slides = d.$slideTrack.children(this.options.slide)),
              d.$slideTrack.children(this.options.slide).detach(),
              d.$slideTrack.append(d.$slides),
              (d.$slidesCache = d.$slides),
              void d.reinit())
        );
      }),
    (b.prototype.setCSS = function (a) {
      var d,
        e,
        b = this,
        c = {};
      b.options.rtl === !0 && (a = -a),
        (d = "left" == b.positionProp ? Math.ceil(a) + "px" : "0px"),
        (e = "top" == b.positionProp ? Math.ceil(a) + "px" : "0px"),
        (c[b.positionProp] = a),
        b.transformsEnabled === !1
          ? b.$slideTrack.css(c)
          : ((c = {}),
            b.cssTransitions === !1
              ? ((c[b.animType] = "translate(" + d + ", " + e + ")"),
                b.$slideTrack.css(c))
              : ((c[b.animType] = "translate3d(" + d + ", " + e + ", 0px)"),
                b.$slideTrack.css(c)));
    }),
    (b.prototype.setDimensions = function () {
      var a = this;
      a.options.vertical === !1
        ? a.options.centerMode === !0 &&
          a.$list.css({ padding: "0px " + a.options.centerPadding })
        : (a.$list.height(
            a.$slides.first().outerHeight(!0) * a.options.slidesToShow
          ),
          a.options.centerMode === !0 &&
            a.$list.css({ padding: a.options.centerPadding + " 0px" })),
        (a.listWidth = a.$list.width()),
        (a.listHeight = a.$list.height()),
        a.options.vertical === !1 && a.options.variableWidth === !1
          ? ((a.slideWidth = Math.ceil(a.listWidth / a.options.slidesToShow)),
            a.$slideTrack.width(
              Math.ceil(
                a.slideWidth * a.$slideTrack.children(".slick-slide").length
              )
            ))
          : a.options.variableWidth === !0
          ? a.$slideTrack.width(5e3 * a.slideCount)
          : ((a.slideWidth = Math.ceil(a.listWidth)),
            a.$slideTrack.height(
              Math.ceil(
                a.$slides.first().outerHeight(!0) *
                  a.$slideTrack.children(".slick-slide").length
              )
            ));
      var b = a.$slides.first().outerWidth(!0) - a.$slides.first().width();
      a.options.variableWidth === !1 &&
        a.$slideTrack.children(".slick-slide").width(a.slideWidth - b);
    }),
    (b.prototype.setFade = function () {
      var c,
        b = this;
      b.$slides.each(function (d, e) {
        (c = b.slideWidth * d * -1),
          b.options.rtl === !0
            ? a(e).css({
                position: "relative",
                right: c,
                top: 0,
                zIndex: b.options.zIndex - 2,
                opacity: 0,
              })
            : a(e).css({
                position: "relative",
                left: c,
                top: 0,
                zIndex: b.options.zIndex - 2,
                opacity: 0,
              });
      }),
        b.$slides
          .eq(b.currentSlide)
          .css({ zIndex: b.options.zIndex - 1, opacity: 1 });
    }),
    (b.prototype.setHeight = function () {
      var a = this;
      if (
        1 === a.options.slidesToShow &&
        a.options.adaptiveHeight === !0 &&
        a.options.vertical === !1
      ) {
        var b = a.$slides.eq(a.currentSlide).outerHeight(!0);
        a.$list.css("height", b);
      }
    }),
    (b.prototype.setOption = b.prototype.slickSetOption =
      function (b, c, d) {
        var f,
          g,
          e = this;
        if ("responsive" === b && "array" === a.type(c))
          for (g in c)
            if ("array" !== a.type(e.options.responsive))
              e.options.responsive = [c[g]];
            else {
              for (f = e.options.responsive.length - 1; f >= 0; )
                e.options.responsive[f].breakpoint === c[g].breakpoint &&
                  e.options.responsive.splice(f, 1),
                  f--;
              e.options.responsive.push(c[g]);
            }
        else e.options[b] = c;
        d === !0 && (e.unload(), e.reinit());
      }),
    (b.prototype.setPosition = function () {
      var a = this;
      a.setDimensions(),
        a.setHeight(),
        a.options.fade === !1
          ? a.setCSS(a.getLeft(a.currentSlide))
          : a.setFade(),
        a.$slider.trigger("setPosition", [a]);
    }),
    (b.prototype.setProps = function () {
      var a = this,
        b = document.body.style;
      (a.positionProp = a.options.vertical === !0 ? "top" : "left"),
        "top" === a.positionProp
          ? a.$slider.addClass("slick-vertical")
          : a.$slider.removeClass("slick-vertical"),
        (void 0 !== b.WebkitTransition ||
          void 0 !== b.MozTransition ||
          void 0 !== b.msTransition) &&
          a.options.useCSS === !0 &&
          (a.cssTransitions = !0),
        a.options.fade &&
          ("number" == typeof a.options.zIndex
            ? a.options.zIndex < 3 && (a.options.zIndex = 3)
            : (a.options.zIndex = a.defaults.zIndex)),
        void 0 !== b.OTransform &&
          ((a.animType = "OTransform"),
          (a.transformType = "-o-transform"),
          (a.transitionType = "OTransition"),
          void 0 === b.perspectiveProperty &&
            void 0 === b.webkitPerspective &&
            (a.animType = !1)),
        void 0 !== b.MozTransform &&
          ((a.animType = "MozTransform"),
          (a.transformType = "-moz-transform"),
          (a.transitionType = "MozTransition"),
          void 0 === b.perspectiveProperty &&
            void 0 === b.MozPerspective &&
            (a.animType = !1)),
        void 0 !== b.webkitTransform &&
          ((a.animType = "webkitTransform"),
          (a.transformType = "-webkit-transform"),
          (a.transitionType = "webkitTransition"),
          void 0 === b.perspectiveProperty &&
            void 0 === b.webkitPerspective &&
            (a.animType = !1)),
        void 0 !== b.msTransform &&
          ((a.animType = "msTransform"),
          (a.transformType = "-ms-transform"),
          (a.transitionType = "msTransition"),
          void 0 === b.msTransform && (a.animType = !1)),
        void 0 !== b.transform &&
          a.animType !== !1 &&
          ((a.animType = "transform"),
          (a.transformType = "transform"),
          (a.transitionType = "transition")),
        (a.transformsEnabled =
          a.options.useTransform && null !== a.animType && a.animType !== !1);
    }),
    (b.prototype.setSlideClasses = function (a) {
      var c,
        d,
        e,
        f,
        b = this;
      (d = b.$slider
        .find(".slick-slide")
        .removeClass("slick-active slick-center slick-current")
        .attr("aria-hidden", "true")),
        b.$slides.eq(a).addClass("slick-current"),
        b.options.centerMode === !0
          ? ((c = Math.floor(b.options.slidesToShow / 2)),
            b.options.infinite === !0 &&
              (a >= c && a <= b.slideCount - 1 - c
                ? b.$slides
                    .slice(a - c, a + c + 1)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : ((e = b.options.slidesToShow + a),
                  d
                    .slice(e - c + 1, e + c + 2)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")),
              0 === a
                ? d
                    .eq(d.length - 1 - b.options.slidesToShow)
                    .addClass("slick-center")
                : a === b.slideCount - 1 &&
                  d.eq(b.options.slidesToShow).addClass("slick-center")),
            b.$slides.eq(a).addClass("slick-center"))
          : a >= 0 && a <= b.slideCount - b.options.slidesToShow
          ? b.$slides
              .slice(a, a + b.options.slidesToShow)
              .addClass("slick-active")
              .attr("aria-hidden", "false")
          : d.length <= b.options.slidesToShow
          ? d.addClass("slick-active").attr("aria-hidden", "false")
          : ((f = b.slideCount % b.options.slidesToShow),
            (e = b.options.infinite === !0 ? b.options.slidesToShow + a : a),
            b.options.slidesToShow == b.options.slidesToScroll &&
            b.slideCount - a < b.options.slidesToShow
              ? d
                  .slice(e - (b.options.slidesToShow - f), e + f)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")
              : d
                  .slice(e, e + b.options.slidesToShow)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")),
        "ondemand" === b.options.lazyLoad && b.lazyLoad();
    }),
    (b.prototype.setupInfinite = function () {
      var c,
        d,
        e,
        b = this;
      if (
        (b.options.fade === !0 && (b.options.centerMode = !1),
        b.options.infinite === !0 &&
          b.options.fade === !1 &&
          ((d = null), b.slideCount > b.options.slidesToShow))
      ) {
        for (
          e =
            b.options.centerMode === !0
              ? b.options.slidesToShow + 1
              : b.options.slidesToShow,
            c = b.slideCount;
          c > b.slideCount - e;
          c -= 1
        )
          (d = c - 1),
            a(b.$slides[d])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", d - b.slideCount)
              .prependTo(b.$slideTrack)
              .addClass("slick-cloned");
        for (c = 0; e > c; c += 1)
          (d = c),
            a(b.$slides[d])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", d + b.slideCount)
              .appendTo(b.$slideTrack)
              .addClass("slick-cloned");
        b.$slideTrack
          .find(".slick-cloned")
          .find("[id]")
          .each(function () {
            a(this).attr("id", "");
          });
      }
    }),
    (b.prototype.setPaused = function (a) {
      var b = this;
      b.options.autoplay === !0 &&
        b.options.pauseOnHover === !0 &&
        ((b.paused = a), a ? b.autoPlayClear() : b.autoPlay());
    }),
    (b.prototype.selectHandler = function (b) {
      var c = this,
        d = a(b.target).is(".slick-slide")
          ? a(b.target)
          : a(b.target).parents(".slick-slide"),
        e = parseInt(d.attr("data-slick-index"));
      return (
        e || (e = 0),
        c.slideCount <= c.options.slidesToShow
          ? (c.setSlideClasses(e), void c.asNavFor(e))
          : void c.slideHandler(e)
      );
    }),
    (b.prototype.slideHandler = function (a, b, c) {
      var d,
        e,
        f,
        g,
        h = null,
        i = this;
      return (
        (b = b || !1),
        (i.animating === !0 && i.options.waitForAnimate === !0) ||
        (i.options.fade === !0 && i.currentSlide === a) ||
        i.slideCount <= i.options.slidesToShow
          ? void 0
          : (b === !1 && i.asNavFor(a),
            (d = a),
            (h = i.getLeft(d)),
            (g = i.getLeft(i.currentSlide)),
            (i.currentLeft = null === i.swipeLeft ? g : i.swipeLeft),
            i.options.infinite === !1 &&
            i.options.centerMode === !1 &&
            (0 > a || a > i.getDotCount() * i.options.slidesToScroll)
              ? void (
                  i.options.fade === !1 &&
                  ((d = i.currentSlide),
                  c !== !0
                    ? i.animateSlide(g, function () {
                        i.postSlide(d);
                      })
                    : i.postSlide(d))
                )
              : i.options.infinite === !1 &&
                i.options.centerMode === !0 &&
                (0 > a || a > i.slideCount - i.options.slidesToScroll)
              ? void (
                  i.options.fade === !1 &&
                  ((d = i.currentSlide),
                  c !== !0
                    ? i.animateSlide(g, function () {
                        i.postSlide(d);
                      })
                    : i.postSlide(d))
                )
              : (i.options.autoplay === !0 && clearInterval(i.autoPlayTimer),
                (e =
                  0 > d
                    ? i.slideCount % i.options.slidesToScroll !== 0
                      ? i.slideCount - (i.slideCount % i.options.slidesToScroll)
                      : i.slideCount + d
                    : d >= i.slideCount
                    ? i.slideCount % i.options.slidesToScroll !== 0
                      ? 0
                      : d - i.slideCount
                    : d),
                (i.animating = !0),
                i.$slider.trigger("beforeChange", [i, i.currentSlide, e]),
                (f = i.currentSlide),
                (i.currentSlide = e),
                i.setSlideClasses(i.currentSlide),
                i.updateDots(),
                i.updateArrows(),
                i.options.fade === !0
                  ? (c !== !0
                      ? (i.fadeSlideOut(f),
                        i.fadeSlide(e, function () {
                          i.postSlide(e);
                        }))
                      : i.postSlide(e),
                    void i.animateHeight())
                  : void (c !== !0
                      ? i.animateSlide(h, function () {
                          i.postSlide(e);
                        })
                      : i.postSlide(e))))
      );
    }),
    (b.prototype.startLoad = function () {
      var a = this;
      a.options.arrows === !0 &&
        a.slideCount > a.options.slidesToShow &&
        (a.$prevArrow.hide(), a.$nextArrow.hide()),
        a.options.dots === !0 &&
          a.slideCount > a.options.slidesToShow &&
          a.$dots.hide(),
        a.$slider.addClass("slick-loading");
    }),
    (b.prototype.swipeDirection = function () {
      var a,
        b,
        c,
        d,
        e = this;
      return (
        (a = e.touchObject.startX - e.touchObject.curX),
        (b = e.touchObject.startY - e.touchObject.curY),
        (c = Math.atan2(b, a)),
        (d = Math.round((180 * c) / Math.PI)),
        0 > d && (d = 360 - Math.abs(d)),
        45 >= d && d >= 0
          ? e.options.rtl === !1
            ? "left"
            : "right"
          : 360 >= d && d >= 315
          ? e.options.rtl === !1
            ? "left"
            : "right"
          : d >= 135 && 225 >= d
          ? e.options.rtl === !1
            ? "right"
            : "left"
          : e.options.verticalSwiping === !0
          ? d >= 35 && 135 >= d
            ? "left"
            : "right"
          : "vertical"
      );
    }),
    (b.prototype.swipeEnd = function (a) {
      var c,
        b = this;
      if (
        ((b.dragging = !1),
        (b.shouldClick = b.touchObject.swipeLength > 10 ? !1 : !0),
        void 0 === b.touchObject.curX)
      )
        return !1;
      if (
        (b.touchObject.edgeHit === !0 &&
          b.$slider.trigger("edge", [b, b.swipeDirection()]),
        b.touchObject.swipeLength >= b.touchObject.minSwipe)
      )
        switch (b.swipeDirection()) {
          case "left":
            (c = b.options.swipeToSlide
              ? b.checkNavigable(b.currentSlide + b.getSlideCount())
              : b.currentSlide + b.getSlideCount()),
              b.slideHandler(c),
              (b.currentDirection = 0),
              (b.touchObject = {}),
              b.$slider.trigger("swipe", [b, "left"]);
            break;
          case "right":
            (c = b.options.swipeToSlide
              ? b.checkNavigable(b.currentSlide - b.getSlideCount())
              : b.currentSlide - b.getSlideCount()),
              b.slideHandler(c),
              (b.currentDirection = 1),
              (b.touchObject = {}),
              b.$slider.trigger("swipe", [b, "right"]);
        }
      else
        b.touchObject.startX !== b.touchObject.curX &&
          (b.slideHandler(b.currentSlide), (b.touchObject = {}));
    }),
    (b.prototype.swipeHandler = function (a) {
      var b = this;
      if (
        !(
          b.options.swipe === !1 ||
          ("ontouchend" in document && b.options.swipe === !1) ||
          (b.options.draggable === !1 && -1 !== a.type.indexOf("mouse"))
        )
      )
        switch (
          ((b.touchObject.fingerCount =
            a.originalEvent && void 0 !== a.originalEvent.touches
              ? a.originalEvent.touches.length
              : 1),
          (b.touchObject.minSwipe = b.listWidth / b.options.touchThreshold),
          b.options.verticalSwiping === !0 &&
            (b.touchObject.minSwipe = b.listHeight / b.options.touchThreshold),
          a.data.action)
        ) {
          case "start":
            b.swipeStart(a);
            break;
          case "move":
            b.swipeMove(a);
            break;
          case "end":
            b.swipeEnd(a);
        }
    }),
    (b.prototype.swipeMove = function (a) {
      var d,
        e,
        f,
        g,
        h,
        b = this;
      return (
        (h = void 0 !== a.originalEvent ? a.originalEvent.touches : null),
        !b.dragging || (h && 1 !== h.length)
          ? !1
          : ((d = b.getLeft(b.currentSlide)),
            (b.touchObject.curX = void 0 !== h ? h[0].pageX : a.clientX),
            (b.touchObject.curY = void 0 !== h ? h[0].pageY : a.clientY),
            (b.touchObject.swipeLength = Math.round(
              Math.sqrt(Math.pow(b.touchObject.curX - b.touchObject.startX, 2))
            )),
            b.options.verticalSwiping === !0 &&
              (b.touchObject.swipeLength = Math.round(
                Math.sqrt(
                  Math.pow(b.touchObject.curY - b.touchObject.startY, 2)
                )
              )),
            (e = b.swipeDirection()),
            "vertical" !== e
              ? (void 0 !== a.originalEvent &&
                  b.touchObject.swipeLength > 4 &&
                  a.preventDefault(),
                (g =
                  (b.options.rtl === !1 ? 1 : -1) *
                  (b.touchObject.curX > b.touchObject.startX ? 1 : -1)),
                b.options.verticalSwiping === !0 &&
                  (g = b.touchObject.curY > b.touchObject.startY ? 1 : -1),
                (f = b.touchObject.swipeLength),
                (b.touchObject.edgeHit = !1),
                b.options.infinite === !1 &&
                  ((0 === b.currentSlide && "right" === e) ||
                    (b.currentSlide >= b.getDotCount() && "left" === e)) &&
                  ((f = b.touchObject.swipeLength * b.options.edgeFriction),
                  (b.touchObject.edgeHit = !0)),
                b.options.vertical === !1
                  ? (b.swipeLeft = d + f * g)
                  : (b.swipeLeft =
                      d + f * (b.$list.height() / b.listWidth) * g),
                b.options.verticalSwiping === !0 && (b.swipeLeft = d + f * g),
                b.options.fade === !0 || b.options.touchMove === !1
                  ? !1
                  : b.animating === !0
                  ? ((b.swipeLeft = null), !1)
                  : void b.setCSS(b.swipeLeft))
              : void 0)
      );
    }),
    (b.prototype.swipeStart = function (a) {
      var c,
        b = this;
      return 1 !== b.touchObject.fingerCount ||
        b.slideCount <= b.options.slidesToShow
        ? ((b.touchObject = {}), !1)
        : (void 0 !== a.originalEvent &&
            void 0 !== a.originalEvent.touches &&
            (c = a.originalEvent.touches[0]),
          (b.touchObject.startX = b.touchObject.curX =
            void 0 !== c ? c.pageX : a.clientX),
          (b.touchObject.startY = b.touchObject.curY =
            void 0 !== c ? c.pageY : a.clientY),
          void (b.dragging = !0));
    }),
    (b.prototype.unfilterSlides = b.prototype.slickUnfilter =
      function () {
        var a = this;
        null !== a.$slidesCache &&
          (a.unload(),
          a.$slideTrack.children(this.options.slide).detach(),
          a.$slidesCache.appendTo(a.$slideTrack),
          a.reinit());
      }),
    (b.prototype.unload = function () {
      var b = this;
      a(".slick-cloned", b.$slider).remove(),
        b.$dots && b.$dots.remove(),
        b.$prevArrow &&
          b.htmlExpr.test(b.options.prevArrow) &&
          b.$prevArrow.remove(),
        b.$nextArrow &&
          b.htmlExpr.test(b.options.nextArrow) &&
          b.$nextArrow.remove(),
        b.$slides
          .removeClass("slick-slide slick-active slick-visible slick-current")
          .attr("aria-hidden", "true")
          .css("width", "");
    }),
    (b.prototype.unslick = function (a) {
      var b = this;
      b.$slider.trigger("unslick", [b, a]), b.destroy();
    }),
    (b.prototype.updateArrows = function () {
      var b,
        a = this;
      (b = Math.floor(a.options.slidesToShow / 2)),
        a.options.arrows === !0 &&
          a.slideCount > a.options.slidesToShow &&
          !a.options.infinite &&
          (a.$prevArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          a.$nextArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          0 === a.currentSlide
            ? (a.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              a.$nextArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : a.currentSlide >= a.slideCount - a.options.slidesToShow &&
              a.options.centerMode === !1
            ? (a.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              a.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : a.currentSlide >= a.slideCount - 1 &&
              a.options.centerMode === !0 &&
              (a.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              a.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false")));
    }),
    (b.prototype.updateDots = function () {
      var a = this;
      null !== a.$dots &&
        (a.$dots
          .find("li")
          .removeClass("slick-active")
          .attr("aria-hidden", "true"),
        a.$dots
          .find("li")
          .eq(Math.floor(a.currentSlide / a.options.slidesToScroll))
          .addClass("slick-active")
          .attr("aria-hidden", "false"));
    }),
    (b.prototype.visibility = function () {
      var a = this;
      document[a.hidden]
        ? ((a.paused = !0), a.autoPlayClear())
        : a.options.autoplay === !0 && ((a.paused = !1), a.autoPlay());
    }),
    (b.prototype.initADA = function () {
      var b = this;
      b.$slides
        .add(b.$slideTrack.find(".slick-cloned"))
        .attr({ "aria-hidden": "true", tabindex: "-1" })
        .find("a, input, button, select")
        .attr({ tabindex: "-1" }),
        b.$slideTrack.attr("role", "listbox"),
        b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function (c) {
          a(this).attr({
            role: "option",
            "aria-describedby": "slick-slide" + b.instanceUid + c,
          });
        }),
        null !== b.$dots &&
          b.$dots
            .attr("role", "tablist")
            .find("li")
            .each(function (c) {
              a(this).attr({
                role: "presentation",
                "aria-selected": "false",
                "aria-controls": "navigation" + b.instanceUid + c,
                id: "slick-slide" + b.instanceUid + c,
              });
            })
            .first()
            .attr("aria-selected", "true")
            .end()
            .find("button")
            .attr("role", "button")
            .end()
            .closest("div")
            .attr("role", "toolbar"),
        b.activateADA();
    }),
    (b.prototype.activateADA = function () {
      var a = this;
      a.$slideTrack
        .find(".slick-active")
        .attr({ "aria-hidden": "false" })
        .find("a, input, button, select")
        .attr({ tabindex: "0" });
    }),
    (b.prototype.focusHandler = function () {
      var b = this;
      b.$slider.on("focus.slick blur.slick", "*", function (c) {
        c.stopImmediatePropagation();
        var d = a(this);
        setTimeout(function () {
          b.isPlay &&
            (d.is(":focus")
              ? (b.autoPlayClear(), (b.paused = !0))
              : ((b.paused = !1), b.autoPlay()));
        }, 0);
      });
    }),
    (a.fn.slick = function () {
      var f,
        g,
        a = this,
        c = arguments[0],
        d = Array.prototype.slice.call(arguments, 1),
        e = a.length;
      for (f = 0; e > f; f++)
        if (
          ("object" == typeof c || "undefined" == typeof c
            ? (a[f].slick = new b(a[f], c))
            : (g = a[f].slick[c].apply(a[f].slick, d)),
          "undefined" != typeof g)
        )
          return g;
      return a;
    });
});
!(function (a, b, c, d) {
  function e(b, c) {
    (this.settings = null),
      (this.options = a.extend({}, e.Defaults, c)),
      (this.$element = a(b)),
      (this._handlers = {}),
      (this._plugins = {}),
      (this._supress = {}),
      (this._current = null),
      (this._speed = null),
      (this._coordinates = []),
      (this._breakpoint = null),
      (this._width = null),
      (this._items = []),
      (this._clones = []),
      (this._mergers = []),
      (this._widths = []),
      (this._invalidated = {}),
      (this._pipe = []),
      (this._drag = {
        time: null,
        target: null,
        pointer: null,
        stage: { start: null, current: null },
        direction: null,
      }),
      (this._states = {
        current: {},
        tags: {
          initializing: ["busy"],
          animating: ["busy"],
          dragging: ["interacting"],
        },
      }),
      a.each(
        ["onResize", "onThrottledResize"],
        a.proxy(function (b, c) {
          this._handlers[c] = a.proxy(this[c], this);
        }, this)
      ),
      a.each(
        e.Plugins,
        a.proxy(function (a, b) {
          this._plugins[a.charAt(0).toLowerCase() + a.slice(1)] = new b(this);
        }, this)
      ),
      a.each(
        e.Workers,
        a.proxy(function (b, c) {
          this._pipe.push({ filter: c.filter, run: a.proxy(c.run, this) });
        }, this)
      ),
      this.setup(),
      this.initialize();
  }
  (e.Defaults = {
    items: 3,
    loop: !1,
    center: !1,
    rewind: !1,
    mouseDrag: !0,
    touchDrag: !0,
    pullDrag: !0,
    freeDrag: !1,
    margin: 0,
    stagePadding: 0,
    merge: !1,
    mergeFit: !0,
    autoWidth: !1,
    startPosition: 0,
    rtl: !1,
    smartSpeed: 250,
    fluidSpeed: !1,
    dragEndSpeed: !1,
    responsive: {},
    responsiveRefreshRate: 200,
    responsiveBaseElement: b,
    fallbackEasing: "swing",
    info: !1,
    nestedItemSelector: !1,
    itemElement: "div",
    stageElement: "div",
    refreshClass: "owl-refresh",
    loadedClass: "owl-loaded",
    loadingClass: "owl-loading",
    rtlClass: "owl-rtl",
    responsiveClass: "owl-responsive",
    dragClass: "owl-drag",
    itemClass: "owl-item",
    stageClass: "owl-stage",
    stageOuterClass: "owl-stage-outer",
    grabClass: "owl-grab",
  }),
    (e.Width = { Default: "default", Inner: "inner", Outer: "outer" }),
    (e.Type = { Event: "event", State: "state" }),
    (e.Plugins = {}),
    (e.Workers = [
      {
        filter: ["width", "settings"],
        run: function () {
          this._width = this.$element.width();
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          a.current = this._items && this._items[this.relative(this._current)];
        },
      },
      {
        filter: ["items", "settings"],
        run: function () {
          this.$stage.children(".cloned").remove();
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          var b = this.settings.margin || "",
            c = !this.settings.autoWidth,
            d = this.settings.rtl,
            e = {
              width: "auto",
              "margin-left": d ? b : "",
              "margin-right": d ? "" : b,
            };
          !c && this.$stage.children().css(e), (a.css = e);
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          var b =
              (this.width() / this.settings.items).toFixed(3) -
              this.settings.margin,
            c = null,
            d = this._items.length,
            e = !this.settings.autoWidth,
            f = [];
          for (a.items = { merge: !1, width: b }; d--; )
            (c = this._mergers[d]),
              (c =
                (this.settings.mergeFit && Math.min(c, this.settings.items)) ||
                c),
              (a.items.merge = c > 1 || a.items.merge),
              (f[d] = e ? b * c : this._items[d].width());
          this._widths = f;
        },
      },
      {
        filter: ["items", "settings"],
        run: function () {
          var b = [],
            c = this._items,
            d = this.settings,
            e = Math.max(2 * d.items, 4),
            f = 2 * Math.ceil(c.length / 2),
            g = d.loop && c.length ? (d.rewind ? e : Math.max(e, f)) : 0,
            h = "",
            i = "";
          for (g /= 2; g--; )
            b.push(this.normalize(b.length / 2, !0)),
              (h += c[b[b.length - 1]][0].outerHTML),
              b.push(this.normalize(c.length - 1 - (b.length - 1) / 2, !0)),
              (i = c[b[b.length - 1]][0].outerHTML + i);
          (this._clones = b),
            a(h).addClass("cloned").appendTo(this.$stage),
            a(i).addClass("cloned").prependTo(this.$stage);
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function () {
          for (
            var a = this.settings.rtl ? 1 : -1,
              b = this._clones.length + this._items.length,
              c = -1,
              d = 0,
              e = 0,
              f = [];
            ++c < b;

          )
            (d = f[c - 1] || 0),
              (e = this._widths[this.relative(c)] + this.settings.margin),
              f.push(d + e * a);
          this._coordinates = f;
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function () {
          var a = this.settings.stagePadding,
            b = this._coordinates,
            c = {
              width: Math.ceil(Math.abs(b[b.length - 1])) + 2 * a,
              "padding-left": a || "",
              "padding-right": a || "",
            };
          this.$stage.css(c);
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          var b = this._coordinates.length,
            c = !this.settings.autoWidth,
            d = this.$stage.children();
          if (c && a.items.merge)
            for (; b--; )
              (a.css.width = this._widths[this.relative(b)]),
                d.eq(b).css(a.css);
          else c && ((a.css.width = a.items.width), d.css(a.css));
        },
      },
      {
        filter: ["items"],
        run: function () {
          this._coordinates.length < 1 && this.$stage.removeAttr("style");
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          (a.current = a.current ? this.$stage.children().index(a.current) : 0),
            (a.current = Math.max(
              this.minimum(),
              Math.min(this.maximum(), a.current)
            )),
            this.reset(a.current);
        },
      },
      {
        filter: ["position"],
        run: function () {
          this.animate(this.coordinates(this._current));
        },
      },
      {
        filter: ["width", "position", "items", "settings"],
        run: function () {
          var a,
            b,
            c,
            d,
            e = this.settings.rtl ? 1 : -1,
            f = 2 * this.settings.stagePadding,
            g = this.coordinates(this.current()) + f,
            h = g + this.width() * e,
            i = [];
          for (c = 0, d = this._coordinates.length; d > c; c++)
            (a = this._coordinates[c - 1] || 0),
              (b = Math.abs(this._coordinates[c]) + f * e),
              ((this.op(a, "<=", g) && this.op(a, ">", h)) ||
                (this.op(b, "<", g) && this.op(b, ">", h))) &&
                i.push(c);
          this.$stage.children(".active").removeClass("active"),
            this.$stage
              .children(":eq(" + i.join("), :eq(") + ")")
              .addClass("active"),
            this.settings.center &&
              (this.$stage.children(".center").removeClass("center"),
              this.$stage.children().eq(this.current()).addClass("center"));
        },
      },
    ]),
    (e.prototype.initialize = function () {
      if (
        (this.enter("initializing"),
        this.trigger("initialize"),
        this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl),
        this.settings.autoWidth && !this.is("pre-loading"))
      ) {
        var b, c, e;
        (b = this.$element.find("img")),
          (c = this.settings.nestedItemSelector
            ? "." + this.settings.nestedItemSelector
            : d),
          (e = this.$element.children(c).width()),
          b.length && 0 >= e && this.preloadAutoWidthImages(b);
      }
      this.$element.addClass(this.options.loadingClass),
        (this.$stage = a(
          "<" +
            this.settings.stageElement +
            ' class="' +
            this.settings.stageClass +
            '"/>'
        ).wrap('<div class="' + this.settings.stageOuterClass + '"/>')),
        this.$element.append(this.$stage.parent()),
        this.replace(this.$element.children().not(this.$stage.parent())),
        this.$element.is(":visible")
          ? this.refresh()
          : this.invalidate("width"),
        this.$element
          .removeClass(this.options.loadingClass)
          .addClass(this.options.loadedClass),
        this.registerEventHandlers(),
        this.leave("initializing"),
        this.trigger("initialized");
    }),
    (e.prototype.setup = function () {
      var b = this.viewport(),
        c = this.options.responsive,
        d = -1,
        e = null;
      c
        ? (a.each(c, function (a) {
            b >= a && a > d && (d = Number(a));
          }),
          (e = a.extend({}, this.options, c[d])),
          "function" == typeof e.stagePadding &&
            (e.stagePadding = e.stagePadding()),
          delete e.responsive,
          e.responsiveClass &&
            this.$element.attr(
              "class",
              this.$element
                .attr("class")
                .replace(
                  new RegExp(
                    "(" + this.options.responsiveClass + "-)\\S+\\s",
                    "g"
                  ),
                  "$1" + d
                )
            ))
        : (e = a.extend({}, this.options)),
        this.trigger("change", { property: { name: "settings", value: e } }),
        (this._breakpoint = d),
        (this.settings = e),
        this.invalidate("settings"),
        this.trigger("changed", {
          property: { name: "settings", value: this.settings },
        });
    }),
    (e.prototype.optionsLogic = function () {
      this.settings.autoWidth &&
        ((this.settings.stagePadding = !1), (this.settings.merge = !1));
    }),
    (e.prototype.prepare = function (b) {
      var c = this.trigger("prepare", { content: b });
      return (
        c.data ||
          (c.data = a("<" + this.settings.itemElement + "/>")
            .addClass(this.options.itemClass)
            .append(b)),
        this.trigger("prepared", { content: c.data }),
        c.data
      );
    }),
    (e.prototype.update = function () {
      for (
        var b = 0,
          c = this._pipe.length,
          d = a.proxy(function (a) {
            return this[a];
          }, this._invalidated),
          e = {};
        c > b;

      )
        (this._invalidated.all || a.grep(this._pipe[b].filter, d).length > 0) &&
          this._pipe[b].run(e),
          b++;
      (this._invalidated = {}), !this.is("valid") && this.enter("valid");
    }),
    (e.prototype.width = function (a) {
      switch ((a = a || e.Width.Default)) {
        case e.Width.Inner:
        case e.Width.Outer:
          return this._width;
        default:
          return (
            this._width - 2 * this.settings.stagePadding + this.settings.margin
          );
      }
    }),
    (e.prototype.refresh = function () {
      this.enter("refreshing"),
        this.trigger("refresh"),
        this.setup(),
        this.optionsLogic(),
        this.$element.addClass(this.options.refreshClass),
        this.update(),
        this.$element.removeClass(this.options.refreshClass),
        this.leave("refreshing"),
        this.trigger("refreshed");
    }),
    (e.prototype.onThrottledResize = function () {
      b.clearTimeout(this.resizeTimer),
        (this.resizeTimer = b.setTimeout(
          this._handlers.onResize,
          this.settings.responsiveRefreshRate
        ));
    }),
    (e.prototype.onResize = function () {
      return this._items.length
        ? this._width === this.$element.width()
          ? !1
          : this.$element.is(":visible")
          ? (this.enter("resizing"),
            this.trigger("resize").isDefaultPrevented()
              ? (this.leave("resizing"), !1)
              : (this.invalidate("width"),
                this.refresh(),
                this.leave("resizing"),
                void this.trigger("resized")))
          : !1
        : !1;
    }),
    (e.prototype.registerEventHandlers = function () {
      a.support.transition &&
        this.$stage.on(
          a.support.transition.end + ".owl.core",
          a.proxy(this.onTransitionEnd, this)
        ),
        this.settings.responsive !== !1 &&
          this.on(b, "resize", this._handlers.onThrottledResize),
        this.settings.mouseDrag &&
          (this.$element.addClass(this.options.dragClass),
          this.$stage.on("mousedown.owl.core", a.proxy(this.onDragStart, this)),
          this.$stage.on(
            "dragstart.owl.core selectstart.owl.core",
            function () {
              return !1;
            }
          )),
        this.settings.touchDrag &&
          (this.$stage.on(
            "touchstart.owl.core",
            a.proxy(this.onDragStart, this)
          ),
          this.$stage.on(
            "touchcancel.owl.core",
            a.proxy(this.onDragEnd, this)
          ));
    }),
    (e.prototype.onDragStart = function (b) {
      var d = null;
      3 !== b.which &&
        (a.support.transform
          ? ((d = this.$stage
              .css("transform")
              .replace(/.*\(|\)| /g, "")
              .split(",")),
            (d = {
              x: d[16 === d.length ? 12 : 4],
              y: d[16 === d.length ? 13 : 5],
            }))
          : ((d = this.$stage.position()),
            (d = {
              x: this.settings.rtl
                ? d.left +
                  this.$stage.width() -
                  this.width() +
                  this.settings.margin
                : d.left,
              y: d.top,
            })),
        this.is("animating") &&
          (a.support.transform ? this.animate(d.x) : this.$stage.stop(),
          this.invalidate("position")),
        this.$element.toggleClass(
          this.options.grabClass,
          "mousedown" === b.type
        ),
        this.speed(0),
        (this._drag.time = new Date().getTime()),
        (this._drag.target = a(b.target)),
        (this._drag.stage.start = d),
        (this._drag.stage.current = d),
        (this._drag.pointer = this.pointer(b)),
        a(c).on(
          "mouseup.owl.core touchend.owl.core",
          a.proxy(this.onDragEnd, this)
        ),
        a(c).one(
          "mousemove.owl.core touchmove.owl.core",
          a.proxy(function (b) {
            var d = this.difference(this._drag.pointer, this.pointer(b));
            a(c).on(
              "mousemove.owl.core touchmove.owl.core",
              a.proxy(this.onDragMove, this)
            ),
              (Math.abs(d.x) < Math.abs(d.y) && this.is("valid")) ||
                (b.preventDefault(),
                this.enter("dragging"),
                this.trigger("drag"));
          }, this)
        ));
    }),
    (e.prototype.onDragMove = function (a) {
      var b = null,
        c = null,
        d = null,
        e = this.difference(this._drag.pointer, this.pointer(a)),
        f = this.difference(this._drag.stage.start, e);
      this.is("dragging") &&
        (a.preventDefault(),
        this.settings.loop
          ? ((b = this.coordinates(this.minimum())),
            (c = this.coordinates(this.maximum() + 1) - b),
            (f.x = ((((f.x - b) % c) + c) % c) + b))
          : ((b = this.settings.rtl
              ? this.coordinates(this.maximum())
              : this.coordinates(this.minimum())),
            (c = this.settings.rtl
              ? this.coordinates(this.minimum())
              : this.coordinates(this.maximum())),
            (d = this.settings.pullDrag ? (-1 * e.x) / 5 : 0),
            (f.x = Math.max(Math.min(f.x, b + d), c + d))),
        (this._drag.stage.current = f),
        this.animate(f.x));
    }),
    (e.prototype.onDragEnd = function (b) {
      var d = this.difference(this._drag.pointer, this.pointer(b)),
        e = this._drag.stage.current,
        f = (d.x > 0) ^ this.settings.rtl ? "left" : "right";
      a(c).off(".owl.core"),
        this.$element.removeClass(this.options.grabClass),
        ((0 !== d.x && this.is("dragging")) || !this.is("valid")) &&
          (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
          this.current(this.closest(e.x, 0 !== d.x ? f : this._drag.direction)),
          this.invalidate("position"),
          this.update(),
          (this._drag.direction = f),
          (Math.abs(d.x) > 3 || new Date().getTime() - this._drag.time > 300) &&
            this._drag.target.one("click.owl.core", function () {
              return !1;
            })),
        this.is("dragging") &&
          (this.leave("dragging"), this.trigger("dragged"));
    }),
    (e.prototype.closest = function (b, c) {
      var d = -1,
        e = 30,
        f = this.width(),
        g = this.coordinates();
      return (
        this.settings.freeDrag ||
          a.each(
            g,
            a.proxy(function (a, h) {
              return (
                "left" === c && b > h - e && h + e > b
                  ? (d = a)
                  : "right" === c && b > h - f - e && h - f + e > b
                  ? (d = a + 1)
                  : this.op(b, "<", h) &&
                    this.op(b, ">", g[a + 1] || h - f) &&
                    (d = "left" === c ? a + 1 : a),
                -1 === d
              );
            }, this)
          ),
        this.settings.loop ||
          (this.op(b, ">", g[this.minimum()])
            ? (d = b = this.minimum())
            : this.op(b, "<", g[this.maximum()]) && (d = b = this.maximum())),
        d
      );
    }),
    (e.prototype.animate = function (b) {
      var c = this.speed() > 0;
      this.is("animating") && this.onTransitionEnd(),
        c && (this.enter("animating"), this.trigger("translate")),
        a.support.transform3d && a.support.transition
          ? this.$stage.css({
              transform: "translate3d(" + b + "px,0px,0px)",
              transition: this.speed() / 1e3 + "s",
            })
          : c
          ? this.$stage.animate(
              { left: b + "px" },
              this.speed(),
              this.settings.fallbackEasing,
              a.proxy(this.onTransitionEnd, this)
            )
          : this.$stage.css({ left: b + "px" });
    }),
    (e.prototype.is = function (a) {
      return this._states.current[a] && this._states.current[a] > 0;
    }),
    (e.prototype.current = function (a) {
      if (a === d) return this._current;
      if (0 === this._items.length) return d;
      if (((a = this.normalize(a)), this._current !== a)) {
        var b = this.trigger("change", {
          property: { name: "position", value: a },
        });
        b.data !== d && (a = this.normalize(b.data)),
          (this._current = a),
          this.invalidate("position"),
          this.trigger("changed", {
            property: { name: "position", value: this._current },
          });
      }
      return this._current;
    }),
    (e.prototype.invalidate = function (b) {
      return (
        "string" === a.type(b) &&
          ((this._invalidated[b] = !0),
          this.is("valid") && this.leave("valid")),
        a.map(this._invalidated, function (a, b) {
          return b;
        })
      );
    }),
    (e.prototype.reset = function (a) {
      (a = this.normalize(a)),
        a !== d &&
          ((this._speed = 0),
          (this._current = a),
          this.suppress(["translate", "translated"]),
          this.animate(this.coordinates(a)),
          this.release(["translate", "translated"]));
    }),
    (e.prototype.normalize = function (a, b) {
      var c = this._items.length,
        e = b ? 0 : this._clones.length;
      return (
        !this.isNumeric(a) || 1 > c
          ? (a = d)
          : (0 > a || a >= c + e) &&
            (a = ((((a - e / 2) % c) + c) % c) + e / 2),
        a
      );
    }),
    (e.prototype.relative = function (a) {
      return (a -= this._clones.length / 2), this.normalize(a, !0);
    }),
    (e.prototype.maximum = function (a) {
      var b,
        c,
        d,
        e = this.settings,
        f = this._coordinates.length;
      if (e.loop) f = this._clones.length / 2 + this._items.length - 1;
      else if (e.autoWidth || e.merge) {
        for (
          b = this._items.length,
            c = this._items[--b].width(),
            d = this.$element.width();
          b-- &&
          ((c += this._items[b].width() + this.settings.margin), !(c > d));

        );
        f = b + 1;
      } else
        f = e.center ? this._items.length - 1 : this._items.length - e.items;
      return a && (f -= this._clones.length / 2), Math.max(f, 0);
    }),
    (e.prototype.minimum = function (a) {
      return a ? 0 : this._clones.length / 2;
    }),
    (e.prototype.items = function (a) {
      return a === d
        ? this._items.slice()
        : ((a = this.normalize(a, !0)), this._items[a]);
    }),
    (e.prototype.mergers = function (a) {
      return a === d
        ? this._mergers.slice()
        : ((a = this.normalize(a, !0)), this._mergers[a]);
    }),
    (e.prototype.clones = function (b) {
      var c = this._clones.length / 2,
        e = c + this._items.length,
        f = function (a) {
          return a % 2 === 0 ? e + a / 2 : c - (a + 1) / 2;
        };
      return b === d
        ? a.map(this._clones, function (a, b) {
            return f(b);
          })
        : a.map(this._clones, function (a, c) {
            return a === b ? f(c) : null;
          });
    }),
    (e.prototype.speed = function (a) {
      return a !== d && (this._speed = a), this._speed;
    }),
    (e.prototype.coordinates = function (b) {
      var c,
        e = 1,
        f = b - 1;
      return b === d
        ? a.map(
            this._coordinates,
            a.proxy(function (a, b) {
              return this.coordinates(b);
            }, this)
          )
        : (this.settings.center
            ? (this.settings.rtl && ((e = -1), (f = b + 1)),
              (c = this._coordinates[b]),
              (c += ((this.width() - c + (this._coordinates[f] || 0)) / 2) * e))
            : (c = this._coordinates[f] || 0),
          (c = Math.ceil(c)));
    }),
    (e.prototype.duration = function (a, b, c) {
      return 0 === c
        ? 0
        : Math.min(Math.max(Math.abs(b - a), 1), 6) *
            Math.abs(c || this.settings.smartSpeed);
    }),
    (e.prototype.to = function (a, b) {
      var c = this.current(),
        d = null,
        e = a - this.relative(c),
        f = (e > 0) - (0 > e),
        g = this._items.length,
        h = this.minimum(),
        i = this.maximum();
      this.settings.loop
        ? (!this.settings.rewind && Math.abs(e) > g / 2 && (e += -1 * f * g),
          (a = c + e),
          (d = ((((a - h) % g) + g) % g) + h),
          d !== a &&
            i >= d - e &&
            d - e > 0 &&
            ((c = d - e), (a = d), this.reset(c)))
        : this.settings.rewind
        ? ((i += 1), (a = ((a % i) + i) % i))
        : (a = Math.max(h, Math.min(i, a))),
        this.speed(this.duration(c, a, b)),
        this.current(a),
        this.$element.is(":visible") && this.update();
    }),
    (e.prototype.next = function (a) {
      (a = a || !1), this.to(this.relative(this.current()) + 1, a);
    }),
    (e.prototype.prev = function (a) {
      (a = a || !1), this.to(this.relative(this.current()) - 1, a);
    }),
    (e.prototype.onTransitionEnd = function (a) {
      return a !== d &&
        (a.stopPropagation(),
        (a.target || a.srcElement || a.originalTarget) !== this.$stage.get(0))
        ? !1
        : (this.leave("animating"), void this.trigger("translated"));
    }),
    (e.prototype.viewport = function () {
      var d;
      if (this.options.responsiveBaseElement !== b)
        d = a(this.options.responsiveBaseElement).width();
      else if (b.innerWidth) d = b.innerWidth;
      else {
        if (!c.documentElement || !c.documentElement.clientWidth)
          throw "Can not detect viewport width.";
        d = c.documentElement.clientWidth;
      }
      return d;
    }),
    (e.prototype.replace = function (b) {
      this.$stage.empty(),
        (this._items = []),
        b && (b = b instanceof jQuery ? b : a(b)),
        this.settings.nestedItemSelector &&
          (b = b.find("." + this.settings.nestedItemSelector)),
        b
          .filter(function () {
            return 1 === this.nodeType;
          })
          .each(
            a.proxy(function (a, b) {
              (b = this.prepare(b)),
                this.$stage.append(b),
                this._items.push(b),
                this._mergers.push(
                  1 *
                    b
                      .find("[data-merge]")
                      .addBack("[data-merge]")
                      .attr("data-merge") || 1
                );
            }, this)
          ),
        this.reset(
          this.isNumeric(this.settings.startPosition)
            ? this.settings.startPosition
            : 0
        ),
        this.invalidate("items");
    }),
    (e.prototype.add = function (b, c) {
      var e = this.relative(this._current);
      (c = c === d ? this._items.length : this.normalize(c, !0)),
        (b = b instanceof jQuery ? b : a(b)),
        this.trigger("add", { content: b, position: c }),
        (b = this.prepare(b)),
        0 === this._items.length || c === this._items.length
          ? (0 === this._items.length && this.$stage.append(b),
            0 !== this._items.length && this._items[c - 1].after(b),
            this._items.push(b),
            this._mergers.push(
              1 *
                b
                  .find("[data-merge]")
                  .addBack("[data-merge]")
                  .attr("data-merge") || 1
            ))
          : (this._items[c].before(b),
            this._items.splice(c, 0, b),
            this._mergers.splice(
              c,
              0,
              1 *
                b
                  .find("[data-merge]")
                  .addBack("[data-merge]")
                  .attr("data-merge") || 1
            )),
        this._items[e] && this.reset(this._items[e].index()),
        this.invalidate("items"),
        this.trigger("added", { content: b, position: c });
    }),
    (e.prototype.remove = function (a) {
      (a = this.normalize(a, !0)),
        a !== d &&
          (this.trigger("remove", { content: this._items[a], position: a }),
          this._items[a].remove(),
          this._items.splice(a, 1),
          this._mergers.splice(a, 1),
          this.invalidate("items"),
          this.trigger("removed", { content: null, position: a }));
    }),
    (e.prototype.preloadAutoWidthImages = function (b) {
      b.each(
        a.proxy(function (b, c) {
          this.enter("pre-loading"),
            (c = a(c)),
            a(new Image())
              .one(
                "load",
                a.proxy(function (a) {
                  c.attr("src", a.target.src),
                    c.css("opacity", 1),
                    this.leave("pre-loading"),
                    !this.is("pre-loading") &&
                      !this.is("initializing") &&
                      this.refresh();
                }, this)
              )
              .attr(
                "src",
                c.attr("src") || c.attr("data-src") || c.attr("data-src-retina")
              );
        }, this)
      );
    }),
    (e.prototype.destroy = function () {
      this.$element.off(".owl.core"),
        this.$stage.off(".owl.core"),
        a(c).off(".owl.core"),
        this.settings.responsive !== !1 &&
          (b.clearTimeout(this.resizeTimer),
          this.off(b, "resize", this._handlers.onThrottledResize));
      for (var d in this._plugins) this._plugins[d].destroy();
      this.$stage.children(".cloned").remove(),
        this.$stage.unwrap(),
        this.$stage.children().contents().unwrap(),
        this.$stage.children().unwrap(),
        this.$element
          .removeClass(this.options.refreshClass)
          .removeClass(this.options.loadingClass)
          .removeClass(this.options.loadedClass)
          .removeClass(this.options.rtlClass)
          .removeClass(this.options.dragClass)
          .removeClass(this.options.grabClass)
          .attr(
            "class",
            this.$element
              .attr("class")
              .replace(
                new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"),
                ""
              )
          )
          .removeData("owl.carousel");
    }),
    (e.prototype.op = function (a, b, c) {
      var d = this.settings.rtl;
      switch (b) {
        case "<":
          return d ? a > c : c > a;
        case ">":
          return d ? c > a : a > c;
        case ">=":
          return d ? c >= a : a >= c;
        case "<=":
          return d ? a >= c : c >= a;
      }
    }),
    (e.prototype.on = function (a, b, c, d) {
      a.addEventListener
        ? a.addEventListener(b, c, d)
        : a.attachEvent && a.attachEvent("on" + b, c);
    }),
    (e.prototype.off = function (a, b, c, d) {
      a.removeEventListener
        ? a.removeEventListener(b, c, d)
        : a.detachEvent && a.detachEvent("on" + b, c);
    }),
    (e.prototype.trigger = function (b, c, d, f, g) {
      var h = { item: { count: this._items.length, index: this.current() } },
        i = a.camelCase(
          a
            .grep(["on", b, d], function (a) {
              return a;
            })
            .join("-")
            .toLowerCase()
        ),
        j = a.Event(
          [b, "owl", d || "carousel"].join(".").toLowerCase(),
          a.extend({ relatedTarget: this }, h, c)
        );
      return (
        this._supress[b] ||
          (a.each(this._plugins, function (a, b) {
            b.onTrigger && b.onTrigger(j);
          }),
          this.register({ type: e.Type.Event, name: b }),
          this.$element.trigger(j),
          this.settings &&
            "function" == typeof this.settings[i] &&
            this.settings[i].call(this, j)),
        j
      );
    }),
    (e.prototype.enter = function (b) {
      a.each(
        [b].concat(this._states.tags[b] || []),
        a.proxy(function (a, b) {
          this._states.current[b] === d && (this._states.current[b] = 0),
            this._states.current[b]++;
        }, this)
      );
    }),
    (e.prototype.leave = function (b) {
      a.each(
        [b].concat(this._states.tags[b] || []),
        a.proxy(function (a, b) {
          this._states.current[b]--;
        }, this)
      );
    }),
    (e.prototype.register = function (b) {
      if (b.type === e.Type.Event) {
        if (
          (a.event.special[b.name] || (a.event.special[b.name] = {}),
          !a.event.special[b.name].owl)
        ) {
          var c = a.event.special[b.name]._default;
          (a.event.special[b.name]._default = function (a) {
            return !c ||
              !c.apply ||
              (a.namespace && -1 !== a.namespace.indexOf("owl"))
              ? a.namespace && a.namespace.indexOf("owl") > -1
              : c.apply(this, arguments);
          }),
            (a.event.special[b.name].owl = !0);
        }
      } else
        b.type === e.Type.State &&
          (this._states.tags[b.name]
            ? (this._states.tags[b.name] = this._states.tags[b.name].concat(
                b.tags
              ))
            : (this._states.tags[b.name] = b.tags),
          (this._states.tags[b.name] = a.grep(
            this._states.tags[b.name],
            a.proxy(function (c, d) {
              return a.inArray(c, this._states.tags[b.name]) === d;
            }, this)
          )));
    }),
    (e.prototype.suppress = function (b) {
      a.each(
        b,
        a.proxy(function (a, b) {
          this._supress[b] = !0;
        }, this)
      );
    }),
    (e.prototype.release = function (b) {
      a.each(
        b,
        a.proxy(function (a, b) {
          delete this._supress[b];
        }, this)
      );
    }),
    (e.prototype.pointer = function (a) {
      var c = { x: null, y: null };
      return (
        (a = a.originalEvent || a || b.event),
        (a =
          a.touches && a.touches.length
            ? a.touches[0]
            : a.changedTouches && a.changedTouches.length
            ? a.changedTouches[0]
            : a),
        a.pageX
          ? ((c.x = a.pageX), (c.y = a.pageY))
          : ((c.x = a.clientX), (c.y = a.clientY)),
        c
      );
    }),
    (e.prototype.isNumeric = function (a) {
      return !isNaN(parseFloat(a));
    }),
    (e.prototype.difference = function (a, b) {
      return { x: a.x - b.x, y: a.y - b.y };
    }),
    (a.fn.owlCarousel = function (b) {
      var c = Array.prototype.slice.call(arguments, 1);
      return this.each(function () {
        var d = a(this),
          f = d.data("owl.carousel");
        f ||
          ((f = new e(this, "object" == typeof b && b)),
          d.data("owl.carousel", f),
          a.each(
            [
              "next",
              "prev",
              "to",
              "destroy",
              "refresh",
              "replace",
              "add",
              "remove",
            ],
            function (b, c) {
              f.register({ type: e.Type.Event, name: c }),
                f.$element.on(
                  c + ".owl.carousel.core",
                  a.proxy(function (a) {
                    a.namespace &&
                      a.relatedTarget !== this &&
                      (this.suppress([c]),
                      f[c].apply(this, [].slice.call(arguments, 1)),
                      this.release([c]));
                  }, f)
                );
            }
          )),
          "string" == typeof b && "_" !== b.charAt(0) && f[b].apply(f, c);
      });
    }),
    (a.fn.owlCarousel.Constructor = e);
})(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._interval = null),
        (this._visible = null),
        (this._handlers = {
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace && this._core.settings.autoRefresh && this.watch();
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers);
    };
    (e.Defaults = { autoRefresh: !0, autoRefreshInterval: 500 }),
      (e.prototype.watch = function () {
        this._interval ||
          ((this._visible = this._core.$element.is(":visible")),
          (this._interval = b.setInterval(
            a.proxy(this.refresh, this),
            this._core.settings.autoRefreshInterval
          )));
      }),
      (e.prototype.refresh = function () {
        this._core.$element.is(":visible") !== this._visible &&
          ((this._visible = !this._visible),
          this._core.$element.toggleClass("owl-hidden", !this._visible),
          this._visible &&
            this._core.invalidate("width") &&
            this._core.refresh());
      }),
      (e.prototype.destroy = function () {
        var a, c;
        b.clearInterval(this._interval);
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
        for (c in Object.getOwnPropertyNames(this))
          "function" != typeof this[c] && (this[c] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.AutoRefresh = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._loaded = []),
        (this._handlers = {
          "initialized.owl.carousel change.owl.carousel resized.owl.carousel":
            a.proxy(function (b) {
              if (
                b.namespace &&
                this._core.settings &&
                this._core.settings.lazyLoad &&
                ((b.property && "position" == b.property.name) ||
                  "initialized" == b.type)
              )
                for (
                  var c = this._core.settings,
                    e = (c.center && Math.ceil(c.items / 2)) || c.items,
                    f = (c.center && -1 * e) || 0,
                    g =
                      (b.property && b.property.value !== d
                        ? b.property.value
                        : this._core.current()) + f,
                    h = this._core.clones().length,
                    i = a.proxy(function (a, b) {
                      this.load(b);
                    }, this);
                  f++ < e;

                )
                  this.load(h / 2 + this._core.relative(g)),
                    h && a.each(this._core.clones(this._core.relative(g)), i),
                    g++;
            }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers);
    };
    (e.Defaults = { lazyLoad: !1 }),
      (e.prototype.load = function (c) {
        var d = this._core.$stage.children().eq(c),
          e = d && d.find(".owl-lazy");
        !e ||
          a.inArray(d.get(0), this._loaded) > -1 ||
          (e.each(
            a.proxy(function (c, d) {
              var e,
                f = a(d),
                g =
                  (b.devicePixelRatio > 1 && f.attr("data-src-retina")) ||
                  f.attr("data-src");
              this._core.trigger("load", { element: f, url: g }, "lazy"),
                f.is("img")
                  ? f
                      .one(
                        "load.owl.lazy",
                        a.proxy(function () {
                          f.css("opacity", 1),
                            this._core.trigger(
                              "loaded",
                              { element: f, url: g },
                              "lazy"
                            );
                        }, this)
                      )
                      .attr("src", g)
                  : ((e = new Image()),
                    (e.onload = a.proxy(function () {
                      f.css({
                        "background-image": "url(" + g + ")",
                        opacity: "1",
                      }),
                        this._core.trigger(
                          "loaded",
                          { element: f, url: g },
                          "lazy"
                        );
                    }, this)),
                    (e.src = g));
            }, this)
          ),
          this._loaded.push(d.get(0)));
      }),
      (e.prototype.destroy = function () {
        var a, b;
        for (a in this.handlers) this._core.$element.off(a, this.handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Lazy = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._handlers = {
          "initialized.owl.carousel refreshed.owl.carousel": a.proxy(function (
            a
          ) {
            a.namespace && this._core.settings.autoHeight && this.update();
          },
          this),
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.autoHeight &&
              "position" == a.property.name &&
              this.update();
          }, this),
          "loaded.owl.lazy": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.autoHeight &&
              a.element.closest("." + this._core.settings.itemClass).index() ===
                this._core.current() &&
              this.update();
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers);
    };
    (e.Defaults = { autoHeight: !1, autoHeightClass: "owl-height" }),
      (e.prototype.update = function () {
        var b = this._core._current,
          c = b + this._core.settings.items,
          d = this._core.$stage.children().toArray().slice(b, c),
          e = [],
          f = 0;
        a.each(d, function (b, c) {
          e.push(a(c).height());
        }),
          (f = Math.max.apply(null, e)),
          this._core.$stage
            .parent()
            .height(f)
            .addClass(this._core.settings.autoHeightClass);
      }),
      (e.prototype.destroy = function () {
        var a, b;
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.AutoHeight = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._videos = {}),
        (this._playing = null),
        (this._handlers = {
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.register({
                type: "state",
                name: "playing",
                tags: ["interacting"],
              });
          }, this),
          "resize.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.video &&
              this.isInFullScreen() &&
              a.preventDefault();
          }, this),
          "refreshed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.is("resizing") &&
              this._core.$stage.find(".cloned .owl-video-frame").remove();
          }, this),
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              "position" === a.property.name &&
              this._playing &&
              this.stop();
          }, this),
          "prepared.owl.carousel": a.proxy(function (b) {
            if (b.namespace) {
              var c = a(b.content).find(".owl-video");
              c.length &&
                (c.css("display", "none"), this.fetch(c, a(b.content)));
            }
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers),
        this._core.$element.on(
          "click.owl.video",
          ".owl-video-play-icon",
          a.proxy(function (a) {
            this.play(a);
          }, this)
        );
    };
    (e.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }),
      (e.prototype.fetch = function (a, b) {
        var c = (function () {
            return a.attr("data-vimeo-id")
              ? "vimeo"
              : a.attr("data-vzaar-id")
              ? "vzaar"
              : "youtube";
          })(),
          d =
            a.attr("data-vimeo-id") ||
            a.attr("data-youtube-id") ||
            a.attr("data-vzaar-id"),
          e = a.attr("data-width") || this._core.settings.videoWidth,
          f = a.attr("data-height") || this._core.settings.videoHeight,
          g = a.attr("href");
        if (!g) throw new Error("Missing video URL.");
        if (
          ((d = g.match(
            /(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
          )),
          d[3].indexOf("youtu") > -1)
        )
          c = "youtube";
        else if (d[3].indexOf("vimeo") > -1) c = "vimeo";
        else {
          if (!(d[3].indexOf("vzaar") > -1))
            throw new Error("Video URL not supported.");
          c = "vzaar";
        }
        (d = d[6]),
          (this._videos[g] = { type: c, id: d, width: e, height: f }),
          b.attr("data-video", g),
          this.thumbnail(a, this._videos[g]);
      }),
      (e.prototype.thumbnail = function (b, c) {
        var d,
          e,
          f,
          g =
            c.width && c.height
              ? 'style="width:' + c.width + "px;height:" + c.height + 'px;"'
              : "",
          h = b.find("img"),
          i = "src",
          j = "",
          k = this._core.settings,
          l = function (a) {
            (e = '<div class="owl-video-play-icon"></div>'),
              (d = k.lazyLoad
                ? '<div class="owl-video-tn ' +
                  j +
                  '" ' +
                  i +
                  '="' +
                  a +
                  '"></div>'
                : '<div class="owl-video-tn" style="opacity:1;background-image:url(' +
                  a +
                  ')"></div>'),
              b.after(d),
              b.after(e);
          };
        return (
          b.wrap('<div class="owl-video-wrapper"' + g + "></div>"),
          this._core.settings.lazyLoad && ((i = "data-src"), (j = "owl-lazy")),
          h.length
            ? (l(h.attr(i)), h.remove(), !1)
            : void ("youtube" === c.type
                ? ((f = "//img.youtube.com/vi/" + c.id + "/hqdefault.jpg"),
                  l(f))
                : "vimeo" === c.type
                ? a.ajax({
                    type: "GET",
                    url: "//vimeo.com/api/v2/video/" + c.id + ".json",
                    jsonp: "callback",
                    dataType: "jsonp",
                    success: function (a) {
                      (f = a[0].thumbnail_large), l(f);
                    },
                  })
                : "vzaar" === c.type &&
                  a.ajax({
                    type: "GET",
                    url: "//vzaar.com/api/videos/" + c.id + ".json",
                    jsonp: "callback",
                    dataType: "jsonp",
                    success: function (a) {
                      (f = a.framegrab_url), l(f);
                    },
                  }))
        );
      }),
      (e.prototype.stop = function () {
        this._core.trigger("stop", null, "video"),
          this._playing.find(".owl-video-frame").remove(),
          this._playing.removeClass("owl-video-playing"),
          (this._playing = null),
          this._core.leave("playing"),
          this._core.trigger("stopped", null, "video");
      }),
      (e.prototype.play = function (b) {
        var c,
          d = a(b.target),
          e = d.closest("." + this._core.settings.itemClass),
          f = this._videos[e.attr("data-video")],
          g = f.width || "100%",
          h = f.height || this._core.$stage.height();
        this._playing ||
          (this._core.enter("playing"),
          this._core.trigger("play", null, "video"),
          (e = this._core.items(this._core.relative(e.index()))),
          this._core.reset(e.index()),
          "youtube" === f.type
            ? (c =
                '<iframe width="' +
                g +
                '" height="' +
                h +
                '" src="//www.youtube.com/embed/' +
                f.id +
                "?autoplay=1&v=" +
                f.id +
                '" frameborder="0" allowfullscreen></iframe>')
            : "vimeo" === f.type
            ? (c =
                '<iframe src="//player.vimeo.com/video/' +
                f.id +
                '?autoplay=1" width="' +
                g +
                '" height="' +
                h +
                '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>')
            : "vzaar" === f.type &&
              (c =
                '<iframe frameborder="0"height="' +
                h +
                '"width="' +
                g +
                '" allowfullscreen mozallowfullscreen webkitAllowFullScreen src="//view.vzaar.com/' +
                f.id +
                '/player?autoplay=true"></iframe>'),
          a('<div class="owl-video-frame">' + c + "</div>").insertAfter(
            e.find(".owl-video")
          ),
          (this._playing = e.addClass("owl-video-playing")));
      }),
      (e.prototype.isInFullScreen = function () {
        var b =
          c.fullscreenElement ||
          c.mozFullScreenElement ||
          c.webkitFullscreenElement;
        return b && a(b).parent().hasClass("owl-video-frame");
      }),
      (e.prototype.destroy = function () {
        var a, b;
        this._core.$element.off("click.owl.video");
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Video = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this.core = b),
        (this.core.options = a.extend({}, e.Defaults, this.core.options)),
        (this.swapping = !0),
        (this.previous = d),
        (this.next = d),
        (this.handlers = {
          "change.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              "position" == a.property.name &&
              ((this.previous = this.core.current()),
              (this.next = a.property.value));
          }, this),
          "drag.owl.carousel dragged.owl.carousel translated.owl.carousel":
            a.proxy(function (a) {
              a.namespace && (this.swapping = "translated" == a.type);
            }, this),
          "translate.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this.swapping &&
              (this.core.options.animateOut || this.core.options.animateIn) &&
              this.swap();
          }, this),
        }),
        this.core.$element.on(this.handlers);
    };
    (e.Defaults = { animateOut: !1, animateIn: !1 }),
      (e.prototype.swap = function () {
        if (
          1 === this.core.settings.items &&
          a.support.animation &&
          a.support.transition
        ) {
          this.core.speed(0);
          var b,
            c = a.proxy(this.clear, this),
            d = this.core.$stage.children().eq(this.previous),
            e = this.core.$stage.children().eq(this.next),
            f = this.core.settings.animateIn,
            g = this.core.settings.animateOut;
          this.core.current() !== this.previous &&
            (g &&
              ((b =
                this.core.coordinates(this.previous) -
                this.core.coordinates(this.next)),
              d
                .one(a.support.animation.end, c)
                .css({ left: b + "px" })
                .addClass("animated owl-animated-out")
                .addClass(g)),
            f &&
              e
                .one(a.support.animation.end, c)
                .addClass("animated owl-animated-in")
                .addClass(f));
        }
      }),
      (e.prototype.clear = function (b) {
        a(b.target)
          .css({ left: "" })
          .removeClass("animated owl-animated-out owl-animated-in")
          .removeClass(this.core.settings.animateIn)
          .removeClass(this.core.settings.animateOut),
          this.core.onTransitionEnd();
      }),
      (e.prototype.destroy = function () {
        var a, b;
        for (a in this.handlers) this.core.$element.off(a, this.handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Animate = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._timeout = null),
        (this._paused = !1),
        (this._handlers = {
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace && "settings" === a.property.name
              ? this._core.settings.autoplay
                ? this.play()
                : this.stop()
              : a.namespace &&
                "position" === a.property.name &&
                this._core.settings.autoplay &&
                this._setAutoPlayInterval();
          }, this),
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace && this._core.settings.autoplay && this.play();
          }, this),
          "play.owl.autoplay": a.proxy(function (a, b, c) {
            a.namespace && this.play(b, c);
          }, this),
          "stop.owl.autoplay": a.proxy(function (a) {
            a.namespace && this.stop();
          }, this),
          "mouseover.owl.autoplay": a.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is("rotating") &&
              this.pause();
          }, this),
          "mouseleave.owl.autoplay": a.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is("rotating") &&
              this.play();
          }, this),
          "touchstart.owl.core": a.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is("rotating") &&
              this.pause();
          }, this),
          "touchend.owl.core": a.proxy(function () {
            this._core.settings.autoplayHoverPause && this.play();
          }, this),
        }),
        this._core.$element.on(this._handlers),
        (this._core.options = a.extend({}, e.Defaults, this._core.options));
    };
    (e.Defaults = {
      autoplay: !1,
      autoplayTimeout: 5e3,
      autoplayHoverPause: !1,
      autoplaySpeed: !1,
    }),
      (e.prototype.play = function (a, b) {
        (this._paused = !1),
          this._core.is("rotating") ||
            (this._core.enter("rotating"), this._setAutoPlayInterval());
      }),
      (e.prototype._getNextTimeout = function (d, e) {
        return (
          this._timeout && b.clearTimeout(this._timeout),
          b.setTimeout(
            a.proxy(function () {
              this._paused ||
                this._core.is("busy") ||
                this._core.is("interacting") ||
                c.hidden ||
                this._core.next(e || this._core.settings.autoplaySpeed);
            }, this),
            d || this._core.settings.autoplayTimeout
          )
        );
      }),
      (e.prototype._setAutoPlayInterval = function () {
        this._timeout = this._getNextTimeout();
      }),
      (e.prototype.stop = function () {
        this._core.is("rotating") &&
          (b.clearTimeout(this._timeout), this._core.leave("rotating"));
      }),
      (e.prototype.pause = function () {
        this._core.is("rotating") && (this._paused = !0);
      }),
      (e.prototype.destroy = function () {
        var a, b;
        this.stop();
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.autoplay = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    "use strict";
    var e = function (b) {
      (this._core = b),
        (this._initialized = !1),
        (this._pages = []),
        (this._controls = {}),
        (this._templates = []),
        (this.$element = this._core.$element),
        (this._overrides = {
          next: this._core.next,
          prev: this._core.prev,
          to: this._core.to,
        }),
        (this._handlers = {
          "prepared.owl.carousel": a.proxy(function (b) {
            b.namespace &&
              this._core.settings.dotsData &&
              this._templates.push(
                '<div class="' +
                  this._core.settings.dotClass +
                  '">' +
                  a(b.content)
                    .find("[data-dot]")
                    .addBack("[data-dot]")
                    .attr("data-dot") +
                  "</div>"
              );
          }, this),
          "added.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.dotsData &&
              this._templates.splice(a.position, 0, this._templates.pop());
          }, this),
          "remove.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.dotsData &&
              this._templates.splice(a.position, 1);
          }, this),
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace && "position" == a.property.name && this.draw();
          }, this),
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              !this._initialized &&
              (this._core.trigger("initialize", null, "navigation"),
              this.initialize(),
              this.update(),
              this.draw(),
              (this._initialized = !0),
              this._core.trigger("initialized", null, "navigation"));
          }, this),
          "refreshed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._initialized &&
              (this._core.trigger("refresh", null, "navigation"),
              this.update(),
              this.draw(),
              this._core.trigger("refreshed", null, "navigation"));
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this.$element.on(this._handlers);
    };
    (e.Defaults = {
      nav: !1,
      navText: ["prev", "next"],
      navSpeed: !1,
      navElement: "div",
      navContainer: !1,
      navContainerClass: "owl-nav",
      navClass: ["owl-prev", "owl-next"],
      slideBy: 1,
      dotClass: "owl-dot",
      dotsClass: "owl-dots",
      dots: !0,
      dotsEach: !1,
      dotsData: !1,
      dotsSpeed: !1,
      dotsContainer: !1,
    }),
      (e.prototype.initialize = function () {
        var b,
          c = this._core.settings;
        (this._controls.$relative = (
          c.navContainer
            ? a(c.navContainer)
            : a("<div>").addClass(c.navContainerClass).appendTo(this.$element)
        ).addClass("disabled")),
          (this._controls.$previous = a("<" + c.navElement + ">")
            .addClass(c.navClass[0])
            .html(c.navText[0])
            .prependTo(this._controls.$relative)
            .on(
              "click",
              a.proxy(function (a) {
                this.prev(c.navSpeed);
              }, this)
            )),
          (this._controls.$next = a("<" + c.navElement + ">")
            .addClass(c.navClass[1])
            .html(c.navText[1])
            .appendTo(this._controls.$relative)
            .on(
              "click",
              a.proxy(function (a) {
                this.next(c.navSpeed);
              }, this)
            )),
          c.dotsData ||
            (this._templates = [
              a("<div>")
                .addClass(c.dotClass)
                .append(a("<span>"))
                .prop("outerHTML"),
            ]),
          (this._controls.$absolute = (
            c.dotsContainer
              ? a(c.dotsContainer)
              : a("<div>").addClass(c.dotsClass).appendTo(this.$element)
          ).addClass("disabled")),
          this._controls.$absolute.on(
            "click",
            "div",
            a.proxy(function (b) {
              var d = a(b.target).parent().is(this._controls.$absolute)
                ? a(b.target).index()
                : a(b.target).parent().index();
              b.preventDefault(), this.to(d, c.dotsSpeed);
            }, this)
          );
        for (b in this._overrides) this._core[b] = a.proxy(this[b], this);
      }),
      (e.prototype.destroy = function () {
        var a, b, c, d;
        for (a in this._handlers) this.$element.off(a, this._handlers[a]);
        for (b in this._controls) this._controls[b].remove();
        for (d in this.overides) this._core[d] = this._overrides[d];
        for (c in Object.getOwnPropertyNames(this))
          "function" != typeof this[c] && (this[c] = null);
      }),
      (e.prototype.update = function () {
        var a,
          b,
          c,
          d = this._core.clones().length / 2,
          e = d + this._core.items().length,
          f = this._core.maximum(!0),
          g = this._core.settings,
          h = g.center || g.autoWidth || g.dotsData ? 1 : g.dotsEach || g.items;
        if (
          ("page" !== g.slideBy && (g.slideBy = Math.min(g.slideBy, g.items)),
          g.dots || "page" == g.slideBy)
        )
          for (this._pages = [], a = d, b = 0, c = 0; e > a; a++) {
            if (b >= h || 0 === b) {
              if (
                (this._pages.push({
                  start: Math.min(f, a - d),
                  end: a - d + h - 1,
                }),
                Math.min(f, a - d) === f)
              )
                break;
              (b = 0), ++c;
            }
            b += this._core.mergers(this._core.relative(a));
          }
      }),
      (e.prototype.draw = function () {
        var b,
          c = this._core.settings,
          d = this._core.items().length <= c.items,
          e = this._core.relative(this._core.current()),
          f = c.loop || c.rewind;
        this._controls.$relative.toggleClass("disabled", !c.nav || d),
          c.nav &&
            (this._controls.$previous.toggleClass(
              "disabled",
              !f && e <= this._core.minimum(!0)
            ),
            this._controls.$next.toggleClass(
              "disabled",
              !f && e >= this._core.maximum(!0)
            )),
          this._controls.$absolute.toggleClass("disabled", !c.dots || d),
          c.dots &&
            ((b =
              this._pages.length - this._controls.$absolute.children().length),
            c.dotsData && 0 !== b
              ? this._controls.$absolute.html(this._templates.join(""))
              : b > 0
              ? this._controls.$absolute.append(
                  new Array(b + 1).join(this._templates[0])
                )
              : 0 > b && this._controls.$absolute.children().slice(b).remove(),
            this._controls.$absolute.find(".active").removeClass("active"),
            this._controls.$absolute
              .children()
              .eq(a.inArray(this.current(), this._pages))
              .addClass("active"));
      }),
      (e.prototype.onTrigger = function (b) {
        var c = this._core.settings;
        b.page = {
          index: a.inArray(this.current(), this._pages),
          count: this._pages.length,
          size:
            c &&
            (c.center || c.autoWidth || c.dotsData ? 1 : c.dotsEach || c.items),
        };
      }),
      (e.prototype.current = function () {
        var b = this._core.relative(this._core.current());
        return a
          .grep(
            this._pages,
            a.proxy(function (a, c) {
              return a.start <= b && a.end >= b;
            }, this)
          )
          .pop();
      }),
      (e.prototype.getPosition = function (b) {
        var c,
          d,
          e = this._core.settings;
        return (
          "page" == e.slideBy
            ? ((c = a.inArray(this.current(), this._pages)),
              (d = this._pages.length),
              b ? ++c : --c,
              (c = this._pages[((c % d) + d) % d].start))
            : ((c = this._core.relative(this._core.current())),
              (d = this._core.items().length),
              b ? (c += e.slideBy) : (c -= e.slideBy)),
          c
        );
      }),
      (e.prototype.next = function (b) {
        a.proxy(this._overrides.to, this._core)(this.getPosition(!0), b);
      }),
      (e.prototype.prev = function (b) {
        a.proxy(this._overrides.to, this._core)(this.getPosition(!1), b);
      }),
      (e.prototype.to = function (b, c, d) {
        var e;
        !d && this._pages.length
          ? ((e = this._pages.length),
            a.proxy(this._overrides.to, this._core)(
              this._pages[((b % e) + e) % e].start,
              c
            ))
          : a.proxy(this._overrides.to, this._core)(b, c);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Navigation = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    "use strict";
    var e = function (c) {
      (this._core = c),
        (this._hashes = {}),
        (this.$element = this._core.$element),
        (this._handlers = {
          "initialized.owl.carousel": a.proxy(function (c) {
            c.namespace &&
              "URLHash" === this._core.settings.startPosition &&
              a(b).trigger("hashchange.owl.navigation");
          }, this),
          "prepared.owl.carousel": a.proxy(function (b) {
            if (b.namespace) {
              var c = a(b.content)
                .find("[data-hash]")
                .addBack("[data-hash]")
                .attr("data-hash");
              if (!c) return;
              this._hashes[c] = b.content;
            }
          }, this),
          "changed.owl.carousel": a.proxy(function (c) {
            if (c.namespace && "position" === c.property.name) {
              var d = this._core.items(
                  this._core.relative(this._core.current())
                ),
                e = a
                  .map(this._hashes, function (a, b) {
                    return a === d ? b : null;
                  })
                  .join();
              if (!e || b.location.hash.slice(1) === e) return;
              b.location.hash = e;
            }
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this.$element.on(this._handlers),
        a(b).on(
          "hashchange.owl.navigation",
          a.proxy(function (a) {
            var c = b.location.hash.substring(1),
              e = this._core.$stage.children(),
              f = this._hashes[c] && e.index(this._hashes[c]);
            f !== d &&
              f !== this._core.current() &&
              this._core.to(this._core.relative(f), !1, !0);
          }, this)
        );
    };
    (e.Defaults = { URLhashListener: !1 }),
      (e.prototype.destroy = function () {
        var c, d;
        a(b).off("hashchange.owl.navigation");
        for (c in this._handlers) this._core.$element.off(c, this._handlers[c]);
        for (d in Object.getOwnPropertyNames(this))
          "function" != typeof this[d] && (this[d] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Hash = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    function e(b, c) {
      var e = !1,
        f = b.charAt(0).toUpperCase() + b.slice(1);
      return (
        a.each((b + " " + h.join(f + " ") + f).split(" "), function (a, b) {
          return g[b] !== d ? ((e = c ? b : !0), !1) : void 0;
        }),
        e
      );
    }
    function f(a) {
      return e(a, !0);
    }
    var g = a("<support>").get(0).style,
      h = "Webkit Moz O ms".split(" "),
      i = {
        transition: {
          end: {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd",
            transition: "transitionend",
          },
        },
        animation: {
          end: {
            WebkitAnimation: "webkitAnimationEnd",
            MozAnimation: "animationend",
            OAnimation: "oAnimationEnd",
            animation: "animationend",
          },
        },
      },
      j = {
        csstransforms: function () {
          return !!e("transform");
        },
        csstransforms3d: function () {
          return !!e("perspective");
        },
        csstransitions: function () {
          return !!e("transition");
        },
        cssanimations: function () {
          return !!e("animation");
        },
      };
    j.csstransitions() &&
      ((a.support.transition = new String(f("transition"))),
      (a.support.transition.end = i.transition.end[a.support.transition])),
      j.cssanimations() &&
        ((a.support.animation = new String(f("animation"))),
        (a.support.animation.end = i.animation.end[a.support.animation])),
      j.csstransforms() &&
        ((a.support.transform = new String(f("transform"))),
        (a.support.transform3d = j.csstransforms3d()));
  })(window.Zepto || window.jQuery, window, document);
!(function (t, e, n, o) {
  "use strict";
  function a(t) {
    var e = n(t.currentTarget),
      o = t.data ? t.data.options : {},
      a = e.attr("data-fancybox") || "",
      i = 0,
      s = [];
    t.isDefaultPrevented() ||
      (t.preventDefault(),
      a
        ? ((s = o.selector ? n(o.selector) : t.data ? t.data.items : []),
          (s = s.length
            ? s.filter('[data-fancybox="' + a + '"]')
            : n('[data-fancybox="' + a + '"]')),
          (i = s.index(e)),
          i < 0 && (i = 0))
        : (s = [e]),
      n.fancybox.open(s, o, i));
  }
  if (n) {
    if (n.fn.fancybox)
      return void (
        "console" in t && console.log("fancyBox already initialized")
      );
    var i = {
        loop: !1,
        margin: [44, 0],
        gutter: 50,
        keyboard: !0,
        arrows: !0,
        infobar: !0,
        toolbar: !0,
        buttons: ["slideShow", "fullScreen", "thumbs", "share", "close"],
        idleTime: 3,
        smallBtn: "auto",
        protect: !1,
        modal: !1,
        image: { preload: "auto" },
        ajax: { settings: { data: { fancybox: !0 } } },
        iframe: {
          tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen allowtransparency="true" src=""></iframe>',
          preload: !0,
          css: {},
          attr: { scrolling: "auto" },
        },
        defaultType: "image",
        animationEffect: "zoom",
        animationDuration: 500,
        zoomOpacity: "auto",
        transitionEffect: "fade",
        transitionDuration: 366,
        slideClass: "",
        baseClass: "",
        baseTpl:
          '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption-wrap"><div class="fancybox-caption"></div></div></div></div>',
        spinnerTpl: '<div class="fancybox-loading"></div>',
        errorTpl: '<div class="fancybox-error"><p>{{ERROR}}<p></div>',
        btnTpl: {
          download:
            '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}"><svg viewBox="0 0 40 40"><path d="M20,23 L20,8 L20,23 L13,16 L20,23 L27,16 L20,23 M26,28 L13,28 L27,28 L14,28" /></svg></a>',
          zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg viewBox="0 0 40 40"><path d="M 18,17 m-8,0 a 8,8 0 1,0 16,0 a 8,8 0 1,0 -16,0 M25,23 L31,29 L25,23" /></svg></button>',
          close:
            '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg viewBox="0 0 40 40"><path d="M10,10 L30,30 M30,10 L10,30" /></svg></button>',
          smallBtn:
            '<button data-fancybox-close class="fancybox-close-small" title="{{CLOSE}}"></button>',
          arrowLeft:
            '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><svg viewBox="0 0 40 40"><path d="M10,20 L30,20 L10,20 L18,28 L10,20 L18,12 L10,20"></path></svg></button>',
          arrowRight:
            '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><svg viewBox="0 0 40 40"><path d="M30,20 L10,20 L30,20 L22,28 L30,20 L22,12 L30,20"></path></svg></button>',
        },
        parentEl: "body",
        autoFocus: !1,
        backFocus: !0,
        trapFocus: !0,
        fullScreen: { autoStart: !1 },
        touch: { vertical: !0, momentum: !0 },
        hash: null,
        media: {},
        slideShow: { autoStart: !1, speed: 4e3 },
        thumbs: {
          autoStart: !1,
          hideOnClose: !0,
          parentEl: ".fancybox-container",
          axis: "y",
        },
        onInit: n.noop,
        beforeLoad: n.noop,
        afterLoad: n.noop,
        beforeShow: n.noop,
        afterShow: n.noop,
        beforeClose: n.noop,
        afterClose: n.noop,
        onActivate: n.noop,
        onDeactivate: n.noop,
        clickContent: function (t, e) {
          return "image" === t.type && "zoom";
        },
        clickSlide: "close",
        clickOutside: "close",
        dblclickContent: !1,
        dblclickSlide: !1,
        dblclickOutside: !1,
        mobile: {
          margin: 0,
          clickContent: function (t, e) {
            return "image" === t.type && "toggleControls";
          },
          clickSlide: function (t, e) {
            return "image" === t.type ? "toggleControls" : "close";
          },
          dblclickContent: function (t, e) {
            return "image" === t.type && "zoom";
          },
          dblclickSlide: function (t, e) {
            return "image" === t.type && "zoom";
          },
        },
        lang: "en",
        i18n: {
          en: {
            CLOSE: "Close",
            NEXT: "Next",
            PREV: "Previous",
            ERROR:
              "The requested content cannot be loaded. <br/> Please try again later.",
            PLAY_START: "Start slideshow",
            PLAY_STOP: "Pause slideshow",
            FULL_SCREEN: "Full screen",
            THUMBS: "Thumbnails",
            DOWNLOAD: "Download",
            SHARE: "Share",
            ZOOM: "Zoom",
          },
          de: {
            CLOSE: "Schliessen",
            NEXT: "Weiter",
            PREV: "ZurÃ¼ck",
            ERROR:
              "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es spÃ¤ter nochmal.",
            PLAY_START: "Diaschau starten",
            PLAY_STOP: "Diaschau beenden",
            FULL_SCREEN: "Vollbild",
            THUMBS: "Vorschaubilder",
            DOWNLOAD: "Herunterladen",
            SHARE: "Teilen",
            ZOOM: "MaÃŸstab",
          },
        },
      },
      s = n(t),
      r = n(e),
      c = 0,
      l = function (t) {
        return t && t.hasOwnProperty && t instanceof n;
      },
      u = (function () {
        return (
          t.requestAnimationFrame ||
          t.webkitRequestAnimationFrame ||
          t.mozRequestAnimationFrame ||
          t.oRequestAnimationFrame ||
          function (e) {
            return t.setTimeout(e, 1e3 / 60);
          }
        );
      })(),
      d = (function () {
        var t,
          n = e.createElement("fakeelement"),
          a = {
            transition: "transitionend",
            OTransition: "oTransitionEnd",
            MozTransition: "transitionend",
            WebkitTransition: "webkitTransitionEnd",
          };
        for (t in a) if (n.style[t] !== o) return a[t];
        return "transitionend";
      })(),
      f = function (t) {
        return t && t.length && t[0].offsetHeight;
      },
      p = function (t, o, a) {
        var i = this;
        (i.opts = n.extend(!0, { index: a }, n.fancybox.defaults, o || {})),
          n.fancybox.isMobile &&
            (i.opts = n.extend(!0, {}, i.opts, i.opts.mobile)),
          o && n.isArray(o.buttons) && (i.opts.buttons = o.buttons),
          (i.id = i.opts.id || ++c),
          (i.group = []),
          (i.currIndex = parseInt(i.opts.index, 10) || 0),
          (i.prevIndex = null),
          (i.prevPos = null),
          (i.currPos = 0),
          (i.firstRun = null),
          i.createGroup(t),
          i.group.length &&
            ((i.$lastFocus = n(e.activeElement).blur()),
            (i.slides = {}),
            i.init());
      };
    n.extend(p.prototype, {
      init: function () {
        var a,
          i,
          s,
          c = this,
          l = c.group[c.currIndex],
          u = l.opts,
          d = n.fancybox.scrollbarWidth;
        (c.scrollTop = r.scrollTop()),
          (c.scrollLeft = r.scrollLeft()),
          n.fancybox.getInstance() ||
            (n("body").addClass("fancybox-active"),
            /iPad|iPhone|iPod/.test(navigator.userAgent) && !t.MSStream
              ? "image" !== l.type &&
                n("body")
                  .css("top", n("body").scrollTop() * -1)
                  .addClass("fancybox-iosfix")
              : !n.fancybox.isMobile &&
                e.body.scrollHeight > t.innerHeight &&
                (d === o &&
                  ((a = n(
                    '<div style="width:50px;height:50px;overflow:scroll;" />'
                  ).appendTo("body")),
                  (d = n.fancybox.scrollbarWidth =
                    a[0].offsetWidth - a[0].clientWidth),
                  a.remove()),
                n("head").append(
                  '<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar { margin-right: ' +
                    d +
                    "px; }</style>"
                ),
                n("body").addClass("compensate-for-scrollbar"))),
          (s = ""),
          n.each(u.buttons, function (t, e) {
            s += u.btnTpl[e] || "";
          }),
          (i = n(
            c.translate(
              c,
              u.baseTpl
                .replace("{{buttons}}", s)
                .replace("{{arrows}}", u.btnTpl.arrowLeft + u.btnTpl.arrowRight)
            )
          )
            .attr("id", "fancybox-container-" + c.id)
            .addClass("fancybox-is-hidden")
            .addClass(u.baseClass)
            .data("FancyBox", c)
            .appendTo(u.parentEl)),
          (c.$refs = { container: i }),
          [
            "bg",
            "inner",
            "infobar",
            "toolbar",
            "stage",
            "caption",
            "navigation",
          ].forEach(function (t) {
            c.$refs[t] = i.find(".fancybox-" + t);
          }),
          c.trigger("onInit"),
          c.activate(),
          c.jumpTo(c.currIndex);
      },
      translate: function (t, e) {
        var n = t.opts.i18n[t.opts.lang];
        return e.replace(/\{\{(\w+)\}\}/g, function (t, e) {
          var a = n[e];
          return a === o ? t : a;
        });
      },
      createGroup: function (t) {
        var e = this,
          a = n.makeArray(t);
        n.each(a, function (t, a) {
          var i,
            s,
            r,
            c,
            l = {},
            u = {};
          n.isPlainObject(a)
            ? ((l = a), (u = a.opts || a))
            : "object" === n.type(a) && n(a).length
            ? ((i = n(a)),
              (u = i.data()),
              (u = n.extend({}, u, u.options || {})),
              (u.$orig = i),
              (l.src = u.src || i.attr("href")),
              l.type || l.src || ((l.type = "inline"), (l.src = a)))
            : (l = { type: "html", src: a + "" }),
            (l.opts = n.extend(!0, {}, e.opts, u)),
            n.isArray(u.buttons) && (l.opts.buttons = u.buttons),
            (s = l.type || l.opts.type),
            (r = l.src || ""),
            !s &&
              r &&
              (r.match(
                /(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i
              )
                ? (s = "image")
                : r.match(/\.(pdf)((\?|#).*)?$/i)
                ? (s = "pdf")
                : "#" === r.charAt(0) && (s = "inline")),
            s ? (l.type = s) : e.trigger("objectNeedsType", l),
            (l.index = e.group.length),
            l.opts.$orig && !l.opts.$orig.length && delete l.opts.$orig,
            !l.opts.$thumb &&
              l.opts.$orig &&
              (l.opts.$thumb = l.opts.$orig.find("img:first")),
            l.opts.$thumb && !l.opts.$thumb.length && delete l.opts.$thumb,
            "function" === n.type(l.opts.caption) &&
              (l.opts.caption = l.opts.caption.apply(a, [e, l])),
            "function" === n.type(e.opts.caption) &&
              (l.opts.caption = e.opts.caption.apply(a, [e, l])),
            l.opts.caption instanceof n ||
              (l.opts.caption =
                l.opts.caption === o ? "" : l.opts.caption + ""),
            "ajax" === s &&
              ((c = r.split(/\s+/, 2)),
              c.length > 1 &&
                ((l.src = c.shift()), (l.opts.filter = c.shift()))),
            "auto" == l.opts.smallBtn &&
              (n.inArray(s, ["html", "inline", "ajax"]) > -1
                ? ((l.opts.toolbar = !1), (l.opts.smallBtn = !0))
                : (l.opts.smallBtn = !1)),
            "pdf" === s && ((l.type = "iframe"), (l.opts.iframe.preload = !1)),
            l.opts.modal &&
              (l.opts = n.extend(!0, l.opts, {
                infobar: 0,
                toolbar: 0,
                smallBtn: 0,
                keyboard: 0,
                slideShow: 0,
                fullScreen: 0,
                thumbs: 0,
                touch: 0,
                clickContent: !1,
                clickSlide: !1,
                clickOutside: !1,
                dblclickContent: !1,
                dblclickSlide: !1,
                dblclickOutside: !1,
              })),
            e.group.push(l);
        });
      },
      addEvents: function () {
        var o = this;
        o.removeEvents(),
          o.$refs.container
            .on("click.fb-close", "[data-fancybox-close]", function (t) {
              t.stopPropagation(), t.preventDefault(), o.close(t);
            })
            .on(
              "click.fb-prev touchend.fb-prev",
              "[data-fancybox-prev]",
              function (t) {
                t.stopPropagation(), t.preventDefault(), o.previous();
              }
            )
            .on(
              "click.fb-next touchend.fb-next",
              "[data-fancybox-next]",
              function (t) {
                t.stopPropagation(), t.preventDefault(), o.next();
              }
            )
            .on("click.fb", "[data-fancybox-zoom]", function (t) {
              o[o.isScaledDown() ? "scaleToActual" : "scaleToFit"]();
            }),
          s.on("orientationchange.fb resize.fb", function (t) {
            t && t.originalEvent && "resize" === t.originalEvent.type
              ? u(function () {
                  o.update();
                })
              : (o.$refs.stage.hide(),
                setTimeout(function () {
                  o.$refs.stage.show(), o.update();
                }, 600));
          }),
          r.on("focusin.fb", function (t) {
            var a = n.fancybox ? n.fancybox.getInstance() : null;
            a.isClosing ||
              !a.current ||
              !a.current.opts.trapFocus ||
              n(t.target).hasClass("fancybox-container") ||
              n(t.target).is(e) ||
              (a &&
                "fixed" !== n(t.target).css("position") &&
                !a.$refs.container.has(t.target).length &&
                (t.stopPropagation(),
                a.focus(),
                s.scrollTop(o.scrollTop).scrollLeft(o.scrollLeft)));
          }),
          r.on("keydown.fb", function (t) {
            var e = o.current,
              a = t.keyCode || t.which;
            if (
              e &&
              e.opts.keyboard &&
              !n(t.target).is("input") &&
              !n(t.target).is("textarea")
            )
              return 8 === a || 27 === a
                ? (t.preventDefault(), void o.close(t))
                : 37 === a || 38 === a
                ? (t.preventDefault(), void o.previous())
                : 39 === a || 40 === a
                ? (t.preventDefault(), void o.next())
                : void o.trigger("afterKeydown", t, a);
          }),
          o.group[o.currIndex].opts.idleTime &&
            ((o.idleSecondsCounter = 0),
            r.on(
              "mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle",
              function (t) {
                (o.idleSecondsCounter = 0),
                  o.isIdle && o.showControls(),
                  (o.isIdle = !1);
              }
            ),
            (o.idleInterval = t.setInterval(function () {
              o.idleSecondsCounter++,
                o.idleSecondsCounter >= o.group[o.currIndex].opts.idleTime &&
                  ((o.isIdle = !0),
                  (o.idleSecondsCounter = 0),
                  o.hideControls());
            }, 1e3)));
      },
      removeEvents: function () {
        var e = this;
        s.off("orientationchange.fb resize.fb"),
          r.off("focusin.fb keydown.fb .fb-idle"),
          this.$refs.container.off(".fb-close .fb-prev .fb-next"),
          e.idleInterval &&
            (t.clearInterval(e.idleInterval), (e.idleInterval = null));
      },
      previous: function (t) {
        return this.jumpTo(this.currPos - 1, t);
      },
      next: function (t) {
        return this.jumpTo(this.currPos + 1, t);
      },
      jumpTo: function (t, e, a) {
        var i,
          s,
          r,
          c,
          l,
          u,
          d,
          p = this,
          h = p.group.length;
        if (!(p.isSliding || p.isClosing || (p.isAnimating && p.firstRun))) {
          if (
            ((t = parseInt(t, 10)),
            (s = p.current ? p.current.opts.loop : p.opts.loop),
            !s && (t < 0 || t >= h))
          )
            return !1;
          if (
            ((i = p.firstRun = null === p.firstRun),
            !(h < 2 && !i && p.isSliding))
          ) {
            if (
              ((c = p.current),
              (p.prevIndex = p.currIndex),
              (p.prevPos = p.currPos),
              (r = p.createSlide(t)),
              h > 1 &&
                ((s || r.index > 0) && p.createSlide(t - 1),
                (s || r.index < h - 1) && p.createSlide(t + 1)),
              (p.current = r),
              (p.currIndex = r.index),
              (p.currPos = r.pos),
              p.trigger("beforeShow", i),
              p.updateControls(),
              (u = n.fancybox.getTranslate(r.$slide)),
              (r.isMoved =
                (0 !== u.left || 0 !== u.top) &&
                !r.$slide.hasClass("fancybox-animated")),
              (r.forcedDuration = o),
              n.isNumeric(e)
                ? (r.forcedDuration = e)
                : (e = r.opts[i ? "animationDuration" : "transitionDuration"]),
              (e = parseInt(e, 10)),
              i)
            )
              return (
                r.opts.animationEffect &&
                  e &&
                  p.$refs.container.css("transition-duration", e + "ms"),
                p.$refs.container.removeClass("fancybox-is-hidden"),
                f(p.$refs.container),
                p.$refs.container.addClass("fancybox-is-open"),
                r.$slide.addClass("fancybox-slide--current"),
                p.loadSlide(r),
                void p.preload()
              );
            n.each(p.slides, function (t, e) {
              n.fancybox.stop(e.$slide);
            }),
              r.$slide
                .removeClass("fancybox-slide--next fancybox-slide--previous")
                .addClass("fancybox-slide--current"),
              r.isMoved
                ? ((l = Math.round(r.$slide.width())),
                  n.each(p.slides, function (t, o) {
                    var a = o.pos - r.pos;
                    n.fancybox.animate(
                      o.$slide,
                      { top: 0, left: a * l + a * o.opts.gutter },
                      e,
                      function () {
                        o.$slide
                          .removeAttr("style")
                          .removeClass(
                            "fancybox-slide--next fancybox-slide--previous"
                          ),
                          o.pos === p.currPos &&
                            ((r.isMoved = !1), p.complete());
                      }
                    );
                  }))
                : p.$refs.stage.children().removeAttr("style"),
              r.isLoaded ? p.revealContent(r) : p.loadSlide(r),
              p.preload(),
              c.pos !== r.pos &&
                ((d =
                  "fancybox-slide--" + (c.pos > r.pos ? "next" : "previous")),
                c.$slide.removeClass(
                  "fancybox-slide--complete fancybox-slide--current fancybox-slide--next fancybox-slide--previous"
                ),
                (c.isComplete = !1),
                e &&
                  (r.isMoved || r.opts.transitionEffect) &&
                  (r.isMoved
                    ? c.$slide.addClass(d)
                    : ((d =
                        "fancybox-animated " +
                        d +
                        " fancybox-fx-" +
                        r.opts.transitionEffect),
                      n.fancybox.animate(c.$slide, d, e, function () {
                        c.$slide.removeClass(d).removeAttr("style");
                      }))));
          }
        }
      },
      createSlide: function (t) {
        var e,
          o,
          a = this;
        return (
          (o = t % a.group.length),
          (o = o < 0 ? a.group.length + o : o),
          !a.slides[t] &&
            a.group[o] &&
            ((e = n('<div class="fancybox-slide"></div>').appendTo(
              a.$refs.stage
            )),
            (a.slides[t] = n.extend(!0, {}, a.group[o], {
              pos: t,
              $slide: e,
              isLoaded: !1,
            })),
            a.updateSlide(a.slides[t])),
          a.slides[t]
        );
      },
      scaleToActual: function (t, e, a) {
        var i,
          s,
          r,
          c,
          l,
          u = this,
          d = u.current,
          f = d.$content,
          p = parseInt(d.$slide.width(), 10),
          h = parseInt(d.$slide.height(), 10),
          g = d.width,
          b = d.height;
        "image" != d.type ||
          d.hasError ||
          !f ||
          u.isAnimating ||
          (n.fancybox.stop(f),
          (u.isAnimating = !0),
          (t = t === o ? 0.5 * p : t),
          (e = e === o ? 0.5 * h : e),
          (i = n.fancybox.getTranslate(f)),
          (c = g / i.width),
          (l = b / i.height),
          (s = 0.5 * p - 0.5 * g),
          (r = 0.5 * h - 0.5 * b),
          g > p &&
            ((s = i.left * c - (t * c - t)),
            s > 0 && (s = 0),
            s < p - g && (s = p - g)),
          b > h &&
            ((r = i.top * l - (e * l - e)),
            r > 0 && (r = 0),
            r < h - b && (r = h - b)),
          u.updateCursor(g, b),
          n.fancybox.animate(
            f,
            { top: r, left: s, scaleX: c, scaleY: l },
            a || 330,
            function () {
              u.isAnimating = !1;
            }
          ),
          u.SlideShow && u.SlideShow.isActive && u.SlideShow.stop());
      },
      scaleToFit: function (t) {
        var e,
          o = this,
          a = o.current,
          i = a.$content;
        "image" != a.type ||
          a.hasError ||
          !i ||
          o.isAnimating ||
          (n.fancybox.stop(i),
          (o.isAnimating = !0),
          (e = o.getFitPos(a)),
          o.updateCursor(e.width, e.height),
          n.fancybox.animate(
            i,
            {
              top: e.top,
              left: e.left,
              scaleX: e.width / i.width(),
              scaleY: e.height / i.height(),
            },
            t || 330,
            function () {
              o.isAnimating = !1;
            }
          ));
      },
      getFitPos: function (t) {
        var e,
          o,
          a,
          i,
          s,
          r = this,
          c = t.$content,
          l = t.width,
          u = t.height,
          d = t.opts.margin;
        return (
          !(!c || !c.length || (!l && !u)) &&
          ("number" === n.type(d) && (d = [d, d]),
          2 == d.length && (d = [d[0], d[1], d[0], d[1]]),
          (e = parseInt(r.$refs.stage.width(), 10) - (d[1] + d[3])),
          (o = parseInt(r.$refs.stage.height(), 10) - (d[0] + d[2])),
          (a = Math.min(1, e / l, o / u)),
          (i = Math.floor(a * l)),
          (s = Math.floor(a * u)),
          {
            top: Math.floor(0.5 * (o - s)) + d[0],
            left: Math.floor(0.5 * (e - i)) + d[3],
            width: i,
            height: s,
          })
        );
      },
      update: function () {
        var t = this;
        n.each(t.slides, function (e, n) {
          t.updateSlide(n);
        });
      },
      updateSlide: function (t) {
        var e = this,
          o = t.$content;
        o &&
          (t.width || t.height) &&
          ((e.isAnimating = !1),
          n.fancybox.stop(o),
          n.fancybox.setTranslate(o, e.getFitPos(t)),
          t.pos === e.currPos && e.updateCursor()),
          t.$slide.trigger("refresh"),
          e.trigger("onUpdate", t);
      },
      updateCursor: function (t, e) {
        var n,
          a = this,
          i = a.$refs.container.removeClass(
            "fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-drag fancybox-can-zoomOut"
          );
        a.current &&
          !a.isClosing &&
          (a.isZoomable()
            ? (i.addClass("fancybox-is-zoomable"),
              (n =
                t !== o && e !== o
                  ? t < a.current.width && e < a.current.height
                  : a.isScaledDown()),
              n
                ? i.addClass("fancybox-can-zoomIn")
                : a.current.opts.touch
                ? i.addClass("fancybox-can-drag")
                : i.addClass("fancybox-can-zoomOut"))
            : a.current.opts.touch && i.addClass("fancybox-can-drag"));
      },
      isZoomable: function () {
        var t,
          e = this,
          o = e.current;
        if (o && !e.isClosing)
          return !!(
            "image" === o.type &&
            o.isLoaded &&
            !o.hasError &&
            ("zoom" === o.opts.clickContent ||
              (n.isFunction(o.opts.clickContent) &&
                "zoom" === o.opts.clickContent(o))) &&
            ((t = e.getFitPos(o)), o.width > t.width || o.height > t.height)
          );
      },
      isScaledDown: function () {
        var t = this,
          e = t.current,
          o = e.$content,
          a = !1;
        return (
          o &&
            ((a = n.fancybox.getTranslate(o)),
            (a = a.width < e.width || a.height < e.height)),
          a
        );
      },
      canPan: function () {
        var t = this,
          e = t.current,
          n = e.$content,
          o = !1;
        return (
          n &&
            ((o = t.getFitPos(e)),
            (o =
              Math.abs(n.width() - o.width) > 1 ||
              Math.abs(n.height() - o.height) > 1)),
          o
        );
      },
      loadSlide: function (t) {
        var e,
          o,
          a,
          i = this;
        if (!t.isLoading && !t.isLoaded) {
          switch (
            ((t.isLoading = !0),
            i.trigger("beforeLoad", t),
            (e = t.type),
            (o = t.$slide),
            o
              .off("refresh")
              .trigger("onReset")
              .addClass("fancybox-slide--" + (e || "unknown"))
              .addClass(t.opts.slideClass),
            e)
          ) {
            case "image":
              i.setImage(t);
              break;
            case "iframe":
              i.setIframe(t);
              break;
            case "html":
              i.setContent(t, t.src || t.content);
              break;
            case "inline":
              n(t.src).length ? i.setContent(t, n(t.src)) : i.setError(t);
              break;
            case "ajax":
              i.showLoading(t),
                (a = n.ajax(
                  n.extend({}, t.opts.ajax.settings, {
                    url: t.src,
                    success: function (e, n) {
                      "success" === n && i.setContent(t, e);
                    },
                    error: function (e, n) {
                      e && "abort" !== n && i.setError(t);
                    },
                  })
                )),
                o.one("onReset", function () {
                  a.abort();
                });
              break;
            default:
              i.setError(t);
          }
          return !0;
        }
      },
      setImage: function (e) {
        var o,
          a,
          i,
          s,
          r = this,
          c = e.opts.srcset || e.opts.image.srcset;
        if (c) {
          (i = t.devicePixelRatio || 1),
            (s = t.innerWidth * i),
            (a = c.split(",").map(function (t) {
              var e = {};
              return (
                t
                  .trim()
                  .split(/\s+/)
                  .forEach(function (t, n) {
                    var o = parseInt(t.substring(0, t.length - 1), 10);
                    return 0 === n
                      ? (e.url = t)
                      : void (
                          o && ((e.value = o), (e.postfix = t[t.length - 1]))
                        );
                  }),
                e
              );
            })),
            a.sort(function (t, e) {
              return t.value - e.value;
            });
          for (var l = 0; l < a.length; l++) {
            var u = a[l];
            if (
              ("w" === u.postfix && u.value >= s) ||
              ("x" === u.postfix && u.value >= i)
            ) {
              o = u;
              break;
            }
          }
          !o && a.length && (o = a[a.length - 1]),
            o &&
              ((e.src = o.url),
              e.width &&
                e.height &&
                "w" == o.postfix &&
                ((e.height = (e.width / e.height) * o.value),
                (e.width = o.value)));
        }
        (e.$content = n('<div class="fancybox-image-wrap"></div>')
          .addClass("fancybox-is-hidden")
          .appendTo(e.$slide)),
          e.opts.preload !== !1 &&
          e.opts.width &&
          e.opts.height &&
          (e.opts.thumb || e.opts.$thumb)
            ? ((e.width = e.opts.width),
              (e.height = e.opts.height),
              (e.$ghost = n("<img />")
                .one("error", function () {
                  n(this).remove(), (e.$ghost = null), r.setBigImage(e);
                })
                .one("load", function () {
                  r.afterLoad(e), r.setBigImage(e);
                })
                .addClass("fancybox-image")
                .appendTo(e.$content)
                .attr("src", e.opts.thumb || e.opts.$thumb.attr("src"))))
            : r.setBigImage(e);
      },
      setBigImage: function (t) {
        var e = this,
          o = n("<img />");
        (t.$image = o
          .one("error", function () {
            e.setError(t);
          })
          .one("load", function () {
            clearTimeout(t.timouts),
              (t.timouts = null),
              e.isClosing ||
                ((t.width = this.naturalWidth),
                (t.height = this.naturalHeight),
                t.opts.image.srcset &&
                  o.attr("sizes", "100vw").attr("srcset", t.opts.image.srcset),
                e.hideLoading(t),
                t.$ghost
                  ? (t.timouts = setTimeout(function () {
                      (t.timouts = null), t.$ghost.hide();
                    }, Math.min(300, Math.max(1e3, t.height / 1600))))
                  : e.afterLoad(t));
          })
          .addClass("fancybox-image")
          .attr("src", t.src)
          .appendTo(t.$content)),
          (o[0].complete || "complete" == o[0].readyState) &&
          o[0].naturalWidth &&
          o[0].naturalHeight
            ? o.trigger("load")
            : o[0].error
            ? o.trigger("error")
            : (t.timouts = setTimeout(function () {
                o[0].complete || t.hasError || e.showLoading(t);
              }, 100));
      },
      setIframe: function (t) {
        var e,
          a = this,
          i = t.opts.iframe,
          s = t.$slide;
        (t.$content = n(
          '<div class="fancybox-content' +
            (i.preload ? " fancybox-is-hidden" : "") +
            '"></div>'
        )
          .css(i.css)
          .appendTo(s)),
          (e = n(i.tpl.replace(/\{rnd\}/g, new Date().getTime()))
            .attr(i.attr)
            .appendTo(t.$content)),
          i.preload
            ? (a.showLoading(t),
              e.on("load.fb error.fb", function (e) {
                (this.isReady = 1), t.$slide.trigger("refresh"), a.afterLoad(t);
              }),
              s.on("refresh.fb", function () {
                var n,
                  a,
                  s,
                  r = t.$content,
                  c = i.css.width,
                  l = i.css.height;
                if (1 === e[0].isReady) {
                  try {
                    (a = e.contents()), (s = a.find("body"));
                  } catch (t) {}
                  s &&
                    s.length &&
                    (c === o &&
                      ((n =
                        e[0].contentWindow.document.documentElement
                          .scrollWidth),
                      (c = Math.ceil(s.outerWidth(!0) + (r.width() - n))),
                      (c += r.outerWidth() - r.innerWidth())),
                    l === o &&
                      ((l = Math.ceil(s.outerHeight(!0))),
                      (l += r.outerHeight() - r.innerHeight())),
                    c && r.width(c),
                    l && r.height(l)),
                    r.removeClass("fancybox-is-hidden");
                }
              }))
            : this.afterLoad(t),
          e.attr("src", t.src),
          t.opts.smallBtn === !0 &&
            t.$content.prepend(a.translate(t, t.opts.btnTpl.smallBtn)),
          s.one("onReset", function () {
            try {
              n(this).find("iframe").hide().attr("src", "//about:blank");
            } catch (t) {}
            n(this).empty(), (t.isLoaded = !1);
          });
      },
      setContent: function (t, e) {
        var o = this;
        o.isClosing ||
          (o.hideLoading(t),
          t.$slide.empty(),
          l(e) && e.parent().length
            ? (e.parent(".fancybox-slide--inline").trigger("onReset"),
              (t.$placeholder = n("<div></div>").hide().insertAfter(e)),
              e.css("display", "inline-block"))
            : t.hasError ||
              ("string" === n.type(e) &&
                ((e = n("<div>").append(n.trim(e)).contents()),
                3 === e[0].nodeType && (e = n("<div>").html(e))),
              t.opts.filter && (e = n("<div>").html(e).find(t.opts.filter))),
          t.$slide.one("onReset", function () {
            t.$placeholder &&
              (t.$placeholder.after(e.hide()).remove(),
              (t.$placeholder = null)),
              t.$smallBtn && (t.$smallBtn.remove(), (t.$smallBtn = null)),
              t.hasError || (n(this).empty(), (t.isLoaded = !1));
          }),
          (t.$content = n(e).appendTo(t.$slide)),
          this.afterLoad(t));
      },
      setError: function (t) {
        (t.hasError = !0),
          t.$slide.removeClass("fancybox-slide--" + t.type),
          this.setContent(t, this.translate(t, t.opts.errorTpl));
      },
      showLoading: function (t) {
        var e = this;
        (t = t || e.current),
          t &&
            !t.$spinner &&
            (t.$spinner = n(e.opts.spinnerTpl).appendTo(t.$slide));
      },
      hideLoading: function (t) {
        var e = this;
        (t = t || e.current),
          t && t.$spinner && (t.$spinner.remove(), delete t.$spinner);
      },
      afterLoad: function (t) {
        var e = this;
        e.isClosing ||
          ((t.isLoading = !1),
          (t.isLoaded = !0),
          e.trigger("afterLoad", t),
          e.hideLoading(t),
          t.opts.smallBtn &&
            !t.$smallBtn &&
            (t.$smallBtn = n(e.translate(t, t.opts.btnTpl.smallBtn)).appendTo(
              t.$content.filter("div,form").first()
            )),
          t.opts.protect &&
            t.$content &&
            !t.hasError &&
            (t.$content.on("contextmenu.fb", function (t) {
              return 2 == t.button && t.preventDefault(), !0;
            }),
            "image" === t.type &&
              n('<div class="fancybox-spaceball"></div>').appendTo(t.$content)),
          e.revealContent(t));
      },
      revealContent: function (t) {
        var e,
          a,
          i,
          s,
          r,
          c = this,
          l = t.$slide,
          u = !1;
        return (
          (e = t.opts[c.firstRun ? "animationEffect" : "transitionEffect"]),
          (i = t.opts[c.firstRun ? "animationDuration" : "transitionDuration"]),
          (i = parseInt(t.forcedDuration === o ? i : t.forcedDuration, 10)),
          (!t.isMoved && t.pos === c.currPos && i) || (e = !1),
          "zoom" !== e ||
            (t.pos === c.currPos &&
              i &&
              "image" === t.type &&
              !t.hasError &&
              (u = c.getThumbPos(t))) ||
            (e = "fade"),
          "zoom" === e
            ? ((r = c.getFitPos(t)),
              (r.scaleX = r.width / u.width),
              (r.scaleY = r.height / u.height),
              delete r.width,
              delete r.height,
              (s = t.opts.zoomOpacity),
              "auto" == s &&
                (s = Math.abs(t.width / t.height - u.width / u.height) > 0.1),
              s && ((u.opacity = 0.1), (r.opacity = 1)),
              n.fancybox.setTranslate(
                t.$content.removeClass("fancybox-is-hidden"),
                u
              ),
              f(t.$content),
              void n.fancybox.animate(t.$content, r, i, function () {
                c.complete();
              }))
            : (c.updateSlide(t),
              e
                ? (n.fancybox.stop(l),
                  (a =
                    "fancybox-animated fancybox-slide--" +
                    (t.pos >= c.prevPos ? "next" : "previous") +
                    " fancybox-fx-" +
                    e),
                  l
                    .removeAttr("style")
                    .removeClass(
                      "fancybox-slide--current fancybox-slide--next fancybox-slide--previous"
                    )
                    .addClass(a),
                  t.$content.removeClass("fancybox-is-hidden"),
                  f(l),
                  void n.fancybox.animate(
                    l,
                    "fancybox-slide--current",
                    i,
                    function (e) {
                      l.removeClass(a).removeAttr("style"),
                        t.pos === c.currPos && c.complete();
                    },
                    !0
                  ))
                : (f(l),
                  t.$content.removeClass("fancybox-is-hidden"),
                  void (t.pos === c.currPos && c.complete())))
        );
      },
      getThumbPos: function (o) {
        var a,
          i = this,
          s = !1,
          r = function (e) {
            for (
              var o, a = e[0], i = a.getBoundingClientRect(), s = [];
              null !== a.parentElement;

            )
              ("hidden" !== n(a.parentElement).css("overflow") &&
                "auto" !== n(a.parentElement).css("overflow")) ||
                s.push(a.parentElement.getBoundingClientRect()),
                (a = a.parentElement);
            return (
              (o = s.every(function (t) {
                var e = Math.min(i.right, t.right) - Math.max(i.left, t.left),
                  n = Math.min(i.bottom, t.bottom) - Math.max(i.top, t.top);
                return e > 0 && n > 0;
              })),
              o &&
                i.bottom > 0 &&
                i.right > 0 &&
                i.left < n(t).width() &&
                i.top < n(t).height()
            );
          },
          c = o.opts.$thumb,
          l = c ? c.offset() : 0;
        return (
          l &&
            c[0].ownerDocument === e &&
            r(c) &&
            ((a = i.$refs.stage.offset()),
            (s = {
              top: l.top - a.top + parseFloat(c.css("border-top-width") || 0),
              left:
                l.left - a.left + parseFloat(c.css("border-left-width") || 0),
              width: c.width(),
              height: c.height(),
              scaleX: 1,
              scaleY: 1,
            })),
          s
        );
      },
      complete: function () {
        var t = this,
          o = t.current,
          a = {};
        o.isMoved ||
          !o.isLoaded ||
          o.isComplete ||
          ((o.isComplete = !0),
          o.$slide.siblings().trigger("onReset"),
          f(o.$slide),
          o.$slide.addClass("fancybox-slide--complete"),
          n.each(t.slides, function (e, o) {
            o.pos >= t.currPos - 1 && o.pos <= t.currPos + 1
              ? (a[o.pos] = o)
              : o && (n.fancybox.stop(o.$slide), o.$slide.off().remove());
          }),
          (t.slides = a),
          t.updateCursor(),
          t.trigger("afterShow"),
          (n(e.activeElement).is("[disabled]") ||
            (o.opts.autoFocus && "image" != o.type && "iframe" !== o.type)) &&
            t.focus());
      },
      preload: function () {
        var t,
          e,
          n = this;
        n.group.length < 2 ||
          ((t = n.slides[n.currPos + 1]),
          (e = n.slides[n.currPos - 1]),
          t && "image" === t.type && n.loadSlide(t),
          e && "image" === e.type && n.loadSlide(e));
      },
      focus: function () {
        var t,
          e = this.current;
        this.isClosing ||
          (e &&
            e.isComplete &&
            ((t = e.$slide.find("input[autofocus]:enabled:visible:first")),
            t.length ||
              (t = e.$slide
                .find("button,:input,[tabindex],a")
                .filter(":enabled:visible:first"))),
          (t = t && t.length ? t : this.$refs.container),
          t.focus());
      },
      activate: function () {
        var t = this;
        n(".fancybox-container").each(function () {
          var e = n(this).data("FancyBox");
          e &&
            e.id !== t.id &&
            !e.isClosing &&
            (e.trigger("onDeactivate"), e.removeEvents(), (e.isVisible = !1));
        }),
          (t.isVisible = !0),
          (t.current || t.isIdle) && (t.update(), t.updateControls()),
          t.trigger("onActivate"),
          t.addEvents();
      },
      close: function (t, e) {
        var o,
          a,
          i,
          s,
          r,
          c,
          l = this,
          p = l.current,
          h = function () {
            l.cleanUp(t);
          };
        return (
          !l.isClosing &&
          ((l.isClosing = !0),
          l.trigger("beforeClose", t) === !1
            ? ((l.isClosing = !1),
              u(function () {
                l.update();
              }),
              !1)
            : (l.removeEvents(),
              p.timouts && clearTimeout(p.timouts),
              (i = p.$content),
              (o = p.opts.animationEffect),
              (a = n.isNumeric(e) ? e : o ? p.opts.animationDuration : 0),
              p.$slide
                .off(d)
                .removeClass(
                  "fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"
                ),
              p.$slide.siblings().trigger("onReset").remove(),
              a &&
                l.$refs.container
                  .removeClass("fancybox-is-open")
                  .addClass("fancybox-is-closing"),
              l.hideLoading(p),
              l.hideControls(),
              l.updateCursor(),
              "zoom" !== o ||
                (t !== !0 &&
                  i &&
                  a &&
                  "image" === p.type &&
                  !p.hasError &&
                  (c = l.getThumbPos(p))) ||
                (o = "fade"),
              "zoom" === o
                ? (n.fancybox.stop(i),
                  (r = n.fancybox.getTranslate(i)),
                  (r.width = r.width * r.scaleX),
                  (r.height = r.height * r.scaleY),
                  (s = p.opts.zoomOpacity),
                  "auto" == s &&
                    (s =
                      Math.abs(p.width / p.height - c.width / c.height) > 0.1),
                  s && (c.opacity = 0),
                  (r.scaleX = r.width / c.width),
                  (r.scaleY = r.height / c.height),
                  (r.width = c.width),
                  (r.height = c.height),
                  n.fancybox.setTranslate(p.$content, r),
                  f(p.$content),
                  n.fancybox.animate(p.$content, c, a, h),
                  !0)
                : (o && a
                    ? t === !0
                      ? setTimeout(h, a)
                      : n.fancybox.animate(
                          p.$slide.removeClass("fancybox-slide--current"),
                          "fancybox-animated fancybox-slide--previous fancybox-fx-" +
                            o,
                          a,
                          h
                        )
                    : h(),
                  !0)))
        );
      },
      cleanUp: function (t) {
        var o,
          a,
          i = this,
          r = n("body");
        i.current.$slide.trigger("onReset"),
          i.$refs.container.empty().remove(),
          i.trigger("afterClose", t),
          i.$lastFocus && i.current.opts.backFocus && i.$lastFocus.focus(),
          (i.current = null),
          (o = n.fancybox.getInstance()),
          o
            ? o.activate()
            : (s.scrollTop(i.scrollTop).scrollLeft(i.scrollLeft),
              r.removeClass("fancybox-active compensate-for-scrollbar"),
              r.hasClass("fancybox-iosfix") &&
                ((a = parseInt(e.body.style.top, 10)),
                r
                  .removeClass("fancybox-iosfix")
                  .css("top", "")
                  .scrollTop(a * -1)),
              n("#fancybox-style-noscroll").remove());
      },
      trigger: function (t, e) {
        var o,
          a = Array.prototype.slice.call(arguments, 1),
          i = this,
          s = e && e.opts ? e : i.current;
        return (
          s ? a.unshift(s) : (s = i),
          a.unshift(i),
          n.isFunction(s.opts[t]) && (o = s.opts[t].apply(s, a)),
          o === !1
            ? o
            : void ("afterClose" !== t && i.$refs
                ? i.$refs.container.trigger(t + ".fb", a)
                : r.trigger(t + ".fb", a))
        );
      },
      updateControls: function (t) {
        var e = this,
          n = e.current,
          o = n.index,
          a = n.opts.caption,
          i = e.$refs.container,
          s = e.$refs.caption;
        n.$slide.trigger("refresh"),
          (e.$caption = a && a.length ? s.html(a) : null),
          e.isHiddenControls || e.isIdle || e.showControls(),
          i.find("[data-fancybox-count]").html(e.group.length),
          i.find("[data-fancybox-index]").html(o + 1),
          i
            .find("[data-fancybox-prev]")
            .prop("disabled", !n.opts.loop && o <= 0),
          i
            .find("[data-fancybox-next]")
            .prop("disabled", !n.opts.loop && o >= e.group.length - 1),
          "image" === n.type
            ? i
                .find("[data-fancybox-download]")
                .attr("href", n.opts.image.src || n.src)
                .show()
            : i.find("[data-fancybox-download],[data-fancybox-zoom]").hide();
      },
      hideControls: function () {
        (this.isHiddenControls = !0),
          this.$refs.container.removeClass(
            "fancybox-show-infobar fancybox-show-toolbar fancybox-show-caption fancybox-show-nav"
          );
      },
      showControls: function () {
        var t = this,
          e = t.current ? t.current.opts : t.opts,
          n = t.$refs.container;
        (t.isHiddenControls = !1),
          (t.idleSecondsCounter = 0),
          n
            .toggleClass("fancybox-show-toolbar", !(!e.toolbar || !e.buttons))
            .toggleClass(
              "fancybox-show-infobar",
              !!(e.infobar && t.group.length > 1)
            )
            .toggleClass(
              "fancybox-show-nav",
              !!(e.arrows && t.group.length > 1)
            )
            .toggleClass("fancybox-is-modal", !!e.modal),
          t.$caption
            ? n.addClass("fancybox-show-caption ")
            : n.removeClass("fancybox-show-caption");
      },
      toggleControls: function () {
        this.isHiddenControls ? this.showControls() : this.hideControls();
      },
    }),
      (n.fancybox = {
        version: "3.2.5",
        defaults: i,
        getInstance: function (t) {
          var e = n(
              '.fancybox-container:not(".fancybox-is-closing"):last'
            ).data("FancyBox"),
            o = Array.prototype.slice.call(arguments, 1);
          return (
            e instanceof p &&
            ("string" === n.type(t)
              ? e[t].apply(e, o)
              : "function" === n.type(t) && t.apply(e, o),
            e)
          );
        },
        open: function (t, e, n) {
          return new p(t, e, n);
        },
        close: function (t) {
          var e = this.getInstance();
          e && (e.close(), t === !0 && this.close());
        },
        destroy: function () {
          this.close(!0), r.off("click.fb-start");
        },
        isMobile:
          e.createTouch !== o &&
          /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          ),
        use3d: (function () {
          var n = e.createElement("div");
          return (
            t.getComputedStyle &&
            t.getComputedStyle(n).getPropertyValue("transform") &&
            !(e.documentMode && e.documentMode < 11)
          );
        })(),
        getTranslate: function (t) {
          var e;
          if (!t || !t.length) return !1;
          if (
            ((e = t.eq(0).css("transform")),
            e && e.indexOf("matrix") !== -1
              ? ((e = e.split("(")[1]),
                (e = e.split(")")[0]),
                (e = e.split(",")))
              : (e = []),
            e.length)
          )
            (e =
              e.length > 10
                ? [e[13], e[12], e[0], e[5]]
                : [e[5], e[4], e[0], e[3]]),
              (e = e.map(parseFloat));
          else {
            e = [0, 0, 1, 1];
            var n = /\.*translate\((.*)px,(.*)px\)/i,
              o = n.exec(t.eq(0).attr("style"));
            o && ((e[0] = parseFloat(o[2])), (e[1] = parseFloat(o[1])));
          }
          return {
            top: e[0],
            left: e[1],
            scaleX: e[2],
            scaleY: e[3],
            opacity: parseFloat(t.css("opacity")),
            width: t.width(),
            height: t.height(),
          };
        },
        setTranslate: function (t, e) {
          var n = "",
            a = {};
          if (t && e)
            return (
              (e.left === o && e.top === o) ||
                ((n =
                  (e.left === o ? t.position().left : e.left) +
                  "px, " +
                  (e.top === o ? t.position().top : e.top) +
                  "px"),
                (n = this.use3d
                  ? "translate3d(" + n + ", 0px)"
                  : "translate(" + n + ")")),
              e.scaleX !== o &&
                e.scaleY !== o &&
                (n =
                  (n.length ? n + " " : "") +
                  "scale(" +
                  e.scaleX +
                  ", " +
                  e.scaleY +
                  ")"),
              n.length && (a.transform = n),
              e.opacity !== o && (a.opacity = e.opacity),
              e.width !== o && (a.width = e.width),
              e.height !== o && (a.height = e.height),
              t.css(a)
            );
        },
        animate: function (t, e, a, i, s) {
          n.isFunction(a) && ((i = a), (a = null)),
            n.isPlainObject(e) || t.removeAttr("style"),
            t.on(d, function (a) {
              (!a ||
                !a.originalEvent ||
                (t.is(a.originalEvent.target) &&
                  "z-index" != a.originalEvent.propertyName)) &&
                (n.fancybox.stop(t),
                n.isPlainObject(e)
                  ? e.scaleX !== o &&
                    e.scaleY !== o &&
                    (t.css("transition-duration", ""),
                    (e.width = Math.round(t.width() * e.scaleX)),
                    (e.height = Math.round(t.height() * e.scaleY)),
                    (e.scaleX = 1),
                    (e.scaleY = 1),
                    n.fancybox.setTranslate(t, e))
                  : s !== !0 && t.removeClass(e),
                n.isFunction(i) && i(a));
            }),
            n.isNumeric(a) && t.css("transition-duration", a + "ms"),
            n.isPlainObject(e) ? n.fancybox.setTranslate(t, e) : t.addClass(e),
            e.scaleX &&
              t.hasClass("fancybox-image-wrap") &&
              t.parent().addClass("fancybox-is-scaling"),
            t.data(
              "timer",
              setTimeout(function () {
                t.trigger("transitionend");
              }, a + 16)
            );
        },
        stop: function (t) {
          clearTimeout(t.data("timer")),
            t.off("transitionend").css("transition-duration", ""),
            t.hasClass("fancybox-image-wrap") &&
              t.parent().removeClass("fancybox-is-scaling");
        },
      }),
      (n.fn.fancybox = function (t) {
        var e;
        return (
          (t = t || {}),
          (e = t.selector || !1),
          e
            ? n("body")
                .off("click.fb-start", e)
                .on("click.fb-start", e, { options: t }, a)
            : this.off("click.fb-start").on(
                "click.fb-start",
                { items: this, options: t },
                a
              ),
          this
        );
      }),
      r.on("click.fb-start", "[data-fancybox]", a);
  }
})(window, document, window.jQuery || jQuery),
  (function (t) {
    "use strict";
    var e = function (e, n, o) {
        if (e)
          return (
            (o = o || ""),
            "object" === t.type(o) && (o = t.param(o, !0)),
            t.each(n, function (t, n) {
              e = e.replace("$" + t, n || "");
            }),
            o.length && (e += (e.indexOf("?") > 0 ? "&" : "?") + o),
            e
          );
      },
      n = {
        youtube: {
          matcher:
            /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
          params: {
            autoplay: 1,
            autohide: 1,
            fs: 1,
            rel: 0,
            hd: 1,
            wmode: "transparent",
            enablejsapi: 1,
            html5: 1,
          },
          paramPlace: 8,
          type: "iframe",
          url: "//www.youtube.com/embed/$4",
          thumb: "//img.youtube.com/vi/$4/hqdefault.jpg",
        },
        vimeo: {
          matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
          params: {
            autoplay: 1,
            hd: 1,
            show_title: 1,
            show_byline: 1,
            show_portrait: 0,
            fullscreen: 1,
            api: 1,
          },
          paramPlace: 3,
          type: "iframe",
          url: "//player.vimeo.com/video/$2",
        },
        metacafe: {
          matcher: /metacafe.com\/watch\/(\d+)\/(.*)?/,
          type: "iframe",
          url: "//www.metacafe.com/embed/$1/?ap=1",
        },
        dailymotion: {
          matcher: /dailymotion.com\/video\/(.*)\/?(.*)/,
          params: { additionalInfos: 0, autoStart: 1 },
          type: "iframe",
          url: "//www.dailymotion.com/embed/video/$1",
        },
        vine: {
          matcher: /vine.co\/v\/([a-zA-Z0-9\?\=\-]+)/,
          type: "iframe",
          url: "//vine.co/v/$1/embed/simple",
        },
        instagram: {
          matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
          type: "image",
          url: "//$1/p/$2/media/?size=l",
        },
        gmap_place: {
          matcher:
            /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
          type: "iframe",
          url: function (t) {
            return (
              "//maps.google." +
              t[2] +
              "/?ll=" +
              (t[9]
                ? t[9] +
                  "&z=" +
                  Math.floor(t[10]) +
                  (t[12] ? t[12].replace(/^\//, "&") : "")
                : t[12]) +
              "&output=" +
              (t[12] && t[12].indexOf("layer=c") > 0 ? "svembed" : "embed")
            );
          },
        },
        gmap_search: {
          matcher:
            /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
          type: "iframe",
          url: function (t) {
            return (
              "//maps.google." +
              t[2] +
              "/maps?q=" +
              t[5].replace("query=", "q=").replace("api=1", "") +
              "&output=embed"
            );
          },
        },
      };
    t(document).on("objectNeedsType.fb", function (o, a, i) {
      var s,
        r,
        c,
        l,
        u,
        d,
        f,
        p = i.src || "",
        h = !1;
      (s = t.extend(!0, {}, n, i.opts.media)),
        t.each(s, function (n, o) {
          if ((c = p.match(o.matcher))) {
            if (((h = o.type), (d = {}), o.paramPlace && c[o.paramPlace])) {
              (u = c[o.paramPlace]),
                "?" == u[0] && (u = u.substring(1)),
                (u = u.split("&"));
              for (var a = 0; a < u.length; ++a) {
                var s = u[a].split("=", 2);
                2 == s.length &&
                  (d[s[0]] = decodeURIComponent(s[1].replace(/\+/g, " ")));
              }
            }
            return (
              (l = t.extend(!0, {}, o.params, i.opts[n], d)),
              (p =
                "function" === t.type(o.url)
                  ? o.url.call(this, c, l, i)
                  : e(o.url, c, l)),
              (r =
                "function" === t.type(o.thumb)
                  ? o.thumb.call(this, c, l, i)
                  : e(o.thumb, c)),
              "vimeo" === n && (p = p.replace("&%23", "#")),
              !1
            );
          }
        }),
        h
          ? ((i.src = p),
            (i.type = h),
            i.opts.thumb ||
              (i.opts.$thumb && i.opts.$thumb.length) ||
              (i.opts.thumb = r),
            "iframe" === h &&
              (t.extend(!0, i.opts, {
                iframe: { preload: !1, attr: { scrolling: "no" } },
              }),
              (i.contentProvider = f),
              (i.opts.slideClass +=
                " fancybox-slide--" +
                ("gmap_place" == f || "gmap_search" == f ? "map" : "video"))))
          : p && (i.type = i.opts.defaultType);
    });
  })(window.jQuery || jQuery),
  (function (t, e, n) {
    "use strict";
    var o = (function () {
        return (
          t.requestAnimationFrame ||
          t.webkitRequestAnimationFrame ||
          t.mozRequestAnimationFrame ||
          t.oRequestAnimationFrame ||
          function (e) {
            return t.setTimeout(e, 1e3 / 60);
          }
        );
      })(),
      a = (function () {
        return (
          t.cancelAnimationFrame ||
          t.webkitCancelAnimationFrame ||
          t.mozCancelAnimationFrame ||
          t.oCancelAnimationFrame ||
          function (e) {
            t.clearTimeout(e);
          }
        );
      })(),
      i = function (e) {
        var n = [];
        (e = e.originalEvent || e || t.e),
          (e =
            e.touches && e.touches.length
              ? e.touches
              : e.changedTouches && e.changedTouches.length
              ? e.changedTouches
              : [e]);
        for (var o in e)
          e[o].pageX
            ? n.push({ x: e[o].pageX, y: e[o].pageY })
            : e[o].clientX && n.push({ x: e[o].clientX, y: e[o].clientY });
        return n;
      },
      s = function (t, e, n) {
        return e && t
          ? "x" === n
            ? t.x - e.x
            : "y" === n
            ? t.y - e.y
            : Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2))
          : 0;
      },
      r = function (t) {
        if (
          t.is(
            'a,area,button,[role="button"],input,label,select,summary,textarea'
          ) ||
          n.isFunction(t.get(0).onclick) ||
          t.data("selectable")
        )
          return !0;
        for (var e = 0, o = t[0].attributes, a = o.length; e < a; e++)
          if ("data-fancybox-" === o[e].nodeName.substr(0, 14)) return !0;
        return !1;
      },
      c = function (e) {
        var n = t.getComputedStyle(e)["overflow-y"],
          o = t.getComputedStyle(e)["overflow-x"],
          a =
            ("scroll" === n || "auto" === n) && e.scrollHeight > e.clientHeight,
          i = ("scroll" === o || "auto" === o) && e.scrollWidth > e.clientWidth;
        return a || i;
      },
      l = function (t) {
        for (var e = !1; ; ) {
          if ((e = c(t.get(0)))) break;
          if (
            ((t = t.parent()),
            !t.length || t.hasClass("fancybox-stage") || t.is("body"))
          )
            break;
        }
        return e;
      },
      u = function (t) {
        var e = this;
        (e.instance = t),
          (e.$bg = t.$refs.bg),
          (e.$stage = t.$refs.stage),
          (e.$container = t.$refs.container),
          e.destroy(),
          e.$container.on(
            "touchstart.fb.touch mousedown.fb.touch",
            n.proxy(e, "ontouchstart")
          );
      };
    (u.prototype.destroy = function () {
      this.$container.off(".fb.touch");
    }),
      (u.prototype.ontouchstart = function (o) {
        var a = this,
          c = n(o.target),
          u = a.instance,
          d = u.current,
          f = d.$content,
          p = "touchstart" == o.type;
        if (
          (p && a.$container.off("mousedown.fb.touch"),
          !d || a.instance.isAnimating || a.instance.isClosing)
        )
          return o.stopPropagation(), void o.preventDefault();
        if (
          (!o.originalEvent || 2 != o.originalEvent.button) &&
          c.length &&
          !r(c) &&
          !r(c.parent()) &&
          !(o.originalEvent.clientX > c[0].clientWidth + c.offset().left) &&
          ((a.startPoints = i(o)),
          a.startPoints && !(a.startPoints.length > 1 && u.isSliding))
        ) {
          if (
            ((a.$target = c),
            (a.$content = f),
            (a.canTap = !0),
            (a.opts = d.opts.touch),
            n(e).off(".fb.touch"),
            n(e).on(
              p
                ? "touchend.fb.touch touchcancel.fb.touch"
                : "mouseup.fb.touch mouseleave.fb.touch",
              n.proxy(a, "ontouchend")
            ),
            n(e).on(
              p ? "touchmove.fb.touch" : "mousemove.fb.touch",
              n.proxy(a, "ontouchmove")
            ),
            (!a.opts && !u.canPan()) ||
              (!c.is(a.$stage) && !a.$stage.find(c).length))
          )
            return void (c.is("img") && o.preventDefault());
          o.stopPropagation(),
            (n.fancybox.isMobile && (l(a.$target) || l(a.$target.parent()))) ||
              o.preventDefault(),
            (a.canvasWidth = Math.round(d.$slide[0].clientWidth)),
            (a.canvasHeight = Math.round(d.$slide[0].clientHeight)),
            (a.startTime = new Date().getTime()),
            (a.distanceX = a.distanceY = a.distance = 0),
            (a.isPanning = !1),
            (a.isSwiping = !1),
            (a.isZooming = !1),
            (a.sliderStartPos = a.sliderLastPos || { top: 0, left: 0 }),
            (a.contentStartPos = n.fancybox.getTranslate(a.$content)),
            (a.contentLastPos = null),
            1 !== a.startPoints.length ||
              a.isZooming ||
              ((a.canTap = !u.isSliding),
              "image" === d.type &&
              (a.contentStartPos.width > a.canvasWidth + 1 ||
                a.contentStartPos.height > a.canvasHeight + 1)
                ? (n.fancybox.stop(a.$content),
                  a.$content.css("transition-duration", "0ms"),
                  (a.isPanning = !0))
                : (a.isSwiping = !0),
              a.$container.addClass("fancybox-controls--isGrabbing")),
            2 !== a.startPoints.length ||
              u.isAnimating ||
              d.hasError ||
              "image" !== d.type ||
              (!d.isLoaded && !d.$ghost) ||
              ((a.isZooming = !0),
              (a.isSwiping = !1),
              (a.isPanning = !1),
              n.fancybox.stop(a.$content),
              a.$content.css("transition-duration", "0ms"),
              (a.centerPointStartX =
                0.5 * (a.startPoints[0].x + a.startPoints[1].x) -
                n(t).scrollLeft()),
              (a.centerPointStartY =
                0.5 * (a.startPoints[0].y + a.startPoints[1].y) -
                n(t).scrollTop()),
              (a.percentageOfImageAtPinchPointX =
                (a.centerPointStartX - a.contentStartPos.left) /
                a.contentStartPos.width),
              (a.percentageOfImageAtPinchPointY =
                (a.centerPointStartY - a.contentStartPos.top) /
                a.contentStartPos.height),
              (a.startDistanceBetweenFingers = s(
                a.startPoints[0],
                a.startPoints[1]
              )));
        }
      }),
      (u.prototype.ontouchmove = function (t) {
        var e = this;
        if (
          ((e.newPoints = i(t)),
          n.fancybox.isMobile && (l(e.$target) || l(e.$target.parent())))
        )
          return t.stopPropagation(), void (e.canTap = !1);
        if (
          (e.opts || e.instance.canPan()) &&
          e.newPoints &&
          e.newPoints.length &&
          ((e.distanceX = s(e.newPoints[0], e.startPoints[0], "x")),
          (e.distanceY = s(e.newPoints[0], e.startPoints[0], "y")),
          (e.distance = s(e.newPoints[0], e.startPoints[0])),
          e.distance > 0)
        ) {
          if (!e.$target.is(e.$stage) && !e.$stage.find(e.$target).length)
            return;
          t.stopPropagation(),
            t.preventDefault(),
            e.isSwiping
              ? e.onSwipe()
              : e.isPanning
              ? e.onPan()
              : e.isZooming && e.onZoom();
        }
      }),
      (u.prototype.onSwipe = function () {
        var e,
          i = this,
          s = i.isSwiping,
          r = i.sliderStartPos.left || 0;
        s === !0
          ? Math.abs(i.distance) > 10 &&
            ((i.canTap = !1),
            i.instance.group.length < 2 && i.opts.vertical
              ? (i.isSwiping = "y")
              : i.instance.isSliding ||
                i.opts.vertical === !1 ||
                ("auto" === i.opts.vertical && n(t).width() > 800)
              ? (i.isSwiping = "x")
              : ((e = Math.abs(
                  (180 * Math.atan2(i.distanceY, i.distanceX)) / Math.PI
                )),
                (i.isSwiping = e > 45 && e < 135 ? "y" : "x")),
            (i.instance.isSliding = i.isSwiping),
            (i.startPoints = i.newPoints),
            n.each(i.instance.slides, function (t, e) {
              n.fancybox.stop(e.$slide),
                e.$slide.css("transition-duration", "0ms"),
                (e.inTransition = !1),
                e.pos === i.instance.current.pos &&
                  (i.sliderStartPos.left = n.fancybox.getTranslate(
                    e.$slide
                  ).left);
            }),
            i.instance.SlideShow &&
              i.instance.SlideShow.isActive &&
              i.instance.SlideShow.stop())
          : ("x" == s &&
              (i.distanceX > 0 &&
              (i.instance.group.length < 2 ||
                (0 === i.instance.current.index &&
                  !i.instance.current.opts.loop))
                ? (r += Math.pow(i.distanceX, 0.8))
                : i.distanceX < 0 &&
                  (i.instance.group.length < 2 ||
                    (i.instance.current.index === i.instance.group.length - 1 &&
                      !i.instance.current.opts.loop))
                ? (r -= Math.pow(-i.distanceX, 0.8))
                : (r += i.distanceX)),
            (i.sliderLastPos = {
              top: "x" == s ? 0 : i.sliderStartPos.top + i.distanceY,
              left: r,
            }),
            i.requestId && (a(i.requestId), (i.requestId = null)),
            (i.requestId = o(function () {
              i.sliderLastPos &&
                (n.each(i.instance.slides, function (t, e) {
                  var o = e.pos - i.instance.currPos;
                  n.fancybox.setTranslate(e.$slide, {
                    top: i.sliderLastPos.top,
                    left:
                      i.sliderLastPos.left +
                      o * i.canvasWidth +
                      o * e.opts.gutter,
                  });
                }),
                i.$container.addClass("fancybox-is-sliding"));
            })));
      }),
      (u.prototype.onPan = function () {
        var t,
          e,
          i,
          s = this;
        (s.canTap = !1),
          (t =
            s.contentStartPos.width > s.canvasWidth
              ? s.contentStartPos.left + s.distanceX
              : s.contentStartPos.left),
          (e = s.contentStartPos.top + s.distanceY),
          (i = s.limitMovement(
            t,
            e,
            s.contentStartPos.width,
            s.contentStartPos.height
          )),
          (i.scaleX = s.contentStartPos.scaleX),
          (i.scaleY = s.contentStartPos.scaleY),
          (s.contentLastPos = i),
          s.requestId && (a(s.requestId), (s.requestId = null)),
          (s.requestId = o(function () {
            n.fancybox.setTranslate(s.$content, s.contentLastPos);
          }));
      }),
      (u.prototype.limitMovement = function (t, e, n, o) {
        var a,
          i,
          s,
          r,
          c = this,
          l = c.canvasWidth,
          u = c.canvasHeight,
          d = c.contentStartPos.left,
          f = c.contentStartPos.top,
          p = c.distanceX,
          h = c.distanceY;
        return (
          (a = Math.max(0, 0.5 * l - 0.5 * n)),
          (i = Math.max(0, 0.5 * u - 0.5 * o)),
          (s = Math.min(l - n, 0.5 * l - 0.5 * n)),
          (r = Math.min(u - o, 0.5 * u - 0.5 * o)),
          n > l &&
            (p > 0 && t > a && (t = a - 1 + Math.pow(-a + d + p, 0.8) || 0),
            p < 0 && t < s && (t = s + 1 - Math.pow(s - d - p, 0.8) || 0)),
          o > u &&
            (h > 0 && e > i && (e = i - 1 + Math.pow(-i + f + h, 0.8) || 0),
            h < 0 && e < r && (e = r + 1 - Math.pow(r - f - h, 0.8) || 0)),
          { top: e, left: t }
        );
      }),
      (u.prototype.limitPosition = function (t, e, n, o) {
        var a = this,
          i = a.canvasWidth,
          s = a.canvasHeight;
        return (
          n > i
            ? ((t = t > 0 ? 0 : t), (t = t < i - n ? i - n : t))
            : (t = Math.max(0, i / 2 - n / 2)),
          o > s
            ? ((e = e > 0 ? 0 : e), (e = e < s - o ? s - o : e))
            : (e = Math.max(0, s / 2 - o / 2)),
          { top: e, left: t }
        );
      }),
      (u.prototype.onZoom = function () {
        var e = this,
          i = e.contentStartPos.width,
          r = e.contentStartPos.height,
          c = e.contentStartPos.left,
          l = e.contentStartPos.top,
          u = s(e.newPoints[0], e.newPoints[1]),
          d = u / e.startDistanceBetweenFingers,
          f = Math.floor(i * d),
          p = Math.floor(r * d),
          h = (i - f) * e.percentageOfImageAtPinchPointX,
          g = (r - p) * e.percentageOfImageAtPinchPointY,
          b = (e.newPoints[0].x + e.newPoints[1].x) / 2 - n(t).scrollLeft(),
          m = (e.newPoints[0].y + e.newPoints[1].y) / 2 - n(t).scrollTop(),
          y = b - e.centerPointStartX,
          v = m - e.centerPointStartY,
          x = c + (h + y),
          w = l + (g + v),
          $ = {
            top: w,
            left: x,
            scaleX: e.contentStartPos.scaleX * d,
            scaleY: e.contentStartPos.scaleY * d,
          };
        (e.canTap = !1),
          (e.newWidth = f),
          (e.newHeight = p),
          (e.contentLastPos = $),
          e.requestId && (a(e.requestId), (e.requestId = null)),
          (e.requestId = o(function () {
            n.fancybox.setTranslate(e.$content, e.contentLastPos);
          }));
      }),
      (u.prototype.ontouchend = function (t) {
        var o = this,
          s = Math.max(new Date().getTime() - o.startTime, 1),
          r = o.isSwiping,
          c = o.isPanning,
          l = o.isZooming;
        return (
          (o.endPoints = i(t)),
          o.$container.removeClass("fancybox-controls--isGrabbing"),
          n(e).off(".fb.touch"),
          o.requestId && (a(o.requestId), (o.requestId = null)),
          (o.isSwiping = !1),
          (o.isPanning = !1),
          (o.isZooming = !1),
          o.canTap
            ? o.onTap(t)
            : ((o.speed = 366),
              (o.velocityX = (o.distanceX / s) * 0.5),
              (o.velocityY = (o.distanceY / s) * 0.5),
              (o.speedX = Math.max(
                0.5 * o.speed,
                Math.min(1.5 * o.speed, (1 / Math.abs(o.velocityX)) * o.speed)
              )),
              void (c ? o.endPanning() : l ? o.endZooming() : o.endSwiping(r)))
        );
      }),
      (u.prototype.endSwiping = function (t) {
        var e = this,
          o = !1;
        (e.instance.isSliding = !1),
          (e.sliderLastPos = null),
          "y" == t && Math.abs(e.distanceY) > 50
            ? (n.fancybox.animate(
                e.instance.current.$slide,
                {
                  top: e.sliderStartPos.top + e.distanceY + 150 * e.velocityY,
                  opacity: 0,
                },
                150
              ),
              (o = e.instance.close(!0, 300)))
            : "x" == t && e.distanceX > 50 && e.instance.group.length > 1
            ? (o = e.instance.previous(e.speedX))
            : "x" == t &&
              e.distanceX < -50 &&
              e.instance.group.length > 1 &&
              (o = e.instance.next(e.speedX)),
          o !== !1 ||
            ("x" != t && "y" != t) ||
            e.instance.jumpTo(e.instance.current.index, 150),
          e.$container.removeClass("fancybox-is-sliding");
      }),
      (u.prototype.endPanning = function () {
        var t,
          e,
          o,
          a = this;
        a.contentLastPos &&
          (a.opts.momentum === !1
            ? ((t = a.contentLastPos.left), (e = a.contentLastPos.top))
            : ((t = a.contentLastPos.left + a.velocityX * a.speed),
              (e = a.contentLastPos.top + a.velocityY * a.speed)),
          (o = a.limitPosition(
            t,
            e,
            a.contentStartPos.width,
            a.contentStartPos.height
          )),
          (o.width = a.contentStartPos.width),
          (o.height = a.contentStartPos.height),
          n.fancybox.animate(a.$content, o, 330));
      }),
      (u.prototype.endZooming = function () {
        var t,
          e,
          o,
          a,
          i = this,
          s = i.instance.current,
          r = i.newWidth,
          c = i.newHeight;
        i.contentLastPos &&
          ((t = i.contentLastPos.left),
          (e = i.contentLastPos.top),
          (a = { top: e, left: t, width: r, height: c, scaleX: 1, scaleY: 1 }),
          n.fancybox.setTranslate(i.$content, a),
          r < i.canvasWidth && c < i.canvasHeight
            ? i.instance.scaleToFit(150)
            : r > s.width || c > s.height
            ? i.instance.scaleToActual(
                i.centerPointStartX,
                i.centerPointStartY,
                150
              )
            : ((o = i.limitPosition(t, e, r, c)),
              n.fancybox.setTranslate(
                i.content,
                n.fancybox.getTranslate(i.$content)
              ),
              n.fancybox.animate(i.$content, o, 150)));
      }),
      (u.prototype.onTap = function (t) {
        var e,
          o = this,
          a = n(t.target),
          s = o.instance,
          r = s.current,
          c = (t && i(t)) || o.startPoints,
          l = c[0] ? c[0].x - o.$stage.offset().left : 0,
          u = c[0] ? c[0].y - o.$stage.offset().top : 0,
          d = function (e) {
            var a = r.opts[e];
            if ((n.isFunction(a) && (a = a.apply(s, [r, t])), a))
              switch (a) {
                case "close":
                  s.close(o.startEvent);
                  break;
                case "toggleControls":
                  s.toggleControls(!0);
                  break;
                case "next":
                  s.next();
                  break;
                case "nextOrClose":
                  s.group.length > 1 ? s.next() : s.close(o.startEvent);
                  break;
                case "zoom":
                  "image" == r.type &&
                    (r.isLoaded || r.$ghost) &&
                    (s.canPan()
                      ? s.scaleToFit()
                      : s.isScaledDown()
                      ? s.scaleToActual(l, u)
                      : s.group.length < 2 && s.close(o.startEvent));
              }
          };
        if (
          !(
            (t.originalEvent && 2 == t.originalEvent.button) ||
            s.isSliding ||
            l > a[0].clientWidth + a.offset().left
          )
        ) {
          if (
            a.is(
              ".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container"
            )
          )
            e = "Outside";
          else if (a.is(".fancybox-slide")) e = "Slide";
          else {
            if (!s.current.$content || !s.current.$content.has(t.target).length)
              return;
            e = "Content";
          }
          if (o.tapped) {
            if (
              (clearTimeout(o.tapped),
              (o.tapped = null),
              Math.abs(l - o.tapX) > 50 ||
                Math.abs(u - o.tapY) > 50 ||
                s.isSliding)
            )
              return this;
            d("dblclick" + e);
          } else
            (o.tapX = l),
              (o.tapY = u),
              r.opts["dblclick" + e] &&
              r.opts["dblclick" + e] !== r.opts["click" + e]
                ? (o.tapped = setTimeout(function () {
                    (o.tapped = null), d("click" + e);
                  }, 300))
                : d("click" + e);
          return this;
        }
      }),
      n(e).on("onActivate.fb", function (t, e) {
        e && !e.Guestures && (e.Guestures = new u(e));
      }),
      n(e).on("beforeClose.fb", function (t, e) {
        e && e.Guestures && e.Guestures.destroy();
      });
  })(window, document, window.jQuery || jQuery),
  (function (t, e) {
    "use strict";
    e.extend(!0, e.fancybox.defaults, {
      btnTpl: {
        slideShow:
          '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg viewBox="0 0 40 40"><path d="M13,12 L27,20 L13,27 Z" /><path d="M15,10 v19 M23,10 v19" /></svg></button>',
      },
      slideShow: { autoStart: !1, speed: 3e3 },
    });
    var n = function (t) {
      (this.instance = t), this.init();
    };
    e.extend(n.prototype, {
      timer: null,
      isActive: !1,
      $button: null,
      init: function () {
        var t = this;
        (t.$button = t.instance.$refs.toolbar
          .find("[data-fancybox-play]")
          .on("click", function () {
            t.toggle();
          })),
          (t.instance.group.length < 2 ||
            !t.instance.group[t.instance.currIndex].opts.slideShow) &&
            t.$button.hide();
      },
      set: function (t) {
        var e = this;
        e.instance &&
        e.instance.current &&
        (t === !0 ||
          e.instance.current.opts.loop ||
          e.instance.currIndex < e.instance.group.length - 1)
          ? (e.timer = setTimeout(function () {
              e.isActive &&
                e.instance.jumpTo(
                  (e.instance.currIndex + 1) % e.instance.group.length
                );
            }, e.instance.current.opts.slideShow.speed))
          : (e.stop(),
            (e.instance.idleSecondsCounter = 0),
            e.instance.showControls());
      },
      clear: function () {
        var t = this;
        clearTimeout(t.timer), (t.timer = null);
      },
      start: function () {
        var t = this,
          e = t.instance.current;
        e &&
          ((t.isActive = !0),
          t.$button
            .attr("title", e.opts.i18n[e.opts.lang].PLAY_STOP)
            .removeClass("fancybox-button--play")
            .addClass("fancybox-button--pause"),
          t.set(!0));
      },
      stop: function () {
        var t = this,
          e = t.instance.current;
        t.clear(),
          t.$button
            .attr("title", e.opts.i18n[e.opts.lang].PLAY_START)
            .removeClass("fancybox-button--pause")
            .addClass("fancybox-button--play"),
          (t.isActive = !1);
      },
      toggle: function () {
        var t = this;
        t.isActive ? t.stop() : t.start();
      },
    }),
      e(t).on({
        "onInit.fb": function (t, e) {
          e && !e.SlideShow && (e.SlideShow = new n(e));
        },
        "beforeShow.fb": function (t, e, n, o) {
          var a = e && e.SlideShow;
          o
            ? a && n.opts.slideShow.autoStart && a.start()
            : a && a.isActive && a.clear();
        },
        "afterShow.fb": function (t, e, n) {
          var o = e && e.SlideShow;
          o && o.isActive && o.set();
        },
        "afterKeydown.fb": function (n, o, a, i, s) {
          var r = o && o.SlideShow;
          !r ||
            !a.opts.slideShow ||
            (80 !== s && 32 !== s) ||
            e(t.activeElement).is("button,a,input") ||
            (i.preventDefault(), r.toggle());
        },
        "beforeClose.fb onDeactivate.fb": function (t, e) {
          var n = e && e.SlideShow;
          n && n.stop();
        },
      }),
      e(t).on("visibilitychange", function () {
        var n = e.fancybox.getInstance(),
          o = n && n.SlideShow;
        o && o.isActive && (t.hidden ? o.clear() : o.set());
      });
  })(document, window.jQuery || jQuery),
  (function (t, e) {
    "use strict";
    var n = (function () {
      var e,
        n,
        o,
        a = [
          [
            "requestFullscreen",
            "exitFullscreen",
            "fullscreenElement",
            "fullscreenEnabled",
            "fullscreenchange",
            "fullscreenerror",
          ],
          [
            "webkitRequestFullscreen",
            "webkitExitFullscreen",
            "webkitFullscreenElement",
            "webkitFullscreenEnabled",
            "webkitfullscreenchange",
            "webkitfullscreenerror",
          ],
          [
            "webkitRequestFullScreen",
            "webkitCancelFullScreen",
            "webkitCurrentFullScreenElement",
            "webkitCancelFullScreen",
            "webkitfullscreenchange",
            "webkitfullscreenerror",
          ],
          [
            "mozRequestFullScreen",
            "mozCancelFullScreen",
            "mozFullScreenElement",
            "mozFullScreenEnabled",
            "mozfullscreenchange",
            "mozfullscreenerror",
          ],
          [
            "msRequestFullscreen",
            "msExitFullscreen",
            "msFullscreenElement",
            "msFullscreenEnabled",
            "MSFullscreenChange",
            "MSFullscreenError",
          ],
        ],
        i = {};
      for (n = 0; n < a.length; n++)
        if (((e = a[n]), e && e[1] in t)) {
          for (o = 0; o < e.length; o++) i[a[0][o]] = e[o];
          return i;
        }
      return !1;
    })();
    if (!n)
      return void (
        e &&
        e.fancybox &&
        (e.fancybox.defaults.btnTpl.fullScreen = !1)
      );
    var o = {
      request: function (e) {
        (e = e || t.documentElement),
          e[n.requestFullscreen](e.ALLOW_KEYBOARD_INPUT);
      },
      exit: function () {
        t[n.exitFullscreen]();
      },
      toggle: function (e) {
        (e = e || t.documentElement),
          this.isFullscreen() ? this.exit() : this.request(e);
      },
      isFullscreen: function () {
        return Boolean(t[n.fullscreenElement]);
      },
      enabled: function () {
        return Boolean(t[n.fullscreenEnabled]);
      },
    };
    e.extend(!0, e.fancybox.defaults, {
      btnTpl: {
        fullScreen:
          '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fullscreen" title="{{FULL_SCREEN}}"><svg viewBox="0 0 40 40"><path d="M9,12 h22 v16 h-22 v-16 v16 h22 v-16 Z" /></svg></button>',
      },
      fullScreen: { autoStart: !1 },
    }),
      e(t).on({
        "onInit.fb": function (t, e) {
          var n;
          e && e.group[e.currIndex].opts.fullScreen
            ? ((n = e.$refs.container),
              n.on(
                "click.fb-fullscreen",
                "[data-fancybox-fullscreen]",
                function (t) {
                  t.stopPropagation(), t.preventDefault(), o.toggle(n[0]);
                }
              ),
              e.opts.fullScreen &&
                e.opts.fullScreen.autoStart === !0 &&
                o.request(n[0]),
              (e.FullScreen = o))
            : e && e.$refs.toolbar.find("[data-fancybox-fullscreen]").hide();
        },
        "afterKeydown.fb": function (t, e, n, o, a) {
          e &&
            e.FullScreen &&
            70 === a &&
            (o.preventDefault(), e.FullScreen.toggle(e.$refs.container[0]));
        },
        "beforeClose.fb": function (t) {
          t && t.FullScreen && o.exit();
        },
      }),
      e(t).on(n.fullscreenchange, function () {
        var t = o.isFullscreen(),
          n = e.fancybox.getInstance();
        n &&
          (n.current &&
            "image" === n.current.type &&
            n.isAnimating &&
            (n.current.$content.css("transition", "none"),
            (n.isAnimating = !1),
            n.update(!0, !0, 0)),
          n.trigger("onFullscreenChange", t),
          n.$refs.container.toggleClass("fancybox-is-fullscreen", t));
      });
  })(document, window.jQuery || jQuery),
  (function (t, e) {
    "use strict";
    e.fancybox.defaults = e.extend(
      !0,
      {
        btnTpl: {
          thumbs:
            '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg viewBox="0 0 120 120"><path d="M30,30 h14 v14 h-14 Z M50,30 h14 v14 h-14 Z M70,30 h14 v14 h-14 Z M30,50 h14 v14 h-14 Z M50,50 h14 v14 h-14 Z M70,50 h14 v14 h-14 Z M30,70 h14 v14 h-14 Z M50,70 h14 v14 h-14 Z M70,70 h14 v14 h-14 Z" /></svg></button>',
        },
        thumbs: {
          autoStart: !1,
          hideOnClose: !0,
          parentEl: ".fancybox-container",
          axis: "y",
        },
      },
      e.fancybox.defaults
    );
    var n = function (t) {
      this.init(t);
    };
    e.extend(n.prototype, {
      $button: null,
      $grid: null,
      $list: null,
      isVisible: !1,
      isActive: !1,
      init: function (t) {
        var e = this;
        (e.instance = t), (t.Thumbs = e);
        var n = t.group[0],
          o = t.group[1];
        (e.opts = t.group[t.currIndex].opts.thumbs),
          (e.$button = t.$refs.toolbar.find("[data-fancybox-thumbs]")),
          e.opts &&
          n &&
          o &&
          ("image" == n.type || n.opts.thumb || n.opts.$thumb) &&
          ("image" == o.type || o.opts.thumb || o.opts.$thumb)
            ? (e.$button.show().on("click", function () {
                e.toggle();
              }),
              (e.isActive = !0))
            : e.$button.hide();
      },
      create: function () {
        var t,
          n,
          o = this,
          a = o.instance,
          i = o.opts.parentEl;
        (o.$grid = e(
          '<div class="fancybox-thumbs fancybox-thumbs-' +
            o.opts.axis +
            '"></div>'
        ).appendTo(a.$refs.container.find(i).addBack().filter(i))),
          (t = "<ul>"),
          e.each(a.group, function (e, o) {
            (n =
              o.opts.thumb ||
              (o.opts.$thumb ? o.opts.$thumb.attr("src") : null)),
              n || "image" !== o.type || (n = o.src),
              n &&
                n.length &&
                (t +=
                  '<li data-index="' +
                  e +
                  '"  tabindex="0" class="fancybox-thumbs-loading"><img data-src="' +
                  n +
                  '" /></li>');
          }),
          (t += "</ul>"),
          (o.$list = e(t)
            .appendTo(o.$grid)
            .on("click", "li", function () {
              a.jumpTo(e(this).data("index"));
            })),
          o.$list
            .find("img")
            .hide()
            .one("load", function () {
              var t,
                n,
                o,
                a,
                i = e(this).parent().removeClass("fancybox-thumbs-loading"),
                s = i.outerWidth(),
                r = i.outerHeight();
              (t = this.naturalWidth || this.width),
                (n = this.naturalHeight || this.height),
                (o = t / s),
                (a = n / r),
                o >= 1 &&
                  a >= 1 &&
                  (o > a ? ((t /= a), (n = r)) : ((t = s), (n /= o))),
                e(this)
                  .css({
                    width: Math.floor(t),
                    height: Math.floor(n),
                    "margin-top":
                      n > r
                        ? Math.floor(0.3 * r - 0.3 * n)
                        : Math.floor(0.5 * r - 0.5 * n),
                    "margin-left": Math.floor(0.5 * s - 0.5 * t),
                  })
                  .show();
            })
            .each(function () {
              this.src = e(this).data("src");
            }),
          "x" === o.opts.axis &&
            o.$list.width(
              parseInt(o.$grid.css("padding-right")) +
                a.group.length * o.$list.children().eq(0).outerWidth(!0) +
                "px"
            );
      },
      focus: function (t) {
        var e,
          n,
          o = this,
          a = o.$list;
        o.instance.current &&
          ((e = a
            .children()
            .removeClass("fancybox-thumbs-active")
            .filter('[data-index="' + o.instance.current.index + '"]')
            .addClass("fancybox-thumbs-active")),
          (n = e.position()),
          "y" === o.opts.axis &&
          (n.top < 0 || n.top > a.height() - e.outerHeight())
            ? a.stop().animate({ scrollTop: a.scrollTop() + n.top }, t)
            : "x" === o.opts.axis &&
              (n.left < a.parent().scrollLeft() ||
                n.left >
                  a.parent().scrollLeft() +
                    (a.parent().width() - e.outerWidth())) &&
              a.parent().stop().animate({ scrollLeft: n.left }, t));
      },
      update: function () {
        this.instance.$refs.container.toggleClass(
          "fancybox-show-thumbs",
          this.isVisible
        ),
          this.isVisible
            ? (this.$grid || this.create(),
              this.instance.trigger("onThumbsShow"),
              this.focus(0))
            : this.$grid && this.instance.trigger("onThumbsHide"),
          this.instance.update();
      },
      hide: function () {
        (this.isVisible = !1), this.update();
      },
      show: function () {
        (this.isVisible = !0), this.update();
      },
      toggle: function () {
        (this.isVisible = !this.isVisible), this.update();
      },
    }),
      e(t).on({
        "onInit.fb": function (t, e) {
          var o;
          e &&
            !e.Thumbs &&
            ((o = new n(e)), o.isActive && o.opts.autoStart === !0 && o.show());
        },
        "beforeShow.fb": function (t, e, n, o) {
          var a = e && e.Thumbs;
          a && a.isVisible && a.focus(o ? 0 : 250);
        },
        "afterKeydown.fb": function (t, e, n, o, a) {
          var i = e && e.Thumbs;
          i && i.isActive && 71 === a && (o.preventDefault(), i.toggle());
        },
        "beforeClose.fb": function (t, e) {
          var n = e && e.Thumbs;
          n && n.isVisible && n.opts.hideOnClose !== !1 && n.$grid.hide();
        },
      });
  })(document, window.jQuery),
  (function (t, e) {
    "use strict";
    function n(t) {
      var e = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;",
        "`": "&#x60;",
        "=": "&#x3D;",
      };
      return String(t).replace(/[&<>"'`=\/]/g, function (t) {
        return e[t];
      });
    }
    e.extend(!0, e.fancybox.defaults, {
      btnTpl: {
        share:
          '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg viewBox="0 0 40 40"><path d="M6,30 C8,18 19,16 23,16 L23,16 L23,10 L33,20 L23,29 L23,24 C19,24 8,27 6,30 Z"></svg></button>',
      },
      share: {
        tpl: '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a href="https://www.facebook.com/sharer/sharer.php?u={{src}}" target="_blank" class="fancybox-share_button"><svg version="1.1" viewBox="0 0 32 32" fill="#3b5998"><path d="M27.6 3h-23.2c-.8 0-1.4.6-1.4 1.4v23.1c0 .9.6 1.5 1.4 1.5h12.5v-10.1h-3.4v-3.9h3.4v-2.9c0-3.4 2.1-5.2 5-5.2 1.4 0 2.7.1 3 .2v3.5h-2.1c-1.6 0-1.9.8-1.9 1.9v2.5h3.9l-.5 3.9h-3.4v10.1h6.6c.8 0 1.4-.6 1.4-1.4v-23.2c.1-.8-.5-1.4-1.3-1.4z"></path></svg><span>Facebook</span></a><a href="https://www.pinterest.com/pin/create/button/?url={{src}}&amp;description={{descr}}" target="_blank" class="fancybox-share_button"><svg version="1.1" viewBox="0 0 32 32" fill="#c92228"><path d="M16 3c-7.2 0-13 5.8-13 13 0 5.5 3.4 10.2 8.3 12.1-.1-1-.2-2.6 0-3.7.2-1 1.5-6.5 1.5-6.5s-.4-.8-.4-1.9c0-1.8 1-3.2 2.4-3.2 1.1 0 1.6.8 1.6 1.8 0 1.1-.7 2.8-1.1 4.3-.3 1.3.6 2.3 1.9 2.3 2.3 0 4.1-2.4 4.1-6 0-3.1-2.2-5.3-5.4-5.3-3.7 0-5.9 2.8-5.9 5.6 0 1.1.4 2.3 1 3 .1.1.1.2.1.4-.1.4-.3 1.3-.4 1.5-.1.2-.2.3-.4.2-1.6-.8-2.6-3.1-2.6-5 0-4.1 3-7.9 8.6-7.9 4.5 0 8 3.2 8 7.5 0 4.5-2.8 8.1-6.7 8.1-1.3 0-2.6-.7-3-1.5 0 0-.7 2.5-.8 3.1-.3 1.1-1.1 2.5-1.6 3.4 1.2.4 2.5.6 3.8.6 7.2 0 13-5.8 13-13 0-7.1-5.8-12.9-13-12.9z"></path></svg><span>Pinterest</span></a><a href="https://twitter.com/intent/tweet?url={{src}}&amp;text={{descr}}" target="_blank" class="fancybox-share_button"><svg version="1.1" viewBox="0 0 32 32" fill="#1da1f2"><path d="M30 7.3c-1 .5-2.1.8-3.3.9 1.2-.7 2.1-1.8 2.5-3.2-1.1.7-2.3 1.1-3.6 1.4-1-1.1-2.5-1.8-4.2-1.8-3.2 0-5.7 2.6-5.7 5.7 0 .5.1.9.1 1.3-4.8-.2-9-2.5-11.8-6-.5.9-.8 1.9-.8 3 0 2 1 3.8 2.6 4.8-.9 0-1.8-.3-2.6-.7v.1c0 2.8 2 5.1 4.6 5.6-.5.1-1 .2-1.5.2-.4 0-.7 0-1.1-.1.7 2.3 2.9 3.9 5.4 4-2 1.5-4.4 2.5-7.1 2.5-.5 0-.9 0-1.4-.1 2.5 1.6 5.6 2.6 8.8 2.6 10.6 0 16.3-8.8 16.3-16.3v-.7c1.1-1 2-2 2.8-3.2z"></path></svg><span>Twitter</span></a></p><p><input type="text" value="{{src_raw}}" onfocus="this.select()" /></p></div>',
      },
    }),
      e(t).on("click", "[data-fancybox-share]", function () {
        var t,
          o,
          a = e.fancybox.getInstance();
        a &&
          ((t = a.current.opts.hash === !1 ? a.current.src : window.location),
          (o = a.current.opts.share.tpl
            .replace(/\{\{src\}\}/g, encodeURIComponent(t))
            .replace(/\{\{src_raw\}\}/g, n(t))
            .replace(
              /\{\{descr\}\}/g,
              a.$caption ? encodeURIComponent(a.$caption.text()) : ""
            )),
          e.fancybox.open({
            src: a.translate(a, o),
            type: "html",
            opts: { animationEffect: "fade", animationDuration: 250 },
          }));
      });
  })(document, window.jQuery || jQuery),
  (function (t, e, n) {
    "use strict";
    function o() {
      var t = e.location.hash.substr(1),
        n = t.split("-"),
        o =
          n.length > 1 && /^\+?\d+$/.test(n[n.length - 1])
            ? parseInt(n.pop(-1), 10) || 1
            : 1,
        a = n.join("-");
      return o < 1 && (o = 1), { hash: t, index: o, gallery: a };
    }
    function a(t) {
      var e;
      "" !== t.gallery &&
        ((e = n("[data-fancybox='" + n.escapeSelector(t.gallery) + "']").eq(
          t.index - 1
        )),
        e.length || (e = n("#" + n.escapeSelector(t.gallery))),
        e.length && ((s = !1), e.trigger("click")));
    }
    function i(t) {
      var e;
      return (
        !!t &&
        ((e = t.current ? t.current.opts : t.opts),
        e.hash || (e.$orig ? e.$orig.data("fancybox") : ""))
      );
    }
    n.escapeSelector ||
      (n.escapeSelector = function (t) {
        var e = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g,
          n = function (t, e) {
            return e
              ? "\0" === t
                ? "ï¿½"
                : t.slice(0, -1) +
                  "\\" +
                  t.charCodeAt(t.length - 1).toString(16) +
                  " "
              : "\\" + t;
          };
        return (t + "").replace(e, n);
      });
    var s = !0,
      r = null,
      c = null;
    n(function () {
      n.fancybox.defaults.hash !== !1 &&
        (n(t).on({
          "onInit.fb": function (t, e) {
            var n, a;
            e.group[e.currIndex].opts.hash !== !1 &&
              ((n = o()),
              (a = i(e)),
              a && n.gallery && a == n.gallery && (e.currIndex = n.index - 1));
          },
          "beforeShow.fb": function (n, o, a) {
            var l;
            a &&
              a.opts.hash !== !1 &&
              ((l = i(o)),
              l &&
                "" !== l &&
                (e.location.hash.indexOf(l) < 0 &&
                  (o.opts.origHash = e.location.hash),
                (r = l + (o.group.length > 1 ? "-" + (a.index + 1) : "")),
                "replaceState" in e.history
                  ? (c && clearTimeout(c),
                    (c = setTimeout(function () {
                      e.history[s ? "pushState" : "replaceState"](
                        {},
                        t.title,
                        e.location.pathname + e.location.search + "#" + r
                      ),
                        (c = null),
                        (s = !1);
                    }, 300)))
                  : (e.location.hash = r)));
          },
          "beforeClose.fb": function (o, a, s) {
            var l, u;
            c && clearTimeout(c),
              s.opts.hash !== !1 &&
                ((l = i(a)),
                (u = a && a.opts.origHash ? a.opts.origHash : ""),
                l &&
                  "" !== l &&
                  ("replaceState" in history
                    ? e.history.replaceState(
                        {},
                        t.title,
                        e.location.pathname + e.location.search + u
                      )
                    : ((e.location.hash = u),
                      n(e).scrollTop(a.scrollTop).scrollLeft(a.scrollLeft))),
                (r = null));
          },
        }),
        n(e).on("hashchange.fb", function () {
          var t = o();
          n.fancybox.getInstance()
            ? !r ||
              r === t.gallery + "-" + t.index ||
              (1 === t.index && r == t.gallery) ||
              ((r = null), n.fancybox.close())
            : "" !== t.gallery && a(t);
        }),
        setTimeout(function () {
          a(o());
        }, 50));
    });
  })(document, window, window.jQuery || jQuery);
typeof JSON != "object" && (JSON = {}),
  (function () {
    "use strict";
    function f(e) {
      return e < 10 ? "0" + e : e;
    }
    function quote(e) {
      return (
        (escapable.lastIndex = 0),
        escapable.test(e)
          ? '"' +
            e.replace(escapable, function (e) {
              var t = meta[e];
              return typeof t == "string"
                ? t
                : "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4);
            }) +
            '"'
          : '"' + e + '"'
      );
    }
    function str(e, t) {
      var n,
        r,
        i,
        s,
        o = gap,
        u,
        a = t[e];
      a &&
        typeof a == "object" &&
        typeof a.toJSON == "function" &&
        (a = a.toJSON(e)),
        typeof rep == "function" && (a = rep.call(t, e, a));
      switch (typeof a) {
        case "string":
          return quote(a);
        case "number":
          return isFinite(a) ? String(a) : "null";
        case "boolean":
        case "null":
          return String(a);
        case "object":
          if (!a) return "null";
          (gap += indent), (u = []);
          if (Object.prototype.toString.apply(a) === "[object Array]") {
            s = a.length;
            for (n = 0; n < s; n += 1) u[n] = str(n, a) || "null";
            return (
              (i =
                u.length === 0
                  ? "[]"
                  : gap
                  ? "[\n" + gap + u.join(",\n" + gap) + "\n" + o + "]"
                  : "[" + u.join(",") + "]"),
              (gap = o),
              i
            );
          }
          if (rep && typeof rep == "object") {
            s = rep.length;
            for (n = 0; n < s; n += 1)
              typeof rep[n] == "string" &&
                ((r = rep[n]),
                (i = str(r, a)),
                i && u.push(quote(r) + (gap ? ": " : ":") + i));
          } else
            for (r in a)
              Object.prototype.hasOwnProperty.call(a, r) &&
                ((i = str(r, a)),
                i && u.push(quote(r) + (gap ? ": " : ":") + i));
          return (
            (i =
              u.length === 0
                ? "{}"
                : gap
                ? "{\n" + gap + u.join(",\n" + gap) + "\n" + o + "}"
                : "{" + u.join(",") + "}"),
            (gap = o),
            i
          );
      }
    }
    typeof Date.prototype.toJSON != "function" &&
      ((Date.prototype.toJSON = function (e) {
        return isFinite(this.valueOf())
          ? this.getUTCFullYear() +
              "-" +
              f(this.getUTCMonth() + 1) +
              "-" +
              f(this.getUTCDate()) +
              "T" +
              f(this.getUTCHours()) +
              ":" +
              f(this.getUTCMinutes()) +
              ":" +
              f(this.getUTCSeconds()) +
              "Z"
          : null;
      }),
      (String.prototype.toJSON =
        Number.prototype.toJSON =
        Boolean.prototype.toJSON =
          function (e) {
            return this.valueOf();
          }));
    var cx =
        /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
      escapable =
        /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
      gap,
      indent,
      meta = {
        "\b": "\\b",
        "	": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\",
      },
      rep;
    typeof JSON.stringify != "function" &&
      (JSON.stringify = function (e, t, n) {
        var r;
        (gap = ""), (indent = "");
        if (typeof n == "number") for (r = 0; r < n; r += 1) indent += " ";
        else typeof n == "string" && (indent = n);
        rep = t;
        if (
          !t ||
          typeof t == "function" ||
          (typeof t == "object" && typeof t.length == "number")
        )
          return str("", { "": e });
        throw new Error("JSON.stringify");
      }),
      typeof JSON.parse != "function" &&
        (JSON.parse = function (text, reviver) {
          function walk(e, t) {
            var n,
              r,
              i = e[t];
            if (i && typeof i == "object")
              for (n in i)
                Object.prototype.hasOwnProperty.call(i, n) &&
                  ((r = walk(i, n)),
                  r !== undefined ? (i[n] = r) : delete i[n]);
            return reviver.call(e, t, i);
          }
          var j;
          (text = String(text)),
            (cx.lastIndex = 0),
            cx.test(text) &&
              (text = text.replace(cx, function (e) {
                return (
                  "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4)
                );
              }));
          if (
            /^[\],:{}\s]*$/.test(
              text
                .replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, "@")
                .replace(
                  /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
                  "]"
                )
                .replace(/(?:^|:|,)(?:\s*\[)+/g, "")
            )
          )
            return (
              (j = eval("(" + text + ")")),
              typeof reviver == "function" ? walk({ "": j }, "") : j
            );
          throw new SyntaxError("JSON.parse");
        });
  })(),
  (function (e, t) {
    "use strict";
    var n = (e.History = e.History || {}),
      r = e.jQuery;
    if (typeof n.Adapter != "undefined")
      throw new Error("History.js Adapter has already been loaded...");
    (n.Adapter = {
      bind: function (e, t, n) {
        r(e).bind(t, n);
      },
      trigger: function (e, t, n) {
        r(e).trigger(t, n);
      },
      extractEventData: function (e, n, r) {
        var i =
          (n && n.originalEvent && n.originalEvent[e]) || (r && r[e]) || t;
        return i;
      },
      onDomLoad: function (e) {
        r(e);
      },
    }),
      typeof n.init != "undefined" && n.init();
  })(window),
  (function (e, t) {
    "use strict";
    var n = e.document,
      r = e.setTimeout || r,
      i = e.clearTimeout || i,
      s = e.setInterval || s,
      o = (e.History = e.History || {});
    if (typeof o.initHtml4 != "undefined")
      throw new Error("History.js HTML4 Support has already been loaded...");
    (o.initHtml4 = function () {
      if (typeof o.initHtml4.initialized != "undefined") return !1;
      (o.initHtml4.initialized = !0),
        (o.enabled = !0),
        (o.savedHashes = []),
        (o.isLastHash = function (e) {
          var t = o.getHashByIndex(),
            n;
          return (n = e === t), n;
        }),
        (o.isHashEqual = function (e, t) {
          return (
            (e = encodeURIComponent(e).replace(/%25/g, "%")),
            (t = encodeURIComponent(t).replace(/%25/g, "%")),
            e === t
          );
        }),
        (o.saveHash = function (e) {
          return o.isLastHash(e) ? !1 : (o.savedHashes.push(e), !0);
        }),
        (o.getHashByIndex = function (e) {
          var t = null;
          return (
            typeof e == "undefined"
              ? (t = o.savedHashes[o.savedHashes.length - 1])
              : e < 0
              ? (t = o.savedHashes[o.savedHashes.length + e])
              : (t = o.savedHashes[e]),
            t
          );
        }),
        (o.discardedHashes = {}),
        (o.discardedStates = {}),
        (o.discardState = function (e, t, n) {
          var r = o.getHashByState(e),
            i;
          return (
            (i = { discardedState: e, backState: n, forwardState: t }),
            (o.discardedStates[r] = i),
            !0
          );
        }),
        (o.discardHash = function (e, t, n) {
          var r = { discardedHash: e, backState: n, forwardState: t };
          return (o.discardedHashes[e] = r), !0;
        }),
        (o.discardedState = function (e) {
          var t = o.getHashByState(e),
            n;
          return (n = o.discardedStates[t] || !1), n;
        }),
        (o.discardedHash = function (e) {
          var t = o.discardedHashes[e] || !1;
          return t;
        }),
        (o.recycleState = function (e) {
          var t = o.getHashByState(e);
          return o.discardedState(e) && delete o.discardedStates[t], !0;
        }),
        o.emulated.hashChange &&
          ((o.hashChangeInit = function () {
            o.checkerFunction = null;
            var t = "",
              r,
              i,
              u,
              a,
              f = Boolean(o.getHash());
            return (
              o.isInternetExplorer()
                ? ((r = "historyjs-iframe"),
                  (i = n.createElement("iframe")),
                  i.setAttribute("id", r),
                  i.setAttribute("src", "#"),
                  (i.style.display = "none"),
                  n.body.appendChild(i),
                  i.contentWindow.document.open(),
                  i.contentWindow.document.close(),
                  (u = ""),
                  (a = !1),
                  (o.checkerFunction = function () {
                    if (a) return !1;
                    a = !0;
                    var n = o.getHash(),
                      r = o.getHash(i.contentWindow.document);
                    return (
                      n !== t
                        ? ((t = n),
                          r !== n &&
                            ((u = r = n),
                            i.contentWindow.document.open(),
                            i.contentWindow.document.close(),
                            (i.contentWindow.document.location.hash =
                              o.escapeHash(n))),
                          o.Adapter.trigger(e, "hashchange"))
                        : r !== u &&
                          ((u = r),
                          f && r === "" ? o.back() : o.setHash(r, !1)),
                      (a = !1),
                      !0
                    );
                  }))
                : (o.checkerFunction = function () {
                    var n = o.getHash() || "";
                    return (
                      n !== t && ((t = n), o.Adapter.trigger(e, "hashchange")),
                      !0
                    );
                  }),
              o.intervalList.push(
                s(o.checkerFunction, o.options.hashChangeInterval)
              ),
              !0
            );
          }),
          o.Adapter.onDomLoad(o.hashChangeInit)),
        o.emulated.pushState &&
          ((o.onHashChange = function (t) {
            var n = (t && t.newURL) || o.getLocationHref(),
              r = o.getHashByUrl(n),
              i = null,
              s = null,
              u = null,
              a;
            return o.isLastHash(r)
              ? (o.busy(!1), !1)
              : (o.doubleCheckComplete(),
                o.saveHash(r),
                r && o.isTraditionalAnchor(r)
                  ? (o.Adapter.trigger(e, "anchorchange"), o.busy(!1), !1)
                  : ((i = o.extractState(
                      o.getFullUrl(r || o.getLocationHref()),
                      !0
                    )),
                    o.isLastSavedState(i)
                      ? (o.busy(!1), !1)
                      : ((s = o.getHashByState(i)),
                        (a = o.discardedState(i)),
                        a
                          ? (o.getHashByIndex(-2) ===
                            o.getHashByState(a.forwardState)
                              ? o.back(!1)
                              : o.forward(!1),
                            !1)
                          : (o.pushState(i.data, i.title, encodeURI(i.url), !1),
                            !0))));
          }),
          o.Adapter.bind(e, "hashchange", o.onHashChange),
          (o.pushState = function (t, n, r, i) {
            r = encodeURI(r).replace(/%25/g, "%");
            if (o.getHashByUrl(r))
              throw new Error(
                "History.js does not support states with fragment-identifiers (hashes/anchors)."
              );
            if (i !== !1 && o.busy())
              return (
                o.pushQueue({
                  scope: o,
                  callback: o.pushState,
                  args: arguments,
                  queue: i,
                }),
                !1
              );
            o.busy(!0);
            var s = o.createStateObject(t, n, r),
              u = o.getHashByState(s),
              a = o.getState(!1),
              f = o.getHashByState(a),
              l = o.getHash(),
              c = o.expectedStateId == s.id;
            return (
              o.storeState(s),
              (o.expectedStateId = s.id),
              o.recycleState(s),
              o.setTitle(s),
              u === f
                ? (o.busy(!1), !1)
                : (o.saveState(s),
                  c || o.Adapter.trigger(e, "statechange"),
                  !o.isHashEqual(u, l) &&
                    !o.isHashEqual(u, o.getShortUrl(o.getLocationHref())) &&
                    o.setHash(u, !1),
                  o.busy(!1),
                  !0)
            );
          }),
          (o.replaceState = function (t, n, r, i) {
            r = encodeURI(r).replace(/%25/g, "%");
            if (o.getHashByUrl(r))
              throw new Error(
                "History.js does not support states with fragment-identifiers (hashes/anchors)."
              );
            if (i !== !1 && o.busy())
              return (
                o.pushQueue({
                  scope: o,
                  callback: o.replaceState,
                  args: arguments,
                  queue: i,
                }),
                !1
              );
            o.busy(!0);
            var s = o.createStateObject(t, n, r),
              u = o.getHashByState(s),
              a = o.getState(!1),
              f = o.getHashByState(a),
              l = o.getStateByIndex(-2);
            return (
              o.discardState(a, s, l),
              u === f
                ? (o.storeState(s),
                  (o.expectedStateId = s.id),
                  o.recycleState(s),
                  o.setTitle(s),
                  o.saveState(s),
                  o.Adapter.trigger(e, "statechange"),
                  o.busy(!1))
                : o.pushState(s.data, s.title, s.url, !1),
              !0
            );
          })),
        o.emulated.pushState &&
          o.getHash() &&
          !o.emulated.hashChange &&
          o.Adapter.onDomLoad(function () {
            o.Adapter.trigger(e, "hashchange");
          });
    }),
      typeof o.init != "undefined" && o.init();
  })(window),
  (function (e, t) {
    "use strict";
    var n = e.console || t,
      r = e.document,
      i = e.navigator,
      s = !1,
      o = e.setTimeout,
      u = e.clearTimeout,
      a = e.setInterval,
      f = e.clearInterval,
      l = e.JSON,
      c = e.alert,
      h = (e.History = e.History || {}),
      p = e.history;
    try {
      (s = e.sessionStorage), s.setItem("TEST", "1"), s.removeItem("TEST");
    } catch (d) {
      s = !1;
    }
    (l.stringify = l.stringify || l.encode), (l.parse = l.parse || l.decode);
    if (typeof h.init != "undefined")
      throw new Error("History.js Core has already been loaded...");
    (h.init = function (e) {
      return typeof h.Adapter == "undefined"
        ? !1
        : (typeof h.initCore != "undefined" && h.initCore(),
          typeof h.initHtml4 != "undefined" && h.initHtml4(),
          !0);
    }),
      (h.initCore = function (d) {
        if (typeof h.initCore.initialized != "undefined") return !1;
        (h.initCore.initialized = !0),
          (h.options = h.options || {}),
          (h.options.hashChangeInterval = h.options.hashChangeInterval || 100),
          (h.options.safariPollInterval = h.options.safariPollInterval || 500),
          (h.options.doubleCheckInterval =
            h.options.doubleCheckInterval || 500),
          (h.options.disableSuid = h.options.disableSuid || !1),
          (h.options.storeInterval = h.options.storeInterval || 1e3),
          (h.options.busyDelay = h.options.busyDelay || 250),
          (h.options.debug = h.options.debug || !1),
          (h.options.initialTitle = h.options.initialTitle || r.title),
          (h.options.html4Mode = h.options.html4Mode || !1),
          (h.options.delayInit = h.options.delayInit || !1),
          (h.intervalList = []),
          (h.clearAllIntervals = function () {
            var e,
              t = h.intervalList;
            if (typeof t != "undefined" && t !== null) {
              for (e = 0; e < t.length; e++) f(t[e]);
              h.intervalList = null;
            }
          }),
          (h.debug = function () {
            (h.options.debug || !1) && h.log.apply(h, arguments);
          }),
          (h.log = function () {
            var e =
                typeof n != "undefined" &&
                typeof n.log != "undefined" &&
                typeof n.log.apply != "undefined",
              t = r.getElementById("log"),
              i,
              s,
              o,
              u,
              a;
            e
              ? ((u = Array.prototype.slice.call(arguments)),
                (i = u.shift()),
                typeof n.debug != "undefined"
                  ? n.debug.apply(n, [i, u])
                  : n.log.apply(n, [i, u]))
              : (i = "\n" + arguments[0] + "\n");
            for (s = 1, o = arguments.length; s < o; ++s) {
              a = arguments[s];
              if (typeof a == "object" && typeof l != "undefined")
                try {
                  a = l.stringify(a);
                } catch (f) {}
              i += "\n" + a + "\n";
            }
            return (
              t
                ? ((t.value += i + "\n-----\n"),
                  (t.scrollTop = t.scrollHeight - t.clientHeight))
                : e || c(i),
              !0
            );
          }),
          (h.getInternetExplorerMajorVersion = function () {
            var e = (h.getInternetExplorerMajorVersion.cached =
              typeof h.getInternetExplorerMajorVersion.cached != "undefined"
                ? h.getInternetExplorerMajorVersion.cached
                : (function () {
                    var e = 3,
                      t = r.createElement("div"),
                      n = t.getElementsByTagName("i");
                    while (
                      (t.innerHTML =
                        "<!--[if gt IE " + ++e + "]><i></i><![endif]-->") &&
                      n[0]
                    );
                    return e > 4 ? e : !1;
                  })());
            return e;
          }),
          (h.isInternetExplorer = function () {
            var e = (h.isInternetExplorer.cached =
              typeof h.isInternetExplorer.cached != "undefined"
                ? h.isInternetExplorer.cached
                : Boolean(h.getInternetExplorerMajorVersion()));
            return e;
          }),
          h.options.html4Mode
            ? (h.emulated = { pushState: !0, hashChange: !0 })
            : (h.emulated = {
                pushState: !Boolean(
                  e.history &&
                    e.history.pushState &&
                    e.history.replaceState &&
                    !/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i.test(
                      i.userAgent
                    ) &&
                    !/AppleWebKit\/5([0-2]|3[0-2])/i.test(i.userAgent)
                ),
                hashChange: Boolean(
                  !("onhashchange" in e || "onhashchange" in r) ||
                    (h.isInternetExplorer() &&
                      h.getInternetExplorerMajorVersion() < 8)
                ),
              }),
          (h.enabled = !h.emulated.pushState),
          (h.bugs = {
            setHash: Boolean(
              !h.emulated.pushState &&
                i.vendor === "Apple Computer, Inc." &&
                /AppleWebKit\/5([0-2]|3[0-3])/.test(i.userAgent)
            ),
            safariPoll: Boolean(
              !h.emulated.pushState &&
                i.vendor === "Apple Computer, Inc." &&
                /AppleWebKit\/5([0-2]|3[0-3])/.test(i.userAgent)
            ),
            ieDoubleCheck: Boolean(
              h.isInternetExplorer() && h.getInternetExplorerMajorVersion() < 8
            ),
            hashEscape: Boolean(
              h.isInternetExplorer() && h.getInternetExplorerMajorVersion() < 7
            ),
          }),
          (h.isEmptyObject = function (e) {
            for (var t in e) if (e.hasOwnProperty(t)) return !1;
            return !0;
          }),
          (h.cloneObject = function (e) {
            var t, n;
            return e ? ((t = l.stringify(e)), (n = l.parse(t))) : (n = {}), n;
          }),
          (h.getRootUrl = function () {
            var e =
              r.location.protocol +
              "//" +
              (r.location.hostname || r.location.host);
            if (r.location.port || !1) e += ":" + r.location.port;
            return (e += "/"), e;
          }),
          (h.getBaseHref = function () {
            var e = r.getElementsByTagName("base"),
              t = null,
              n = "";
            return (
              e.length === 1 &&
                ((t = e[0]), (n = t.href.replace(/[^\/]+$/, ""))),
              (n = n.replace(/\/+$/, "")),
              n && (n += "/"),
              n
            );
          }),
          (h.getBaseUrl = function () {
            var e = h.getBaseHref() || h.getBasePageUrl() || h.getRootUrl();
            return e;
          }),
          (h.getPageUrl = function () {
            var e = h.getState(!1, !1),
              t = (e || {}).url || h.getLocationHref(),
              n;
            return (
              (n = t.replace(/\/+$/, "").replace(/[^\/]+$/, function (e, t, n) {
                return /\./.test(e) ? e : e + "/";
              })),
              n
            );
          }),
          (h.getBasePageUrl = function () {
            var e =
              h
                .getLocationHref()
                .replace(/[#\?].*/, "")
                .replace(/[^\/]+$/, function (e, t, n) {
                  return /[^\/]$/.test(e) ? "" : e;
                })
                .replace(/\/+$/, "") + "/";
            return e;
          }),
          (h.getFullUrl = function (e, t) {
            var n = e,
              r = e.substring(0, 1);
            return (
              (t = typeof t == "undefined" ? !0 : t),
              /[a-z]+\:\/\//.test(e) ||
                (r === "/"
                  ? (n = h.getRootUrl() + e.replace(/^\/+/, ""))
                  : r === "#"
                  ? (n = h.getPageUrl().replace(/#.*/, "") + e)
                  : r === "?"
                  ? (n = h.getPageUrl().replace(/[\?#].*/, "") + e)
                  : t
                  ? (n = h.getBaseUrl() + e.replace(/^(\.\/)+/, ""))
                  : (n = h.getBasePageUrl() + e.replace(/^(\.\/)+/, ""))),
              n.replace(/\#$/, "")
            );
          }),
          (h.getShortUrl = function (e) {
            var t = e,
              n = h.getBaseUrl(),
              r = h.getRootUrl();
            return (
              h.emulated.pushState && (t = t.replace(n, "")),
              (t = t.replace(r, "/")),
              h.isTraditionalAnchor(t) && (t = "./" + t),
              (t = t.replace(/^(\.\/)+/g, "./").replace(/\#$/, "")),
              t
            );
          }),
          (h.getLocationHref = function (e) {
            return (
              (e = e || r),
              e.URL === e.location.href
                ? e.location.href
                : e.location.href === decodeURIComponent(e.URL)
                ? e.URL
                : e.location.hash &&
                  decodeURIComponent(e.location.href.replace(/^[^#]+/, "")) ===
                    e.location.hash
                ? e.location.href
                : e.URL.indexOf("#") == -1 && e.location.href.indexOf("#") != -1
                ? e.location.href
                : e.URL || e.location.href
            );
          }),
          (h.store = {}),
          (h.idToState = h.idToState || {}),
          (h.stateToId = h.stateToId || {}),
          (h.urlToId = h.urlToId || {}),
          (h.storedStates = h.storedStates || []),
          (h.savedStates = h.savedStates || []),
          (h.normalizeStore = function () {
            (h.store.idToState = h.store.idToState || {}),
              (h.store.urlToId = h.store.urlToId || {}),
              (h.store.stateToId = h.store.stateToId || {});
          }),
          (h.getState = function (e, t) {
            typeof e == "undefined" && (e = !0),
              typeof t == "undefined" && (t = !0);
            var n = h.getLastSavedState();
            return (
              !n && t && (n = h.createStateObject()),
              e && ((n = h.cloneObject(n)), (n.url = n.cleanUrl || n.url)),
              n
            );
          }),
          (h.getIdByState = function (e) {
            var t = h.extractId(e.url),
              n;
            if (!t) {
              n = h.getStateString(e);
              if (typeof h.stateToId[n] != "undefined") t = h.stateToId[n];
              else if (typeof h.store.stateToId[n] != "undefined")
                t = h.store.stateToId[n];
              else {
                for (;;) {
                  t =
                    new Date().getTime() +
                    String(Math.random()).replace(/\D/g, "");
                  if (
                    typeof h.idToState[t] == "undefined" &&
                    typeof h.store.idToState[t] == "undefined"
                  )
                    break;
                }
                (h.stateToId[n] = t), (h.idToState[t] = e);
              }
            }
            return t;
          }),
          (h.normalizeState = function (e) {
            var t, n;
            if (!e || typeof e != "object") e = {};
            if (typeof e.normalized != "undefined") return e;
            if (!e.data || typeof e.data != "object") e.data = {};
            return (
              (t = {}),
              (t.normalized = !0),
              (t.title = e.title || ""),
              (t.url = h.getFullUrl(e.url ? e.url : h.getLocationHref())),
              (t.hash = h.getShortUrl(t.url)),
              (t.data = h.cloneObject(e.data)),
              (t.id = h.getIdByState(t)),
              (t.cleanUrl = t.url.replace(/\??\&_suid.*/, "")),
              (t.url = t.cleanUrl),
              (n = !h.isEmptyObject(t.data)),
              (t.title || n) &&
                h.options.disableSuid !== !0 &&
                ((t.hash = h.getShortUrl(t.url).replace(/\??\&_suid.*/, "")),
                /\?/.test(t.hash) || (t.hash += "?"),
                (t.hash += "&_suid=" + t.id)),
              (t.hashedUrl = h.getFullUrl(t.hash)),
              (h.emulated.pushState || h.bugs.safariPoll) &&
                h.hasUrlDuplicate(t) &&
                (t.url = t.hashedUrl),
              t
            );
          }),
          (h.createStateObject = function (e, t, n) {
            var r = { data: e, title: t, url: n };
            return (r = h.normalizeState(r)), r;
          }),
          (h.getStateById = function (e) {
            e = String(e);
            var n = h.idToState[e] || h.store.idToState[e] || t;
            return n;
          }),
          (h.getStateString = function (e) {
            var t, n, r;
            return (
              (t = h.normalizeState(e)),
              (n = { data: t.data, title: e.title, url: e.url }),
              (r = l.stringify(n)),
              r
            );
          }),
          (h.getStateId = function (e) {
            var t, n;
            return (t = h.normalizeState(e)), (n = t.id), n;
          }),
          (h.getHashByState = function (e) {
            var t, n;
            return (t = h.normalizeState(e)), (n = t.hash), n;
          }),
          (h.extractId = function (e) {
            var t, n, r, i;
            return (
              e.indexOf("#") != -1 ? (i = e.split("#")[0]) : (i = e),
              (n = /(.*)\&_suid=([0-9]+)$/.exec(i)),
              (r = n ? n[1] || e : e),
              (t = n ? String(n[2] || "") : ""),
              t || !1
            );
          }),
          (h.isTraditionalAnchor = function (e) {
            var t = !/[\/\?\.]/.test(e);
            return t;
          }),
          (h.extractState = function (e, t) {
            var n = null,
              r,
              i;
            return (
              (t = t || !1),
              (r = h.extractId(e)),
              r && (n = h.getStateById(r)),
              n ||
                ((i = h.getFullUrl(e)),
                (r = h.getIdByUrl(i) || !1),
                r && (n = h.getStateById(r)),
                !n &&
                  t &&
                  !h.isTraditionalAnchor(e) &&
                  (n = h.createStateObject(null, null, i))),
              n
            );
          }),
          (h.getIdByUrl = function (e) {
            var n = h.urlToId[e] || h.store.urlToId[e] || t;
            return n;
          }),
          (h.getLastSavedState = function () {
            return h.savedStates[h.savedStates.length - 1] || t;
          }),
          (h.getLastStoredState = function () {
            return h.storedStates[h.storedStates.length - 1] || t;
          }),
          (h.hasUrlDuplicate = function (e) {
            var t = !1,
              n;
            return (n = h.extractState(e.url)), (t = n && n.id !== e.id), t;
          }),
          (h.storeState = function (e) {
            return (
              (h.urlToId[e.url] = e.id),
              h.storedStates.push(h.cloneObject(e)),
              e
            );
          }),
          (h.isLastSavedState = function (e) {
            var t = !1,
              n,
              r,
              i;
            return (
              h.savedStates.length &&
                ((n = e.id),
                (r = h.getLastSavedState()),
                (i = r.id),
                (t = n === i)),
              t
            );
          }),
          (h.saveState = function (e) {
            return h.isLastSavedState(e)
              ? !1
              : (h.savedStates.push(h.cloneObject(e)), !0);
          }),
          (h.getStateByIndex = function (e) {
            var t = null;
            return (
              typeof e == "undefined"
                ? (t = h.savedStates[h.savedStates.length - 1])
                : e < 0
                ? (t = h.savedStates[h.savedStates.length + e])
                : (t = h.savedStates[e]),
              t
            );
          }),
          (h.getCurrentIndex = function () {
            var e = null;
            return (
              h.savedStates.length < 1
                ? (e = 0)
                : (e = h.savedStates.length - 1),
              e
            );
          }),
          (h.getHash = function (e) {
            var t = h.getLocationHref(e),
              n;
            return (n = h.getHashByUrl(t)), n;
          }),
          (h.unescapeHash = function (e) {
            var t = h.normalizeHash(e);
            return (t = decodeURIComponent(t)), t;
          }),
          (h.normalizeHash = function (e) {
            var t = e.replace(/[^#]*#/, "").replace(/#.*/, "");
            return t;
          }),
          (h.setHash = function (e, t) {
            var n, i;
            return t !== !1 && h.busy()
              ? (h.pushQueue({
                  scope: h,
                  callback: h.setHash,
                  args: arguments,
                  queue: t,
                }),
                !1)
              : (h.busy(!0),
                (n = h.extractState(e, !0)),
                n && !h.emulated.pushState
                  ? h.pushState(n.data, n.title, n.url, !1)
                  : h.getHash() !== e &&
                    (h.bugs.setHash
                      ? ((i = h.getPageUrl()),
                        h.pushState(null, null, i + "#" + e, !1))
                      : (r.location.hash = e)),
                h);
          }),
          (h.escapeHash = function (t) {
            var n = h.normalizeHash(t);
            return (
              (n = e.encodeURIComponent(n)),
              h.bugs.hashEscape ||
                (n = n
                  .replace(/\%21/g, "!")
                  .replace(/\%26/g, "&")
                  .replace(/\%3D/g, "=")
                  .replace(/\%3F/g, "?")),
              n
            );
          }),
          (h.getHashByUrl = function (e) {
            var t = String(e).replace(/([^#]*)#?([^#]*)#?(.*)/, "$2");
            return (t = h.unescapeHash(t)), t;
          }),
          (h.setTitle = function (e) {
            var t = e.title,
              n;
            t ||
              ((n = h.getStateByIndex(0)),
              n && n.url === e.url && (t = n.title || h.options.initialTitle));
            try {
              r.getElementsByTagName("title")[0].innerHTML = t
                .replace("<", "&lt;")
                .replace(">", "&gt;")
                .replace(" & ", " &amp; ");
            } catch (i) {}
            return (r.title = t), h;
          }),
          (h.queues = []),
          (h.busy = function (e) {
            typeof e != "undefined"
              ? (h.busy.flag = e)
              : typeof h.busy.flag == "undefined" && (h.busy.flag = !1);
            if (!h.busy.flag) {
              u(h.busy.timeout);
              var t = function () {
                var e, n, r;
                if (h.busy.flag) return;
                for (e = h.queues.length - 1; e >= 0; --e) {
                  n = h.queues[e];
                  if (n.length === 0) continue;
                  (r = n.shift()),
                    h.fireQueueItem(r),
                    (h.busy.timeout = o(t, h.options.busyDelay));
                }
              };
              h.busy.timeout = o(t, h.options.busyDelay);
            }
            return h.busy.flag;
          }),
          (h.busy.flag = !1),
          (h.fireQueueItem = function (e) {
            return e.callback.apply(e.scope || h, e.args || []);
          }),
          (h.pushQueue = function (e) {
            return (
              (h.queues[e.queue || 0] = h.queues[e.queue || 0] || []),
              h.queues[e.queue || 0].push(e),
              h
            );
          }),
          (h.queue = function (e, t) {
            return (
              typeof e == "function" && (e = { callback: e }),
              typeof t != "undefined" && (e.queue = t),
              h.busy() ? h.pushQueue(e) : h.fireQueueItem(e),
              h
            );
          }),
          (h.clearQueue = function () {
            return (h.busy.flag = !1), (h.queues = []), h;
          }),
          (h.stateChanged = !1),
          (h.doubleChecker = !1),
          (h.doubleCheckComplete = function () {
            return (h.stateChanged = !0), h.doubleCheckClear(), h;
          }),
          (h.doubleCheckClear = function () {
            return (
              h.doubleChecker && (u(h.doubleChecker), (h.doubleChecker = !1)), h
            );
          }),
          (h.doubleCheck = function (e) {
            return (
              (h.stateChanged = !1),
              h.doubleCheckClear(),
              h.bugs.ieDoubleCheck &&
                (h.doubleChecker = o(function () {
                  return h.doubleCheckClear(), h.stateChanged || e(), !0;
                }, h.options.doubleCheckInterval)),
              h
            );
          }),
          (h.safariStatePoll = function () {
            var t = h.extractState(h.getLocationHref()),
              n;
            if (!h.isLastSavedState(t))
              return (
                (n = t),
                n || (n = h.createStateObject()),
                h.Adapter.trigger(e, "popstate"),
                h
              );
            return;
          }),
          (h.back = function (e) {
            return e !== !1 && h.busy()
              ? (h.pushQueue({
                  scope: h,
                  callback: h.back,
                  args: arguments,
                  queue: e,
                }),
                !1)
              : (h.busy(!0),
                h.doubleCheck(function () {
                  h.back(!1);
                }),
                p.go(-1),
                !0);
          }),
          (h.forward = function (e) {
            return e !== !1 && h.busy()
              ? (h.pushQueue({
                  scope: h,
                  callback: h.forward,
                  args: arguments,
                  queue: e,
                }),
                !1)
              : (h.busy(!0),
                h.doubleCheck(function () {
                  h.forward(!1);
                }),
                p.go(1),
                !0);
          }),
          (h.go = function (e, t) {
            var n;
            if (e > 0) for (n = 1; n <= e; ++n) h.forward(t);
            else {
              if (!(e < 0))
                throw new Error(
                  "History.go: History.go requires a positive or negative integer passed."
                );
              for (n = -1; n >= e; --n) h.back(t);
            }
            return h;
          });
        if (h.emulated.pushState) {
          var v = function () {};
          (h.pushState = h.pushState || v),
            (h.replaceState = h.replaceState || v);
        } else
          (h.onPopState = function (t, n) {
            var r = !1,
              i = !1,
              s,
              o;
            return (
              h.doubleCheckComplete(),
              (s = h.getHash()),
              s
                ? ((o = h.extractState(s || h.getLocationHref(), !0)),
                  o
                    ? h.replaceState(o.data, o.title, o.url, !1)
                    : (h.Adapter.trigger(e, "anchorchange"), h.busy(!1)),
                  (h.expectedStateId = !1),
                  !1)
                : ((r = h.Adapter.extractEventData("state", t, n) || !1),
                  r
                    ? (i = h.getStateById(r))
                    : h.expectedStateId
                    ? (i = h.getStateById(h.expectedStateId))
                    : (i = h.extractState(h.getLocationHref())),
                  i ||
                    (i = h.createStateObject(null, null, h.getLocationHref())),
                  (h.expectedStateId = !1),
                  h.isLastSavedState(i)
                    ? (h.busy(!1), !1)
                    : (h.storeState(i),
                      h.saveState(i),
                      h.setTitle(i),
                      h.Adapter.trigger(e, "statechange"),
                      h.busy(!1),
                      !0))
            );
          }),
            h.Adapter.bind(e, "popstate", h.onPopState),
            (h.pushState = function (t, n, r, i) {
              if (h.getHashByUrl(r) && h.emulated.pushState)
                throw new Error(
                  "History.js does not support states with fragement-identifiers (hashes/anchors)."
                );
              if (i !== !1 && h.busy())
                return (
                  h.pushQueue({
                    scope: h,
                    callback: h.pushState,
                    args: arguments,
                    queue: i,
                  }),
                  !1
                );
              h.busy(!0);
              var s = h.createStateObject(t, n, r);
              return (
                h.isLastSavedState(s)
                  ? h.busy(!1)
                  : (h.storeState(s),
                    (h.expectedStateId = s.id),
                    p.pushState(s.id, s.title, s.url),
                    h.Adapter.trigger(e, "popstate")),
                !0
              );
            }),
            (h.replaceState = function (t, n, r, i) {
              if (h.getHashByUrl(r) && h.emulated.pushState)
                throw new Error(
                  "History.js does not support states with fragement-identifiers (hashes/anchors)."
                );
              if (i !== !1 && h.busy())
                return (
                  h.pushQueue({
                    scope: h,
                    callback: h.replaceState,
                    args: arguments,
                    queue: i,
                  }),
                  !1
                );
              h.busy(!0);
              var s = h.createStateObject(t, n, r);
              return (
                h.isLastSavedState(s)
                  ? h.busy(!1)
                  : (h.storeState(s),
                    (h.expectedStateId = s.id),
                    p.replaceState(s.id, s.title, s.url),
                    h.Adapter.trigger(e, "popstate")),
                !0
              );
            });
        if (s) {
          try {
            h.store = l.parse(s.getItem("History.store")) || {};
          } catch (m) {
            h.store = {};
          }
          h.normalizeStore();
        } else (h.store = {}), h.normalizeStore();
        h.Adapter.bind(e, "unload", h.clearAllIntervals),
          h.saveState(h.storeState(h.extractState(h.getLocationHref(), !0))),
          s &&
            ((h.onUnload = function () {
              var e, t, n;
              try {
                e = l.parse(s.getItem("History.store")) || {};
              } catch (r) {
                e = {};
              }
              (e.idToState = e.idToState || {}),
                (e.urlToId = e.urlToId || {}),
                (e.stateToId = e.stateToId || {});
              for (t in h.idToState) {
                if (!h.idToState.hasOwnProperty(t)) continue;
                e.idToState[t] = h.idToState[t];
              }
              for (t in h.urlToId) {
                if (!h.urlToId.hasOwnProperty(t)) continue;
                e.urlToId[t] = h.urlToId[t];
              }
              for (t in h.stateToId) {
                if (!h.stateToId.hasOwnProperty(t)) continue;
                e.stateToId[t] = h.stateToId[t];
              }
              (h.store = e), h.normalizeStore(), (n = l.stringify(e));
              try {
                s.setItem("History.store", n);
              } catch (i) {
                if (i.code !== DOMException.QUOTA_EXCEEDED_ERR) throw i;
                s.length &&
                  (s.removeItem("History.store"),
                  s.setItem("History.store", n));
              }
            }),
            h.intervalList.push(a(h.onUnload, h.options.storeInterval)),
            h.Adapter.bind(e, "beforeunload", h.onUnload),
            h.Adapter.bind(e, "unload", h.onUnload));
        if (!h.emulated.pushState) {
          h.bugs.safariPoll &&
            h.intervalList.push(
              a(h.safariStatePoll, h.options.safariPollInterval)
            );
          if (
            i.vendor === "Apple Computer, Inc." ||
            (i.appCodeName || "") === "Mozilla"
          )
            h.Adapter.bind(e, "hashchange", function () {
              h.Adapter.trigger(e, "popstate");
            }),
              h.getHash() &&
                h.Adapter.onDomLoad(function () {
                  h.Adapter.trigger(e, "hashchange");
                });
        }
      }),
      (!h.options || !h.options.delayInit) && h.init();
  })(window);
!(function (a) {
  "use strict";
  "function" == typeof define && define.amd ? define(["jquery"], a) : a(jQuery);
})(function (a) {
  "use strict";
  function b(a) {
    if (a instanceof Date) return a;
    if (String(a).match(g))
      return (
        String(a).match(/^[0-9]*$/) && (a = Number(a)),
        String(a).match(/\-/) && (a = String(a).replace(/\-/g, "/")),
        new Date(a)
      );
    throw new Error("Couldn't cast `" + a + "` to a date object.");
  }
  function c(a) {
    var b = a.toString().replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
    return new RegExp(b);
  }
  function d(a) {
    return function (b) {
      var d = b.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
      if (d)
        for (var f = 0, g = d.length; g > f; ++f) {
          var h = d[f].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),
            j = c(h[0]),
            k = h[1] || "",
            l = h[3] || "",
            m = null;
          (h = h[2]),
            i.hasOwnProperty(h) && ((m = i[h]), (m = Number(a[m]))),
            null !== m &&
              ("!" === k && (m = e(l, m)),
              "" === k && 10 > m && (m = "0" + m.toString()),
              (b = b.replace(j, m.toString())));
        }
      return (b = b.replace(/%%/, "%"));
    };
  }
  function e(a, b) {
    var c = "s",
      d = "";
    return (
      a &&
        ((a = a.replace(/(:|;|\s)/gi, "").split(/\,/)),
        1 === a.length ? (c = a[0]) : ((d = a[0]), (c = a[1]))),
      1 === Math.abs(b) ? d : c
    );
  }
  var f = [],
    g = [],
    h = { precision: 100, elapse: !1 };
  g.push(/^[0-9]*$/.source),
    g.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
    g.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
    (g = new RegExp(g.join("|")));
  var i = {
      Y: "years",
      m: "months",
      n: "daysToMonth",
      w: "weeks",
      d: "daysToWeek",
      D: "totalDays",
      H: "hours",
      M: "minutes",
      S: "seconds",
    },
    j = function (b, c, d) {
      (this.el = b),
        (this.$el = a(b)),
        (this.interval = null),
        (this.offset = {}),
        (this.options = a.extend({}, h)),
        (this.instanceNumber = f.length),
        f.push(this),
        this.$el.data("countdown-instance", this.instanceNumber),
        d &&
          ("function" == typeof d
            ? (this.$el.on("update.countdown", d),
              this.$el.on("stoped.countdown", d),
              this.$el.on("finish.countdown", d))
            : (this.options = a.extend({}, h, d))),
        this.setFinalDate(c),
        this.start();
    };
  a.extend(j.prototype, {
    start: function () {
      null !== this.interval && clearInterval(this.interval);
      var a = this;
      this.update(),
        (this.interval = setInterval(function () {
          a.update.call(a);
        }, this.options.precision));
    },
    stop: function () {
      clearInterval(this.interval),
        (this.interval = null),
        this.dispatchEvent("stoped");
    },
    toggle: function () {
      this.interval ? this.stop() : this.start();
    },
    pause: function () {
      this.stop();
    },
    resume: function () {
      this.start();
    },
    remove: function () {
      this.stop.call(this),
        (f[this.instanceNumber] = null),
        delete this.$el.data().countdownInstance;
    },
    setFinalDate: function (a) {
      this.finalDate = b(a);
    },
    update: function () {
      if (0 === this.$el.closest("html").length) return void this.remove();
      var b,
        c = void 0 !== a._data(this.el, "events"),
        d = new Date();
      (b = this.finalDate.getTime() - d.getTime()),
        (b = Math.ceil(b / 1e3)),
        (b = !this.options.elapse && 0 > b ? 0 : Math.abs(b)),
        this.totalSecsLeft !== b &&
          c &&
          ((this.totalSecsLeft = b),
          (this.elapsed = d >= this.finalDate),
          (this.offset = {
            seconds: this.totalSecsLeft % 60,
            minutes: Math.floor(this.totalSecsLeft / 60) % 60,
            hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
            days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
            daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
            daysToMonth: Math.floor(
              (this.totalSecsLeft / 60 / 60 / 24) % 30.4368
            ),
            totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
            weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
            months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
            years: Math.abs(this.finalDate.getFullYear() - d.getFullYear()),
          }),
          this.options.elapse || 0 !== this.totalSecsLeft
            ? this.dispatchEvent("update")
            : (this.stop(), this.dispatchEvent("finish")));
    },
    dispatchEvent: function (b) {
      var c = a.Event(b + ".countdown");
      (c.finalDate = this.finalDate),
        (c.elapsed = this.elapsed),
        (c.offset = a.extend({}, this.offset)),
        (c.strftime = d(this.offset)),
        this.$el.trigger(c);
    },
  }),
    (a.fn.countdown = function () {
      var b = Array.prototype.slice.call(arguments, 0);
      return this.each(function () {
        var c = a(this).data("countdown-instance");
        if (void 0 !== c) {
          var d = f[c],
            e = b[0];
          j.prototype.hasOwnProperty(e)
            ? d[e].apply(d, b.slice(1))
            : null === String(e).match(/^[$A-Z_][0-9A-Z_$]*$/i)
            ? (d.setFinalDate.call(d, e), d.start())
            : a.error(
                "Method %s does not exist on jQuery.countdown".replace(
                  /\%s/gi,
                  e
                )
              );
        } else new j(this, b[0], b[1]);
      });
    });
});
jQuery.cookie = function (b, j, m) {
  if (typeof j != "undefined") {
    m = m || {};
    if (j === null) {
      j = "";
      m.expires = -1;
    }
    var e = "";
    if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
      var f;
      if (typeof m.expires == "number") {
        f = new Date();
        f.setTime(f.getTime() + m.expires * 24 * 60 * 60 * 1000);
      } else {
        f = m.expires;
      }
      e = "; expires=" + f.toUTCString();
    }
    var l = m.path ? "; path=" + m.path : "";
    var g = m.domain ? "; domain=" + m.domain : "";
    var a = m.secure ? "; secure" : "";
    document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("");
  } else {
    var d = null;
    if (document.cookie && document.cookie != "") {
      var k = document.cookie.split(";");
      for (var h = 0; h < k.length; h++) {
        var c = jQuery.trim(k[h]);
        if (c.substring(0, b.length + 1) == b + "=") {
          d = decodeURIComponent(c.substring(b.length + 1));
          break;
        }
      }
    }
    return d;
  }
};
if (typeof Currency === "undefined") {
  var Currency = {};
}
Currency.cookie = {
  configuration: { expires: 365, path: "/", domain: window.location.hostname },
  name: "currency",
  write: function (a) {
    jQuery.cookie(this.name, a, this.configuration);
  },
  read: function () {
    return jQuery.cookie(this.name);
  },
  destroy: function () {
    jQuery.cookie(this.name, null, this.configuration);
  },
};
Currency.moneyFormats = {
  USD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} USD",
  },
  EUR: {
    money_format: "&euro;{{amount}}",
    money_with_currency_format: "&euro;{{amount}} EUR",
  },
  GBP: {
    money_format: "&pound;{{amount}}",
    money_with_currency_format: "&pound;{{amount}} GBP",
  },
  CAD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} CAD",
  },
  ALL: {
    money_format: "Lek {{amount}}",
    money_with_currency_format: "Lek {{amount}} ALL",
  },
  DZD: {
    money_format: "DA {{amount}}",
    money_with_currency_format: "DA {{amount}} DZD",
  },
  AOA: {
    money_format: "Kz{{amount}}",
    money_with_currency_format: "Kz{{amount}} AOA",
  },
  ARS: {
    money_format: "${{amount_with_comma_separator}}",
    money_with_currency_format: "${{amount_with_comma_separator}} ARS",
  },
  AMD: {
    money_format: "{{amount}} AMD",
    money_with_currency_format: "{{amount}} AMD",
  },
  AWG: {
    money_format: "Afl{{amount}}",
    money_with_currency_format: "Afl{{amount}} AWG",
  },
  AUD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} AUD",
  },
  BBD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} Bds",
  },
  AZN: {
    money_format: "m.{{amount}}",
    money_with_currency_format: "m.{{amount}} AZN",
  },
  BDT: {
    money_format: "Tk {{amount}}",
    money_with_currency_format: "Tk {{amount}} BDT",
  },
  BSD: {
    money_format: "BS${{amount}}",
    money_with_currency_format: "BS${{amount}} BSD",
  },
  BHD: {
    money_format: "{{amount}}0 BD",
    money_with_currency_format: "{{amount}}0 BHD",
  },
  BYR: {
    money_format: "Br {{amount}}",
    money_with_currency_format: "Br {{amount}} BYR",
  },
  BZD: {
    money_format: "BZ${{amount}}",
    money_with_currency_format: "BZ${{amount}} BZD",
  },
  BTN: {
    money_format: "Nu {{amount}}",
    money_with_currency_format: "Nu {{amount}} BTN",
  },
  BAM: {
    money_format: "KM {{amount_with_comma_separator}}",
    money_with_currency_format: "KM {{amount_with_comma_separator}} BAM",
  },
  BRL: {
    money_format: "R$ {{amount_with_comma_separator}}",
    money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL",
  },
  BOB: {
    money_format: "Bs{{amount_with_comma_separator}}",
    money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB",
  },
  BWP: {
    money_format: "P{{amount}}",
    money_with_currency_format: "P{{amount}} BWP",
  },
  BND: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} BND",
  },
  BGN: {
    money_format: "{{amount}} ÃÂ»ÃÂ²",
    money_with_currency_format: "{{amount}} ÃÂ»ÃÂ² BGN",
  },
  MMK: {
    money_format: "K{{amount}}",
    money_with_currency_format: "K{{amount}} MMK",
  },
  KHR: {
    money_format: "KHR{{amount}}",
    money_with_currency_format: "KHR{{amount}}",
  },
  KYD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} KYD",
  },
  XAF: {
    money_format: "FCFA{{amount}}",
    money_with_currency_format: "FCFA{{amount}} XAF",
  },
  CLP: {
    money_format: "${{amount_no_decimals}}",
    money_with_currency_format: "${{amount_no_decimals}} CLP",
  },
  CNY: {
    money_format: "&#165;{{amount}}",
    money_with_currency_format: "&#165;{{amount}} CNY",
  },
  COP: {
    money_format: "${{amount_with_comma_separator}}",
    money_with_currency_format: "${{amount_with_comma_separator}} COP",
  },
  CRC: {
    money_format: "&#8353; {{amount_with_comma_separator}}",
    money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC",
  },
  HRK: {
    money_format: "{{amount_with_comma_separator}} kn",
    money_with_currency_format: "{{amount_with_comma_separator}} kn HRK",
  },
  CZK: {
    money_format: "{{amount_with_comma_separator}} K&#269;",
    money_with_currency_format: "{{amount_with_comma_separator}} K&#269;",
  },
  DKK: {
    money_format: "{{amount_with_comma_separator}}",
    money_with_currency_format: "kr.{{amount_with_comma_separator}}",
  },
  DOP: {
    money_format: "RD$ {{amount}}",
    money_with_currency_format: "RD$ {{amount}}",
  },
  XCD: {
    money_format: "${{amount}}",
    money_with_currency_format: "EC${{amount}}",
  },
  EGP: {
    money_format: "LE {{amount}}",
    money_with_currency_format: "LE {{amount}} EGP",
  },
  ETB: {
    money_format: "Br{{amount}}",
    money_with_currency_format: "Br{{amount}} ETB",
  },
  XPF: {
    money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
    money_with_currency_format:
      "{{amount_no_decimals_with_comma_separator}} XPF",
  },
  FJD: {
    money_format: "${{amount}}",
    money_with_currency_format: "FJ${{amount}}",
  },
  GMD: {
    money_format: "D {{amount}}",
    money_with_currency_format: "D {{amount}} GMD",
  },
  GHS: {
    money_format: "GH&#8373;{{amount}}",
    money_with_currency_format: "GH&#8373;{{amount}}",
  },
  GTQ: {
    money_format: "Q{{amount}}",
    money_with_currency_format: "{{amount}} GTQ",
  },
  GYD: {
    money_format: "G${{amount}}",
    money_with_currency_format: "${{amount}} GYD",
  },
  GEL: {
    money_format: "{{amount}} GEL",
    money_with_currency_format: "{{amount}} GEL",
  },
  HNL: {
    money_format: "L {{amount}}",
    money_with_currency_format: "L {{amount}} HNL",
  },
  HKD: {
    money_format: "${{amount}}",
    money_with_currency_format: "HK${{amount}}",
  },
  HUF: {
    money_format: "{{amount_no_decimals_with_comma_separator}}",
    money_with_currency_format:
      "{{amount_no_decimals_with_comma_separator}} Ft",
  },
  ISK: {
    money_format: "{{amount_no_decimals}} kr",
    money_with_currency_format: "{{amount_no_decimals}} kr ISK",
  },
  INR: {
    money_format: "Rs. {{amount}}",
    money_with_currency_format: "Rs. {{amount}}",
  },
  IDR: {
    money_format: "{{amount_with_comma_separator}}",
    money_with_currency_format: "Rp {{amount_with_comma_separator}}",
  },
  ILS: {
    money_format: "{{amount}} NIS",
    money_with_currency_format: "{{amount}} NIS",
  },
  JMD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} JMD",
  },
  JPY: {
    money_format: "&#165;{{amount_no_decimals}}",
    money_with_currency_format: "&#165;{{amount_no_decimals}} JPY",
  },
  JEP: {
    money_format: "&pound;{{amount}}",
    money_with_currency_format: "&pound;{{amount}} JEP",
  },
  JOD: {
    money_format: "{{amount}}0 JD",
    money_with_currency_format: "{{amount}}0 JOD",
  },
  KZT: {
    money_format: "{{amount}} KZT",
    money_with_currency_format: "{{amount}} KZT",
  },
  KES: {
    money_format: "KSh{{amount}}",
    money_with_currency_format: "KSh{{amount}}",
  },
  KWD: {
    money_format: "{{amount}}0 KD",
    money_with_currency_format: "{{amount}}0 KWD",
  },
  KGS: {
    money_format: "ÃÂ»ÃÂ²{{amount}}",
    money_with_currency_format: "ÃÂ»ÃÂ²{{amount}}",
  },
  LVL: {
    money_format: "Ls {{amount}}",
    money_with_currency_format: "Ls {{amount}} LVL",
  },
  LBP: {
    money_format: "L&pound;{{amount}}",
    money_with_currency_format: "L&pound;{{amount}} LBP",
  },
  LTL: {
    money_format: "{{amount}} Lt",
    money_with_currency_format: "{{amount}} Lt",
  },
  MGA: {
    money_format: "Ar {{amount}}",
    money_with_currency_format: "Ar {{amount}} MGA",
  },
  MKD: {
    money_format: "ÃÂ´ÃÂµÃÂ½ {{amount}}",
    money_with_currency_format: "ÃÂ´ÃÂµÃÂ½ {{amount}} MKD",
  },
  MOP: {
    money_format: "MOP${{amount}}",
    money_with_currency_format: "MOP${{amount}}",
  },
  MVR: {
    money_format: "Rf{{amount}}",
    money_with_currency_format: "Rf{{amount}} MRf",
  },
  MXN: {
    money_format: "$ {{amount}}",
    money_with_currency_format: "$ {{amount}} MXN",
  },
  MYR: {
    money_format: "RM{{amount}} MYR",
    money_with_currency_format: "RM{{amount}} MYR",
  },
  MUR: {
    money_format: "Rs {{amount}}",
    money_with_currency_format: "Rs {{amount}} MUR",
  },
  MDL: {
    money_format: "{{amount}} MDL",
    money_with_currency_format: "{{amount}} MDL",
  },
  MAD: {
    money_format: "{{amount}} dh",
    money_with_currency_format: "Dh {{amount}} MAD",
  },
  MNT: {
    money_format: "{{amount_no_decimals}} &#8366",
    money_with_currency_format: "{{amount_no_decimals}} MNT",
  },
  MZN: {
    money_format: "{{amount}} Mt",
    money_with_currency_format: "Mt {{amount}} MZN",
  },
  NAD: {
    money_format: "N${{amount}}",
    money_with_currency_format: "N${{amount}} NAD",
  },
  NPR: {
    money_format: "Rs{{amount}}",
    money_with_currency_format: "Rs{{amount}} NPR",
  },
  ANG: {
    money_format: "&fnof;{{amount}}",
    money_with_currency_format: "{{amount}} NA&fnof;",
  },
  NZD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} NZD",
  },
  NIO: {
    money_format: "C${{amount}}",
    money_with_currency_format: "C${{amount}} NIO",
  },
  NGN: {
    money_format: "&#8358;{{amount}}",
    money_with_currency_format: "&#8358;{{amount}} NGN",
  },
  NOK: {
    money_format: "kr {{amount_with_comma_separator}}",
    money_with_currency_format: "kr {{amount_with_comma_separator}} NOK",
  },
  OMR: {
    money_format: "{{amount_with_comma_separator}} OMR",
    money_with_currency_format: "{{amount_with_comma_separator}} OMR",
  },
  PKR: {
    money_format: "Rs.{{amount}}",
    money_with_currency_format: "Rs.{{amount}} PKR",
  },
  PGK: {
    money_format: "K {{amount}}",
    money_with_currency_format: "K {{amount}} PGK",
  },
  PYG: {
    money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
    money_with_currency_format:
      "Gs. {{amount_no_decimals_with_comma_separator}} PYG",
  },
  PEN: {
    money_format: "S/. {{amount}}",
    money_with_currency_format: "S/. {{amount}} PEN",
  },
  PHP: {
    money_format: "&#8369;{{amount}}",
    money_with_currency_format: "&#8369;{{amount}} PHP",
  },
  PLN: {
    money_format: "{{amount_with_comma_separator}} zl",
    money_with_currency_format: "{{amount_with_comma_separator}} zl PLN",
  },
  QAR: {
    money_format: "QAR {{amount_with_comma_separator}}",
    money_with_currency_format: "QAR {{amount_with_comma_separator}}",
  },
  RON: {
    money_format: "{{amount_with_comma_separator}} lei",
    money_with_currency_format: "{{amount_with_comma_separator}} lei RON",
  },
  RUB: {
    money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
    money_with_currency_format:
      "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB",
  },
  RWF: {
    money_format: "{{amount_no_decimals}} RF",
    money_with_currency_format: "{{amount_no_decimals}} RWF",
  },
  WST: {
    money_format: "WS$ {{amount}}",
    money_with_currency_format: "WS$ {{amount}} WST",
  },
  SAR: {
    money_format: "{{amount}} SR",
    money_with_currency_format: "{{amount}} SAR",
  },
  STD: {
    money_format: "Db {{amount}}",
    money_with_currency_format: "Db {{amount}} STD",
  },
  RSD: {
    money_format: "{{amount}} RSD",
    money_with_currency_format: "{{amount}} RSD",
  },
  SCR: {
    money_format: "Rs {{amount}}",
    money_with_currency_format: "Rs {{amount}} SCR",
  },
  SGD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} SGD",
  },
  SYP: {
    money_format: "S&pound;{{amount}}",
    money_with_currency_format: "S&pound;{{amount}} SYP",
  },
  ZAR: {
    money_format: "R {{amount}}",
    money_with_currency_format: "R {{amount}} ZAR",
  },
  KRW: {
    money_format: "&#8361;{{amount_no_decimals}}",
    money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW",
  },
  LKR: {
    money_format: "Rs {{amount}}",
    money_with_currency_format: "Rs {{amount}} LKR",
  },
  SEK: {
    money_format: "{{amount_no_decimals}} kr",
    money_with_currency_format: "{{amount_no_decimals}} kr SEK",
  },
  CHF: {
    money_format: "SFr. {{amount}}",
    money_with_currency_format: "SFr. {{amount}} CHF",
  },
  TWD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} TWD",
  },
  THB: {
    money_format: "{{amount}} &#xe3f;",
    money_with_currency_format: "{{amount}} &#xe3f; THB",
  },
  TZS: {
    money_format: "{{amount}} TZS",
    money_with_currency_format: "{{amount}} TZS",
  },
  TTD: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}} TTD",
  },
  TND: {
    money_format: "{{amount}}",
    money_with_currency_format: "{{amount}} DT",
  },
  TRY: {
    money_format: "{{amount}}TL",
    money_with_currency_format: "{{amount}}TL",
  },
  UGX: {
    money_format: "Ush {{amount_no_decimals}}",
    money_with_currency_format: "Ush {{amount_no_decimals}} UGX",
  },
  UAH: {
    money_format: "Ã¢â€šÂ´{{amount}}",
    money_with_currency_format: "Ã¢â€šÂ´{{amount}} UAH",
  },
  AED: {
    money_format: "Dhs. {{amount}}",
    money_with_currency_format: "Dhs. {{amount}} AED",
  },
  UYU: {
    money_format: "${{amount_with_comma_separator}}",
    money_with_currency_format: "${{amount_with_comma_separator}} UYU",
  },
  VUV: {
    money_format: "${{amount}}",
    money_with_currency_format: "${{amount}}VT",
  },
  VEF: {
    money_format: "Bs. {{amount_with_comma_separator}}",
    money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF",
  },
  VND: {
    money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
    money_with_currency_format:
      "{{amount_no_decimals_with_comma_separator}} VND",
  },
  XBT: {
    money_format: "{{amount_no_decimals}} BTC",
    money_with_currency_format: "{{amount_no_decimals}} BTC",
  },
  XOF: {
    money_format: "CFA{{amount}}",
    money_with_currency_format: "CFA{{amount}} XOF",
  },
  ZMW: {
    money_format: "K{{amount_no_decimals_with_comma_separator}}",
    money_with_currency_format:
      "ZMW{{amount_no_decimals_with_comma_separator}}",
  },
};
Currency.formatMoney = function (b, g) {
  if (typeof Shopify.formatMoney === "function") {
    return Shopify.formatMoney(b, g);
  }
  if (typeof b == "string") {
    b = b.replace(".", "");
  }
  var f = "";
  var e = /\{\{\s*(\w+)\s*\}\}/;
  var a = g || "${{amount}}";
  function c(h, i) {
    return typeof h == "undefined" ? i : h;
  }
  function d(m, k, l, j) {
    k = c(k, 2);
    l = c(l, ",");
    j = c(j, ".");
    if (isNaN(m) || m == null) {
      return 0;
    }
    m = (m / 100).toFixed(k);
    var n = m.split("."),
      i = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + l),
      h = n[1] ? j + n[1] : "";
    return i + h;
  }
  switch (a.match(e)[1]) {
    case "amount":
      f = d(b, 2);
      break;
    case "amount_no_decimals":
      f = d(b, 0);
      break;
    case "amount_with_comma_separator":
      f = d(b, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      f = d(b, 0, ".", ",");
      break;
  }
  return a.replace(e, f);
};
Currency.currentCurrency = "";
Currency.format = "money_with_currency_format";
Currency.convertAll = function (c, b, a, d) {
  jQuery(a || "span.money").each(function () {
    if (jQuery(this).attr("data-currency") === b) {
      return;
    }
    if (jQuery(this).attr("data-currency-" + b)) {
      jQuery(this).html(jQuery(this).attr("data-currency-" + b));
    } else {
      var e = 0;
      var f = Currency.moneyFormats[c][d || Currency.format] || "{{amount}}";
      var g = Currency.moneyFormats[b][d || Currency.format] || "{{amount}}";
      if (f.indexOf("amount_no_decimals") !== -1) {
        e = Currency.convert(
          parseInt(
            jQuery(this)
              .html()
              .replace(/[^0-9]/g, ""),
            10
          ) * 100,
          c,
          b
        );
      } else {
        if (c === "JOD" || c == "KWD" || c == "BHD") {
          e = Currency.convert(
            parseInt(
              jQuery(this)
                .html()
                .replace(/[^0-9]/g, ""),
              10
            ) / 10,
            c,
            b
          );
        } else {
          e = Currency.convert(
            parseInt(
              jQuery(this)
                .html()
                .replace(/[^0-9]/g, ""),
              10
            ),
            c,
            b
          );
        }
      }
      var h = Currency.formatMoney(e, g);
      jQuery(this).html(h);
      jQuery(this).attr("data-currency-" + b, h);
    }
    jQuery(this).attr("data-currency", b);
  });
  this.currentCurrency = b;
  this.cookie.write(b);
};
